export default {
  ERROR_HANDLING_HEADER: "Error Handling",
  ERROR_HANDLING_CUSTOM_HELP_TITLE: "How custom error handling works:",
  ERROR_HANDLING_CUSTOM_HELP_1: "Add custom error handling rules below. Each row lets you specify an error message, select an action, and enable/disable the rule with the checkbox.",
  ERROR_HANDLING_CUSTOM_HELP_2: "Use the checkbox to enable or disable a rule. When checked, the rule is active; when unchecked, it is ignored.",
  ERROR_HANDLING_CUSTOM_HELP_3: "You can add (+) or remove (-) custom rules as needed.",
  ERROR_HANDLING_CUSTOM_HELP_4: "Hover over the error message input to see the full message if it is truncated.",
  ERROR_HANDLING_CUSTOM_HELP_5: "Note: If the checkbox is unchecked, the error message will be shown in the UI. If checked, the error will not be shown.",
  ERROR_HANDLING_STATIC_HELP_TITLE: "Static error handling:",
  ERROR_HANDLING_STATIC_HELP_1: "You can only enable or disable the error using the checkbox.",
  ERROR_HANDLING_STATIC_HELP_2: "The error message and action cannot be changed for this rule.",
  ERROR_HANDLING_STATIC_HELP_3: "Note: If the checkbox is unchecked, the error message will be shown in the UI. If checked, the error will not be shown.",
  ERROR_HANDLING_INPUT_TOOLTIP: "Enter a custom error message for this rule. This message will be used to identify the error handling condition.",
  SUCCESS_HANDLING_STATIC_HELP_TITLE: "Success Handling",
  SUCCESS_HANDLING_STATIC_HELP_1: "You can enable or disable the success message by toggling the checkbox.",
  SUCCESS_HANDLING_STATIC_HELP_2: "The success message text can be changed for this rule.",
  SUCCESS_HANDLING_STATIC_HELP_3: "Note: If the checkbox is unchecked, the success message will be shown in the UI. If checked, the message will not be shown.",
  ERROR_HANDLING_ERROR_MESSAGE: "Error Message",
  ERROR_HANDLING_SELECT_ACTION: "Select Action",
  ERROR_HANDLING_ADD_RULE: "Add new error handling rule",
  ERROR_HANDLING_REMOVE_RULE: "Remove this rule",
  ERROR_HANDLING_AUTOMATIC: "Automatic",
  ERROR_HANDLING_CUSTOM: "Custom",
  ERROR_HANDLING_IGNORE: "Ignore",
  ERROR_HANDLING_DUPLICATE_ERROR: "Error: Duplicate error message detected.",
  ERROR_HANDLING_UNIQUE_NONEMPTY_ERROR: "Error: Please enter a unique, non-empty error message before adding another.",
  ERROR_HANDLING_ENABLE_DISABLE_RULE: "If unchecked, an error will be shown in the UI. If checked, the error will not be shown.",
  SKIP_TO_CONTENT: "Skip to Content",
  USER_NAV_DROPDOWN_NAME_UNAVAILABLE: "Name Unavailable",
  USER_NAV_DROPDOWN_EMAIL_UNAVAILABLE: "Email Unavailable",
  GENERAL_EMAIL_DESCRIPTION: "Configure general settings for Email authentication.",
  ANCHOR_OPENS_IN_NEW_TAB: " (opens in a new tab)",
  MSG_NO_DATA_AVAILABLE_TO_DISPLAY: "No data is available to display",
  MSG_SAML_NOT_CONFIGURED: "The tenant does not exist or do not have Single Sign-On enabled",
  ALL_SITES_PAGE_DESCRIPTION: "List all your tenants and switch to the one you want to access.",
  ALL_SITES_PAGE_OWNED_SITES_TABLE_TITLE: "List of LoginRadius Sites",
  ALL_SITES_PAGE_SHARED_SITES_TABLE_TITLE: "Shared Site(s):",
  // Support > Support Tickets
  NEW_TICKET: "New Ticket",
  OPEN_A_NEW_TICKET: "Open a New Ticket",
  SITE_LIST: "Site List",
  LEAVE_TENANT_POPUP_DESCRIPTION: "Are you sure you want to leave ",
  SUPPORT_TICKET_DESC: "This is the recommended way to contact our technical support team.",
  OPEN_NEW_TICKET_DESCRIPTION: "Submit a new support ticket by completing the form below and ensure you include all relevant information so we can better assist you.",
  EXISTING_TICKET_HEADER: "Existing Tickets",
  BILLING_AND_ACCOUNT: "Billing and Account",
  ACCOUNT: "Account",
  BILLING: "Billing",
  CUSTOMER_ANALYTICS_CONFIGURATION_SETTINGS: "Dashboard Configuration Settings",
  GENERAL_QUESTIONS: "General Questions",
  IMPLEMENTATION_API: "Implementation - API",
  IMPLEMENTATION_SDK_LIBRARY: "Implementation - SDK/Library",
  IMPLEMENTATION_MOBILE: "Implementation - Mobile",
  INTERFACE_DESIGN: "Interface Design - UI/Layout",
  SECURITY_AND_PERFORMANCE: "Security and Performance",
  SOCIAL_PROVIDER_APPS: "Social Provider Apps",
  USER_PROFILE_DATA: "User Profile Data",
  OTHER: "Other",
  TICKET_ID: "Ticket ID",
  DATE_CREATED: "Date Created",
  TICKET_SUBJECT: "Subject",
  STATUS: "Status",
  TICKET_CATEGORY: "Ticket Category",
  SITE_NAME: "Site Name",
  PRIORITY: "Priority",
  RESPONSE_TIME_URGENT: "Response Time: We typically respond within 3 hours.",
  RESPONSE_TIME_HIGH: "Response Time: We typically respond within 12 hours.",
  RESPONSE_TIME_NORMAL: "Response Time: We typically respond within 24 hours.",
  RESPONSE_TIME_LOW: "Response Time: We typically respond within 48 hours.",
  PRODUCTION: "Production",
  DEVELOPMENT: "Development",
  STAGING: "Staging",
  TICKET_SUBJECT_LABEL: "Ticket Subject",
  TICKET_SUBJECT_PLACEHOLDER: "Enter a title",
  TICKET_CATEGORY_ERROR: "Please select a ticket category.",
  SITE_NAME_ERROR: "Please select the related tenant's name to submit a new ticket.",
  TICKET_SUBJECT_ERROR: "Ticket subject is required.",
  TICKET_SUBJECT_ERROR_INVALID: "Ticket subject is invalid.",
  TICKET_DESCRIPTION_ERROR_INVALID: "Description is invalid.",
  TICKET_DESCRIPTION_ERROR: "Description is required.",
  TICKET_DESCRIPTION_LABEL: "Ticket Description",
  SITE_ENVIRONMENT: "Site Environment",
  WEBSITE_URL: "Website URL",
  ENTER_THE_URL: "Enter the related URL",
  CONTACT_PHONE_NUMBER: "Contact Phone Number",
  GENERAL_PHONE_DESCRIPTION: "Configure general settings for Phone authentication.",
  INCLUDE_COUNTRY_CODE: "Please include the country code.",
  SUPPORT_TICKET_DESCRIPTION_PLACEHOLDER: "Tell us as much as you can about this issue so we can replicate it and resolve it. Feel free to include details about your OS, browser, etc.",
  SUPPORT_TICKET_MY_TEAM: "My Team (Select the team members to whom you want to give access to the generated support ticket.)",
  SELECT_ALL: "Select All",
  DESELECT_ALL: "Deselect All",
  ADD_SCREENSHOT_SCREENCAST: "Add Screenshot/Screencast",
  CHOOSE_FILE: "Choose File",
  UPLOADED_IMAGES: "Uploaded Images",
  SUBMIT_TICKET: "Submit Ticket",
  RESET: "Reset",
  SUBMIT_TICKET_SUCCESS: "Thank you for submitting your query. Our technical support team will get back to you soon.",
  SUBMIT_TICKET_ERROR: "Something went wrong. Please try again.",
  LOGS_TAB_DESCRIPTION: "View recent error log data for your SSO connection. Click the refresh button to see the latest logs.",
  RECENT_LOGS: "Recent Logs",
  NO_LOGS: "No logs data available",
  FORMS_DESCRIPTION: "View, manage, and customize the appearance of the forms used for your tenant.",

  // Manage Customer
  DUPLICATE_CONTEXT: "Duplicate context name",
  CONTEXT_UPDATE: "Context updated successfully.",
  CONTEXT_ADDED: "Context added successfully.",
  ROLES_ADDED: "Roles added successfully.",
  UNASSIGNED_ROLES: "Roles unassigned successfully.",
  ROLES_CONFIGURE: "You don’t have any roles configured for this app. Please configure roles and permissions from",
  DELETE_SUCCESS: "Context deleted successfully.",
  USERS_UPDATED: "Users updated successfully.",
  SELECT_ROLES_ERR: "Please select a role for all users.",

  // Multiple Custom domain Branding
  NO_CUSTOMDOMAIN_DESCRIPTION: "Get started by adding custom domain to your LoginRadius site",
  // Account > Team Management
  AUDIT_LOGS_RECENT_ACCOUNT_ACTIVITIES: "Track recent actions performed by your team members.",
  PLATFORM_INTELLIGENCE_DESCRIPTION: "The Platform Intelligence section provides comprehensive insights into your application's performance and user behavior.",
  CONSUMER_AUDIT_LOGS_RECENT_ACCOUNT_ACTIVITIES: "Record of all recent account activities.",
  CONSUMER_AUDIT_LOGS_TITLE: "User Audit Logs",
  CONSUMER_AUDIT_LOGS_DESCRIPTION: "Storage of log data for user-specific authentications, access requests, and system interactions recorded over the last 7 days.",
  EXPLORE_INTEGRATIONS: "Explore Integrations",
  CONSUMER_AUDIT_LOG_START_DATE_ERROR: "Start date cannot be ahead of the end date.",
  CONSUMER_AUDIT_LOG_EVENT_SUMMARY: "Event Summary",
  CONSUMER_AUDIT_LOG_REQUEST_DETAILS: "Request Details",
  CONSUMER_AUDIT_LOG_RESPONSE_DETAILS: "Response Details",
  CONSUMER_AUDIT_LOG_METADATA: "Metadata",
  CONSUMER_AUDIT_LOG_DETAILS_TAB: "Log Details",
  CONSUMER_AUDIT_LOG_RAW_TAB: "Raw JSON Data",
  MARK_EMAIL_VERIFIED: "Mark Email as Verified",
  MARK_PHONE_VERIFIED: "Mark Phone as Verified",
  ADDITIONAL_PERMISSION: "Additional Permissions",
  LEARN_MORE_PERMISSIONS: "Learn more about permissions",
  NAME_PLACEHOLDER: "Enter name here",
  EMAIL_PLACEHOLDER: "E.g., username@xyz.com",
  TENANTS_PLACEHOLDER: "Select Tenant(s)",
  ROLES_PLACEHOLDER: "Select Role(s)",
  PERMISSIONS_PLACEHOLDER: "Select Permission(s)",
  NAME: "Name",
  EMAIL: "Email",
  DOB: "Date of Birth",
  PHONE: "Phone",
  CODE: "Code",
  DATE: "Date",
  TIME: "Time",
  ENABLE: "Enable",
  DISABLE: "Disable",
  ENABLED: "Enabled",
  DISABLED: "Disabled",
  EDIT_TEAM_MEMBER: "Edit team member",
  EDIT: "Edit",
  DELETE: "Delete",
  REMOVE_USER: "Remove User",
  RESEND_PASSWORD: "Resend Password",
  LOGOUT_THIS_USER: "Log Out This User",
  RESET_CODES: "Reset Codes",
  VERIFICATION_CODE: "Verification Code",
  COUNTRY_CODE: "Country Code",
  ENTER_THE_FLAGFORFIELDNAME_HERE_PLACEHOLDER: "Enter the FLAG_FOR_FIELD_NAME here",
  FLAG_FOR_FIELD_NAME: "FLAG_FOR_FIELD_NAME",
  ENTER_THE_NAME: "Enter the name",
  ENTER_THE_EMAIL: "Enter the email",
  MANAGE_USER: "Manage User",
  TENANT_NAME: "Tenant Name",
  TENANT_ROLES: "Tenant Roles",
  ADD_PHONE_NUMBER: "Add Phone Number",
  UPDATE_NUMBER: "Update Number",
  ADD_TEAM_MEMBER_MANAGE_TEAM: "Manage how your team can access their LoginRadius accounts.",
  SELECT_MEMBER_TRANSFER_OWNERSHIP: "Select a team member to whom the tenant ownership should be transferred.",
  CREATE_A_NEW_USER: "Create a New User",
  ENTER_THE_FIRST_NAME: "Enter the first name",
  EMAIL_FIELD_PLACEHOLDER: "Enter an email",
  EMAIL_IS_REQUIRED: "Email is required.",
  EMAIL_IS_INVALID: "Email is invalid.",
  NAME_IS_INVALID: "Name is invalid.",
  EMAIL_IS_OWN: "Please do not use your own email.",
  APP_NAME_IS_REQUIRED: "App name is required.",
  APP_ROLE_IS_REQUIRED: "App role is required.",
  YOUR_SITES: "Your Tenants",
  MORE_INFO_ABOUT_PERMISSION: "More information about permissions",
  MORE_INFO_ABOUT_EMAIL_TEMPLATES: "Click here for more details on Email Template Management",
  TRANSFERRED: "Tenant transferred.",
  NOT_TRANSFERRED: "Tenant could not be transferred.",
  BUTTON_PROCEED: "Proceed",
  ADDITIONAL_PERMISSIONS: "Additional Permissions",
  DELETE_CONFIRMATION: "Are you sure you want to delete this user?",
  ROLE: "Role",
  BUTTON_UPDATE: "Update",
  BUTTON_DELETE: "Delete",
  BUTTON_CONFIRM_DELETE: "Yes, Delete",
  BUTTON_CREATE: "Create",
  BUTTON_REMOVE: "Remove",
  BUTTON_ADD: "Add",
  BUTTON_IMPORT: "Import",
  BUTTON_CHANGE: "Change",
  BUTTON_CLEAR: "Clear",
  BUTTON_APPLY: "Apply",
  BUTTON_REQUEST_CHANGE: "Request Change",
  BUTTON_GENERATE_RANDOM_PASSWORD: "Generate Random Password",
  LABEL_EMAIL_AND_PASSWORD: "Email and Password",
  LABEL_JSON: "JSON",
  LABEL_CSV: "CSV",
  LABEL_AZURE_AD: "Azure AD",
  LABEL_ADFS: "ADFS",
  LABEL_SALESFORCE: "Salesforce",
  LABEL_SAML: "SAML",
  LABEL_APP_NAME: "App Name",
  LABEL_SELECT_APP: "Select App",
  LABEL_LOGIN_FLOW: "Login Flow",
  LABEL_IDP_BINDING: "ID Provider Binding",
  LABEL_IDP_LOCATION: "ID Provider Location",
  LABEL_IDP_LOGOUT_URL: "ID Provider Logout URL",
  LABEL_IDP_CERTIFICATE: "ID Provider Certificate",
  LABEL_SP_CERTIFICATE: "Service Provider Certificate",
  RENEW_CERTIFICATE_LABEL: "Renew Certificate",
  LABEL_SP_CERTIFICATE_KEY: "Service Provider Certificate Key",
  LABEL_RELAYSTATE_PARAM: "RelayState Parameter",
  LABEL_SELECT_FIELDS: "Select Fields",
  PLACEHOLDER_NO_FIELD_SELECTED: "No Field Selected",
  LABEL_SELECT_ALL_FIELDS: "Select All Fields",
  LABEL_DESELECT_ALL_FIELDS: "Deselect All Fields",
  LABEL_SEARCH_FOR_FIELDS: "Search for Fields",
  LABEL_ENTER_PROFILE_KEY: "Profile Key",
  LABEL_PLEASE_CONFIRM: "Please confirm",
  CREATE_NEW_APP: "Create New App",
  ENTER_EMAIL_DETAILS: "Please enter your email details",
  LABEL_DELETE_CONFIRMATION: "Are you sure you want to delete this?",
  LABEL_RENEW_CERTIFICATE_DESCRIPTION: "Are you sure you want to renew the certificate for this app?",
  SAML_FEDSSO_CERTIFICATE_DESCRIPTION: "The certificate will be used to establish trust between the Identity Provider and Service Provider.",
  SAML_FEDSSO_ATTRIBUTES_DESCRIPTION: "The key-value mappings define the attributes in the SAML response sent to the service provider.",
  FEDSSO_URL_LABEL_HEADER: "The URL of the page to where users will be redirected for authentication.",
  FEDSSO_SERVICE_PROVIDER_LABEL_HEADER: "The Service Provider endpoints and settings that LoginRadius will use to establish a SAML session.",
  LABEL_REMOVE_CONFIRMATION: "Are you sure you want to delete this?",
  LABEL_CAPTCHA_POPUP_WARNING:
    "<div><p>Are you sure you want to disable reCAPTCHA V2? reCAPTCHA V2 is deprecated, and you will not be able to use it after disabling it.</p><span>If you wish to continue using the already configured reCAPTCHA V2, click the <b>Cancel</b> button.</span></div>",
  LABEL_REVOKE_CONFIRMATION: "Are you sure you want to revoke all tokens?",
  HINT_USE_THIS_APP_NAME_TO_LOGIN: "Note: Use this app name to log in to your account.",
  ENTER_IDP_LOCATION: "Enter ID Provider Location",
  ENTER_IDP_LOGOUT_URL: "Enter ID Provider Logout URL",
  ENTER_IDP_CERTIFICATE: "Enter ID Provider Certificate",
  ENTER_SP_CERTIFICATE: "Enter Service Provider Certificate",
  ENTER_SP_CERTIFICATE_KEY: "Enter Service Provider Certificate Key",
  ENTER_RELAYSTATE_PARAM: "Enter RelayState Parameter",
  IS_IDP_ADFS: "Is your IDP ADFS?",
  INVALID_URL: "Invalid URL",
  INVALID_CERTIFICATE: "Invalid Certificate",
  FORGET_PASS_GREETING: "Forgot Password Greeting",
  NEVER_LOGGED_IN: "Never logged in",
  // Roles > Context
  ROLE_CONTEXT_TITLE: "Configured Contexts, Roles, and Additional Permissions",

  // Account > Billing
  ALREADY_EXISTS: "This user already exists.",
  USER_ADDED: "User added.",
  EMAIL_HAS_BEEN_SENT: "An email has been sent to ",
  LAST_LOGIN_JUST_NOW: "Just Now",
  INVALID_DOMAIN: "Emails with restricted domains are not allowed. Please use a proper business email address.",
  VIEW_SUBSCRIPTION_DETAILS: "View your LoginRadius subscription details and change your payment method here. For billing assistance, please contact our support team.",
  UPDATE: "Update",
  UPDATE_SUBSCRIPTIONS_ANCHOR_TITLE: "Update Subscription Details",
  NO_BILLING_INFO_FOUND: "No billing information has been found for your site. Please contact LoginRadius Support.",
  NO_SUBSCRIPTIONS: "You have no subscriptions.",
  VIEW_INVOICES: "View your recent invoices from LoginRadius here.",
  VIEW: "View",
  NO_INVOICES: "You have no invoices.",
  UPDATE_SUBSCRIPTION_DETAILS: "Update Subscription Details",
  VIEW_INVOICE_DETAILS: "View Invoice",
  VIEW_INVOICE_LINK: "View",
  NO_SUBSCRIPTION_INVALID_BILLING_ACCOUNT: "Subscription details cannot be retrieved due to an invalid billing account.",
  NO_INVOICE_INVALID_BILLING_ACCOUNT: "Invoices cannot be retrieved due to an invalid billing account.",
  MSG_PERMISSION_NOT_AVAILABLE: "You do not have permission to view this page. Please ask the site owner for permission to proceed.",
  TEAM_MANAGEMENT_TITLE: "Team Management",
  ADD_TEAM_MEMBER_TITLE: "Add team member",
  // Team Management > Single Sign-On
  MSG_FEATURE_NOT_AVAILABLE: "This feature is not available with your current plan. Please contact LoginRadius Support for more information.",
  MSG_ERROR_GETTING_FEATURES_OR_PERMISSIONS: "There seems to be an issue on our end. Please try again later.",
  // Team Management > Single Sign-On
  SINGLE_SIGN_ON_TAB_DESCRIPTION: "Configure a Single Sign-On option for your team members to access the Admin Console.",
  PLEASE_CHECK_YOUR_INTERNET_CONNECTION: "Please check your internet connection.",
  DATA_MAPPING: "Data Mapping",
  DATA_MAPPING_DESCRIPTION: "Fields or properties you want to map to the data response.",
  FIELD_PROPS_WANTS_TO_ADD_IN_DATA_RESPONSE: "Fields or properties you want to map to the data response.",
  CERTIFICATES: "Certificates",
  CERTIFICATES_DESCRIPTION: "The certificates will establish trust between the identity provider and the service provider.",
  CERTIFICATE_DESCRIPTION: "The certificate will establish trust between the identity provider and the service provider.",
  MAINTENANCE_DESCRIPTION: "The LoginRadius user account is currently undergoing scheduled maintenance to improve features and functionality. Please check back in a few minutes.",
  NOTE_DESCRIPTION: "The LoginRadius Core API remains fully operational and will not be affected by the maintenance. If you have any questions, please contact our support team at",
  NOTE: "Note:",
  VALID_USER_MESSAGE: "Please use a valid customer ID before processing this request.",
  SAVING_DATA: "Saving Data...",
  PROCESSING_REQUEST: "Processing Request...",
  ERROR_WHILE_FETCHING_CHART_DATA: "Error while fetching chart data.",
  NO_DATA_AVAILABLE_TO_DISPLAY: "No data is available to display.",
  IMPERSONATION_ALERT_MSG: "Are you sure? The account access will be ",
  IMPERSONATION_SUCCESS_MSG: "The account access for",
  IMPERSONATION_GRANTED: "granted to the",
  IMPERSONATION_REVOKED: "revoked from the",
  IMPERSONATION_TITLE: "Account Access",
  IMPERSONATION_TOOLTIP_MSG: "Would you like to grant access to LoginRadius's production support team so they can provide production support for your account?",
  LOGINRADIUS_USER: " LoginRadius production support team.",
  IMPERSONATION_DESCRIPION: "Allow the LoginRadius production support team access to your Admin Console.",
  IMPERSONATION_NOT_OWNER_TOOLTIP: "Only the site owner can manage account access.",
  ACCOUNT_PROFILE_HEADER: "View and edit your LoginRadius profile.",
  ACCOUNT_SETTING_HEADER: "Manage your login preferences—connect a social account to simplify the login process or grant dashboard access to LoginRadius's production support personnel.",
  ACCOUNT_LOGIN_SESSION: "View all your previous login activities.",
  ACCOUNT_PASSKEY_HEADER: "Add and manage passkeys to sign in to your LoginRadius account without a password.",
  ACCOUNT_PASSKEY_UPDATED: "Passkey settings updated successfully.",
  ACCOUNT_CONNECTED_HEADER: "Connect or disconnect social accounts to simplify signing in to your LoginRadius account.",
  ACCOUNT_CONNECTED_UPDATED: "Connected accounts updated successfully.",
  ACCOUNT_MFA_HEADER: "Add an extra layer of security to your LoginRadius account with multi-factor authentication.",
  ACCOUNT_MFA_UPDATED: "Multi-factor authentication settings updated successfully.",
  ACCOUNT_BACKUP_HEADER: "You can use backup codes to recover access to your account.",
  ACCOUNT_BACKUP_UPDATED: "Backup codes reset successfully.",
  ACCOUNT_CONTROL_HEADER: "Manage access control settings for your LoginRadius account.",
  ACCOUNT_LOGOUT_ALL_SESSIONS: "Logout all sessions",
  ACCOUNT_DETAILS_TITLE: "Account details",
  ACCOUNT_ACCESS_LABEL: "Account access",
  ACCOUNT_SECURITY_HEADER: "Manage additional security settings for your LoginRadius account.",
  ACCOUNT_SECURITY_MULTIFACTOR_HEADER: "Multi-Factor Authentication",
  MULTIFACTOR_AUTHENTICATION: "Multi-factor authentication is enabled.",
  ACCOUNT_SECURITY_MULTIFACTOR_DESCRIPTION:
    "Multi-Factor Authentication enhances account security by requiring additional verification to log in to LoginRadius. There are two ways to enable Multi-Factor Authentication: 1) with an authenticator app, or 2) verification via SMS.",
  ACCOUNT_SECURITY_ENTER_VERIFICATION_CODE: "Enter Verification Code",
  ACCOUNT_SECURITY_GOOGLE_AUTH_HEADER: "Verify identity via an authenticator app",
  ACCOUNT_SECURITY_GOOGLE_AUTHENTICATOR_APP_STEP_1_IMAGE_ALTERNATIVE: "Authenticator locking step one",
  ACCOUNT_SECURITY_GOOGLE_AUTHENTICATOR_APP_STEP_2_IMAGE_ALTERNATIVE: "Barcode for adding account to Authenticator App",
  ACCOUNT_SECURITY_GOOGLE_AUTHENTICATOR_APP_STEP_3_IMAGE_ALTERNATIVE: "Password on mobile phone app",
  ACCOUNT_SECURITY_GOOGLE_AUTH_DESCRIPTION: "Use the Google Authenticator app or a similar app.",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TITLE: "Configure Authenticator App",
  ACCOUNT_SECURITY_GOOGLE_MODAL_HEADER_PART_1: "Once configured, you’ll be required to enter a code created by the ",
  ACCOUNT_SECURITY_GOOGLE_MODAL_HEADER_PART_2: "Authenticator App",
  ACCOUNT_SECURITY_GOOGLE_MODAL_HEADER_PART_3: " to log in to your LoginRadius Admin Console account.",
  ACCOUNT_SECURITY_GOOGLE_MODAL_ONE_TITLE: "Step 1",
  ACCOUNT_SECURITY_GOOGLE_MODAL_ONE_HEADER: "Get the App",
  ACCOUNT_SECURITY_GOOGLE_MODAL_ONE_DESCRIPTION: "Download and install the Authenticator app on your phone or tablet.",
  ACCOUNT_SECURITY_GOOGLE_MODAL_ONE_DESCRIPTION_PART_2_LINK_ALT: "Link to Google Authenticator mobile app webpage",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_TITLE: "Step 2",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_HEADER: "Scan this Barcode",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_DESCRIPTION: "Open the authentication app and follow these steps:",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_STEPONE_PRE: "Tap the",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_STEPONE_SUF: "icon in the bottom-right corner of the app",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_STEPTWO: "Scan the image to the left using your phone's camera",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_TROUBLESHOOT: "Can't scan this barcode?",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_TROUBLESHOOT_HIDE: "Hide Manual Entry Code",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_SOLUTION_ONE:
    "Instead of scanning, use your authentication app's 'Manual Entry' or equivalent option and provide the following time-based key. (Lowercase letters will work too.)",
  ACCOUNT_SECURITY_GOOGLE_MODAL_TWO_SOLUTION_TWO: "Your app will generate a 6-digit verification code, which you can use below.",
  ACCOUNT_SECURITY_GOOGLE_MODAL_THREE_TITLE: "Step 3",
  ACCOUNT_SECURITY_GOOGLE_MODAL_THREE_DESCRIPTION: "Once the barcode above is scanned, enter the 6-digit verification code generated by the app.",
  ACCOUNT_SECURITY_GOOGLE_MODAL_CONFIRM: "Verify Code and Activate",
  ACCOUNT_SECURITY_GOOGLE_SETUP_SUCCESS: "You have successfully enabled the Authenticator App for multi-factor authentication.",
  ACCOUNT_SECURITY_GOOGLE_DELETE_SUCCESS: "The Authenticator App for multi-factor authentication has been successfully removed from your LoginRadius account.",
  ACCOUNT_SECURITY_SMS_AUTH_HEADER: "Verify identity via SMS",
  ACCOUNT_SECURITY_SMS_AUTH_DESCRIPTION: "Receive a verification code via SMS (standard messaging rates may apply).",
  ACCOUNT_SECURITY_SMS_AUTH_EXTRA_DESCRIPTION: "We’ll send a time-sensitive authentication code to your mobile phone via text message when you login.",
  ACCOUNT_SECURITY_SMS_PROMPT: "What’s your mobile phone number?",
  ACCOUNT_SECURITY_SMS_FIELD: "Enter your mobile phone number",
  ACCOUNT_SECURITY_SMS_VERIFICATION_MESSAGE: "After verifying the number, this feature will be enabled.",
  ACCOUNT_SECURITY_SEND_AUTH_CODE: "Send Authentication Code",
  ACCOUNT_SECURITY_SMS_OTP_SENT: "OTP has been sent successfully.",
  ACCOUNT_SECURITY_SMS_OTP_SENT_MESSAGE: "We’ve sent a 6-digit verification code to the number above.",
  ACCOUNT_SECURITY_SMS_OTP_CONFIRM: "Verify Code and Enable",
  ACCOUNT_SECURITY_SMS_OTP_RESEND: "Resend OTP",
  ACCOUNT_SECURITY_SMS_SETUP_SUCCESS: "You have successfully enabled SMS multi-factor authentication.",
  ACCOUNT_SECURITY_SMS_DELETE_SUCCESS: "SMS multi-factor authentication has been successfully removed from your LoginRadius account.",
  ACCOUNT_SECURITY_BACKUP_CODE_AUTH_HEADER: "Backup Codes",
  ACCOUNT_SECURITY_BACKUP_CODE_AUTH_DESCRIPTION: "You can use backup codes to login if you have lost your phone or cannot receive codes via SMS or an authenticator app.",
  ACCOUNT_SECURITY_BACKUP_CODE_DISCLAIMER:
    "Note: We recommend storing your backup codes wherever you keep your other valuable items. Like the codes on your phone, backup codes are only valuable to someone if they also manage to steal your password.",
  EXISTING_PASSWORD_INCORRECT: "The old password was incorrect.",
  ACCOUNT_PROFILE_CHANGE_SUCCESS: "Your account details have been updated successfully.",
  ACCOUNT_PROFILE_CHANGE_ERROR: "Your account details could not be updated successfully.",
  VALIDATION_NAME_REQUIRED: "The user's name is required.",
  VALIDATION_ORGANISATION_REQUIRED: "The user's organization is required.",
  VALIDATION_EMAIL_FORMATE: "The user's contact email is not in a valid format.",
  VALIDATION_PHONE_REQUIRED: "The user's phone number is required.",
  VALIDATION_PHONE_FORMATE: "The user's phone number is not in a valid format.",
  VALIDATION_PHONE_MIN_DIGIT_REQUIRED: "The user's phone number must have a minimum of 10 digits.",
  FIELD_NAME: "Name",
  FIELD_ORGANISATION: "Organization",
  FIELD_PHONE: "Phone Number",
  FIELD_AUTH_EMAIL: "Authentication Email",
  FIELD_CONTACT_EMAIL: "Contact Email",
  FIELD_TIME_ZONE: "Your Time Zone",
  FIELD_ACCOUNT_CREATION_DATE: "Account Creation Date (Displayed in UTC)",
  ACCOUNT_NAME_PRE_TEXT: "Hello",
  BUTTON_SAVE: "Save",
  BUTTON_SAVE_CHANGE: "Save Changes",
  BUTTON_CANCEL: "Cancel",
  BUTTON_EDIT_PROFILE: "Edit My Profile",
  SUB_ROUTE_ACCOUNT_PROFILE: "Profile",
  SUB_ROUTE_ACCOUNT_SETTINGS: "Settings",
  SUB_ROUTE_ACCOUNT_LOGIN_SESSION: "Login Session",
  SUB_ROUTE_ACCOUNT_PASSKEY: "Passkeys",
  SUB_ROUTE_ACCOUNT_CONNECTED: "Connected Accounts",
  SUB_ROUTE_ACCOUNT_MFA: "Multi-Factor Authentication",
  SUB_ROUTE_ACCOUNT_BACKUP: "Backup Codes",
  SUB_ROUTE_ACCOUNT_CONTROL: "Account Control",
  SUB_ROUTE_ACCOUNT_SECURITY: "Security",
  FIELD_NEW_PASSWORD: "New Password",

  FIELD_OLD_PASSWORD: "Old Password",
  FIELD_CONFIRM_PASSWORD: "Confirm Password",
  BUTTON_RESET_MY_PASSWORD: "Reset My Password",
  FIELD_NEW_PIN: "New PIN",
  FIELD_CONFIRM_PIN: "Confirm PIN",
  BUTTON_RESET_MY_PIN: "Reset My PIN",
  ARE_YOU_SURE_RESET_THIS: "Are you sure you want to reset?",
  BUTTON_SUBMIT: "Submit",
  VALIDATION_OLD_PASSWORD: "Old password is required.",
  VALIDATION_NEW_PASSWORD: "New password is required.",
  VALIDATION_CONFIRM_PASSWORD: "Confirm password is required.",
  VALIDATION_NEW_PIN: "New PIN is required.",
  VALIDATION_CONFIRM_PIN: "Confirm PIN is required.",
  VALIDATION_PASSWORD_MISMATCH: "New Password and Confirm Password do not match.",
  RESET_PASSWORD: "Reset password",
  RESET_PIN: "Reset PIN",
  POPUP_BODY_TEXT_LOGIN_SESSION: "Are you sure you want to log out from all web sessions?",
  PLEASE_CONFIRM: "Please confirm",
  HOSTED_PAGE_PREVIEW: "Auth Studio Preview",
  HOSTED_PAGE_PREVIEW_DOMAIN_TOOLTIP: "Domains mapped to this template",
  HOSTED_PAGE_PREVIEW_PKCE_TOOLTIP: "Routes the preview through the /authorize endpoint using the PKCE flow. Requires an OIDC / OAuth app.",
  // Modal chrome
  HOSTED_PAGE_PREVIEW_MODAL_TITLE: "Preview",
  HOSTED_PAGE_PREVIEW_OPEN_BUTTON: "Open preview",
  HOSTED_PAGE_PREVIEW_SUBTITLE: "Build a shareable preview link for",
  HOSTED_PAGE_PREVIEW_PAGE_SUFFIX: "page",
  // Shared option / page-type words
  HOSTED_PAGE_PREVIEW_AUTH: "Auth",
  HOSTED_PAGE_PREVIEW_WORKFLOW: "Workflow",
  HOSTED_PAGE_PREVIEW_LEGACY: "Legacy",
  HOSTED_PAGE_PREVIEW_AUTHORIZE: "Authorize",
  // Field labels
  HOSTED_PAGE_PREVIEW_PAGE_TYPE_LABEL: "Page type",
  HOSTED_PAGE_PREVIEW_FLOW_TYPE_LABEL: "Flow type",
  HOSTED_PAGE_PREVIEW_APP_LABEL: "OIDC / OAuth app",
  HOSTED_PAGE_PREVIEW_PKCE_LABEL: "PKCE flow",
  HOSTED_PAGE_PREVIEW_DEBUG_LABEL: "Debug mode",
  HOSTED_PAGE_PREVIEW_DOMAIN_LABEL: "Domain",
  HOSTED_PAGE_PREVIEW_STYLE_LABEL: "Style",
  HOSTED_PAGE_PREVIEW_REDIRECT_LABEL: "Redirect URL",
  // Placeholders
  HOSTED_PAGE_PREVIEW_APP_PLACEHOLDER: "Select an app",
  HOSTED_PAGE_PREVIEW_WORKFLOW_PLACEHOLDER: "Select a workflow",
  HOSTED_PAGE_PREVIEW_DOMAIN_PLACEHOLDER: "Select a domain",
  HOSTED_PAGE_PREVIEW_STYLE_PLACEHOLDER: "Default style",
  HOSTED_PAGE_PREVIEW_REDIRECT_PICKER_PLACEHOLDER: "Select a registered redirect URI",
  // Disabled-option tooltips
  HOSTED_PAGE_PREVIEW_IO_DISABLED_TOOLTIP: "Identity Orchestration is not enabled for this tenant.",
  HOSTED_PAGE_PREVIEW_LEGACY_B2B_TOOLTIP: "Legacy flow isn't supported for B2B tenants.",
  HOSTED_PAGE_PREVIEW_LEGACY_ENABLED_TOOLTIP: "Preview your authentication flow on your tenant's /auth endpoint using direct authentication.",
  HOSTED_PAGE_PREVIEW_AUTHORIZE_ENABLED_TOOLTIP: "Generate a preview URL using OpenID Connect / OAuth at /service/oidc/{app-name}/authorize with your selected app.",
  HOSTED_PAGE_PREVIEW_AUTHORIZE_UNSUPPORTED: "Authorize flow is supported with new templates, please create one.",
  // PKCE alerts
  HOSTED_PAGE_PREVIEW_PKCE_ON_INFO: "Routes through /authorize with PKCE; the SDK completes the code exchange in the browser.",
  HOSTED_PAGE_PREVIEW_PKCE_OFF_WARNING: "PKCE is off — the authorize URL carries no code_challenge. The authorization code must be exchanged for tokens from your backend.",
  // Inline field hints
  HOSTED_PAGE_PREVIEW_APP_REQUIRED_HINT: "Required for this flow.",
  HOSTED_PAGE_PREVIEW_WORKFLOW_REQUIRED_HINT: "Required for a workflow preview.",
  HOSTED_PAGE_PREVIEW_REDIRECT_PICKER_HINT: "Pick a redirect URI registered on the app — it's sent to the IDP exactly as registered.",
  // %s is the /profile path segment (rendered as a code chip)
  HOSTED_PAGE_PREVIEW_REDIRECT_NO_URIS_HINT: "This app has no registered redirect URIs, so the full %s URL (with clientId & clientName) is used so it always resolves.",
  HOSTED_PAGE_PREVIEW_REDIRECT_DEFAULT_HINT: "Auto-filled to %s. The page navigates here after login. Editable.",
  HOSTED_PAGE_PREVIEW_REDIRECT_RESET: "Reset to default",
  HOSTED_PAGE_PREVIEW_REDIRECT_READONLY_TOOLTIP: "This is the default URL used by LoginRadius. To use a different URL, register it as a redirect URI in the app.",
  // Validation / preview-URL panel. %s tokens are filled in code.
  HOSTED_PAGE_PREVIEW_REDIRECT_MISMATCH_ERROR: 'Redirect URL must match a Login Redirect URI registered on "%s".',
  HOSTED_PAGE_PREVIEW_LOADING_TEMPLATE: "Loading template details…",
  HOSTED_PAGE_PREVIEW_SELECT_TO_GENERATE: "Select %s to generate the URL.",
  HOSTED_PAGE_PREVIEW_AND_SEPARATOR: " and ",
  HOSTED_PAGE_PREVIEW_INVALID_REDIRECT: "Enter a valid http(s) Redirect URL.",
  HOSTED_PAGE_PREVIEW_MISSING_APP: "OIDC / OAuth App",
  HOSTED_PAGE_PREVIEW_URL_LABEL: "Preview URL",
  HOSTED_PAGE_PREVIEW_READY: "ready",
  HOSTED_PAGE_PREVIEW_COPIED: "Copied",
  HOSTED_PAGE_PREVIEW_COPY: "Copy",
  HOSTED_PAGE: "Auth Studio",
  HOSTED_PAGE_NOT_CONFIGURED: "Auth Studio is not configured for your apps.",
  CONFIRM_BUTTON_TEXT: "Confirm",
  PLEASE_ADD_VALID_JS_FILE_URL: "Please add a valid JavaScript file URL.",
  PLEASE_ADD_VALID_CSS_FILE_URL: "Please add a valid custom stylesheet file URL.",
  PLEASE_ADD_VALID_JS_FILE: "Please add a valid JavaScript file.",
  PLEASE_ADD_VALID_CSS_FILE: "Please add a valid custom stylesheet file.",
  PLEASE_ADD_VALID_HTML_TAG_FILE: "Please add a valid HTML tag.",
  PLEASE_CHOOSE_METADATA_FILE: "Upload file",
  XML_FILE_WRONG: "The file cannot be read. Please specify an XML file containing your SAML settings. If the error persists, consider downloading the file from your Custom IDP again.",
  PLEASE_ENTER_VALID_FILE: "Please enter a valid file.",
  PLEASE_ENTER_VALID_URL: "Please enter a valid URL.",
  PLEASE_ENTER_VALID_TAG: "Please enter a valid HTML tag.",
  TAG_ALREADY_EXISTS: "The HTML tag already exists.",
  BUTTON_SIGNOUT_VALUE: "Log out from all web sessions",
  TABLE_COL_HEADER_ACCESS_TYPE: "ACCESS TYPE",
  TABLE_COL_HEADER_LOACTION: "LOCATION (IP ADDRESS)",
  TABLE_COL_HEADER_DATE: "DATE/TIME",
  YOU_ARE_USING_DEFAULT_IDENTITY_SETTING: "You are using the default Identity Experience Framework settings.",
  MESSAGE_ACCOUNT_LINKING_SUCCESS: "The account has been linked.",
  MESSAGE_ACCOUNT_UNLINKING_SUCCESS: "The account has been unlinked.",
  MESSAGE_ACCOUNT_PASSWORD_CHANGE: "Your password has been changed successfully.",
  HOSTED_PAGE_TITLE_HEADING_0:
    "Auth Studio is a unified, centralized place to send customers requesting access to their accounts. If you choose to use this feature, you can fully customize your Auth Studio settings at any time. For details on the Authentication Page interfaces and customizations, please see ",
  HOSTED_PAGE_TITLE_HEADING_1:
    "This is a centralized profile management portal for your customers. From here, you can fully customize your Auth Studio settings at any time. For details on the Profile Page interfaces and customizations, please see ",
  THIS_DOCUMENT: "this document.",
  HOSTED_PAGE_SAVE_SUCCESS: "Auth Studio settings saved successfully.",
  HOSTED_PAGE_SAVE_ERROR: "Auth Studio settings could not be saved successfully.",
  PIN_AUTH_SAVE_ERROR: "PIN Authentication settings could not be saved successfully.",
  HOSTED_PAGE_DELETE_SUCCESS: "Auth Studio file deleted successfully.",
  HOSTED_PAGE_DELETE_ERROR: "Auth Studio file could not be deleted successfully.",
  HOSTED_PAGE_REPLACE_SUCCESS: "Auth Studio file replaced successfully.",
  HOSTED_PAGE_REPLACE_ERROR: "Auth Studio file could not be replaced successfully.",
  HOSTED_PAGE_RESET_SUCCESS: "Auth Studio reset successfully.",
  HOSTED_PAGE_RESET_ERROR: "Auth Studio could not be reset successfully.",
  HOSTED_URL_ALREADY_EXISTS_ERROR: "The hosted file URL already exists in this configuration.",
  SETTING_UPDATED_SUCCESSFULLY: "Settings updated successfully.",
  SETTING_DELETED_SUCCESSFULLY: "Settings deleted successfully.",
  RESET_AUTH_PAGE: "Reset Authentication Pages to Default",
  RESET_PROFILE_PAGE: "Reset Profile Pages to Default",
  REST_WORKFLOW_PAGE: "Reset Workflow Pages to Default",
  SUCCESS_MESSAGE_RENEW_CERTIFICATE: "Certificate has been renewed.",
  SOMETHING_WENT_WRONG_WHILE_LOADING_PLEASE_TRY_AGAIN: "Something went wrong. Please try again.",
  ONLY_CONFIGURED_PROVIDERS_ALLOWED_TO_ORDER: "Only configured providers can be reordered.",
  PLEASE_WAIT: "Please wait...",
  CLOSE: "Close",
  SEARCH: "Search",
  SEARCH_BY_UID: "Search by UID",
  LOG_INFORMATION: "Log Information",
  UNIDENTIFIED_USER: "Unidentified User",
  PAGE_URL: "Page URL",
  ADD_NEW: "Add New",
  REPLACE: "Replace",
  FROM_NAME: "From Name",
  FROM_EMAIL_ID: "From Email",
  FROM_NAME_REQUIRED: "From Name is required.",
  FROM_NAME_MAX_CHAR: "Names must be alphanumeric and must not exceed 32 characters.",
  FROM_EMAIL_REQUIRED: "From Email is required.",
  FROM_EMAIL_VALID: "Email format must be valid and must not exceed 32 characters.",
  NAME_TOOLTIP_WHEN_SMTP_CONFIGURED: "Sender's name applicable to this email template",
  EMAIL_TOOLTIP_WHEN_SMTP_CONFIGURED: "Sender's email applicable to this email template",
  IMAGE_URL_TOOLTIP: "Provide an image URL",
  IMAGE_URL_LABEL: "Background Image (Optional)",
  PHONE_NUMBER_VALIDATION: "The user's phone number is not in a valid format.",
  CONFIRM_PASSWORD_NOT_MATCH: "Confirm Password must match the New Password.",
  BREADCRUMB_MY_ACCOUNT_TEXT: "/Account/My Account",
  HEADING_OVERVIEW: "Overview",
  HEADING_LOGIN_ACTIVITY: "Login Activity",
  ACTIVITY_LOG: "Activity Log",
  HEADING_CUSTOMER_PROFILES_PER_DAY: "Customer Profiles Per Day",
  SUBHEADING_CUSTOMER_PROFILES_PER_DAY: "Number of new customer profiles per day",
  TAB_DESCRIPTION_OVERVIEW: `The Overview section provides key statistics for your LoginRadius site. Hover over any day on the calendar charts below to view login volumes. Scroll down for high-level statistics and recent signups. As you explore the User Insights tabs, you’ll notice a calendar tool in the upper right-hand corner of each page—this tool allows you to adjust the charts to reflect a specific time period.`,
  MSG_UNABLE_TO_GET_LOGIN_DATA: "Unable to retrieve login data.",
  MSG_UNABLE_TO_GET_USERS_DATA: "Unable to retrieve user data.",
  MSG_CUSTOMER_ACCOUNTS: "Customer Accounts",
  MSG_CUSTOMER_PROFILES: "Customer Profiles",
  MSG_TOP_PROVIDER: "Top Provider",
  MSG_TOP_COUNTRY: "Top Country",
  MSG_LOGINS: "Logins",
  MSG_NEW_SIGNUPS: "New Signups",
  ARE_YOU_WANTED_TO_HOST_ON_LOGINRADIUS_SERVER: "Do you want to host this file on the LoginRadius server?",
  MSG_ACTIVE_CUSTOMERS: "Active Customers",
  CUSTOMER_MANAGEMENT_TAB1_DISCRIPTION:
    "This is your Customer Management area, where you’ll find tools to help manage your customer base without needing to create your own management console. From here, you can search for a specific customer by entering their Name, Email, or UID in the search bar below. Click through the tabs on the left for more Customer Management features.",
  CUSTOMER_MANAGEMENT_TAB2_DISCRIPTION:
    "Here is a list of all customers registered with your LoginRadius site. You can perform customer management functions such as adding, editing, or deleting customer profiles, as well as triggering emails and resetting customers' passwords. Click on the quick view or full view of a selected customer to access these functions.",
  CUSTOMER_MANAGEMENT_TAB3_DISCRIPTION:
    "If any customers have been blocked from logging into your site(s) or app(s), they will be listed here. Use this page to unblock, delete, or manage these customers.",
  CUSTOMER_MANAGEMENT_TAB4_DISCRIPTION:
    "Use this interface to add customers to your site. Once the mandatory fields are filled and the form is submitted, the new customer will be registered with your site. If email settings are configured for your site, you can send a verification email.",
  CUSTOMER_STAT_TAB_DESCRIPTION: "The Customer Stats section contains customer accounts, profiles, and blocked customer statistics.",
  CUSTOMER_GROWTH_TAB_DESCRIPTION: "The Customer Growth section shows historical customer profile growth and user profiles registered or deleted in the selected time period.",
  PROVIDER_TAB_DESCRIPTION: "The Provider section shows the top 5 providers customers have registered in the selected time period.",
  REGION_TAB_DESCRIPTION: "The Region section shows the top countries customers have registered in the selected time period.",
  AGEGROUP_TAB_DESCRIPTION: "The Age Group section shows the age group distribution of customers registered in the selected time period.",
  GENDER_TAB_DESCRIPTION: "The Gender section shows the gender distribution of customers registered in the selected time period.",
  BROWSER_TAB_DESCRIPTION: "The Browser section shows a chart displaying the most popular browsers used to register on your site or application in the selected time period.",
  DEVICE_TAB_DESCRIPTION: "The Device section shows a chart displaying the most popular devices used to register on your site or application in the selected time period.",
  PROVIDER_ANALYTICS_TAB1_DISCRIPTION: "The Daily Distribution section displays the number of registrations by login provider over the selected time period.",
  PROVIDER_ANALYTICS_TAB2_DISCRIPTION: "The Region section breaks down the number of profiles or accounts created by country over the selected time period.",
  PROVIDER_ANALYTICS_TAB3_DISCRIPTION: "The Age Group section breaks down the number of profiles or accounts created by age over the selected time period.",
  PROVIDER_ANALYTICS_TAB4_DISCRIPTION: "The Gender Group section breaks down the number of profiles or accounts created by gender over the selected time period.",
  LOGIN_ANALYTICS_TAB1_DISCRIPTION: "The Login Stats section contains statistics related to customer profile logins.",
  LOGIN_ANALYTICS_TAB2_DISCRIPTION: "The Login Distribution section shows logins per day in the selected time period.",
  LOGIN_ANALYTICS_TAB3_DISCRIPTION: "The Daily Active Customers section shows the number of unique customer logins per day in the selected time period.",
  LOGIN_ANALYTICS_TAB4_DISCRIPTION: "The Monthly Active Customers section shows the number of unique monthly customer logins in the selected time period.",
  LOGIN_ANALYTICS_TAB5_DISCRIPTION: "The Customer Return Rate section shows the average number of times a customer logs in from a provider in the selected time period.",
  LOGIN_ANALYTICS_TAB6_DISCRIPTION: "The Provider Engagement section provides insight into the number of unique customer profiles logging in from each provider over the selected time period.",
  LOGIN_ANALYTICS_TAB7_DISCRIPTION: "The Browser Engagement section shows a chart displaying the popular browsers used to log in to your site or application.",
  LOGIN_ANALYTICS_TAB8_DISCRIPTION: "The Device Engagement section shows charts displaying the popular devices used to log in to your site or application.",
  LOGIN_ANALYTICS_MAX_ERROR_CODES: "You can select up to %s error codes.",
  MSG_ERROR_FETCHING_LOGIN_ANALYTICS: "Error fetching login analytics.",
  API_ANALYTICS_DESCRIPTION: "LoginRadius Platform Analytics provides a comprehensive view of your API activity and performance.",
  API_ANALYTICS_NO_VALID_DATA: "No valid data returned for %s with the applied filters",
  API_ANALYTICS_NO_DATA: "No data returned for %s with the applied filters",
  API_ANALYTICS_CSV_DOWNLOAD_ERROR: "Failed to fetch data for CSV export %s with the applied filters",
  API_ANALYTICS_TOP_FIVE_HEADER: "Request volume by source (Top 5)",
  API_ANALYTICS_TOP_FIVE_SUB_HEADER: "Distribution of top 5 contributors of your attributes. Download the CSV for full data.",
  API_ANALYTICS_TOP_100_VALUES: "Top 100 Values of %s",
  DOWNLOAD_CSV: "Download CSV",
  API_ANALYTICS_REQUEST_COUNT_DESCRIPTION:
    "This section contains a comparative chart of the number of requests made to various types of CRUD APIs. You can select different intervals to view windowed data. You can also enable auto-refresh, which will update the charts every minute.",
  API_ANALYTICS_RESPONSE_CODE_DESCRIPTION:
    "This section contains a comparative chart of the number of HTTP success (2xx) and error (4xx, 5xx) requests handled by our servers over the selected time interval.",
  API_ANALYTICS_PERF_LOOKUP_DESCRIPTION: "This section contains a comparative chart of the response time percentages for profile lookup APIs over the selected time interval.",
  API_ANALYTICS_PERF_AUTH_DESCRIPTION: "This section contains a comparative chart of the response time percentages for authentication APIs over the selected time interval.",
  API_ANALYTICS_PERF_CREATE_DESCRIPTION: "This section contains a comparative chart of the response time percentages for profile creation APIs over the selected time interval.",
  API_ANALYTICS_PERF_DELETE_DESCRIPTION: "This section contains a comparative chart of the response time percentages for profile deletion APIs over the selected time interval.",
  API_ANALYTICS_PERF_UPDATE_DESCRIPTION: "This section contains a comparative chart of the response time percentages for profile update APIs over the selected time interval.",
  COMM_ANALYTICS_SMS_DESCRIPTION:
    "This section contains charts displaying the number of SMS messages sent for various purposes (e.g., registration, password reset) through Twilio integration. You can select different intervals to view windowed data.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_DESCRIPTION: "Authorize customers for this tenant.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_COULD_NOT_REMOVE_USER: "Could not remove user.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_AN_EMAIL_HAS_BEEN_SENT: "An email has been sent to",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_EMAIL_RESET_PASSWORD_NOT_SENT: "Email reset password could not be sent.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_USER_SUCCESSFULLY_SIGNED_OUT: "This user has been successfully signed out.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_APP_ROLES_NOT_FETCHED: "Error while fetching app roles.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_USER_ROLE_UPDATED: "User role updated.",
  TEAM_MANAGEMENT_MANAGE_TEAM_MEMBER_USER_ROLE_NOT_UPDATED: "Could not update user role.",
  AUDIT_LOGS_DESC: "Logs of all team member activities, including adding, deleting, updating, and site feature updates.",
  AUDIT_LOGS_TITLE: "View Audit Logs",
  AUTHORIZED_CUSTOMERS: "Manage team members for your LoginRadius tenant.",
  CUSTOMER_RETURN_RATE: "User Return Rate",
  // Deployment
  DEPLOYMENT_LIBS_SDK_LIBRARY: "SDK Library",
  DEPLOYMENT_LIBS_MOBILE_LIBRARY: "Mobile Library",
  DEPLOYMENT_LIBS_TURNKEY_PLUGINS: "Turnkey Plugins",
  DEPLOYMENT_LIBS_SDK_LIBRARY_HEADER:
    "Software Developer Kits can assist you in integrating and simplifying API calls in your native server-side application. Our SDKs use familiar technologies such as REST APIs and the OAuth 2.0 protocol. Follow these instructions to implement the LoginRadius platform on websites built with various programming languages.",
  DEPLOYMENT_LIBS_MOBILE_LIBRARY_HEADER:
    "Follow these instructions to implement the LoginRadius solution on various mobile platforms. If you don’t see the mobile platform your app is built on, please use our API or contact us for a custom SDK.",
  DEPLOYMENT_LIBS_TURNKEY_PLUGINS_HEADER:
    "Follow these instructions to implement the LoginRadius platform on websites built with Content Management Systems (CMS). If you don’t see your website’s CMS here, please use our API or contact us for a custom turnkey plugin.",
  DEPLOYMENT_LIBS_TURNKEY_PLUGINS_SELECT: "Select the programming language for your website",
  SELECT_A_SDK: "Select an SDK",
  DEPLOYMENT_LIBS_MOBILE_LIBRARY_SELECT: "Select the Mobile Library",
  DEPLOYMENT_LIBS_SDK_LIBRARY_SELECT: "Select the CMS for your website",
  SELECT_A_CMS: "Select a CMS",
  DEPLOYMENT_LIBS_DEFAULT: "General Implementation Guides",
  DEPLOYMENT_LIBS_DEFAULT_NEXT: "Please read the general guides on implementing the LoginRadius platform.",
  DEPLOYMENT_LIBS_DEFAULT_STARTED: "Getting Started Guide",
  DEPLOYMENT_LIBS_DEFAULT_STARTED_NEXT: "to familiarize yourself with the LoginRadius Dashboard.",
  DEPLOYMENT_LIBS_DEFAULT_GUID: "User Flow Guide",
  DEPLOYMENT_LIBS_DEFAULT_GUID_NEXT: "to understand how the LoginRadius platform interacts with your web and mobile applications.",
  DEPLOYMENT_LIBS_DEFAULT_SIGN: "Single Sign-On Guide",
  DEPLOYMENT_LIBS_DEFAULT_SIGN_NEXT: "to understand the login flow.",
  DEPLOYMENT_LIBS_DOWNLOAD: "Download the",
  DEPLOYMENT_LIBS_FOLLOW: "Follow the",
  DEPLOYMENT_LIBS_FOLLOW_NEXT: "documentation for installation and configuration",
  DEPLOYMENT_LIBS_DOWNLOAD_ASSISTANCE: "If you still require assistance,",
  DEPLOYMENT_LIBS_DOWNLOAD_ASSISTANCE_NEXT: "please contact our support team",
  NO_DOMAIN_ADDED: "No Custom Domain added",
  NO_DOMAIN_SUB: "Get started by adding a custom domain or use LoginRadius default domain",
  DEMO_PROJECT: "Demo Project",
  SUBHEADING_LOGIN_ACTIVITY: "Number of logins per day",
  PLUGINS: "Plugin",
  SDK: "SDK",
  ADD_NEW_SITE_BUTTON: "Add New Domain",
  PIN_AUTH_EMAIL_HEADER: "You can customize the email message delivered to end users requesting a PIN reset. The template supports HTML and CSS.",
  PIN_AUTH_SMS_HEADER: "You can customize the SMS sent to end users requesting a PIN reset.",
  PROD_WEBSITE_URL: "Name of the Domain",
  NAME_OF_USER: "Name of User",
  STAG_WEBSITE_URL: "Dev/Staging/Sandbox Website URL(s)",
  LABEL_PROD_URL: "Enter Domain URL",
  EDIT_SITE: "Edit your domain",
  ADD_NEW_SITE: "Add a new domain",
  PLACEHOLDER_PROD_URL: "Enter the production site URL here",
  PLACEHOLDER_STAG_URL: "Enter the staging site URL here",
  ERROR_SINGLE_SITE_EXISTS: "At least one domain must be present.",
  SITE_CONFIGURATION_SECTION_SAVED: "Site configurations saved successfully.",
  LABEL_STAG_URL: "Enter Staging URL",
  LIMIT_REACHED: "You have reached the maximum number of %s allowed for your plan.",
  SAVE: "Save",
  VERIFY: "Verify",
  ENTER_A_VALID_URL: "Enter a valid URL.",
  CUSTOM_DOMAIN_TITLE: "Your Custom Domain",
  CUSTOM_DOMAIN_CNAME_LABEL: "CNAME",
  CUSTOM_DOMAIN_DOMAIN_PREFIX_ERROR: "Domain name should not start with http/https prefix.",
  CUSTOM_DOMAIN_DOMAIN_SUBPATH_ERROR: "Domain name should not contain any subpaths (/).",
  CUSTOM_DOMAIN_PENDING_TOOLTIP: "Domain verification may take up to 12 hours to complete. If verification is still pending after this period, please contact LoginRadius Support.",
  CUSTOM_DOMAIN_TEMPLATE_COLUMN_TITLE: "Template Name",
  CUSTOM_DOMAIN_TEMPLATE_TOOLTIP: "Checkout your templates",
  CUSTOM_DOMAIN_DEFAULT_TEMPLATE_TOOLTIP: "This domain will run on your default template",
  CUSTOM_DOMAIN_STYLE_COLUMN_TITLE: "Style Name",
  CUSTOM_DOMAIN_DEFAULT_STYLE_TOOLTIP: "This domain will run on your default style",
  CUSTOM_DOMAIN_UNMAPPED_TAG: "unmapped",
  CUSTOM_DOMAIN_ADD_DISABLED_TOOLTIP: "Please verify your custom domain before adding another one.",
  CUSTOM_DOMAIN_STYLE_NAME_LABEL: "Style Name (Optional)",
  CUSTOM_DOMAIN_TEMPLATE_MODAL_TITLE: "Choose a template for %s",
  NO_CUSTOM_DOMAIN: "You don’t have Custom Domains yet",
  NO_CUSTOM_DOMAIN_SUB: "Get started by adding a custom domain",
  NO_CUSTOM_DOMAIN_FEATURE: "Custom Domains Deployment Not Available",
  NO_CUSTOM_DOMAIN_SUB_FEATURE: "This feature is not available with your current plan. Please contact LoginRadius Support for more information.",
  CONTACT_US: "Contact Us",
  REQUEST_INTEGRATION: "Request to enable integration",
  BUTTON_GENERATE: "Generate",
  COPY_TO_CLIPBOARD: "Copied to Clipboard",
  COPIED: "Copied!",
  DNS_MANAGER: "Open your <b>DNS manager</b>",
  CUSTOM_DOMAIN_INSTRUCTIONS_STEP3: "Add the following value as a <b>CNAME</b> record",
  CUSTOM_DOMAIN_INSTRUCTIONS_STEP2: "Create a <b>subdomain</b> or use an <b>existing subdomain</b>",
  CUSTOM_DOMAIN_MESSAGE: "Please contact LoginRadius Support to enable, add, or update a custom domain.",
  CUSTOM_DOMAIN_NOTE: "If a custom domain has been added to your application, it is necessary to update all associated social login provider applications.",
  GENERAL_SETUP_GUIDE: "General Setup Guide",
  CUSTOM_DOMAIN_INSTRUCTIONS: "Follow these steps to set up your custom domain.",
  FEATURE_NOT_AVAILABLE: "Feature Not Available",
  ACCESS_NOT_AVAILABLE: "You do not have access to view this page.",
  CONTACT_LOGINRADIUS: "Contact LoginRadius",
  FEATURE_RESTRICT_MESSAGE: "This feature is not available with your current plan. Please contact LoginRadius Support for more information.",
  ACCESS_PERMISSION_MESSAGE: "You do not have permission to view this page. Please ask the site owner for permission to proceed.",
  CUSTOM_DOMAIN_HEADER: "You can customize your Auth Studio URL. Configure custom domain settings to replace LoginRadius’s unique URL with your domain URL.",
  CUSTOM_DOMAIN_HEADER_L2: "Add a New Website/App Domain(s)",
  REMOVE: "Remove",
  REVOKE_ALL: "Revoke All",
  COPY: "Copy",
  SHARE_PROFILE: "Share Profile",
  SELECT_TO_ENABLE: "Select to Enable",
  ENABLE_RISK_BASED_AUTHENTICATION: "Enable Risk-Based Authentication",
  RISK_BASED_AUTHENTICATION: "Customize the following options based on your user base and authentication risk criteria.",
  SOTT_LABEL: "Encode SOTT",
  SELECT_SOTT_TECHNOLOGY: "Select Technology",
  MOBILE_APPS_COPY_TEXT: "Make sure to copy your new Secure One-Time Token (SOTT) now. You won’t be able to see it again!",
  ADD_SOTT_MESSAGE: "SOTT generated successfully.",
  REVOKE_SOTT_MESSAGE: "SOTT deleted successfully.",
  REVOKE_ALL_SOTT_MESSAGE: "All SOTT(s) revoked successfully.",
  GENERATE_NEW_SOTT: "Generate New SOTT",
  NEW_SOTT: "New SOTT",
  ADDITIONAL_API_SECRET: "Additional API Secret(s)",
  ADD_ADDITIONAL_API_SECRET: "Add additional API secret",
  CREATE_NEW_API_SECRET: "Create Secret",
  TECHNOLOGY: "Select Technology",
  TECHNOLOGY_ERROR: "Technology is required.",
  COMMENT: "Comment",
  DEFAULT_MOBILE_SOTT_RANGE: "7",
  ENTER_COMMENT: "Please enter the details for the new SOTT",
  DATE_RANGE_TOKEN: "Date Range of Token Validity",
  URL_REQUIRED: "A URL is required.",
  SITE_DOMAIN_DELETED: "Tenant domain deleted successfully.",
  SOTT_NOTE: "This option allows you to encode a part of the SOTT from '+' to '%2B'.",
  JS_WIDGET_PREVIEW: "JS Widget Preview",
  JS_WIDGETS: "JS Widgets",
  JS_WIDGETS_DESCRIPTION: "Personalize the login flow to create a cohesive user experience.",
  WIDGET_SETTINGS: "Widget Settings",
  SAVE_SETTINGS: "Save Settings",
  WIDGET_SETTINGS_UPDATED_SUCCESSFULLY: "Widget settings updated successfully.",
  FOR_MORE_INFORMATION: "For more information, please see the",
  DOCUMENTATION: "Documentation",
  STEPS_FOLLOW: "Follow these steps to configure the widget",
  MORE_DETAILS: "Click here for more detail",
  HEADER_SECTION: "Add the Customer Registration JS in the header section.",
  HEAD_JS_CODE_INFO: "Copy the code below and paste it before the </head> tag. If you have already added this code, skip this step.",
  COPY_HEAD_JS_CODE_INFO: "Copy the code below and paste it before the </head> tag.",
  COPY_TEMPLATE_CODE: "Copy the template code below and paste it after the </body> tag.",
  COPY_CONTAINER_CODE: "Copy the code below and paste it after the <body> tag. Place it where you want the widget to display on your webpage.",
  COPY_INTERFACE_CODE: "Copy the code below and paste it after the <body> tag. Place it where you want to display the social login interface on your webpage.",
  DEBUG_MODE: "Debug Mode",
  STAY_LOGIN: "Enable Stay Logged-In Option",
  TRADITIONAL_LOGIN_REQUIRED: "Ask for Required Fields on Traditional Login",
  ENABLE_USERNAME: "Enable Username",
  GENERAL_USERNAME_DESCRIPTION: "Configure general settings for Username authentication.",
  FORGOT_PASSWORD_URL: "Forgot Password URL",
  RESET_PASSWORD_EMAIL_TEMPLATE: "Reset Password Email Template",
  WELCOME_SMS_TEMPLATE: "Welcome SMS Template",
  FORGOT_PASSWORD_TEMPLATE: "Forgot Password Template",
  FORGOT_PASSWORD_SMS_TEMPLATE: "Forgot Password SMS Template",
  LOGIN_ON_EMAIL_VERIFICATION: "Enable Login on Email Verification",
  PROMPT_PASSWORD_SOCIALLOGIN: "Prompt Password on Social Login",
  ASK_EMAIL_UNVERIFIED_USER: "Always Ask Email for Unverified Users",
  UNLINKING_CALLBACK: "Callback URL for Unlinking",
  CALLBACK_INSIDE_SAME_WINDOW: "Redirect the customer inside the child window (pop-up window) on successful login.",
  DISPLAY_PASSWORD_STRENGTH: "Display Password Strength",
  ENABLE_PHONE_NUMBER: "Enable Phone Number Login",
  ENABLE_MFA: "Enable Required MFA",
  MFA_BEHAVIOUR: "MFA Behaviour",
  MFA_BEHAVIOUR_DESCRIPTION: "Define how strongly your application verifies who's signing in.",
  MFA_ENFORCEMENT: "MFA Enforcement",
  MFA_ENFORCEMENT_DESCRIPTION: "With Optional MFA, users can bypass this step if they choose, while Required MFA ensures that users can only continue after successfully verifying their identity.",
  SOTT: "Secure One-Time Token",
  ADD_EMAIL_TEMPLATE: "Add Email Template",
  SMS_TEMPLATE: "SMS Template",
  PING_COUNT: "Ping Count",
  PING_INTERVAL: "Ping Interval",
  REDIRECT_URL: "Redirect URL",
  SMART_LOGIN_EMAIL_TEMPLATE: "Smart Login Email Template",
  VERIFICATION_EMAIL_TEMPLATE: "Verification Email Template",
  EMAIL_SIGNUP_FLOW_CAPTION: "To configure email address as  an optional field, enable Phone as an Authentication Type.",
  EMAIL_VERIFICATION_TEMPLATE: "Email Verification Template",
  EMAIL_VERIFICATION_URL: "Email Verification URL",
  SMS_TEMPLATE_PHONE_VERIFICATION: "SMS Template Name for Phone Verification",
  TERMS_HTML: "Terms and Conditions HTML",
  ENABLE_OPTIONAL_MFA: "Enable Optional MFA",
  MFA_PASSWORDLESS_EMAIL_TOOLTIP: "Email OTP MFA cannot be used with Email Passwordless login. Please choose another MFA method.",
  MFA_PASSWORDLESS_SMS_TOOLTIP: "SMS OTP MFA cannot be used with Phone Passwordless login. Please choose another MFA method.",
  ENABLE_GA: "Enable Google Authentication",
  ENABLE_INSTANT_LINK_LOGIN: "Enable Instant Link Login",
  ENABLE_INSTANT_OTP_LOGIN: "Enable Instant OTP Login",
  FORM_VALIDATION_MESSAGE: "Form Validation Message",
  RENDER_DELAY: "Form Render Delay",
  PASSWORD_LENGTH: "Password Length",
  VERIFICATION_URL: "Verification URL",
  ACCESS_TOKEN: "Access Token Response",
  CALLBACK_URL: "LoginRadius redirects the customer to this URL with the token in the POST body.",
  CALLBACK_TYPE: "To determine the method used to return the token to the customer",
  WELCOME_EMAIL_TEMPLATE: "Welcome Email Template",
  DISABLED_EMAIL_VERIFICATION: "Disabled Email Verification",
  NO_SSO_FOUND: "No SSO Integrations Found",
  OPTIONAL_EMAIL_VERIFICATION: "Optional Email Verification",
  ONE_TOUCH_LOGIN_WELCOME_SMS_TEMPLATE: "One-Touch Login Welcome SMS Template",
  ONE_TOUCH_LOGIN_SMS_TEMPLATE: "One-Touch Login SMS Template",
  ONE_TOUCH_LOGIN_EMAIL_TEMPLATE: "One-Touch Login Email Template",
  ONE_TOUCH_LOGIN_REDIRECT_URL: "One-Touch Login Redirect URL",
  MOBILE_APP_TITLE: "SOTT (Mobile App)",
  MOBILE_APPS_HEADER: "Generate a Secure One-Time Token (SOTT) with your API key and secret to authorize mobile app access to LoginRadius.",
  WEB_APPS_HEADER:
    "Whitelist application domains to seamlessly utilize LoginRadius features. For example, when using the SSO feature, you must add third-party Custom IDP or Service Provider URLs in addition to your application URL.",
  VALIDATION_PASSWORD_MIN_SIX_CHAR: "Passwords must contain at least six characters or numbers. We recommend combining uppercase and lowercase letters and numbers for a strong password.",
  DATA_EXPORT_TABLE_HEADER_NUMBER_SYMBOL: "#",
  START_DATE: "Start Date",
  START_DATE_UTC: "Start Date (UTC)",
  DATA_EXPORT_TABLE_HEADER_EXPORT_ENDDATE: "End Date (UTC)",
  DATA_EXPORT_TABLE_HEADER_EXPORT_FREQUENCY: "Frequency",
  DATA_EXPORT_TABLE_HEADER_EXPORT_RECIPIENTS: "Recipients",
  DATA_EXPORT_TABLE_HEADER_EXPORT_PROGRESS: "Progress",
  DATA_EXPORT_TABLE_HEADER_EXPORT_ACTION: "Action",
  DATA_EXPORT_POPUP_TITLE_CREATE_DATA_EXPORT: "Create Data Export",
  DATA_EXPORT_ON_DEMAND_EXPORT_TAB_DESCRIPTION:
    "The on-demand data export page allows you to customize and export user profile reports. Once a report is requested, LoginRadius will send you (and any additional recipients) an email with a secure link to download the data extract in the requested format (CSV or JSON). Depending on the request pipeline, it may take up to an hour to receive the report.",
  DATA_EXPORT_ON_DEMAND_EXPORT_NO_ACTIVE_REQUESTS: "You currently have no active on-demand export requests.",
  DATA_EXPORT_SCHEDULED_EXPORT_NO_ACTIVE_REQUESTS: "You currently have no active scheduled export requests.",
  NO_DATA_AVAILABLE: "No data is available to display",
  DATA_EXPORT_SCHEDULED_EXPORT_TAB_DESCRIPTION:
    "The scheduled data export page allows you to set a schedule for customized user profile reports. Reports can be scheduled daily, weekly, or monthly. Each time a report is generated, LoginRadius will send you (and any additional recipients) an email with a secure link to download the data extract in the requested format (CSV or JSON).",
  DATA_EXPORT_SEGMENTED_EXPORT_DATES: "0001-01-01T00:00:00Z",
  CONFIGURED_REQUESTS: "Configured Requests",
  DATA_EXPORT_ADD_A_NEW_REQUEST: "Add a New Request",
  DATA_EXPORT_SCHEDULED_EXPORT_TAB_NO_ACTIVE_SCHEDULED_EXPORT_REQUESTS: "You currently have no active scheduled export requests.",
  SELECTED_SEGMENTATION_QUERY: "Selected Segmentation Query",
  FILTER_QUERY: "Filter Query:",

  DATA_EXPORT_STATUS_IN_PROGRESS: "In Progress",
  DATA_EXPORT_STATUS_NOT_YET_STARTED: "Not Yet Started",
  DATA_EXPORT_ADD_RECIPIENTS: "Add Recipients",
  DATA_EXPORT_ENCRYPTION_KEY: "Set Encryption Key",
  DATA_EXPORT_ENCRYPTION_KEY_FIELD_TITLE: "Enter a key to unlock the data export file during download.",
  DATA_EXPORT_ENCRYPTION_KEY_NOTE: "Keep the encryption key safe, as it will be needed to open the zip file sent to you.",
  DATA_EXPORT_SCHEDULED_EXPORT_STATUS_DONE: "Done",
  REQUEST_REMOVED_SUCCESSFULLY: "Request removed successfully.",
  DATA_EXPORT_SCHEDULED_EXPORT_REQUEST_SCHEDULE_NEW_REQUEST_FORM_RADIO_BUTTON_GROUP_DESCRIPTION: "Select Export Type",
  DATA_EXPORT_SCHEDULED_EXPORT_REQUEST_SCHEDULE_NEW_REQUEST_FORM_DESCRIPTION: "Please fill out the form below to configure a new request.",
  DATA_EXPORT_SCHEDULED_EXPORT_ALL_FIELDS_EXPORTED_IN_JSON: "All fields are exported in JSON.",
  DATA_EXPORT_SCHEDULED_FREQUENCY_FIELD_DESCRIPTION_ON_HOVER: "Select whether you’d like to generate daily, weekly, or monthly reports.",
  DATA_EXPORT_SCHEDULED_EXPORT_SCHEDULED_RUNTIME: "Scheduled Runtime",
  DATA_EXPORT_SCHEDULED_EXPORT_SCHEDULED_RUNTIME_FIELD_DESCRIPTION_ON_HOVER: "Select the time you would like to generate a report in UTC time zone.",
  DATA_EXPORT_SCHEDULED_EXPORT_SCHEDULED_RUNTIME_FIELD_ERROR_MESSAGE: "Daily runtime must be a value between 1 and 24.",
  DATA_EXPORT_SCHEDULED_EXPORT_DAY_FOR_WEEKLY_EXPORT_FIELD_DESCRIPTION_ON_HOVER: "For weekly requests, select the day of the week (e.g., Monday or Tuesday) to generate the report.",
  DATA_EXPORT_SCHEDULED_EXPORT_MONTHLY_DATE_FIELD_LABEL: "Scheduled Monthly Date",
  DATA_EXPORT_SCHEDULED_EXPORT_WEEKLY_DAY: "Scheduled Weekly Day",
  DATA_EXPORT_SCHEDULED_EXPORT_MONTHLY_DATE_FIELD_DESCRIPTION_ON_HOVER: "For monthly requests, select the date each month you would like to generate the report.",
  DATA_EXPORT_SCHEDULED_EXPORT_MONTHLY_DATE_FIELD_ERROR_MESSAGE: "Monthly date must be a value between 1 and 31.",
  DATA_EXPORT_SCHEDULED_EXPORT_REQUEST_ADDED_SUCCESSFULLY: "Request added successfully.",
  DATA_EXPORT_SUCCESS_MESSAGE_VIEW_EXPORT: "to view your request.",
  DOES_NOT_HAVE_VALID_SCHEMA: "does not have a valid schema.",
  NOT_APPLICABLE_EXTENDED: "Not Applicable",
  NO_DATA_FOUND: "No data found.",
  ERROR_MESSAGE_START_DATE_REQUIRED: "Start Date is required.",
  LABEL_SELECT_START_DATE: "Select Start Date",
  PLACEHOLDER_END_DATE: "End Date",
  ERROR_MESSAGE_END_DATE_REQUIRED: "End Date is required.",
  LABEL_SELECT_END_DATE: "Select End Date",
  DATA_EXPORT_ON_DEMAND_EXPORT_INVALID_DATE_RANGE: "Invalid date range. The start date cannot be later than the end date.",
  SETTINGS: "Settings",
  REGISTRATION_FORMS: "Registration Forms",
  LOGIN: "Log In",
  SIGNUP: "Sign Up",
  REGISTRATION: "Registration",
  FORGOT_PASSWORD: "Forgot Password",
  DEPLOYMEMNT_JSWIDGETS_TAB_SETTINGS_HEADER:
    "You can enable client-side JavaScript options to be implemented on your web application. However, you can overwrite these settings through the JavaScript library's options.",

  SELECT_GOOGLE_CAPTCHA: "Select Google reCAPTCHA",
  ASK_REQUIRE_FIELD_ON_TRADITIONAL_LOGIN: "Ask for Required Fields on Traditional Login",
  ASK_REQUIRE_FIELD_ON_TRADITIONAL_LOGIN_INFO: "When enabled, users must fill in the required fields added to the existing data schema (after registration) during traditional login.",
  IS_LOGOUT_ON_EMAIL_VERIFICATION: "Auto Logout on Email Verification",
  IS_LOGOUT_ON_EMAIL_VERIFICATION_INFO: "When enabled, the user is automatically logged out of the session upon email verification.",
  IS_USER_NAME_LOGIN: "Is Username Login",
  IS_USER_NAME_LOGIN_INFO: "Enable Username Login",
  IS_USER_NAME_LOGIN_INFO_NEXT:
    "This is automatically enabled by adding the Username field to the data schema of the registration form. When enabled, the user can log in with a username and password.",
  GOOGLE_RECAPTCHA: "Google reCAPTCHA",
  GOOGLE_RECAPTCHA_IS_REQUIRED: "Google reCAPTCHA is required.",
  GOOGLE_RECAPTCHA_IFO: "Select Google reCAPTCHA",
  V2_RECAPTCHA: "V2 reCAPTCHA",
  ENABLE_V2_RECAPTCHA: "Enable V2 reCAPTCHA",
  INVISIBLE_RECAPTCHA: "Invisible reCAPTCHA",
  ENABLE_INVISIBLE_RECAPTCHA: "Enable Invisible reCAPTCHA",
  ASK_PASSWORD_ON_SOCIAL_LOGIN: "Ask for Password on Social Sign up",
  ASK_EMAILID_FOR_UNVERIFIED_USER_LOGIN: "Ask for Email address for Unverified User Login",
  ASK_EMAILID_FOR_UNVERIFIED_USER_LOGIN_INFO: "When enabled, unverified users must enter their email address to log in.",
  ASK_OPTIONAL_FIELDS_ON_SOCIAL_SIGNUP: "Ask for Optional Fields on Social Sign up",
  ASK_OPTIONAL_FIELDS_ON_SOCIAL_SIGNUP_INFO: "When enabled, users must fill in optional registration fields when signing up with a social account.",
  ENABLE_AUTOMATIC_LOGIN_AFTER_EMAIL_VERIFICATION: "Enable Auto Login Upon Email Verification",
  ENABLE_DIRECT_LOGIN_AFTER_SUCCESSFUL_EMAIL_VERIFICATION: "Enable direct login after successful email verification",
  SAVE_OPTIONS: "Save Options",
  SETTING_HAVE_BEEN_SAVED_SUCCESSFULLY: "Settings saved successfully.",
  SETTING_COULD_NOT_SAVED_SUCCESSFULLY: "Settings could not be saved successfully.",
  ADVANCE_OPTIONS: "Advanced Options",
  FEATURE_RESTRICT: "Permission to update these settings is not available with your current plan. Please contact LoginRadius Support for more information.",
  JSWIDGET_REGISTRATION_FORMS_HEADER: "From here, you can select enabled fields and generate registration form schemas to create different schemas for multiple site page use cases.",
  MESSAGE_SHOW_AFTER_LOGOUT_CHECK_EMAIL_VERIFICATION: "This option will be disabled because you’ve selected Logout on Email Verification.",
  MESSAGE_SHOW_AFTER_LOGIN_CHECK_EMAIL_VERIFICATION: "This option will be disabled because you’ve selected Automatic Login After Email Verification.",
  EXPORT_LOG_TAB_DESCRIPTION: "This page contains all logs for export requests and their download links.",
  LINK_EXPIRED: "Link Expired",
  EXPORT_FAILED: "Export Failed",
  EXPORT_SUCCESSFUL: "Export Successful",
  DOWNLOAD: "Download",
  CLICK_TO_DOWNLOAD_EXPORT_LOG: "Click to download export logs",
  NO_ACTIVE_EXPORT_LOGS: "You currently have no active export logs.",
  UPDATE_SCHEMA: "Update Schema",
  FIELD_NAME_SCHEMA: "Field Name",
  SMS_TEMPLATE_AUTH: "Enter SMS Template name for Multi-Factor Authentication",
  ENTER_SMS_TEMPLATE: "Enter SMS Template name",
  UNSAVED_CHANGES_TITLE: "Unsaved Changes",
  UNSAVED_CHANGES_DESCRIPTION: "You have unsaved changes. Are you sure you want to leave?",
  SAVE_CHANGES: "Save changes",
  DISCARD_AND_LEAVE: "Discard",
  SAVE_AND_CONTINUE: "Save and continue",
  SAVE_AND_GO_BACK: "Save and go back",
  STAY: "Stay",
  BUTTON_DISCARD: "Discard Changes",
  ENTER_FIELD_NAME: "Enter Field Name",
  OPTIONS: "Options",
  FIELD_TYPE: "Field Type",
  FIELD_ID: "Field ID",
  GENERATE_SCHEMA: "Generate Schema",
  EMAIL_ADDRESS: "Email Address",
  ENTER_YOUR_EMAIL_ID: "Enter your email address",
  PASSWORD: "Password",
  ENTER_YOUR_PASSWORD: "Enter your password",
  ENTER_YOUR_PASSWORD_AGAIN: "Enter your password again",
  REMEMBER_ME: "Remember Me",
  SURNAME: "Surname",
  PREFIX: "Prefix",
  SUFFIX: "Suffix",
  GENDER: "Gender",
  BIRTH_DATE: "Birth Date",
  STATE: "State",
  PHONE_ID: "Phone ID",
  NICKNAME: "Nickname",
  SECOND_NAME: "Middle Name",
  THUMBNAIL_IMG_URL: "URL of Thumbnail Image",
  IMAGE_URL: "URL of Image",
  HOME_TOWN: "Hometown",
  INDUSTRY: "Industry",
  ON: "On",
  TIMEZONE: "Timezone",
  MAIN_ADDRESS: "Main Address",
  LOCAL_CITY: "Local City",
  LOCAL_COUNTRY: "Local Country",
  CITY_PROFILE: "City Profile",
  RELATIONSHIP_STATUS: "Relationship Status",
  RELIGION: "Religion",
  POLICY: "Policy",
  FIRST_NAME: "First Name",
  MIDDLE_NAME: "Middle Name",
  LAST_NAME: "Last Name",
  USERNAME: "Username",
  COUNTRY: "Country",
  CITY: "City",
  COMPANY: "Company",
  FIELD_IS_REQUIRED: "The field is required.",
  FIELD_IS_MUST_CONTAIN_VALID_EMAIL: "The field must contain a valid email address.",
  FIELD_MUST_ATLEAST_SIX_CHR_LONG: "The field must be at least six characters long.",
  DOES_NOT_MATCH: "Does not match",
  USERNAME_PASSWORD_IS_WRONG: "The username or password is incorrect.",
  USERNAME_PASSWORD_IS_WRONG_PLEASE_USE_CORRECT_COMBINATION: "The username or password is incorrect. Please use the correct combination.",
  API_KEY_IS_NOT_VALID: "The API key is invalid.",
  USER_DOES_NOT_EXISTS: "The user does not exist.",
  USER_ID_N_PASSWORD_INVALID: "The user ID or password is invalid.",
  EMAIL_IS_NOT_VERIFIED: "The email is not verified.",
  PHONE_ID_NOT_VERIFIED: "The phone ID is not verified.",
  EMAIL_VERIFICATION_ALREADY_DONE: "The email verification link has already been used.",
  EMAIL_FOR_RESET_PASSWORD: "We’ll email you instructions for resetting your password.",
  OR_LOGIN_WITH_EMAIL: "Or you can log in with an email",
  OR_SIGNUP_WITH_EMAIL: "Or you can sign up with an email",
  LOGIN_WITH: "Log in with",
  SIGNUP_WITH: "Sign up with",
  VISIT_EMAIL_CLICK_LINK: "Please go to your email address and click the link.",
  SIGNUP_SUCCESS: "You have signed up successfully.",
  FOLLOW_STEPS_TO_CONFIGURE: "Follow these steps to configure the widget.",
  ADD_THE_CUSTOMER_REGISTRATION_JS_IN_HEADER: "Add the Customer Registration JS to the header section.",
  COPY_PASTE_BEFORE_HEAD_SECTION: "Copy the code below and paste it before the </head> tag. If you have already added that code, skip this step.",
  COPY_PASTE_BEFORE_HEAD_SECTION_1: "Copy the code below and paste it before the </head> tag.",
  COPY_PASTE_AFTER_HEAD_SECTION: "Copy the code below and paste it after the <body> tag. Place it where you want the widget to display on your webpage.",
  LANGUAGE: "Language",
  LOGO_URL: "Logo URL",
  LOGO_BACKGROUND_COLOR_VALUE: "Logo Background Color Value",
  SELECT_THE_BODY_FONT: "Select the Body Font",
  BODY_BACKGROUND_COLOR: "Body Background Color",
  TAB_LOGIN_IN: "Tab Name (Login)",
  TAB_SIGN_UP: "Tab Name (Sign Up)",
  TAB_FORGOT_PASS: "Tab Name (Forgot Password)",
  BREAKER_TEXT: "Breaker Text",
  SOCIAL_BLOCK_LABEL: "Social Block Label",
  SOCIAL_BUTTON_STYLING: "Social Button Styling",
  BACKGROUND: "Background",
  COLOR: "Color",
  SELF_HOSTED_PAGE_HEADING:
    "You can customize the UI and UX elements as per your requirements using CSS and HTML for a set of registration, authentication, and related webpages, such as forgot password and profile.",
  IDENTITY_EXPERIENCE_SELF_HOSTED_PAGE: "Identity Experience Framework (Self-Hosted)",
  VIEW_CODE: "View Code",
  VIEW_INTERFACE: "View Interface",
  REFRESH_PREVIEW: "Refresh Changes",
  CHOOSE_OPTIONS: "Choose Your Options",
  VIEW_VAILDATION_RULES: "View Validation Rules",
  TOOLTIP_VALIDATION_FIELD: "Specify any validations you would like LoginRadius to perform for this value. Please add the regular expression (RegEx) for validation rules.",
  CLICK_HERE_FOR_MORE_DETAIL: "Click here for more details.",
  LOGIN_ACTION_HEADER:
    "Follow these instructions to implement the LoginRadius solution using our standard JavaScript interfaces. This section allows you to quickly prototype the interface scripts and deploy the JavaScript code on your client-side application. It includes a JavaScript interface for customer login.",
  REGISTRATION_ACTION_HEADER: "This section includes a JavaScript interface for customer registration and incorporates the desired registration fields.",
  FORGOT_PASSWORD_ACTION_HEADER: "This section includes a JavaScript interface for when customers forget their password and requests access.",
  RESET_PASSWORD_ACTION_HEADER:
    "After a customer goes through the forgot password process, they are prompted to reset their password. This section includes a JavaScript interface for resetting a customer’s password.",
  VERIFY_EMAIL_ACTION_HEADER:
    "After a customer registers, they are prompted to verify their email (if email verification is enabled). This section includes a JavaScript interface for email verification.",
  CHNAGE_PASSWORD_ACTION_HEADER:
    "You may have chosen settings that periodically prompt customers to change their password, or customers may choose to change it themselves. This section includes a JavaScript interface for changing a customer’s password.",
  SOCIAL_LOGIN_ACTION_HEADER: "This section includes a JavaScript interface for when a customer chooses to log in with their social account.",
  LINK_ACCOUNT_ACTION_HEADER: "This section includes a JavaScript interface for when a customer chooses to link accounts.",
  UNLINK_ACCOUNT_ACTION_HEADER: "This section includes a JavaScript interface for when a customer chooses to unlink accounts.",
  PROFILE_EDITOR_ACTION_HEADER: "This section includes a JavaScript interface for when a customer edits their profile.",
  TWO_FACTOR_AUTH_ACTION_HEADER:
    "You might have configured your settings to allow Multi-Factor Authentication. This section includes a JavaScript interface for the Multi-Factor Authentication process.",
  ADD_EMAIL_ACTION_HEADER: "This section includes a JavaScript interface for when a customer chooses to add an email.",
  REMOVE_EMAIL_ACTION_HEADER: "This section includes a JavaScript interface for when a customer chooses to remove an email.",
  RESEND_EMAIL_ACTION_HEADER:
    "If a user does not verify their email before the access token expires, they must request another email verification. This section includes a JavaScript interface for resending an email verification.",
  CHANGE_USERNAME_ACTION_HEADER: "This section includes a JavaScript interface for when a user chooses to change their username.",
  UPDATE_PHONE_NUMBER_ACTION_HEADER: "This section includes a JavaScript interface for when a user needs to update their phone number.",
  AUTO_LOGIN_ACTION_HEADER: "Users can set up a login flow that allows users to log in without a password.",
  PAGE_TITLE_CUSTOMER_ANALYTICS: "LoginRadius User Dashboard",
  CUSTOMER_ANAYLTICS_DESCRIPTION: "LoginRadius User Analytics provides a comprehensive view of your users's profiles and activities.",
  PLATFORM_ANAYLTICS_DESCRIPTION: "LoginRadius Platform Analytics provides a comprehensive view of your API activity and performance.",
  MSG_CUSTOMER_ANALYTICS_UNABLE_TO_GET_CUSTOMER_PROFILES: "Unable to retrieve user profiles.",
  MSG_CUSTOMER_ANALYTICS_TOTAL_REGISTERED_PROFILES: "Total Registered User Profiles",
  MSG_CUSTOMER_ANALYTICS_NEW_CUSTOMER_PROFILES: "New User Profiles in the Last 30 Days",
  MSG_CUSTOMER_ANALYTICS_MOST_POPULAR_ID: "The Most Popular ID Used on This Site",
  MSG_CUSTOMER_ANALYTICS_MANAGING_THIS_SITE: "Team Members Managing This Site",
  MSG_CUSTOMER_ANALYTICS_TEAM_MEMBERS: "Team Members",
  MSG_CUSTOMER_ANALYTICS_CUSTOMER_PROFILES: "User Profiles",
  MSG_CUSTOMER_ANALYTICS_MANAGE_YOUR_CUSTOMER: "Manage Your Users",
  MSG_CUSTOMER_ANALYTICS_LOGIN_ACTIVITY: "Login Activity",
  MSG_CUSTOMER_ANALYTICS_NO_OF_LOGINS_PER_DAY: "Number of Logins Per Day",
  SCHEMA_GENERATED_FOR_ACTIVE_FIELD: "Schema generated for active fields.",
  SUPPORT_VIEW_EXISTING_TICKETS: "View all of your previous support tickets and their statuses here.",
  SUPPORT_NO_EXISTING_TICKETS: "You have no support tickets.",
  SUPPORT_TICKET_SEE_THE_TICKET: "See the Ticket",
  SUPPORT_TICKET_SUBJECT: "Enable ",
  SUPPORT_TICKET_DESCRIPTION: " is disabled. Please upgrade to enable this feature.",
  REGISTRATION_FORM_SCHEMA: "Registration Form Schema",
  PASSWORD_RULES: "Password Validations",
  PASSWORD_EXPIRATION_HEADER: "Configure a time-based password expiry policy to control how often your customers must change their passwords.",
  PASSWORD_EXPIRATION_SECTION_HEADER: "Set the password expiration period and users must reset their passwords after it expires.",
  PASSWORD_HISTORY_HEADER: "Set the number of previous passwords that cannot be reused to prevent repetition and strengthen password security.",
  PASSWORD_HISTORY_SECTION_HEADER: "Prevent users from reusing previous passwords.",
  PASSWORD_COMPLEXITY_HEADER: "Configure password complexity criteria.",
  PASSWORD_COMPLEXITY_TITLE: "Password Complexity and Validations",
  PLUS_ADD: "Add",
  ADD_ROW: "Add Row",
  ADD_STORE: "Add Store",
  UNSUBSCRIBE: "Unsubscribe",
  WEB_HOOKS_TAB_DESCRIPTION:
    "Webhooks allow you to set up integrations that subscribe to certain events in real time. Webhooks operate on a subscribe-and-notify model: subscribe your hook and receive a notification.",
  IDENTITY_API_SETTINGS_TAB_DESCRIPTION: "This page displays the threshold for the number of calls you can make in a specific period using the Identity API.",
  IDENTITY_API: "Identity API",
  CONTACT_SUPPORT_FOR_INCREASING: "Contact Support to Increase This",
  WEB_HOOK_NAME: "Webhook Name",
  WEB_HOOK_EVENT: "Webhook Event",
  INVALID_WEB_HOOK_EXPRESSION: "Webhook names can only contain letters, numbers, underscores, hyphens, and spaces.",
  SUBSCRIBE_URL: "Subscribe URL",
  URL_UNSUBSCRIBED_SUCCESSFULLY: "URL unsubscribed successfully.",
  SUBSCRIBED_URL_ADDED_SUCCESSFULLY: "Subscribed URL added successfully.",
  ARE_YOU_SURE_UNSUBSCRIBE: "Are you sure you want to unsubscribe?",
  PLEASE_FILL_OUT_FORM_BELOW: "Please fill out the form below to subscribe to a new URL.",
  NO_CURRENT_WEB_HOOK_REQUESTS: "You currently have no active webhook requests.",
  EVENT_IS_REQUIRED: "Event is required.",
  SUBSCRIBE_URL_IS_REQUIRED: "Subscribe URL is required.",
  TOKEN_LIFE_TIME_TOOLTIP: "Configurable from 1 to 129,600 minutes (90 days). Please contact support for a longer token lifetime.",
  SESSION_MANAGEMENT_HEADER: "Configure and manage default policies for user sessions.",
  TOKEN_LIFE_TIME_HEADER: "Configure the lifetime of Access and Refresh tokens for your application.",
  ACCESS_TOKEN_HEADING: "Access Token",
  TOKEN_LIFETIME: "Token Lifetime",
  TOKEN_LIFE_TIME_DESCRIPTION:
    "Configure the access token lifetime based on your use case. Upon token expiry, the customer must log in again. It can be set from 1 to 129,600 minutes (90 days). Contact support to set a longer token expiry.",
  NOTE_TEXT_FOR_ACCESS_TOKEN: "If the Access Token lifetime is greater than or equal to the Refresh Token lifetime, the Refresh Token lifetime will be set to 1.5 times the Access Token lifetime.",
  ACCESS_LIFETIME_INPUT_HEADING: "Access Token Lifetime",
  ACCESS_LIFETIME_TOKEN_ERROR_NO_VALUE: "Access token lifetime must be numeric, without spaces, and between 1 and 129,600 minutes.",
  ACCESS_LIFETIME_TOKEN_ERROR_LIMIT: "Value must be between 1 and 129,600 minutes.",
  ACCESS_LIFETIME_TOKEN_ERROR_LIMIT_EXCEED: "You cannot exceed 129,600 minutes (90 days). Please contact support for a longer token lifetime.",
  ACCESS_LIFETIME_TOKEN_ERROR_INVALID: "Token lifetime is invalid.",
  REFRESH_ACCESS_TOKEN_HEADING: "Refresh Token",
  REFRESH_TOKEN_LIFE_TIME_DESCRIPTION:
    "Configure the refresh token lifetime to obtain additional access tokens based on your use case. The default lifetime is 60 days (86,400 minutes) and can be extended to 365 days (525,600 minutes). Contact support to set a longer token expiry.",
  REFRESH_TOKEN_LIFETIME_INPUT_HEADING: "Refresh Token Lifetime",
  REFRESH_TOKEN_LIFETIME_TOKEN_ERROR_NO_VALUE: "Refresh token lifetime must be numeric, without spaces, and must not exceed 525,600 minutes.",
  REFRESH_TOKEN_LIFETIME_TOKEN_ERROR_LIMIT: "Refresh token lifetime must be greater than the access token lifetime.",
  REFRESH_TOKEN_LIFETIME_TOKEN_ERROR_LIMIT_EXCEED: "You cannot exceed 525,600 minutes. Please contact support for a longer token lifetime.",
  REFRESH_TOKEN_LIFETIME_TOKEN_ERROR_INVALID: "Refresh Access Token lifetime is invalid.",
  FORCE_LOGOUT_HEADER: "Enabling the force logout option allows you to expire all active sessions of a customer when they reset or change their password.",
  FORCE_LOGOUT: "Force Logout",
  ENABLE_FORCE_LOGOUT_TEXT: "Enable force logout (all active sessions of a user will expire after a password change or reset).",
  REMEMBER_ME_HEADER:
    "You can further customize your login form by configuring the Remember Me option. Enabling this option will display a 'Remember Me' checkbox on your login prompts using the LoginRadius JavaScript Interfaces. If selected, the customer will receive a 'Remember Me' token that allows them to remain logged in even after closing the browser until the access token expires.",
  ENABLE_REMEMBER_ME: "Remember me",
  IS_REQUIRED: "is required.",
  GOOGLE_CAPTCHA_TAB_NAME: "Google reCAPTCHA2 Settings",
  QQ_TENCENT_CAPTCHA_TAB_NAME: "QQ Tencent CAPTCHA Settings",
  CAPTCHA: "CAPTCHA",
  CAPTCHA_SETTINGS_DESCRIPTION: "Configure the CAPTCHA settings for user registration.",
  CAPTCHA_SETTINGS: "CAPTCHA Settings",
  PUBLIC_KEY: "Site Key",
  PRIVATE_KEY: "Secret Key",
  THRESHOLD: "Risk Threshold",
  THRESHOLD_NOTE: "To apply the risk threshold, you must have hCaptcha’s Enterprise Plan with Passive Mode.",
  DISABLE_CAPTCHA_POPUP_MESSAGE: "Are you sure you want to disable CAPTCHA?",
  GOOGLE_CAPTCHA_PUBLIC_KEY_PLACEHOLDER: "Enter your Google reCAPTCHA2 public key",
  GOOGLE_CAPTCHA_PRIVATE_KEY_PLACEHOLDER: "Enter your Google reCAPTCHA2 private key",
  TENCENT_CAPTCHA_PUBLIC_KEY_PLACEHOLDER: "Enter your QQ Tencent CAPTCHA public key",
  TENCENT_CAPTCHA_PRIVATE_KEY_PLACEHOLDER: "Enter your QQ Tencent CAPTCHA private key",
  CAPTCHA_INSTRUCTION: "How do I set up ",
  CAPTCHA_TYPE: "CAPTCHA Type",
  CAPTCHA_THEME: "CAPTCHA Theme",
  CAPTCHA_CHECKBOX_AND_CHALLENGE: "CAPTCHA Checkbox and Challenge",
  CAPTCHA_CHALLENGE: "CAPTCHA Challenge",
  RECAPTCHA_V2_THEME: `"I'm not a robot" Checkbox`,
  INVISIBLE_RECAPTCHA_V2_THEME: "Invisible reCAPTCHA Badge",
  LIGHT: "Light",
  LIGHT_TOOLTIP: "Users must select the CAPTCHA checkbox and then complete the CAPTCHA challenge.",
  ROBOT_CAPTCHA: "Users will be presented with an 'I’m not a robot' checkbox and sometimes a challenge.",
  INVISIBLE_CAPTCHA: "Invisible CAPTCHA operates in the background and challenges users only when a risk is detected.",
  DARK: "Dark",
  DARK_TOOLTIP: "Users must complete the presented CAPTCHA challenge.",
  RISK_THRESHOLD_VALIDATION_ERROR: "Risk threshold value must be between 0.0 and 1.0.",
  THRESHOLD_TOOLTIP: "Enter a value from 0.0 (no risk) to 1.0 (confirmed threat). CAPTCHA will be considered failed upon reaching the entered risk score.",
  NOTE_TEXT_FOR_HCAPTCHA: "hCaptcha’s Enterprise Plan with passive mode is required to apply the risk threshold.",
  QQ_CAPTCHA_INSTRUCTION: "How do I set up QQ Tencent CAPTCHA?",
  CAPTCHA_SUCCESS_MESSAGE: "Settings have been saved.",
  QQ_CAPTCHA_SUCCESS_MESSAGE: "QQ Tencent CAPTCHA integration settings saved successfully.",
  CAPTCHA_DISABLED: "CAPTCHA has been disabled.",
  ACCESS_RESTRICTION_VALIDATION_ERROR: "The domain/email field is either invalid or blank. Please check it.",
  EMAIL_OR_DOMAIN_REQUIRED: "Email or domain is required.",
  IP_ACCESS_HEADER: "Control access to LoginRadius APIs by allowing or denying IP addresses.",
  WHITELIST: "Whitelist",
  BLACKLIST: "Blacklist",
  NONE_HEADER: "Disable access restrictions so that any domain can register or log in to your tenant",
  BLACKLIST_HEADER: "Deny registration or access requests from these domain names and email addresses. Multiple mixed values are allowed — e.g., example.com and user@example.org.",
  WHITELIST_HEADER: "Always allow registration or access requests from these domain names and email addresses. Multiple mixed values are permitted — e.g., example.com and user@example.org.",
  NONE: "None",
  DOMAIN_PLACEHOLDER: "Enter a domain or email",
  SELECT_CAPTCHA: "Select CAPTCHA",
  ACCESS_RESTRICTION_DISABLED_MESSAGE: "Access restrictions have been successfully disabled.",
  ACCESS_RESTRICTION_SUCCESS_MESSAGE: "Domains/emails have been updated.",
  CONFIGURATION: "Configuration",
  TUTORIAL: "Tutorial",
  BOT_PROTECTIONS_HEADER: "Mitigate automated bot attacks with CAPTCHA, reCAPTCHA, Tencent CAPTCHA, and hCAPTCHA.",
  BOT_PROTECTIONS_DESCRIPTION: "Configure and manage CAPTCHA settings",
  VALUE_MUST_BE_LESS_THEN_OR_EQUAL_TO_100: "Value must be less than or equal to 100.",
  VALUE_MUST_BE_LESS_THEN_OR_EQUAL_TO_1200: "Value must be less than or equal to 1,200.",
  VALUE_MUST_BE_LESS_THEN_OR_EQUAL_TO_36500: "Value must be less than or equal to 36,500.",
  FIELD_NAME_IS_REQUIRED: "Field name is required.",
  UNIT_OF_TIME: "Unit of Time",
  PASSWORD_EXPIRATION_TOOL_TIP: "e.g., if you choose '6' and 'Month,' customers will be prompted to reset their password every six months.",
  FOLLWING_ARE_THE_PASSWORD_RULES_OF_YOUR_LOGINRADIUS_SITE: "The following are the current password validations for your LoginRadius tenant.",
  NUMBER_OF_PAST_PASSWORD_USER_IS_NOT_ALLOWED_TO_USE: "Number of Past Passwords Users Are Not Allowed to Reuse",
  PASSWORD_HISTORY_TOOL_TIP: "The number of old passwords a user cannot reuse when submitting a new password for a reset.",
  TOKEN_EXPIRE_TIME: "Access Token Expiration:",
  MINUTES: "Minutes",
  REMEMBER_ME_EXPIRY_TOKEN: "Remember Me Token Expiry Time",
  VALUE_MUST_BE_BETWEEN_1_TO_100: "Value must be between 1 and 100.",
  HERE: "here",
  TO_UPDATE_THE_PASSWORD_COMPLEXITY_CLICK: "Update the password validations in the Forms section.",
  TO_GO_TO_STANDARD_LOGIN: "to go to Standard Login",
  HOW_OFTEN_DO_YOU_WANT_CUSTOMER_TO_RESET_THE_PASSWORD: "How often do you want customers to reset their password?",
  THE_NUMBER_OF_DURATION_IN_A_GIVEN_UNIT_OF_TIME: "The duration in a given unit of time",
  PASSWORD_SETTING_SAVED_SUCCESSFULLY: "Password settings saved successfully.",
  PASSWORD_EXPIRATION_SETTING_SAVED_SUCCESSFULLY: "Password expiration settings saved successfully.",
  DATA_GOVERNANCE_DATA_CENTER_TAB_DESCRIPTION:
    "This section displays all the data storage locations supported by LoginRadius and the specific location where your customers' data is stored. Regional regulations are considered when choosing data storage locations.",
  DATA_GOVERNANCE_DATA_CENTER_CURRENT_DATA_LOCATION: "Your current data storage location is:",
  STORAGE_LOCATION_UPDATE_SUPPORT_TICKET_TITLE: "Data Storage Location Update",
  ACCESS_TOKEN_EXPIRATION_TIME: "Access Token Expiration Time Update",
  ACCESS_TOKEN_TICKET_DESC1: "The current access token expiration time is",
  ACCESS_TOKEN_TICKET_DESC2: "minutes. Please update this to:",
  STORAGE_LOCATION_UPDATE_SUPPORT_TICKET_DESCRIPTION: "The current data storage location is DATA_STORAGE_LOCATION_PLACEHOLDER. Please update this to:",
  STORAGE_LOCATION_UPDATE_SUPPORT_TICKET_DESCRIPTION_PLACEHOLDER: "DATA_STORAGE_LOCATION_PLACEHOLDER",
  AMERICAS: "Americas",
  ASIA_PACIFIC: "Asia Pacific",
  ENCRYPTION_IN_TRANSIT_DESCRIPTION: "This section displays the high-level flow of end-to-end encryption in transit with the LoginRadius API. It also shows HTTPS details with supported ciphers.",
  SEE_OUR_SSL_CERTIFICATE_REPORT: "See our SSL Certificate Report",
  ENCRYPTION_AT_TRANSIT: "Encryption in Transit:",
  SIGNATURE_ALGORITHM: "Signature Algorithm - SHA256 + RSA (Excellent)",
  PROTOCOL_SUPPORT: "Protocol Support - TLS 1.2",
  ENCRYPTION_AT_REST: "Encryption at Rest:",
  HTTPS_DETAILS: "HTTPS Details:",
  SSL_CIPHERS_SUPPORTED: "SSL Ciphers Supported:",
  ENCRYPTION_AT_REST_DESCRIPTION:
    "This section displays the high-level setup of the LoginRadius Encryption at Rest feature. Encryption at Rest adds additional security to your LoginRadius Cloud Storage by encrypting data when it is stored.",
  REQUEST_CHANGE: "Request Change",
  ENCRYPTION_AT_REST_SUPPORT_TICKET_SUBJECT: "Enable Encryption at Rest",
  ENCRYPTION_AT_REST_SUPPORT_TICKET_DESCRIPTION: "Encryption at Rest is disabled. Please upgrade to enable this feature.",
  MULTI_FACTOR_AUTH_SETTING_HEADER: "Enable MFA to request additional authentication from users after successful primary authentication.",
  MULTI_FACTOR_AUTH_FACTORS_HEADER: "Enable at least one factor.",
  EMAIL_PASSCODE_DESCRIPTION: "Deliver MFA OTPs to users’ email addresses. You can customize the template used to send email OTPs.",
  SMS_PASSCODE_DESCRIPTION: "Deliver MFA OTPs to users’ phone numbers. You can customize the template used to send SMS OTPs.",
  MULTI_FACTOR_AUTH: "Multi-Factor Authentication",
  SELECT_FLOW: "Select Flow",
  MULTIFACTOR_OPTIONAL_TEXT: "Multi-Factor Authentication is optional for all end users—they can enable or disable it during login.",
  MULTIFACTOR_MANDATORY_TEXT: "Multi-Factor Authentication is mandatory for all end users—they must authenticate twice before logging in.",
  GOOGLE_AUTHENTICATOR_CARD_DESCRIPTION:
    "Configure a Time-based OTP (TOTP) mechanism for Multi-Factor Authentication. Your customers can use LoginRadius Authenticator, Google Authenticator, Microsoft Authenticator, or other well-known authenticator apps and password managers to set up TOTP generation on their end.",
  GOOGLE_AUTHENTICATOR_HEADER: "Perform MFA with secure TOTPs. Allow users to set up TOTP generation for MFA with any compatible app, such as Google Authenticator or LoginRadius Authenticator.",
  ENABLE_GOOGLE_AUTHENTICATOR_APP: "Enable Authenticator App",
  GOOGLE_AUTHENTICATOR_APPS_HEADER: "MFA Authenticator Apps Settings",
  GOOGLE_AUTHENTICATOR_TEXT:
    "Enable this option to allow your customers to configure TOTP generation on their preferred authenticator app. The following options let you configure how the TOTP setup QR code is displayed to your customers.",
  AUTHENTICATOR_IMAGE_TEXT: "Configure from a range of authenticators",
  DISABLE_AUTHENTICATOR_POPUP: "Are you sure you want to disable Authenticator Apps?",
  CONFIGURE_THE_SETTINGS: "Configure the Settings",
  CONFIGURE_THE_SETTINGS_TEXT: "Configure the settings in this section to use your Google Authenticator account for your site’s multi-step authentication.",
  PLEASE_ENTER_MEANINGFUL_DIMENSION_TO_MAINTAIN_ASPECT_RATIO_OF_QRCODE: "Please enter meaningful dimensions to maintain the aspect ratio of the QR code.",
  QR_CODE_HEIGHT: "QR Code Height",
  ENTER_THE_QR_CODE_HEIGHT_HERE: "Enter the QR code height here",
  QR_CODE_WIDTH: "QR Code Width",
  ENTER_THE_QR_CODE_WIDTH_HERE: "Enter the QR code width here",
  ACCOUNT_SECRET_KEY: "Account Secret Key",
  ISSUER_ID: "Issuer ID",
  ENTER_THE_ISSUER_ID_HERE: "Enter the issuer ID here",
  GOOGLE_MULTI_FACTOR_CONFIGURATION_SAVED_SUCCESSFULLY: "Multi-factor configurations saved successfully.",
  BRUTE_FORCE_LOCKOUT_SUCCESS_MESSAGE: "Brute Force Lockout settings saved successfully.",
  LOGIN_LOCKED_TYPE_MIN_LENGTH: "must be greater than or equal to 1",
  LOGIN_LOCKED_TYPE_MAX_LENGTH: "must be less than or equal to 2,147,483,647",
  LOCKOUT_PERIOD_LABEL: "Suspend Effective Period",
  LOCKOUT_PERIOD_REQUIRED: "Suspend Effective Period is required.",
  BRUTE_FORCE_LOCKOUT_LABEL: "Brute Force Lockout Threshold",
  TAB_DESCRIPTION_SEARCH_CUSTOMERS: "Here is a list of all active users registered with your LoginRadius site. You can search and manage your users based on the provided search parameters.",
  HASHING_ALGORITHM: "Hashing Algorithm",
  HASHING_ALGORITHM_DESC: "This section displays all of the password encryption values that are stored by LoginRadius Cloud Storage for your website or mobile app",
  ENCRYPTION_TYPE: "Encryption Type",
  PER_PASSWORD_SALT: "Per Password Salt",
  PASSWORD_SALT: "Password Salt",
  SALT_ATTACH_TYPE: "Salt Attach Type",
  ALGO_PROPERTY: "Algorithm Property",
  PASSWORD_HASH_ENCODING_TYPE: "Password Hash Encoding Type",
  PASSWORD_SALT_ENCODING_TYPE: "Password Salt Encoding Type",
  EXPIRATION_FREQUENCY: "Expiration Frequency",
  EXPIRATION_FREQUENCY_RANGE: "Expiration Frequency Range",
  HASH_ALG_SUPPORT_TICKET_SUBJECT: "Hashing Algorithm Update",
  ENABLE_INTEGRATION_SUPPORT_TICKET_SUBJECT: "Request to Enable Integration",
  VALID_CUSTOMER_ID: "Customer ID is invalid.",
  NOT_APPLICABLE: "N/A",
  DEFAULT: "Default",
  UTF8: "UTF-8",
  CURR_HASH_ALG_IS: "The current hashing algorithm is",
  PLEASE_UPDATE_TO: "Please update this to:",
  SECURITY_QUESTION_HEADER:
    "Users can select your predefined security questions and set secret answers. Prompt users to answer security questions for various events, such as password reset and multi-factor authentication.",
  SECURITY_QUESTION_DOES_NOT_EXIST: "Security question settings are not configured, or the resource does not exist.",
  ADD_QUESTION: "Add Question",
  ADD_SECURITY_QUESTION: "Add Security Question",
  SECURITY_QUESTION_LABLE: "Security Question",
  UPDATE_QUESTION: "Update Question",
  ENTER_A_NEW_SECURITY_QUESTION_HERE: "Enter a new security question here",
  ENTER_A_NEW_SECURITY_QUESTION: "Enter Security Question",
  NUMBER_OF_SECURITY_QUESTION_RENDER: "Number of Security Questions (to appear)",
  SECURITY_QUESTION_LIMIT_RESET_PASSWORD: "Security Question Attempt Limit (Optional)",
  CONFIGURED_QUESTION: "Configured Questions",
  CONFIGURED_DOMAIN: "Configured Domains",
  DOMAINS: "Domains",
  SECURITY_QUESTION_REMOVED_SUCCESSFULLY: "Security question removed successfully.",
  SECURITY_QUESTION_ADDED_SUCCESSFULLY: "You have successfully added a new security question.",
  SECURITY_QUESTION_UPDATED_SUCCESSFULLY: "You have successfully updated your security questions.",
  SECURITY_QUESTION_SAVED_SUCCESSFULLY: "Security question settings saved successfully.",
  SECURITY_QUESTION_SETTINGS: "Security Question Settings",
  STANDARD_DATA_FIELDS_TAB_DESCRIPTION:
    "This section displays all the customer data fields stored by LoginRadius Cloud Storage for your website or mobile app. These fields correspond to your data configuration in Standard Login.",
  CUSTOM_DATA_FIELDS_TAB_DESCRIPTION:
    "This section displays all the custom data fields stored by LoginRadius Cloud Storage for your website or mobile app. These fields correspond to your data configurations in Standard Login.",
  CUSTOM_OBJECTS_TAB_DESCRIPTION:
    "Create, read, update, and delete any type of user data at scale through REST APIs. Store and manage custom user data such as search history, wishlists, billing data, documents, etc.",
  LIST_OF_CUSTOMER_PROFILE: "List of customer profile data points currently stored for",
  LIST_OF_CUSTOM_FIELDS: "List of custom fields currently stored for",
  FIELDS: "Fields",
  CREATE_USER_ROLES: "Create, edit, and delete user roles as necessary.",
  EDIT_USER_ROLES: "Edit a user role and associated permissions.",
  CREATE_NEW_USER_ROLE: "Create a new user role with specific access permissions.",
  CLICK_HERE_TO_CREATE_NEW_CUSTOM_FIELD: "Click here to create a new custom field",
  YOU_DO_NOT_HAVE_ANY_CUSTOM_DATA_FIELDS: "You do not have any custom data fields.",
  CUSTOM_DATA_OBJECTS_IN_YOUR_ACCOUNT: "Custom Data Objects in Your Account:",
  CONTACT_LOGINRADIUS_TO_ADD_CUSTOM_OBJECTS: "Please contact LoginRadius Support to add one or more custom objects.",
  YOU_DONT_HAVE_ANY_CUSTOM_DATA_OBJECTS: "You don’t have any custom data objects in your account.",
  NO_SCHEMA_AVAILABLE: "No schema available",
  SHOW_SCHEMA: "Show Schema",
  HIDE_SCHEMA: "Hide Schema",
  ERROR_WHILE_FETCHING_DATA: "Error while fetching data",
  DUPLICATED_DOMAINS: "Duplicate domains are not allowed.",
  DUPLICATED_IPS: "Duplicate IPs or IP ranges are not allowed.",
  LOCKOUT_PERIOD_REQUIRED_MIN_LENGTH: "Suspend Effective Period must be greater than or equal to 1.",
  BRUTE_FORCE_LOCKOUT_LABEL_PLACEHOLDER: "The number of failed login attempts before an account is locked out",
  LOCKOUT_TYPE_PLACEHOLDER: "Lockout Type: None, Suspend, CAPTCHA, Security Question, or Block",
  LOCKOUT_TYPE_DESCRIPTION:
    "Suspend temporarily blocks access, Block permanently locks the account, Captcha challenges the user to prove they're human, and Security Question prompts an identity check.",
  LOCKOUT_RULES_HEADER: "Lockout Rules",
  LOCKOUT_RULES_DESCRIPTION: "Define what happens when a user fails to log in too many times.",
  LOCKOUT_PERIOD_LABEL_DESCRIPTION: "How long an account remains suspended before the user can try again. Set this higher for stricter security, lower for a less disruptive experience.",
  BRUTE_FORCE_LOCKOUT_LABEL_DESCRIPTION: "The number of failed login attempts before an account is locked out.",
  LOCKOUT_TYPE_SUSPEND_CAPTION: "Temporarily suspends the user's account for a specified period.",
  LOCKOUT_TYPE_BLOCK_CAPTION: "Permanently blocks the user's account.",
  LOCKOUT_TYPE_CAPTCHA_CAPTION: "Prompts a CAPTCHA challenge upon subsequent login attempts.",
  LOCKOUT_TYPE_SECURITY_QUESTION_CAPTION: "Prompts a security question upon subsequent login attempts.",
  LOCKOUT_PERIOD_LABEL_PLACEHOLDER: "Set an effective time period for account suspension. By default, it is set to 900 seconds.",
  LOCKOUT_TYPE: "Lockout Type",
  BRUTE_FORCE_LOCKOUT_HEADER: "Block repeated failed login attempts to prevent brute force attacks.",
  BRUTE_FORCE_LOCKOUT_DESCRIPTION: "Select a method to lock out users and set up the login attempt limit.",
  MAXIXMUM_LIMIT_ERROR_MESSAGE: "The 'Remember Me' token expiry value cannot exceed the access token expiry time, which is",
  NO_PERMISSION: "Access Denied",
  NO_FEATURE: "Feature Not Available",
  ERR_GETTING_FEATURE_PERMISSION: "Error Retrieving Features/Permissions",
  SMS_PASSCODE_HEADER_TEXT: "You can customize the message delivered to customers via SMS for your site’s Multi-Factor Authentication by creating new templates below.",
  SMS_PASSCODE_SETTINGS: "SMS Passcode Settings",
  PIN_AUTH_DESCRIPTION: "PIN authentication can be configured for end users, allowing them to set a PIN for their account and use it during authentication or re-authentication instead of a password.",
  SMS_PASSCODE_SETTINGS_HEADER: "Configure these settings for the SMS triggered for Multi-Factor Passcode through LoginRadius.",
  REQUEST_LIMIT: "Request Limit",
  REQUEST_LIMIT_: "Request Limit",
  REQUEST_LIMIT_PLACEHOLDER: "Enter Request Limit",
  REQUEST_LIMIT_TOOLTIP:
    "The Request Limit is the number of times a customer can request a one-time passcode SMS during the request period before this feature is temporarily disabled. For example, a user can only request this SMS 5 times (Request Limit) over 120 seconds (Request Period) before the feature is disabled.",
  THE_REQUEST_LIMIT_IS_REQUIRED: "The request limit is required.",
  THE_REQUEST_LIMIT_IS_LESSTHEN: "The request limit must be less than or equal to %s.",
  REQUEST_DISABLED_PERIOD: "Request Disabled Period",
  REQUEST_DISABLED_PERIOD_PLACEHOLDER: "Enter Request Disabled Period",
  REQUEST_DISABLED_PERIOD_TOOLTIP: "The amount of time that the #settingsname# request remains disabled for the customer after they reach their request limit",
  THE_REQUEST_DISABLED_PERIOD_SECONDS_IS_REQUIRED: "The Request Disabled Period is required.",
  THE_REQUEST_DISABLED_PERIOD_SECONDS_IS_LESSTHEN: "The Request Disabled Period must be less than or equal to %s.",
  MULTI_FACTOR_OTP_VALIDITY_LIMIT_SECONDS: "Multi-Factor OTP Validity Limit (Seconds)",
  MULTI_FACTOR_OTP_VALIDITY_LIMIT_SECONDS_PLACEHOLDER: "Enter Multi-Factor OTP Limit",
  MULTI_FACTOR_OTP_VALIDITY_LIMIT_SECONDS_TOOLTIP: "OTP validity period",
  THE_MULTI_FACTOR_OTP_VALIDATION_LIMIT_SECONDS_IS_REQUIRED: "The Multi-Factor OTP validity limit is required.",
  THE_MULTI_FACTOR_OTP_VALIDATION_LIMIT_SECONDS_IS_LESSTHEN: "The Multi-Factor OTP validity limit must be less than or equal to %s.",
  TO_SETUP_TWILIO_API_SETTINGS_AND_OTP_SETTINGS_CLICK: "To set up Twilio API settings and OTP settings, click",
  SMS_CONTENT: "SMS Content",
  ADD_TEMPLATE: "Add",
  EDIT_TEMPLATE: "Edit",
  DELETE_TEMPLATE: "Delete",
  SEND_TEST_EMAIL: "Send Test Email",
  SAVE_TEMPLATE: "Save Template",
  RESET_TEMPLATE: "Reset",
  RESET_SMTP_INSTRUCTION: "Are you sure you want to reset? The SMTP sender name and email configured for individual email templates will no longer work.",
  NOTE_FOR_MULTIPLE_SMTP: "You can customize the sender name and email instead of using the global values from configured SMTP. This customization will apply only to this email template.",
  TEMPLATE_ID: "Template Name",
  TEMPLATE_ID_PLACEHOLDER: "Enter Template Name",
  MAX_PASSWORD_HISTORY: "Maximum Password History",
  TAB_DESCRIPTION_BLOCKED_CUSTOMERS: "If any users have been blocked from logging into your site(s) or app(s), they will be listed here. Use this page to unblock, delete, or manage these users.",
  USER_INFO_TAB: "User Info",
  CUSTOMER_INFORMATION: "User information",
  PROFILE_INFO_TAB: "Profile Info",
  INSIGHTS_TAB: "Insights",
  SOCIALINFO_TAB: "Social Info",
  CUSTOM_OBJ_TAB: "Custom Objects",
  LOGOUT_ALERT: "This action logs the user out of the application.",
  SIGNED_UP: "Signed Up",
  PRIMARY_IDENTITY_PROVIDER: "Primary Identity Provider",
  SIGN_UP_IP: "Sign-Up IP",
  LAST_LOGIN: "Last Login",
  LAST_LOGIN_LOCATION: "Last Login Location",
  SIGNED_UP_DATE: "Signed Up Date",
  CREATED_DATE: "Created Date",
  SIGN_UP_HOST: "Sign-Up Host",
  OS: "Operating System",
  USER_AGENT: "User Agent",
  BROWSER: "Browser / Device",
  SOURCE: "Source",
  SOURCE_ID: "Source ID",
  PASSWORD_RESET_URL: "Reset Password URL",
  MFA_DESCRIPTION: "Users will have the option to enable or disable MFA for logging in.",
  ID: "ID",
  REGISTRATION_SOURCE: "Registration Source",
  LAST_PASSWORD_CHANGED_DATE: "Last Password Reset Date",
  END_DATE_SOTT: "The end date should be greater than 1 minute from now.",
  LAST_PASSWORD_CHANGE_TOKEN: "Last Password Change Token",
  LOGIN_COUNT: "Login Count",
  FAILED_LOGIN_ATTEMPT: "Failed Login Attempts",
  IS_ACTIVE: "Is Active",
  IS_DELETED: "Is Deleted",
  IS_LOGIN_LOCKED: "Is Login Locked",
  IS_LOGIN_DIASBLED: "Is Login Disabled",
  SEC_QUES_FAILED_RESET: "Security Question Failed Reset Password Attempts",
  PASSWORD_EXP_DATE: "Password Expiration Date",
  MODIFIED_DATE: "Modified Date",
  ADD_NEW_CUSTOMERS_HEADING: "Add a New Customer",
  ADD_NEW_CUSTOMERS_DESCRIPTION:
    "Use this interface to add customers to your site. Once the mandatory fields are filled and the form is submitted, the new customer will be registered with your site. If email settings are configured for your site, you can send a verification email.",
  EMAIL_ID_FIELD: "Email address",
  INVALID_EMAIL_ID: "Invalid email address",
  PASSWORD_FIELD: "Password",
  EMAIL_TEMPLATE: "Email Template",
  SEND_VERIFICATION_EMAIL: "Send Verification Email",
  THIS_WILL_SEND_VERIFICATION_EMAIL: "This will send a verification email to the user.",
  ENTER_EMAIL_VERIFICATION_URL: "Enter Email Verification URL",
  VERIFICATION_DEFAULT: "verification-default",
  ONECLICKSIGNIN_DEFAULT: "oneclicksignin-default",
  ONETIMEPASSCODE_DEFAULT: "onetimepasscode-default",
  ONETOUCHLOGIN_DEFAULT: "onetouchlogin-default",
  SMARTLOGIN_DEFAULT: "smartlogin-default",
  PHONEID_VERIFIED: "Phone ID Verified",
  SET_PHONEID_VERIFIED: "This will set PhoneIdVerified to true for the user.",
  NO_LEADING_TRAILING_SPACES: "Password must not contain leading or trailing spaces.",
  API_DESC: "Create APIs according to your requirements by defining the name, identifier, and scope.",
  ADD_CUSTOMERS: "Add User",
  INVITE_CUSTOMER: "Invite User",
  VIEW_ORGANIZATION: "View Organization",
  IDENTITY_UPDATED: "User identity has been created successfully.",
  REQUIRED: "is required.",
  IS_SAME: "Value is the same as the old value.",
  EXISTS: "already exists with the same value.",
  CUSTOM_VALIDATION: "is required.",
  MATCHES: "Does not match the %s pattern.",
  MATCHES_FIELD: "Field does not match the %s field.",
  VALID_DATE: "must contain a valid date.",
  VALID_DOMAIN: "must contain a valid domain.",
  VALID_COLOR: "must contain a valid color.",
  VALID_GENERIC: "must be valid.",
  IS_DUPLICATE: "must not contain duplicate values.",
  IS_EXIST: "already exists in this %s.",
  IS_DUPLICATE_URL: "must not contain duplicate URLs.",
  MIN_LENGTH: "must be at least %s characters in length.",
  MAX_LENGTH: "must not exceed %s characters in length.",
  EXACT_LENGTH: "must be exactly %s characters in length.",
  GREATER_THAN: "must contain a number greater than %s.",
  LESS_THAN: "must contain a number less than %s.",
  LESS_THAN_OR_EQUAL_TO: "must be less than or equal to %s.",
  BETWEEN_VALUE: "must be between %s and %g.",
  TENANT_NAME_MIN_ERROR: "Tenant name must be between 4 and 25 characters and can only include lowercase letters, numbers, and hyphen.",
  TENANT_NAME_SPECIAL_CHAR_ERROR: "Tenant name is invalid, use only lowercase letters, numbers and hyphen.",
  ALPHA: "must contain only alphabetical characters.",
  ALPHA_NUMERIC: "must contain only alphanumeric characters.",
  STRICT_ALPHA_NUMERIC: "must contain at least one letter.",
  ALPHA_NUMERIC_SPACE: "must contain only alphanumeric characters and spaces.",
  ALPHA_DASH: "must contain only alphanumeric characters, underscores, and dashes.",
  ALPHANUMERIC_COMBO: "must contain only a combination of alphanumeric characters.",
  ALPHA_NUMERIC_DASH_COMBO: "must contain only a combination of alphanumeric characters and dashes.",
  ALPHA_NUMERIC_UNDERSCORE_DASH: "must contain only alphanumeric characters, underscores, and dashes.",
  START_WITH_ALPHABET: "must start with a letter.",
  START_WITH_ALPHNUMERIC: "must start and end with an alphanumeric character.",
  NO_SPACES: "must not contain spaces.",
  NO_UPPERCASE: "must not contain uppercase characters.",
  NUMERIC: "must contain only numbers.",
  INTEGER: "must contain an integer.",
  DECIMAL: "must contain a decimal number.",
  IS_NATURAL: "must contain only positive numbers.",
  IS_NATURAL_NO_ZERO: "must contain a number greater than zero.",
  VALID_CA_ZIP: "must contain a valid postal code.",
  VALID_CREDIT_CARD: "must contain a valid credit card number.",
  VALID_PHONENO: "Is not valid.",
  VALID_URL: "must contain a valid URL.",
  VALID_STRICT_URL: "must be a valid http(s) or ftp URL with a public domain. localhost and IP addresses are not allowed.",
  VALID_IP: "must contain a valid IP.",
  VALID_EMAIL: "must contain a valid email address.",
  VALID_BASE64: "must contain a Base64 string.",
  API_VERSION_TAB_DESCRIPTION: "This section displays the LoginRadius API version your site uses.",
  SMART_LOGIN_SETTING_HEADER: "Smart Login delegates the authentication process to a different device and does not require users to log in with a password. Request to enable Smart Login",
  LOCATION_TOOLTIP: "This is the location to which an SP sends assertions using the protocol and binding it shares with the IdP.",
  IDP_LOCATION_TOOLTIP: "This is the location to which an IdP (Custom IDP) sends assertions using the protocol and binding it shares with the SP (Service Provider).",
  LOGOUT_URL_TOOLTIP: "Enter the sign-out endpoint you receive from the SAML Endpoint.",
  CERTIFICATE_TOOLTIP: "Upload the certificate file you receive from the SAML Endpoint.",
  ANONYMOUS_LOGIN: "Anonymous Login",
  CUSTOMER_CAN_LOGIN_WITH_ANONYMOUS_LOGIN: "Customers can register with Anonymous Login.",
  ANONYMOUS_LOGIN_HEADER:
    "Anonymous Login provides the ability to identify your application’s anonymous visitors and gather information about their activities before registration. This anonymous data is attached to the user’s profile upon registration. You can request to enable Anonymous Login <a id='lnk_anonymousLogin' class='global-link' href='/support/tickets' >here</a>.",
  SMART_LOGIN_SETTING: "Smart Login Settings",
  SEND: "Send",
  CUSTOMER_CAN_LOGIN_WITH_SMART_LOGIN: "Customers can log in with Smart Login.",
  ONE_TOUCH_LOGIN_SETTING_HEADER:
    "One-Touch Login sends a verification email or SMS to users for authentication, eliminating the need for a password at registration or login. Request to enable One-Touch Login ",
  ONE_TOUCH_LOGIN_SETTING: "One-Touch Login Settings",
  CUSTOMER_CAN_LOGIN_WITH_ONE_TOUCH_LOGIN: "Customers can provide an email or phone number to log in with One-Touch Login.",
  LOGINRADIUS_API_VERSION_1: "LoginRadius API Version 1",
  LOGINRADIUS_API_VERSION_2: "LoginRadius API Version 2",
  BODY_IS_REQUIRED: "Email body is required.",
  BODY_CONTENT_IS_REQUIRED: "SMS content is required.",
  ENTER_SMS_CONTENT: "Enter SMS Content",
  TEMPLATE_ID_IS_REQUIRED: "Template name is required.",
  TEMPLATE_SUCCESSFULLY_ADDED: "Template added successfully.",
  TEMPLATE_SUCCESSFULLY_EDITED: "Template updated successfully.",
  TEMPLATE_SUCCESSFULLY_REMOVED: "Template removed successfully.",
  TEMPLATE_SUCCESSFULLY_RESET: "Template reset successfully.",
  BUTTON_RESET: "Reset",
  ADD_NEW_SMS_TEMPLATE: "Add New SMS Template",
  ADD_NEW_EMAIL_TEMPLATE: "Add New Email Template",
  TEMPLATE_NAME_ALREADY_EXISTE: "Template name already exists.",
  PRIVACY_VERSIONING_DESCRIPTION: "Manage multiple versions of your privacy policy and prompt customer action when new versions are released.",
  ENABLE_PRIVACY_POLICY_VERSIONS: "Enable Privacy Policy Versions",
  VERSION_HISTORY: "Version History",
  ADD_NEW_VERSION: "Add Version",
  IS_ENABLED: "Is Enabled",
  SELECT: "Select",
  STRICT: "Strict",
  MODERATED: "Moderated",
  CREATE_PRIVACY_POLICY_VERSION: "Create a Privacy Policy Version",
  VERSION: "Version",
  MODE: "Mode",
  VERSION_REQUIRED_ERROR_MSG: "Privacy policy version is required.",
  START_TIME: "Start Time",
  START_TIME_UTC: "Start Time (UTC)",
  END_TIME: "End Time",
  END_TIME_UTC: "End Time (UTC)",
  EXPORT_START_TIME: "Export Start Time (UTC)",
  EXPORT_END_TIME: "Export End Time (UTC)",
  DOWNLOAD_LINK: "Download Link",
  EXPIRY_TIME: "Expiry Time",
  EXPIRY_TIME_UTC: "Expiry Time (UTC)",
  START_DATE_AND_TIME: "Start Date and Time",
  DATE_TIME_ACCOUNT_TIMEZONE: "Date and time in your account timezone.",
  DATE_TIME_REQUIRED_ERROR_MSG: "Date and time are required.",
  SELECTED_DATE_TIME_GREATER: "The selected date and time must be later than the current date and time.",
  POLICY_ENABLED: "Privacy Policy Version enabled successfully.",
  POLICY_DISABLED: "Privacy Policy Version disabled successfully.",
  POLICY_SAVED: "Privacy Policy Version saved successfully.",
  DATA_COMPLIANCES_DESC:
    "LoginRadius has partnered with leading technology infrastructure providers, namely Microsoft Azure and Amazon AWS, to deliver a reliable and robust service with top performance and security. Below is a list of standards and compliances that LoginRadius adheres to.",
  DATA_COMPLIANCES_LIST_HEADER: "Through our infrastructure partners, we meet the following compliances:",
  GDPR_COMPLIANCE_DESC:
    "Since May 2018, the European Union (EU) has enforced regulations to strengthen data protection and privacy for individuals, known as the General Data Protection Regulation (GDPR). This affects organizations operating within the EU and international organizations with customers in the EU. LoginRadius’ platform helps you fully comply with GDPR.",
  GDPR_ARTICLE_7_2_CUSTOMER_CONSENT_TITLE: "Article 7 (2): Customer Consent: Collected",
  GDPR_ARTICLE_7_2_CUSTOMER_CONSENT_DESC: "Consent must be explicit, unambiguous, and obtained for each purpose for which customer data is used.",
  GDPR_ARTICLE_7_1_CUSTOMER_CONSENT_TITLE: "Article 7 (1): Customer Consent: Documented",
  GDPR_ARTICLE_7_1_CUSTOMER_CONSENT_DESC:
    "Businesses must provide documented records of the customer’s consent, including the conditions under which consent was given and the specific purpose for which it was obtained.",
  GDPR_ARTICLE_7_3_CUSTOMER_CONSENT_WITHDRAW_TITLE: "Article 7 (3): Customer Consent: Right to Withdraw Consent",
  GDPR_ARTICLE_7_3_CUSTOMER_CONSENT_WITHDRAW_DESC: "Customers may easily withdraw consent to collect or process their data at any time.",
  GDPR_ARTICLE_8_CHILD_CONSENT_TITLE: "Article 8: Conditions Applicable to a Child’s Consent in Relation to Information Society Services",
  GDPR_ARTICLE_8_CHILD_CONSENT_DESC: "The user’s age has been verified as being of the age of consent.",
  GDPR_ARTICLE_15_RIGHT_OF_ACCESS_TITLE: "Article 15: Right of Access by the Customer",
  GDPR_ARTICLE_15_RIGHT_OF_ACCESS_DESC:
    "Customers can view, export, and edit their personal data at any time. Additionally, customers have the right to be provided with information about all personal data stored by the applicable businesses.",
  GDPR_ARTICLE_16_RIGHT_TO_RECTIFICATION_TITLE: "Article 16: Right to Rectification",
  GDPR_ARTICLE_16_RIGHT_TO_RECTIFICATION_DESC:
    "Customers must be able to easily change profile and opt-in preferences or correct inaccurate information within a reasonable time and via a simple communication method, such as email.",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_TITLE: "Article 17: Right to Be Forgotten",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_DESC: "Customers have the 'right to be forgotten'—that is, to have their personal data erased—for reasons including:",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_BULLET1: "The information is no longer necessary.",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_BULLET2: "The customer withdraws consent.",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_BULLET3: "The customer objects to the purpose of personal data processing.",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_BULLET4: "The customer’s personal data was collected or processed unlawfully.",
  GDPR_ARTICLE_17_RIGHT_TO_BE_FORGETTEN_BULLET5: "The customer’s personal data must be erased to comply with a legal obligation in their country of origin.",
  GDPR_ARTICLE_18_RESTRICTION_OF_PROCESSING_TITLE: "Article 18: Right to Restriction of Processing",
  GDPR_ARTICLE_18_RESTRICTION_OF_PROCESSING_DESC: "Customers have the right to request that businesses freeze the processing of their personal data.",
  GDPR_ARTICLE_28_DELEGATION_OF_INACTIVE_DATA_TITLE: "Article 28 (3) (g): Deletion of Inactive Data",
  GDPR_ARTICLE_28_DELEGATION_OF_INACTIVE_DATA_DESC:
    "The GDPR requires businesses to purge a customer’s personal data if the customer deletes their profile or if the profile has been inactive for a predetermined period. All copies of such data must also be purged, unless otherwise specified by law. Associated data must also be removed from any third-party technologies, such as CRM or ESP solutions.",
  AGE_VERIFICATION_DESC: "This section allows you to set the minimum age required for sign-up as per the Children’s Online Privacy Protection Act (COPPA) rule.",
  MIN_AGE_SIGNUP: "Minimum Age Required to Sign Up",
  AGE_VERIFICATION_EMPTY_ERROR: "Age is required.",
  AGE_VERIFICATION_INVALID_ERROR: "Please enter a valid age.",
  CREDIENTIAL_INPUT_TOOLTIP: "To refrain from updating this field, leave it empty.",
  APP_UPDATED_SUCCESSFULLY: "App config updated successfully.",
  APP_SAVED_SUCCESSFULLY: "App config saved successfully.",
  APP_DELETED_SUCCESSFULLY: "Application deleted successfully.",
  SETTING_SAVED_SUCCESSFULLY: "Settings saved successfully.",
  SETTING_RESET_SUCCESSFULLY: "Settings reset successfully.",
  QUESTION_ALREADY_EXISTS: "Security question already exists.",
  API_CREDENTIALS_HEADER: "Manage Your LoginRadius API Credentials Here",
  API_CREDENTIAL_DESCRIPTION: "Manage your LoginRadius API credentials here.",
  ACCOUNT_API_KEY_CARD_DESCRIPTION: "Access your LoginRadius API Key and Secret here. Keep your Secret secure and limit team access.",
  ACCOUNT_API_KEY_TAB_HEADER: "API Credentials for",
  ADDITIONAL_API_SECRETS_CARD_DESCRIPTION_L1: "Add up to 15 API Secrets to control secure, limited access to specific areas of your site.",
  ADDITIONAL_API_SECRETS_CARD_DESCRIPTION: "Access your LoginRadius API Key and Secret here. Keep your Secret secure and limit team access.",
  API_KEY: "API Key",
  API_SECRET: "API Secret",
  SHOW: "Show",
  RESET_SECRET: "Reset Secret",
  RESET_POPUP_MESSAGE: "If you change or reset the API secret, any API calls you have developed will stop working until you update them with your new key.",
  API_KEY_SUCCESSFULLY_RESET: "The API Secret has been successfully reset.",
  API_KEY_COULD_NOT_SUCCESSFULLY_RESET: "The API Secret could not be reset successfully.",
  CONFIRM_DISABLE: "Are you sure you want to disable?",
  CONFIRM_DELETE: "Are you sure you want to delete?",
  CONFIRM_UPDATE: "Updating any key and secret will update the ID. Do you want to update?",
  CONFIRM_DISABLE_TEXT: "Disable",
  RISK_BASED_TIMERANGEUNIT: "Based on Number of Days",
  RISK_BASED_TIMERANGEUNIT_INPUT: "Expire After Number of Days",
  RISK_BASED_TIMERANGEUNIT_LABEL: "Based on Number",
  RISK_BASED_TIMERANGEUNIT_INPUT2: "Remember Number of Counts",
  RISK_BASED_TIMERANGE_INPUT: "Expire in #type#",
  ACTIONS: "Actions",
  BLOCK_USER: "Block User",
  BLOCK: "Block",
  UNBLOCK: "Unblock",
  UNBLOCK_USER: "Unblock User",
  BLOCK_USER_ALERT: "This action blocks the customer and prevents access to authorized data in the application.",
  UNBLOCK_USER_ALERT: "This action unblocks the customer and grants access to authorized data in the application.",
  EMAIL_TO_ADMIN_WARNING: "Add admin email address to receive notifications.",
  SECURITY_QUESTIONS_WARNING: "Add security questions to use security questions as Multi factor Authentication setting in case of risk detected.",
  EMAIL_TO_ADMIN: "Email to Admin",
  EMAIL_TO_USER: "Email to User",
  RISK_BASED_ACTIONS_SELECT_MESSAGE: "Please select at least one action or notification.",
  RISK_BASED_DISABLE_MESSAGE: "Risk-Based configuration disabled successfully.",
  RISK_BASED_SUCCESS_MESSAGE: "Risk-Based configuration saved successfully.",
  RISK_BASED_ERROR_MESSAGE: "Risk-Based configuration could not be saved successfully.",
  MULTI_FACTOR_SETTINGS_LABEL: "Multi-Factor Authentication Settings in Case of Risk Detected",
  MULTI_FACTOR_SETTINGS_HEADER:
    "This section allows you to configure Multi-Factor Authentication. If the detected behavior meets your risk criteria, the user will need to undergo Multi-Factor Authentication.",
  RISK_BASED_HEADER: "Automatically trigger an extra authentication challenge only when a successful login attempt seems suspicious or risky.",
  API_SECRET_GET_SUCCESSFULLY: "API Secret fetched successfully.",
  API_SECRET_COULD_NOT_GET_SUCCESSFULLY: "API Secret could not be fetched successfully.",
  IP_REQUIRED: "IP Address/Range is required.",
  IP_ACCESS_RESTRICTION_VALIDATION_ERROR: "IP address or IP range must be in a valid format, e.g., 192.168.0.1 or 192.168.0.1-192.168.0.255",
  IP_ACCESS_RESTRICTION_RANGE_VALIDATION_ERROR: "Start IP must be lower than the End IP.",
  IP_ACCESS_RESTRICTION_LEADING_ZERO: "IP address or IP range must be in a valid format.",
  ALLOW: "Allow",
  DENY: "Deny",
  NONE_IP_HEADER: "Disables or resets the restrictions, meaning any IP address is allowed to access the LoginRadius Account APIs.",
  DENY_HEADER: "Denied IP addresses/ranges cannot access LoginRadius APIs, while all unspecified IP addresses are allowed.",
  ALLOW_HEADER: "Only allowed IP addresses/ranges can access LoginRadius APIs, and all unspecified IP addresses are denied.",
  DISABLE_IP_POPUP_HEADER: "You’re disabling IP Access Management. Do you want to proceed?",
  GENERAL_HEADER: "General",
  GENERAL_PASSKEY_DESCRIPTION: "Configure general settings for Passkey authentication.",
  DISABLE_PASSKEY_POPUP_HEADER: "You’re disabling Passkeys. Do you want to proceed?",
  DISABLE_BREACHED_PASSWORD_POPUP_HEADER: "You’re disabling Breached Password Protection. Do you want to proceed?",
  DISABLE_DOMAIN_RESTRICTION_POPUP_HEADER: "You’re disabling Domain Access Management. Do you want to proceed?",
  ENTER_IP: "Enter an IP Address/Range",
  IP_PLACEHOLDER: "Example: 192.168.0.1 or 192.168.0.1-192.168.0.255",
  IP_ACCESS_SUCCESS_MESSAGE: "IP authorization settings saved successfully.",
  IP_ACCESS_DISABLED_SUCCESS_MESSAGE: "Access restriction has been disabled.",
  ACCESS_TYPE: "Access Type",
  ENABLE_DOMAIN_ACCESS_MANAGEMENT: "Enable Domain Access Management",
  DOMAIN_ACCESS: "Domain Access Management",
  DOMAIN_ACCESS_CARD_DESC: "Control registration access by allowing or blocking domain names and email addresses.",
  ALLOWLIST_TITLE: "Allowlist",
  ENTER_DOMAIN_NAMES_OR_EMAIL_IDS: "Enter domain or email address",
  BLOCKLIST_TITLE: "Blocklist",
  ACCESS_RESTRICTION_HEADER1: "Enable this option to whitelist or blacklist specific domain names and email addresses.",
  ACCESS_RESTRICTION_CARD_DESC: "Configure and manage which domain names and email addresses are allowed for user registration.",
  ADD_NEW_EMAIL: "Add Email",
  ADD_NEW_PROVIDER: "Add Provider",
  MANAGE_APPS: "Manage Apps",
  MANAGE_APPS_DESCRIPTION: "Manage your newly created apps here.",
  FEDERATED_SSO_OPENID_FORM_LOGIN_REDIRECT_URL: "Login Redirect URL",
  FEDERATED_SSO_OPENID_FORM_LOGOUT_REDIRECT_URL: "Logout Redirect URL",
  FEDERATED_SSO_OPENID_FORM_CORS_ORIGIN: "CORS Origin",
  FEDERATED_SSO_OPENID_FORM__ALLOWED_CORS_ORIGIN: "Allowed CORS Origin",
  FEDERATED_SSO_OPENID_FORM_SCOPES_FOR_MANAGEMENT_API: "Scopes for Management API",
  FEDERATED_SSO_OPENID_FORM_SCOPES_FOR_MANAGEMENT_API_HELP_TEXT_PART1: "API's Scopes",
  FEDERATED_SSO_OPENID_FORM_SCOPES_FOR_MANAGEMENT_API_HELP_TEXT_PART2: "/identity/v2/manage",
  BACKCHANNEL_LOGOUT_ISENABLED: "Backchannel Logout Enabled",
  BACKCHANNEL_LOGOUT_URIS: "Backchannel Logout URIs",
  BACKCHANNEL_LOGOUT_TOKEN_TTL: "Backchannel Logout Token TTL",
  FEDERATED_SSO_OPENID_FORM_REFRESH_TOKEN: "Refresh Token TTL (Seconds)",
  REFRESH_TOKEN_GREATER_THAN_TOKEN_TTL: "Refresh Token TTL must be greater than the Token Expiration.",
  FEDERATED_SSO_OPENID_FORM_ALREADY_EXIST_URL: "The URL already exists.",
  CONNECTIONS: "Connections",
  CONNECTIONS_DESCRIPTION: "When enabled, you can configure the connection.",
  MINIMUM_ACCEPTED_VALUE_IS: "The minimum accepted value is",
  ADD_PLUS: "Add",
  ADD_NEW_APP: "Add Apps",
  ADD_NEW_SAML_APP: "Add a New SAML App",
  ADD_NEW_SAML_APP_DES: "Fill out the form below to submit a request to add a new app.",
  ADD_NEW_OPENID_APP: "Add OpenID Connect App",
  ADD_NEW_STORE: "Add a New Store",
  EMAIL_ADDRESS_COULD_NOT_SAVED_SUCCESSFULLY: "Email address could not be saved successfully.",
  EMAIL_ADDRESS_SAVED_SUCCESSFULLY: "Email address saved successfully.",
  EMAIL_ADDRESS_DELETE_SUCCESSFULLY: "Email address deleted successfully.",
  EMAIL_ADDRESS_COULD_NOT_DELETE_SUCCESSFULLY: "Email address could not be deleted successfully.",
  DUPLICATE_EMAIL_NOT_ALLOWED: "Duplicate emails are not allowed.",
  ENTER_AN_ADMIN_EMAIL: "Enter an admin email",
  ADMIN_EMAIL_HEADER: "Add the administrator’s email to receive notifications when Risk-Based Authentication is set to 'Email to Admin’.",
  SAML_SAML_VERSION: "SAML Version",
  RBA_SELECT_TYPE: "Login Flow",

  RBA_HELP_TEXT_CITY_ONE:
    "When this option is enabled, we will preserve each #type# for the specified number of days. After the #type# exceeds this duration, it will be flagged as expired. Use 0 for an indefinite time period.",
  RBA_HELP_TEXT_CITY_TWO:
    "When this option is enabled, we will maintain a list of each #type#. The list's length is determined by the specified number. If a new #type# is added, the oldest #type# exceeding the list length will be flagged as expired.",
  RBA_HELP_TEXT:
    "You have not selected a Multi-Factor Authentication Action in the Risk-Based Actions settings, and the default authentication method is Email. You can update this under the first tab on the same page.",
  RBA_NOTIFICATION: "Notification",
  RAB_ACTION: "Action",
  PERMISSION_MESSAGE_MULTI_FACTOR_AUTH:
    "These settings cannot be changed because Multi-Factor Authentication has not yet been enabled for your site. Please contact LoginRadius support for more information.",
  RBA_INVALID_NUMBER_RANGE: "The value must be between 1 and 2,147,483,647.",

  RBA_FACTOR_DESC_CITY: "Flag logins from an unfamiliar city, an early signal of account takeover",
  RBA_FACTOR_DESC_COUNTRY: "Flag logins from a new country to catch impossible-travel anomalies",
  RBA_FACTOR_DESC_IP: "Flag logins from an unrecognized IP or known risky network",
  RBA_FACTOR_DESC_BROWSER: "Flag logins from an unfamiliar browser, a sign of session hijacking",
  RBA_FACTOR_DESC_DEVICE: "Flag logins from an unrecognized device, a strong risk signal",

  // Profile Management - Data Query
  DATA_QUERY_TAB1_DESCRIPTION: "This is your User Query area. You can find users matching all or any of the applied filters, enabling a more specific user search.",
  DATA_QUERY_TAB2_DESCRIPTION: "This is your Custom Object Query area. You can retrieve custom objects matching all or any of the applied filters.",
  SELECT_CUSTOM_OBJ: "Select Custom Object",
  NO_CUSTOMOBJECT_FOUND: "No Custom Objects are configured with a schema.",
  NO_USERS_FOUND: "No users were found for the selected custom object.",
  PLEASE_SELECT_CUSTOM_OBJ: "Please select a custom object from the list to proceed.",
  CUSTOMOBJECT_NA: "Data is not found or not available for querying. Please contact LoginRadius support.",
  CUSTOMOBJECT_MACTHING_PROFILES: "Number of Custom Objects Matching These Criteria",
  TOTAL_CUSTOMOBJECTS: "Total Number of Custom Objects",

  // CUSTOMER SEGMENTATION - BASIC SEGMENTATION
  CUSTOMER_SEGMENTATION_BASIC_SEGMENTATION_TAB_DESCRIPTION:
    "This is your Basic Segmentation area. Follow the steps below to specify and apply criteria to generate segmented lists of your registered customer profiles. These can be downloaded in CSV or JSON format and integrated into your marketing platforms.",
  CUSTOMER_SEGMENTATION_ADVANCED_SEGMENTATION_TAB_DESCRIPTION:
    "This is your User Segmentation area. You can group filters and segment users based on data profile field queries or custom object queries. These can be downloaded in CSV or JSON format and integrated into your marketing platforms.",
  CUSTOMER_SEGMENTATION_BASIC_SEGMENTATION_TOTAL_REGISTERED_CUSTOMER_PROFILES: "Total Number of Registered User Profiles",
  CUSTOMER_SEGMENTATION_BASIC_SEGMENTATION_CUSTOMER_PROFILES_MATCHING_CRITERIA: "Number of User Profiles Matching These Criteria",
  CUSTOMER_SEGMENTATION_USER_PROFILES_NOT_AVAILABLE: "An internal server error occurred. Please try again later.",
  ADMIN_EMAIL_PERMISSION_MSG: "These settings are unavailable because Risk-Based Authentication has not been enabled for your tenant yet. Please contact LoginRadius support for more information.",
  ADMIN_EMAIL: "Admin Email",

  // DATA EXPORT
  DATA_EXPORT_TAB_DESCRIPTION: "This is your Data Export area. You can export your customer data in CSV or JSON format.",

  // Profile Management - Customer Segmentation - Saved Segmentation
  SAVED_SEGMENTATION_DESC: "This is your Saved Segmentation area. You can access your saved segmentation filters here.",
  NO_SAVED_SEGMENTS: "No Saved Segmentations",
  DELETE_SEGMENTATION: "Delete Segmentation",
  CONFIRM_DELETE_SEGMENTATION: "Are you sure you want to delete this segmentation?",
  DELETE_SEGMENT_ERROR_MSG: "Failed to delete segmentation.",
  DELETE_SEGMENT_SUCCESS_MSG: "Segmentation deleted successfully.",
  ERROR_FETCHING_DATA: "An error occurred while fetching data from the server.",
  APPLY_SEGMENT: "Apply the Segment",
  ADDITIONAL_API_SECRETS_HEADERS:
    "You can add up to 10 additional API Secrets for your LoginRadius site by selecting the desired APIs from the list. Use these API Secrets to securely grant limited access to specific areas of your site.",
  ADDITIONAL_SECRETS: "Additional Secret(s)",
  ADD_A_NEW_API_SECRET: "Add a New API Secret",
  ENTER_THE_COMMENT: "Enter the Comment",
  ROLES: "Roles",
  ROLES_IS_REQUIRED: "A role is required.",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SECONDRY_FROM_YOUR_LOGINRADIUS_SITE: "Are you sure you want to delete this additional secret?",
  THIS_WILL_GENERATE_OR_ADD_A_NEW_ADDITIONAL_API_SECRET_TO_YOUR_LOGINRADIUS_SITE: "This will generate or add a new additional API Secret to your tenant.",
  WEBHOOK_REMOVE_MESSAGE: "Deleting this additional secret will stop the related webhook from functioning if it is currently in use.",
  ADDITIONAL_SECRET_HAS_BEEN_REMOVED_SUCCESSFULLY: "The additional secret has been removed successfully.",
  AN_ADDITIONAL_API_SECRET_HAS_BEEN_SUCCESSFULLY_ADDED: "An additional API Secret has been successfully added.",
  API_IS_REQUIRED: "An API is required.",
  APIS: "API(s)",
  SELECT_API: "Select One or More API(s)",
  SELECT_API_LABEL: "APIs",
  SELECT_ROLE: "Select Role",
  SELECT_RULE: "Select Rule",
  SELECT_OPTR: "Select Operator",
  SELECT_RULE_VAL: "Select Rule Value",
  REQUIRED_FILTER_RULE: "This is a required filter and can't be changed.",
  SHOULD_BE_STRING: "Enter a String",
  SHOULD_BE_NUMBER: "Enter a Number",
  NO_DATA: "No Data Available",
  SELECT_DATE_TIME: "Select Date and Time",
  SELECT_DATE: "Select a Date",
  YOU_DO_NOT_HAVE_ANY_ADDITIONAL_SECRET_ADDED: "You have not added any additional secrets.",
  SECRET: "Secret",
  ACTION: "Action",
  EMAIL_SETUP_INSTRUCTIONS: "Set up Passwordless Login with Email settings.",
  SMS_SETUP_INSTRUCTIONS: "Set up One-Time Passcode settings.",
  SMS: "SMS",
  MFA_WITH_EMAIL: "MFA with Email",
  MFA_WITH_SMS: "MFA with SMS",
  SecurityQuestion: "Security Questions",
  MFA_WITH_EMAIL_INSTRUCTIONS: "Configure Email content and settings.",
  MFA_WITH_SMS_INSTRUCTIONS: "Configure SMS content and settings.",
  SECURITYQUESTION_SETUP_INSTRUCTIONS: "Set up security question settings.",
  REQUESTED_EXPORT_MORE_THAN_500K: "The requested export exceeds 500,000 records or 25% of the total profiles. Please contact LoginRadius support.",
  OAUTH_PROVIDER_HEADER:
    "This section allows you to configure a custom Identity Provider (IDP) supporting <a id='lnk_smartLogin' class='global-link' href='https://tools.ietf.org/html/rfc6749' rel='noopener noreferrer' target='_blank'>OAuth</a>. When configured, LoginRadius will forward your authentication request to this provider, which will return a response indicating whether the user is authenticated.",
  SAML_PROVIDER_HEADER:
    "This section allows you to configure a custom Identity Provider (IDP) supporting SAML. When configured, LoginRadius will forward your request to this provider, which will return a response indicating whether the user is authenticated.",
  ADFS_PROVDER_HEADER:
    "This section allows you to configure a custom Identity Provider (IDP) supporting ADFS. When configured, LoginRadius will forward your request to this provider, which will return a response indicating whether the user is authenticated.",
  JWT_PROVDER_HEADER:
    "This page is used to create, view, and manage all JWT configurations. Configuring a custom JWT provider allows customers to log in to your LoginRadius site using their existing credentials.",
  FOR_ADDITIONAL_DETAILS: "For additional details",
  SSO_CONNECTORS: "SSO Connectors",
  SHOPIFY_PROVIDER_HEADER: "This section allows you to configure plugin settings for use with supported third-party SSO integrations.",
  PASSWORD_DELEGATION_HEADER:
    "From here, you can configure your password delegation request. This allows you to use a third-party service as the source of password data instead of the LoginRadius Cloud Storage password.",
  DELEGATION_AUTH_HEADER:
    "The Delegation API streamlines authentication for a given application with LoginRadius SSO, ensuring a seamless user experience. If you want to integrate login for your site using custom login or an open API, you can customize the API input and response. Use the interface below to configure a new request or manage existing ones.",
  CLICK_HERE: "Click here",
  CONFIRM_DELETE_TEXT: "Confirm Delete",
  SMS_PASSCODE: "SMS OTP",
  DUPLICATE_URL_NOT_ALLOWED: "Duplicate URLs are not allowed.",
  CUSTOM_DOMAIN_SUPPORT_TICKET_SUBJECT: "Enable, add, or update a custom domain",
  SEGMENTATION_SAVED: "Segmentation saved successfully.",
  UNABLE_TO_SAVE_SEGMENTATION: "Unable to save segmentation.",
  EXPORT_EXCEEDING_LIMIT: "The requested export exceeds 1 million records. Please contact LoginRadius support.",
  FILTER: "Filters",
  SAVE_SEGMENT: "Save Segment",
  EXPORT: "Export",
  EXPORT_SEGMENTED_LIST: "Export Segmented List",
  SEGMENT_NAME: "Segment Name",
  SAVE_THE_SEGMENT: "Save the Segment",
  CANCEL: "Cancel",
  CUSTOM_OBJECTS_SUPPORT_TICKET_SUBJECT: "Add one or more custom objects",
  BOT_PROTECTION_HEADER: "Dynamically request CAPTCHA challenges to protect specific APIs from bot attacks.",
  BOT_PROTECTION_HEADER1: "Bot Protection Allowed on APIs",
  BOT_PROTECTION_HEADER2: "List of APIs you want to protect.",
  BOT_PROTECTION_ENABLE_HEADER: "When Bot Protection is activated, you can configure which APIs have protection enabled or disabled.",
  BOT_PROTECTION_NO_DATA: "To use Bot Protection, enable and configure a CAPTCHA setting in the Auth Security section.",
  BOT_PROTECTION: "Bot Protection",
  REGISTRATION_DATA_HEADER_TEXT: "You can add, update, or delete registration data from here.",
  REGISTRATION_DATA: "Registration Data",
  ADD_NEW_FIELD: "Add New Field",
  TYPE: "Type",
  KEY: "Key",
  VALUE: "Value",

  // COMMUNICATION CONFIGURATION
  EMAIL_CONFIGURATION_TAB_DESCRIPTION: "Select a provider and configure SMTP email settings to enable LoginRadius to send emails through the chosen email service.",
  SAVE_SMTP_SETTINGS_SUCCESS: "SMTP settings saved successfully.",
  VERIFY_SMTP_SETTING_SUCCESS: "SMTP settings verified successfully.",
  TO_EMAIL: "To Email",
  ENTER_THE_RECIPIENT_ADDRESS: "Enter the recipient's address",
  HAS_INVALID_FORMAT_SUFFIX: "has an invalid format.",
  VERIFY_SMTP_SETTINGS_EMAIL_SUBJECT: "Test Email - LoginRadius",
  VERIFY_SMTP_SETTINGS_EMAIL_MESSAGE:
    "This is a test email to validate your SMTP credentials for LoginRadius' User Registration feature on your website. <br><br>The SMTP server credentials have been verified.<br><br>Thank you,<br>LoginRadius Team",
  LEARN_MORE_AT: "Learn more at",
  SPECIFIC_STRING_NOT_VALID_FORM_FOR_EMAIL_ADDRESS: "The specified string is not in the required format for an email address.",
  EMAIL_CANNOT_BE_SENT_CHECK_EMAIL_CONFIGURATION: "The email cannot be sent. Please check your email configuration.",
  SUCCESSFUL_SMTP_SETTINGS_RESET_MESSAGE: "Settings have been reset successfully.",
  SUCCESSFUL_SMTP_SETTINGS_DELETE_MESSAGE: "Settings have been deleted successfully.",
  DEFAULT_SUPPORTED_SMTP_PLATFORMS: "Select and configure an SMTP provider",
  OR_ADD_YOUR_OWN_CUSTOM_SETTINGS: "or add your own custom settings",
  SEND_EMAIL_VERIFICATION_DESCRIBTION: "Send an email to verify that your configuration settings are correct.",
  SEND_EMAIL_VERIFICATION_DESCRIBTION_MAILZY: "Send an email to verify that your configuration settings are correct.",

  // EMAIL TEMPLATES
  SMS_CONFIGURATION_TITLE: "SMS Configuration",
  SMS_CONFIGURATION_HEADER: "Configure LoginRadius with your SMS provider settings to deliver OTPs to your customers via text, SMS, or voice calls.",
  GLOBAL_SMS_VOICE_SETTINGS: "Global Text/SMS/Voice OTP Settings",
  GLOBAL_SETTINGS: "Global Text/SMS/Voice OTP Settings",
  SMS_OTP_HELP_TEXT: " OTP will be sent via SMS for both initial and resend requests.",
  SMS_AND_VOICE_OTP_HELP_TEXT: " OTP will be sent via SMS initially, but users can choose SMS or Voice Call for OTP resend requests.",
  DEFAULT_SUPPORTED_SMS_PLATFORMS: "Default Supported Platforms",
  SMS_PROVIDER_NOT_CONFIGURABLE: "Configuration options are not available with the selected provider. Please contact LoginRadius support for more information.",
  TWILIO_ACCOUNT_SID: "Twilio Account SID",
  ENTER_TWILIO_ACCOUNT_SID: "Enter your Twilio Account SID here",
  HOW_TO_GET_A_SID: "What is an SID and how do I get one?",
  TWILIO_AUTH_TOKEN: "Twilio Auth Token",
  ENTER_TWILIO_AUTH_TOKEN: "Enter your Twilio Auth Token here",
  TWILIO_NUMBER: "Twilio Number",
  ENTER_TWILIO_NUMBER: "Enter your Twilio Number here",
  SHOULD_BE_GREATER_THAN_ZERO: "must be greater than 0",
  NOT_LESS_THAN_34_CHARS: "must not be less than 34 characters",
  NOT_GREATER_THAN_34_CHARS: "must not exceed 34 characters",
  MINIMUM_OTP_LENGTH_IS: "The minimum OTP length is",
  SETTINGS_SAVED_SUCCESSFULLY: "Settings saved successfully.",
  SMS_SETTINGS_RESET: "SMS settings have been reset.",
  DISABLE_TWILIO_ON_SAVE: "Do you want to save the settings? After saving, the Twilio details will be erased.",
  SMS_SETTING_RESET_POPUP: "Do you want to reset the settings?",
  AUDIT_LOG_RESET: "Do you want to reset the Audit Log Integration Configuration?",
  EMAIL_TEMPLATE_TYPE: "Email Template Type",
  TEMPLATE_ID_: "Template ID",
  SUBJECT: "Subject",
  TEMPLATE_ID_REQUIRED: "Template ID is required.",
  TEMPLATE_SUBJECT_REQUIRED: "Template Subject is required.",
  FROM_EMAIL_ADDRESS: "From Email Address",
  EMAIL_BODY: "Email Body",
  CITY_SUBJECT: "Suspicious City Email Settings",
  COUNTRY_SUBJECT: "Suspicious Country Email Settings",
  BROWSER_SUBJECT: "Suspicious Browser Email Settings",
  IP_SUBJECT: "Suspicious IP Email Settings",
  DEVICE_SUBJECT: "Suspicious Device Email Settings",
  ADMIN_SUBJECT: "Risk Identified Email to Admin Settings",
  SMS_CITY_SUBJECT: "Suspicious City SMS Settings",
  SMS_COUNTRY_SUBJECT: "Suspicious Country SMS Settings",
  SMS_BROWSER_SUBJECT: "Suspicious Browser SMS Settings",
  SMS_IP_SUBJECT: "Suspicious IP SMS Settings",
  SMS_DEVICE_SUBJECT: "Suspicious Device SMS Settings",
  SMS_NOTIFICATION: "Request Disabled Period",
  SMS_LINK_EXPIRE: "#settingsname# OTP Validity Limit (Seconds)",
  SMS_LINK_EXPIRE_INFO: "The duration for which the code in the #settingsname# SMS remains valid.",
  REQUEST_LIMIT_INFO: "The number of times a customer can request #emailname# emails within a given time period.",
  SMS_NOTIFICATION_INFO: "The duration during which the #settingsname# SMS request remains disabled for the customer after they reach their request limit.",
  SMS_REQUEST_LIMIT_INFO:
    "The number of times a customer can request a #settingsname# SMS during the request period before this option is temporarily disabled. For example, a user can request this SMS 5 times (Request Limit) over 120 seconds (Request Period) before the option is temporarily disabled.",
  EMAIL_NOTIFICATION: "Request Disabled Period",
  PASSWORDLESS_LOGIN: "Passwordless Login",
  SUSPICIOUS_CITY: "Suspicious City",
  SUSPICIOUS_COUNTRY: "Suspicious Country",
  SUSPICIOUS_IP: "Suspicious IP",
  SUSPICIOUS_BROWSER: "Suspicious Browser",
  SUSPICIOUS_DEVICE: "Suspicious Device",
  SUSPICIOUS_ADMIN: "Risk Identified",
  VERIFICATION_SMS: "Verification",
  PHONENO_SMS_NOTIFICATION_FREQUENCY: "The duration a customer can request a #settingsms# and the disabled period after they reach their request limit.",
  PHONE_NUMBER_CHANGE_SMS: "Phone Number Change",
  PASSWORD_RESET_SMS: "Password Reset",
  ONETOUCHLOGIN_SMS: "One-Touch Login",
  EMAIL_VERIFICATION: "Email Verification",
  VERIFICATION_EMAIL_LINK_EXPIRE: "#emailname# Token Validity Limit (Minutes)",
  VERIFICATION_TOKEN_TYPE: "Token Type",
  VERIFICATION_REQUEST_LIMIT_INFO: "The number of times a customer can request #emailname# within a given time period.",
  VERIFICATION_EMAIL_LINK_EXPIRE_INFO: "The duration for which the link in the #emailname# email remains valid.",
  VERIFICATION_TOKEN_TYPE_INFO: "Choose whether the email should contain a link or an OTP for verification or authentication.",
  VERIFICATION_TOKEN_TYPE_NOTE:
    "If you change the token type, the relevant placeholder is automatically updated only for default templates. For custom templates, manually update the placeholder. Regardless of the template type, edit the template text as needed.",
  MAGIC_LINK: "Magic Link",
  MAGICLINK: "Magic Link",
  OTP: "OTP",
  RESET_PASSWORD_EMAIL_ENABLED: "Enable Reset Password Confirmation Email",
  ENABLE_WELCOME_EMAIL: "Enable Welcome Email",
  EMAIL_NOTIFICATION_INFO: "The duration a customer can request #emailname# emails and the disabled duration after the request limit is reached.",
  EMAIL_LINK_EXPIRE: "Suspicious City Email Token Validity Limit (Minutes)",
  EMAIL_LINK_EXPIRE_INFO: "The duration for which the link in the #emailname# email remains valid.",
  TEXT_TEMPLATE: "Text Template",
  TEMPLATE_DELETED_SUCCESSFULLY: "Template removed successfully.",
  SAME_TEMPLATE_NAME: "This email template already exists. Please use a different or unique name for the new email template.",
  DATA_SOURCE_TYPE: "Data Source Type",
  PARENT_TYPE: "Parent Type",
  PARENT_SELECTE_TYPE: "Select Parent Type",
  PARENT_VALUE: "Parent Value",
  PARENT_SELECTE_VALUE: "Select Parent Value",
  SELECTE_DATA_SOURCE: "Select Data Source",
  ENTER_CODE: "Enter Code",
  ENTER_KEY: "Enter Key",
  ENTER_VALUE: "Enter Value",
  DATA_SOURCE_TYPE_REQUIRED: "Data Source Type is required.",
  KEY_IS_REQUIRED: "Key is required.",
  VALUE_IS_REQUIRED: "Value is required.",
  CUSTOM_REGISTRATION_DATA_UPDATE_SUCCESSFULLY: "Custom Registration Data updated successfully.",
  CUSTOM_REGISTRATION_DATA_ADD_SUCCESSFULLY: "Custom Registration Data added successfully.",
  CUSTOM_REGISTRATION_DATA_DELETED_SUCCESSFULLY: "Custom Registration Data deleted successfully.",
  TYPE_IS_REQUIRED: "Type is required.",
  ACCTION: "Action",
  SMS_TEMPLATE_TYPE: "SMS Template Type",
  SMS_BODY: "SMS Body",
  TEMPLATE_TYPE: "Template Type",
  TEMPLATE_NAME: "Template Name",
  RBA_SMS_TEMPLATES_HEADER: "Fully customize the SMS sent to admins or customers in the case of risky events here.",
  SMS_TEMPLATES_HEADER: "Edit and manage templates for user authentication and transactional SMS.",
  EMAIL_TEMPLATES_HEADER: "Edit and manage templates for user authentication and transactional emails.",
  EMAIL_TEMPLATES_ACTION_COLUMN: "Actions",
  EMAIL_TEMPLATES_MENU_EDIT: "Edit",
  EMAIL_TEMPLATES_MENU_SEND_TEST: "Send Test Email",
  EMAIL_TEMPLATES_MENU_COPY_NAME: "Copy Template Name",
  EMAIL_TEMPLATES_COPY_SUCCESS: "Template Name copied to clipboard",
  EMAIL_TEMPLATES_RESET_FAILED: "Failed to reset template.",
  EMAIL_TEMPLATES_DELETE_FAILED: "Failed to delete template.",
  EMAIL_TEMPLATES_UPDATE_FAILED: "Failed to update template.",
  EMAIL_TEMPLATES_ADD_FAILED: "Failed to add template.",
  EMAIL_TEMPLATES_SEARCH_PLACEHOLDER: "Search for templates",
  EMAIL_TEMPLATES_EMAIL_SETTINGS: "Email settings",
  EMAIL_TEMPLATES_TAB_TYPE_LABEL: "Templates Type",
  EMAIL_TEMPLATES_BACK_TO_AUTH_CONFIGURATION: "Back to Auth Configuration",
  EMAIL_TEMPLATES_BACK_TO_PIN_AUTH: "Back to Pin Authentication",
  EMAIL_TEMPLATES_BACK_TO_RBA: "Back to Risk-Based Authentication",
  EMAIL_TEMPLATES_FEATURE_MFA: "MFA or Step Up Authentication",
  EMAIL_TEMPLATES_FEATURE_RBA: "Risk-Based Authentication",
  EMAIL_TEMPLATES_FEATURE_PIN: "Pin Authentication",
  EMAIL_TEMPLATES_TAB_EMAIL: "Email",
  EMAIL_TEMPLATES_TAB_PASSWORDLESS: "Passwordless",
  EMAIL_TEMPLATES_TAB_MFA: "MFA",
  EMAIL_TEMPLATES_TAB_RBA: "Risk Based",
  EMAIL_TEMPLATES_TAB_PIN: "PIN",
  EMAIL_TEMPLATES_TAB_SMART_LOGIN: "Smart Login",
  EMAIL_TEMPLATES_TAB_ONE_TOUCH: "One Touch Login",
  EMAIL_TEMPLATES_SETTINGS_TEMPLATE_TYPE_LABEL: "Email Template Type",
  EMAIL_TEMPLATES_SETTINGS_TEMPLATE_TYPE_PLACEHOLDER: "Select email template type",
  EMAIL_TEMPLATES_SETTINGS_TEMPLATE_TYPE_REQUIRED: "Please select an email template type",
  EMAIL_TEMPLATES_SELECT_TOKEN_TYPE_PLACEHOLDER: "Select token type",
  EMAIL_TEMPLATES_MANUAL_UPDATE_REQUIRED_TITLE: "Manual Update Required",
  EMAIL_TEMPLATES_MANUAL_UPDATE_REQUIRED_DESCRIPTION:
    "Your template content won't reflect this change automatically. Please update your email template code manually to match the selected token type.",
  EMAIL_TEMPLATES_MANUAL_UPDATE_GOT_IT: "Got it",
  EMAIL_TEMPLATES_PREVIEW_SUBJECT_PLACEHOLDER: "Email Subject",
  EMAIL_TEMPLATES_PREVIEW_SELECT_BRAND: "Select Brand",
  EMAIL_TEMPLATES_PREVIEW_SELECT_STYLE: "Select Style",
  EMAIL_TEMPLATES_DROPDOWN_TEMPLATES_HEADER: "Templates",
  EMAIL_TEMPLATES_DROPDOWN_STYLES_HEADER: "Styles",
  EMAIL_TEMPLATES_VIEW_PLACEHOLDERS: "View Placeholders",
  EMAIL_TEMPLATES_EXPLORE_VARIABLES: "Explore Placeholders",
  EMAIL_TEMPLATES_NOTE_ONE_TEMPLATE_TITLE: "One Template for all your Brands",
  EMAIL_TEMPLATES_NOTE_STYLE_DESCRIPTION: "Use Style Placeholders to create one template that automatically adapts to each brand's styles including font, color, and more.",
  EMAIL_TEMPLATES_EXPLORE_STYLE_PLACEHOLDERS: "Explore Style Placeholders",
  EMAIL_TEMPLATES_NOTE_DISMISS: "Dismiss style placeholders note",
  EMAIL_TEMPLATES_EMAIL_SETTINGS_SAVED_LOCALLY: "Email settings saved locally",
  EMAIL_TEMPLATES_BRAND_SELECTOR_TOOLTIP: "Preview this template with your current styles, to make it adapt dynamically to the selected style, use Placeholders in your code",
  EMAIL_SETTINGS_MODAL_TITLE: "Email Settings",
  EMAIL_SETTINGS_MODAL_SAVE_CHANGES_BUTTON: "Save Changes",
  EMAIL_SETTINGS_MODAL_EMAIL_PROVIDER_LABEL: "Email Provider",
  EMAIL_SETTINGS_MODAL_EMAIL_PROVIDER_TOOLTIP: "Select the service that will be used to send your emails",
  EMAIL_SETTINGS_MODAL_EMAIL_PROVIDER_REQUIRED: "Please select an email provider",
  EMAIL_SETTINGS_MODAL_EMAIL_PROVIDER_PLACEHOLDER: "Select email provider",
  EMAIL_SETTINGS_MODAL_FROM_EMAIL_LABEL: "From Email Address",
  EMAIL_SETTINGS_MODAL_FROM_EMAIL_TOOLTIP: "This is the email address your recipients will see as the sender. Make sure it’s a valid and verified address.",
  EMAIL_SETTINGS_MODAL_FROM_EMAIL_REQUIRED: "Please enter from email address",
  EMAIL_SETTINGS_MODAL_FROM_EMAIL_INVALID: "Please enter a valid email",
  EMAIL_SETTINGS_MODAL_FROM_EMAIL_PLACEHOLDER: "johndoe@department.com",
  EMAIL_SETTINGS_MODAL_FROM_NAME_LABEL: "From Name",
  EMAIL_SETTINGS_MODAL_FROM_NAME_TOOLTIP: "This name appears in the recipient’s inbox as the sender of the email",
  EMAIL_SETTINGS_MODAL_FROM_NAME_REQUIRED: "Please enter from name",
  EMAIL_SETTINGS_MODAL_FROM_NAME_MAX_LENGTH: "From Name cannot exceed 50 characters",
  EMAIL_SETTINGS_MODAL_FROM_NAME_PLACEHOLDER: "John Doe",
  EMAIL_PLACEHOLDER_MODAL_COPY_SUCCESS: "Placeholder copied to clipboard",
  EMAIL_PLACEHOLDER_MODAL_TITLE: "Placeholders",
  EMAIL_PLACEHOLDER_MODAL_TAB_IDENTITY: "Identity Placeholders",
  EMAIL_PLACEHOLDER_MODAL_TAB_STYLE: "Style Placeholders",
  EMAIL_PLACEHOLDER_MODAL_IDENTITY_BANNER_TITLE: "What are Identity Placeholders?",
  EMAIL_PLACEHOLDER_MODAL_IDENTITY_BANNER_DESC:
    "User Placeholders are named containers for storing data about the user; allowing templates to reference, manipulate, and update values like Name, Email, Phone, etc.",
  EMAIL_PLACEHOLDER_MODAL_STYLE_BANNER_TITLE: "What are Style Placeholders?",
  EMAIL_PLACEHOLDER_MODAL_STYLE_BANNER_DESC:
    "Style Placeholders are containers which use styling values stored in Auth Studio, like Button Color, Button Radius, Background Color, etc. You can control these values in",
  EMAIL_PLACEHOLDER_MODAL_HOSTED_PAGES: "Auth Studio",
  EMAIL_PLACEHOLDER_MODAL_SEARCH_PLACEHOLDER: "Search for Placeholders",
  EMAIL_PLACEHOLDER_MODAL_COLUMN_PLACEHOLDER: "Placeholder",
  EMAIL_PLACEHOLDER_MODAL_COLUMN_PROPERTY: "Property",
  EMAIL_PLACEHOLDER_MODAL_COLUMN_VALUE: "Value",
  BUTTON_SEND: "Send",
  PLACEHOLDER_USE_CASE_NAME: "Displays name of the customer",
  PLACEHOLDER_USE_CASE_GUID: "Displays the unique identifier",
  PLACEHOLDER_USE_CASE_URL: "Displays the website address",
  PLACEHOLDER_USE_CASE_PROVIDERS: "Displays the provider",
  PLACEHOLDER_USE_CASE_EMAIL: "Displays the email address",
  PLACEHOLDER_USE_CASE_FIRST_NAME: "Displays the first name",
  PLACEHOLDER_USE_CASE_LAST_NAME: "Displays the last name",
  PLACEHOLDER_USE_CASE_ADDRESS: "Displays the primary address of the customer",
  PLACEHOLDER_USE_CASE_ADDRESS2: "Displays the secondary address of the customer",
  PLACEHOLDER_USE_CASE_COUNTRY: "Displays the country of the customer",
  PLACEHOLDER_USE_CASE_CITY: "Displays the city",
  PLACEHOLDER_USE_CASE_POSTAL_CODE: "Displays the postal code",
  PLACEHOLDER_USE_CASE_REGION: "Displays the region",
  PLACEHOLDER_USE_CASE_STATE: "Displays the state",
  PLACEHOLDER_USE_CASE_IP_ADDRESS: "Displays the IP address",
  PLACEHOLDER_USE_CASE_USER_AGENT: "Displays the user agent",
  PLACEHOLDER_USE_CASE_USER_NAME: "Displays the username",
  PLACEHOLDER_USE_CASE_OTP: "Displays the one-time password",
  PLACEHOLDER_USE_CASE_TEMPLATE_NAME: "Displays the name of the configured template",
  PLACEHOLDER_USE_CASE_STYLE_NAME: "Displays the name of the configured style",
  PLACEHOLDER_USE_CASE_LOGO_DISPLAY: "Displays the brand logo display property (block/none)",
  PLACEHOLDER_USE_CASE_LOGO_URL: "Displays the URL of the brand logo",
  PLACEHOLDER_USE_CASE_PRIMARY_COLOR: "Displays the primary color of the brand",
  PLACEHOLDER_USE_CASE_FONT_FAMILY: "Displays the font family used by the brand",
  PLACEHOLDER_USE_CASE_BACKGROUND: "Displays the email background (CSS background property only)",
  PLACEHOLDER_USE_CASE_PRIMARY_TEXT_COLOR: "Displays the primary text color",
  PLACEHOLDER_USE_CASE_SECONDARY_TEXT_COLOR: "Displays the secondary text color",
  PLACEHOLDER_USE_CASE_CARD_BACKGROUND_COLOR: "Displays the card background color",
  PLACEHOLDER_USE_CASE_CARD_BOX_SHADOW: "Displays the card box shadow",
  PLACEHOLDER_USE_CASE_CARD_PADDING_TOP: "Displays the card padding top",
  PLACEHOLDER_USE_CASE_CARD_PADDING_RIGHT: "Displays the card padding right",
  PLACEHOLDER_USE_CASE_CARD_PADDING_BOTTOM: "Displays the card padding bottom",
  PLACEHOLDER_USE_CASE_CARD_PADDING_LEFT: "Displays the card padding left",
  PLACEHOLDER_USE_CASE_CARD_BORDER_COLOR: "Displays the card border color",
  PLACEHOLDER_USE_CASE_CARD_BORDER_WIDTH_TOP: "Displays the card border width top",
  PLACEHOLDER_USE_CASE_CARD_BORDER_WIDTH_RIGHT: "Displays the card border width right",
  PLACEHOLDER_USE_CASE_CARD_BORDER_WIDTH_BOTTOM: "Displays the card border width bottom",
  PLACEHOLDER_USE_CASE_CARD_BORDER_WIDTH_LEFT: "Displays the card border width left",
  PLACEHOLDER_USE_CASE_CARD_BORDER_RADIUS_TOP_LEFT: "Displays the card border radius top left",
  PLACEHOLDER_USE_CASE_CARD_BORDER_RADIUS_TOP_RIGHT: "Displays the card border radius top right",
  PLACEHOLDER_USE_CASE_CARD_BORDER_RADIUS_BOTTOM_LEFT: "Displays the card border radius bottom left",
  PLACEHOLDER_USE_CASE_CARD_BORDER_RADIUS_BOTTOM_RIGHT: "Displays the card border radius bottom right",
  PLACEHOLDER_USE_CASE_PRIMARY_BUTTON_TEXT_COLOR: "Displays the text color of the primary button",
  PLACEHOLDER_USE_CASE_PRIMARY_BUTTON_BORDER_RADIUS: "Displays the border radius of the primary button",
  PLACEHOLDER_USE_CASE_PRIMARY_BUTTON_BORDER_COLOR: "Displays the border color of the primary button",
  PLACEHOLDER_USE_CASE_PRIMARY_BUTTON_BOX_SHADOW: "Displays the box shadow of the primary button",
  PLACEHOLDER_USE_CASE_PRIMARY_BUTTON_COLOR: "Displays the background color of the primary button",
  PLACEHOLDER_USE_CASE_SECONDARY_BUTTON_COLOR: "Displays the background color of the secondary button",
  PLACEHOLDER_USE_CASE_SECONDARY_BUTTON_TEXT_COLOR: "Displays the text color of the secondary button",
  PLACEHOLDER_USE_CASE_SECONDARY_BUTTON_BORDER_RADIUS: "Displays the border radius of the secondary button",
  PLACEHOLDER_USE_CASE_SECONDARY_BUTTON_BOX_SHADOW: "Displays the box shadow of the secondary button",
  PLACEHOLDER_USE_CASE_SECONDARY_BUTTON_BORDER_COLOR: "Displays the border color of the secondary button",
  PLACEHOLDER_USE_CASE_LINK_TEXT_COLOR: "Displays the text color of the link button",
  PLACEHOLDER_USE_CASE_LINK_FONT_WEIGHT: "Displays the font weight of the link button",
  PLACEHOLDER_USE_CASE_HEADER_FONT_SIZE: "Displays the font size of the header",
  PLACEHOLDER_USE_CASE_HEADER_FONT_WEIGHT: "Displays the font weight of the header",
  PLACEHOLDER_USE_CASE_SUBHEADER_FONT_SIZE: "Displays the font size of the subheader",
  PLACEHOLDER_USE_CASE_SUBHEADER_FONT_WEIGHT: "Displays the font weight of the subheader",
  PLACEHOLDER_USE_CASE_FOOTER_TEXT_COLOR: "Displays the text color of the footer",
  PLACEHOLDER_USE_CASE_FOOTER_BACKGROUND_COLOR: "Displays the background color of the footer",
  PLACEHOLDER_USE_CASE_CUSTOM: "Custom placeholder",
  EMAIL_TEMPLATES_AI_MODAL_TITLE: "Add New Template",
  EMAIL_TEMPLATES_AI_BADGE_TEXT: "LoginRadius AI",
  EMAIL_TEMPLATES_AI_TOOLTIP_TEMPLATE_TYPE: "Select the type of email template",
  EMAIL_TEMPLATES_AI_TEMPLATE_NAME_PLACEHOLDER: "Enter template name",
  EMAIL_TEMPLATES_AI_TEMPLATE_NAME_MAX_LENGTH: "Template Name cannot exceed 50 characters.",
  EMAIL_TEMPLATES_AI_TOOLTIP_TOKEN_TYPE: "Choose whether the email should contain a link or an OTP for verification or authentication",
  EMAIL_TEMPLATES_AI_TOKEN_TYPE_REQUIRED: "Please select a token type",
  EMAIL_TEMPLATES_AI_TEMPLATE_STYLING_LABEL: "Template Styling",
  EMAIL_TEMPLATES_AI_TOOLTIP_TEMPLATE_STYLING: "Control template’s visual style. With Brand Styles, your template can adapt with all your existing styles",
  EMAIL_TEMPLATES_AI_TEMPLATE_STYLING_REQUIRED: "Please select a template styling option",
  EMAIL_TEMPLATES_AI_STYLING_STATIC_LABEL: "Start Without Brand Styles",
  EMAIL_TEMPLATES_AI_STYLING_STATIC_DESCRIPTION:
    "Create an email template with a fixed design, where colors, fonts, and layout are defined directly in the template—giving you full creative control that does not change across styles.",
  EMAIL_TEMPLATES_AI_AVAILABLE_IN_V3: "Available in V3",
  EMAIL_TEMPLATES_AI_STYLING_DYNAMIC_LABEL: "Use Brand Styles",
  EMAIL_TEMPLATES_AI_STYLING_DYNAMIC_DESCRIPTION:
    "Create an email template using style placeholders of existing Auth Studio templates, such as colors, fonts, spacing and more, so the email template can automatically adapt across all your styles.",
  EMAIL_TEMPLATES_AI_PROMPT_LABEL: "Prompt",

  EMAIL_TEMPLATES_AI_PROMPT_REQUIRED: "Please enter a prompt",
  EMAIL_TEMPLATES_AI_PROMPT_PLACEHOLDER: "Write your prompt",
  EMAIL_TEMPLATES_AI_SAMPLE_PROMPT: "Random Prompt",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_1: "I need an email template for when a user wants to add a new email address. It should just ask them to verify with an OTP.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_2:
    "Generate an HTML template to add email with OTP. Use a clean, modern theme — e.g., primary color #1a73e8, accent/secondary #f1f3f4, and neutral text #333; font-family Arial or a similar sans-serif. It needs a title, a line of text like 'Use this code to confirm your new email:', the #OTP# variable, and a footer. Also, add a small line saying 'This code expires in 10 minutes.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_1:
    "Write a professional and welcoming email for our B2B platform, 'TeamSync'. The subject should be 'You're invited to join [Organization Name]'. The body should say 'To accept your invitation, please use this code: #OTP#'. Use a clean, corporate-style layout.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_2:
    "Generate the email to invite user to organization (OTP) template. It must clearly state they've been invited and provide the #OTP# for verification along with an expiry time. Keep the design minimal — use a simple sans-serif font (e.g., Arial or Helvetica), a restrained color palette (primary blue like #1a73e8, white background, and subtle gray accents such as #f5f5f5), and clear readable typography. We need this to be highly reliable.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_1:
    "Generate a security-focused email for delete account using OTP. Subject: 'Action Required: Account Deletion Request'. Clearly state that a request was made and to use the #OTP# to confirm. Must include a 'If this wasn't you, please contact support immediately' line.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_2:
    "Write a simple, serious email for account deletion. Use a neutral, professional theme: dark blue or charcoal text on a white background with subtle gray accents; clean sans‑serif font such as Arial or Helvetica at a readable size. 'We're sorry to see you go.' Then, 'To confirm you want to permanently delete your account, use this code: #OTP#'. Add a strong warning that this action is irreversible.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_1:
    "Create a helpful 'Reset Password' email for our 'GameVerse' app. 'Lost your password? No worries!' It needs to show the OTP code clearly in the #FPass section. Below that, in the #FProv section, gently remind them 'You usually log in with: #Providers#'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_2:
    "I need a reset password email. It should give the user an OTP and also tell them what provider they used to log in. Use a clean, modern theme with primary color #1a73e8, accent #ff6b6b, neutral background #f5f7fa, and system sans-serif or 'Inter' font; headings bold, body regular, accessible contrast.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_RESETPASSWORD_1:
    "Create a security confirmation email for 'GlobalBank'. Subject: 'Your Password Has Been Changed'. It must sound very official and secure. 'Your password was successfully reset' And a strong warning: 'If you did not make this change, please lock your account and contact us immediately.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_RESETPASSWORD_2:
    "Generate an email that just tells the user their password was successfully changed. Use a clean, simple theme with neutral colors (white background, #333333 text) and a single accent color (e.g., #0A84FF) and a readable sans-serif font such as Arial or Roboto.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_1:
    "Generate an email verification template for new signups (REGISTRATION - OTP). Subject: 'Your Verification Code'. Body text: 'Welcome! Please use the following code to verify your email address: #OTP#'. Include a standard footer with our company info.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_2:
    "Make a 'Welcome to ShopCentral!' email. Use brand theme — warm orange accents (#FF6A00), soft gray background (#F7F7F7), and clean sans-serif fonts (system-ui, Arial) with good contrast. 'Just one more step to start shopping!' Ask them to verify their email using the provided code. Make the #OTP# code placeholder really big and easy to copy on a phone.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_WELCOME_1:
    "Generate a generic WELCOME template. my custom welcome message will be injected. Start with 'Welcome to [Our Company Name]!' 'We're excited to have you...",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_WELCOME_2:
    "Design a beautiful, image-heavy welcome email for our travel site 'GoExplore'. Subject: 'Welcome Aboard, [User's Name]!' It should have a nice hero image of a beach [https://placehold.co/600x400/000000/ffffff?text=beach], using a tropical color palette (teal, coral, sandy beige) and clean sans-serif fonts (Poppins or Helvetica) with warm accent color for CTAs, a short welcome message, and maybe some links to 'Get Started' [https://travel.com/get-started] or 'Explore Deals' [https://travel.com/explore-deals].",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_1:
    "Make a super simple 'Login to QuickDocs' email. Subject: 'Your Login Code'. Body: 'Here's your code to sign in: #OTP#'. Make it very mobile-friendly and fast to load. No images, just text and the code.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_2:
    "I need an email for our one-click sign-in feature. It just sends an OTP. Use a clean, minimal theme with brand colors (navy #123456 and accent teal #00A89D), neutral background (#f7f8fa), and a clear call-to-action button. Prefer a simple font stack (Helvetica, Arial, sans-serif) and concise, readable typography.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SECONDFACTORAUTHENTICATION_1:
    "Create a 'GlobalBank' 2FA email. Subject: 'Your Two-Factor Authentication Code'. It needs to look very official and secure. 'Use this code to complete your login: #OTP#'. Add a strong warning: 'Do not share this code with anyone. Our staff will never ask for it.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SECONDFACTORAUTHENTICATION_2:
    "Generate a template for multi-factor authentication. This is a high-security email. Plain, clear. Use a sober dark-blue and white color scheme, minimal layout, and a clean sans-serif font (e.g., Arial or Helvetica) for readability. 'Your verification code is: #OTP#'. Also include 'If you did not request this, please change your password immediately.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_IP_EMAIL_TO_USER_1:
    "Generate the template for reporting login using suspicious ip address. Must clearly display 'New IP Address: #SuspiciousValue#' and 'Time: #SuspiciousLoginTime#'. Include a strong recommendation to change their password if they don't recognize this activity.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_IP_EMAIL_TO_USER_2:
    "Make a security alert email. 'Suspicious Login Alert'. Use our brand's red warning color. 'We detected a login from a new IP address: #SuspiciousValue# at #SuspiciousLoginTime#.' Then give them a link to 'Review Account Activity'. Use a clean sans-serif font (Arial/Helvetica, system sans), bold the red headline, body text in neutral dark gray, subtle light-gray background, and present the 'Review Account Activity' link as a prominent red CTA button with white text and readable font sizes.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_CITY_EMAIL_TO_USER_1:
    "Create a 'Security Alert' email for 'GoExplore'. 'Hi [Name], did you just log in from #SuspiciousValue#?' Show the city and the time (#SuspiciousLoginTime#). 'If this looks unfamiliar, please secure your account immediately.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_CITY_EMAIL_TO_USER_2:
    "Need a 'report suspicious city login' email template. Use an alert theme with red accent color (#d9534f) and a neutral background (#f8f9fa), clean sans-serif font (Arial or Helvetica). List the details in a structured way: 'City: #SuspiciousValue#', 'Time: #SuspiciousLoginTime#'. Provide a direct link to their account's security settings page.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_COUNTRY_EMAIL_TO_USER_1:
    "This is a high-priority alert. 'URGENT: Security Alert for your GlobalBank Account'. 'A new login from #SuspiciousValue# (Time: #SuspiciousLoginTime#) was detected.' Make it very clear and provide a 'Lock My Account' link.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_COUNTRY_EMAIL_TO_USER_2:
    "Generate an 'report login form new country' email template. 'We detected a login from a new country: #SuspiciousValue#.' 'Date/Time: #SuspiciousLoginTime#.' This must have a prominent 'If this wasn't you, reset your password now' link. Use a clean, security-focused theme: red accent (#E53935) for alerts, dark gray headings, light gray background, and a system sans-serif font (e.g., Roboto/Arial).",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_BROWSER_EMAIL_TO_USER_1:
    "Make a 'New Browser Login' notification for 'GameVerse'. 'Hey! We noticed you logged in from a new browser: #SuspiciousValue#.' 'Time: #SuspiciousLoginTime#'. Keep it friendly but informative. 'Was this you? If not, let's secure your account.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_BROWSER_EMAIL_TO_USER_2:
    "Alert user about a login from a new browser. Use a clean, security-themed design with navy blue and alert red accents, neutral gray background, and white content panels; prefer sans-serif fonts like Arial or Roboto with clear readable sizes and strong contrast for accessibility.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_DEVICE_EMAIL_TO_USER_1:
    "Generate a suspicious device login email template. 'A login from a new device (#SuspiciousValue#) occurred at #SuspiciousLoginTime#. If you do not recognize this activity, please secure your account.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_SUSPICIOUS_DEVICE_EMAIL_TO_USER_2:
    "Create an email 'New Device Sign-In'. 'Your 'ShopCentral' account was just accessed from a new device: #SuspiciousValue#.' Include the time. 'If this was you, you can ignore this. If not, please change your password.' Use a clean, professional theme — primary color navy #0A2540, accent teal #00A99D, warning red #D9534F; fonts: system UI sans-serif stack (Arial, Helvetica, -apple-system, Roboto).",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_RISK_IDENTIFIED_TO_ADMIN_1:
    "This is an internal admin alert for our 'AcmeCorp' platform. Subject: 'LoginRadius Risk Alert'. 'A high-risk login was detected.' Then list all the details: 'User UID: #uid#', 'Risk Factor: #SuspicousFactor#', 'Value: #SuspicousValue#', 'Time: #SuspicousLoginTime#'. Make it look like a system report, very plain.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_RISK_IDENTIFIED_TO_ADMIN_2:
    "Generate a plain-text or simple HTML email for RISK_IDENTIFIED_TO_ADMIN. Use a simple, professional theme—neutral colors (e.g., #333333 text, #f7f7f7 background), an accent blue like #0070d2, and a clean sans-serif font such as Arial or Helvetica. It needs to be a data dump. Use a list format: UID: #uid#, Factor: #SuspicousFactor#, Value: #SuspicousValue#, Time: #SuspicousLoginTime#. Add a link to our admin dashboard for more details: https://admin.acmecorp.com/user/#uid#.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_1:
    "Create an email for our 'GlobalBank' app. 'Reset Your PIN'. 'Use the following code to set a new PIN: #OTP#'. Must be very secure and professional. Use our official bank header and footer.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_2:
    "Email for resetting a PIN. It should send an OTP. Theme: clean, trustworthy design using blue (#1E88E5) and white with a subtle gray (#F5F7FA) background, green (#43A047) accent for success states; use a modern sans-serif font (Inter or system sans-serif, fallback Arial), high-contrast dark text, and a clear primary CTA button styled in blue.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_AUTOLOGIN_1:
    "Create a 'Here's your magic login link!' email for 'GameVerse'. 'Click the button below to sign in to your account instantly.' Button text: 'Sign Me In'. Make it fun and use our brand colors and logo.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_AUTOLOGIN_2:
    "Template for Smart Login. This is similar to ONECLICKSIGNIN. The key is the link: #Url#?vtype=smartlogin&vtoken=#GUID#. Create a prominent button with this link. Add a line: 'This link was requested for your account and is one-time use.' Use a clean, modern theme — primary color #1a73e8 (blue) for the button, secondary neutral #f5f7fa background, dark gray #333 text; font: Helvetica, Arial, sans-serif.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_1:
    "Generate the template for One touch login using OTP. The description says 'confirm their email'. So, Subject: 'Confirm Your Email Address'. Body: 'Please use this code to continue: #OTP#'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_2:
    "Make an email for 'ShopCentral'. 'Confirm your email to continue'. 'To sign in or create your account, please use this code: #OTP#'. This is for new users, so make it welcoming and explain what's happening. Use a friendly, modern ShopCentral theme: navy blue header (e.g., #0A47A1), white background, bright orange accent for the CTA (e.g., #FF6A00), and clean sans-serif fonts like Montserrat or Arial; keep layout simple and mobile-friendly.",
  EMAIL_TEMPLATES_AI_CREATE_FAILED: "Failed to create template with AI",
  EMAIL_TEMPLATES_AI_CREATE_BUTTON: "Create Template",
  EMAIL_TEMPLATES_TYPE_VERIFICATION_EMAIL: "Verification Email",
  EMAIL_TEMPLATES_TYPE_FORGOT_PASSWORD_EMAIL: "Forgot Password Email",
  EMAIL_TEMPLATES_TYPE_WELCOME_EMAIL: "Welcome Email",
  EMAIL_TEMPLATES_TYPE_ADD_EMAIL: "Add Email",
  EMAIL_TEMPLATES_TYPE_PASSWORD_RESET_EMAIL: "Password Reset Email",
  EMAIL_TEMPLATES_TYPE_DELETE_ACCOUNT_EMAIL: "Delete Account Email",
  EMAIL_TEMPLATES_TYPE_EMAIL_PASSCODE: "Email Passcode",
  EMAIL_TEMPLATES_TYPE_PASSWORDLESS_LOGIN: "Passwordless Login",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_CITY: "Suspicious City",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_COUNTRY: "Suspicious Country",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_IP: "Suspicious IP",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_BROWSER: "Suspicious Browser",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_DEVICE: "Suspicious Device",
  EMAIL_TEMPLATES_TYPE_SUSPICIOUS_ADMIN: "Suspicious Admin",
  EMAIL_TEMPLATES_TYPE_FORGOT_PIN: "Forgot Pin",
  EMAIL_TEMPLATES_TYPE_SMART_LOGIN: "Smart Login",
  EMAIL_TEMPLATES_TYPE_ONE_TOUCH_LOGIN: "One Touch Login",
  EMAIL_TEMPLATES_TYPE_INVITE_ORGANIZATION: "Invite User to Organization",
  DEFAULT_SMS_TEMPLATE: "Hello #Name#, your account was recently logged into from a new city, #SuspiciousValue#, on #SuspiciousLoginTime#. Regards",
  SMS_CONTENT_: "SMS Content",
  SMS_CONTENT_REQUIRED: "SMS Content is required.",
  SENT_EMAIL: "Email sent successfully.",
  UNABLE_SEND_EMAIL: "Unable to send email.",
  UNABLE_DELETE_TEMPLATE: "Unable to delete template.",
  LABEL_RESET_CONFIRMATION: "Are you sure you want to reset this to the default template?",
  SMS_SETTING_TEXT: "Configure these settings for the SMS triggered for Multi-Factor Passcode through LoginRadius.",
  ADD_EMAIL: "Add Email(s)",

  // Identity Workflow > Verification Workflow
  VERIFICATION_WORKFLOW_TAB_DESCRIPTION: "View the configured email verification workflow and, if desired, request changes.",
  MANDATORY_EMAIL_VERIFICATION: "Email Verification",
  MANDATORY_EMAIL_VERIFICATION_DESCRIPTION:
    "Email verification is mandatory for your application users after registration. Users will receive a verification email and must complete the verification process to log in for the first time.",
  OPTIONAL_EMAIL_VERIFICATION_DESCRIPTION:
    "Email verification is optional for your application users after registration. Users will receive a verification email but can log in without completing the verification process.",
  NO_EMAIL_VERIFICATION: "No Email Verification",
  NO_EMAIL_VERIFICATION_DESCRIPTION: "Email verification is not required after registration.",
  SOCIAL_EMAIL_VERIFICATION: "Social Email Verification",
  SOCIAL_EMAIL_VERIFICATION_DESCRIPTION: "When enabled, users registering through social providers receive a verification email and must verify their email address before logging in.",
  SOCIAL_PROVIDERS: "Social Providers",
  // Identity Workflow > Communication Configuration
  GLOBAL_EMAIL_SETTINGS_TAB_DESCRIPTION: "Default settings for all event-based emails.",
  REQUEST_LIMIT_NO_STAR: "Request Limit (Seconds)",
  REQUEST_DISABLED_PERIOD_MINUTES: "Request Disabled Period",
  EMAIL_TOKEN_VALIDITY_LIMIT: "Email Token Validity Limit",
  GLOBAL_EMAIL_SETTINGS_REQUEST_LIMIT_INFO: "The number of times an end user can request event-based emails within a given time period.",
  GLOBAL_EMAIL_SETTINGS_DISABLED_PERIOD_MINUTES_INFO: "The duration a customer can request verification emails and the disabled duration after the request limit is reached.",
  GLOBAL_EMAIL_SETTINGS_TOKEN_VALIDITY_LIMIT_INFO: "The duration for which the link in the event-based email remains valid.",
  MAXIMUM_ACCEPTED_VALUE_IS: "The maximum accepted value is",
  VALUE_MUST_BE_BETWEEN: "The value must be between",
  AND: "and",
  VALUE_MUST_BE_AN_INTEGER: "The value must be an integer.",
  GLOBAL_SMS_SETTINGS_TAB_DESCRIPTION:
    "For all event-based OTPs, configure the delivery method (via text, SMS, or voice call) to your users, along with settings such as OTP length, type, limit, and validity.",
  GLOBAL_SMS_SETTINGS_REQUEST_LIMIT_INFO:
    "The number of times a user can request an event-specific OTP during the configured period. For example, a user can request an OTP 5 times (Request Limit) over 120 seconds (Request Disabled Period).",
  GLOBAL_SMS_SETTINGS_DISABLED_PERIOD_SECONDS_INFO: "The period during which the request limit is enforced and the disable period for the user upon reaching the request limit.",
  GLOBAL_SMS_SETTINGS_OTP_VALIDITY_LIMIT_INFO: "OTP code validity duration.",
  REQUEST_DISABLED_PERIOD_SECONDS: "Request Disabled Period (Minutes)",
  OTP_VALIDITY_LIMIT: "OTP Validity Limit",
  OPTION_NUMERIC: "Numeric",
  OPTION_ALPHA_NUMERIC: "Alphanumeric",
  OPTION_ALPHA_NUMERIC_ALL_UPPERCASE: "Alphanumeric (All Uppercase)",
  OPTION_ALPHA_NUMERIC_ALL_LOWERCASE: "Alphanumeric (All Lowercase)",
  OTP_LENGTH_REQUIRED: "OTP Length is required.",
  MINIMUM_OTP_LENGTH_ERROR_MESSAGE: "The minimum OTP length is ",
  ENTER_OTP_LENGTH: "Enter the OTP Length here",
  OTP_TYPE_REQUIRED: "OTP Type is required.",

  ADD: "Add",
  MANAGE_CUSTOM_AUTH: "Manage Your Custom OAuth Configurations",
  MANAGE_SAML_AUTH: "Manage Your SAML Configurations",
  MANAGE_ADFS_AUTH: "Manage Your ADFS Configurations",
  MANAGE_JWT_AUTH: "Manage Your JWT Configurations",
  CONFIGURED_STORES: "Configured Stores",
  CONFIGURED_APPS: "Configured Apps",
  NO_CONFIGURED_APP: "Get started by adding applications to authenticate.",
  NO_CONFIGURED_APP_TITLE: "No Apps Available",
  NO_CONFIGURED_STORE: "You currently have no configured stores.",
  NO_CONFIGURED_APPS: "You currently have no configured apps.",
  ENTER_PROVIDER_NAME: "Enter Provider Name",
  ENTER_THE: "Enter the ",
  ADD_A_NEW_PROVIDER: "Add a New Provider",
  ADD_A_NEW_PROVIDER_DES: "Fill out the form below to submit a request to add a new app.",
  ADD_A_NEW_JWT_APP: "Add JWT App",
  CLOCK_SKEW_TOOLTIP:
    "Clock Skew is the acceptable time difference between the issuer and the receiver. It accepts an integer value. Enter a positive value if the receiver's clock is behind the issuer's, and a negative value if ahead. A zero or blank value indicates no time difference.",
  EITHER_JWKSURL_OR_KEY_IS_REQUIRED: "Either a JWKS Endpoint or a Key is required.",
  UPDATE_EMAIL_PROFILE_TOOLTIP: "If enabled, the RaaS profile will be updated with the value received from the social profile.",
  INVALID_QUERY_IN_SAVED_SEGMENTS: "The query in the saved segmentation is invalid.",
  INVALID_SEGMENT_NAME: "Invalid segment name. It cannot consist solely of whitespace or exceed 100 characters.",
  INVALID_SEGMENT_NAME_POPUP: "Invalid Segment Name",
  INVALID_VALUE: "Invalid value",
  SAGEMENT_NAME_EXISITS: "A segment with this name already exists. Please enter a different name.",
  INVALID_JSON: "Invalid JSON.",

  // Auth Workflow
  ACCOUNT_WORKFLOW_DESC:
    "Enable or disable authentication methods for your application. You can also manage settings related to account merging, registration via a custom provider, and duplicate emails with usernames.",
  ADVANCED_WORKFLOW_DESC: "Configure advanced workflows related to registration and authentication security.",
  WORKFLOW_EMAIL_REGISTRATION: "Email Registration",
  WORKFLOW_EMAIL_REGISTRATION_DESC: "When enabled, users can register with an email address.",
  WORKFLOW_PHONE_REGISTRATION: "Phone Registration",
  WORKFLOW_PHONE_REGISTRATION_DESC: "When enabled, users can register with a phone number.",
  WORKFLOW_SOCIAL_REGISTRATION: "Social Registration",
  WORKFLOW_SOCIAL_REGISTRATION_DESC: "When enabled, users can register with a social ID provider.",
  WORKFLOW_PASSWORDLESS_LOGIN: "Passwordless Login",
  WORKFLOW_PASSWORDLESS_LOGIN_DESC:
    "When enabled, registered users can log in with a link or OTP sent to their email or phone number. However, users must set an account password during registration.",
  WORKFLOW_USERNAME_REGISTRATION: "Username Registration",
  WORKFLOW_USERNAME_REGISTRATION_DESC: "When enabled, users can log in with a username instead of an email address.",
  WORKFLOW_USERNAME_DUPLICATE_EMAILS: "Duplicate Email with Username",
  WORKFLOW_USERNAME_DUPLICATE_EMAILS_DESC: "When enabled, a user can have multiple accounts with the same email address, but each account must have a unique username.",
  WORKFLOW_CASE_SENSITIVE_USERNAME: "Case-Sensitive Username",
  WORKFLOW_CASE_SENSITIVE_USERNAME_DESC:
    "When enabled, usernames are case-sensitive. For example, 'Username', 'UserName', 'username', and 'USERNAME' are considered different users within the same application.",
  WORKFLOW_SECURE_COOKIE: "Secure Cookie",
  WORKFLOW_SECURE_COOKIE_DESC: "HTTP requests will include a cookie only if made over a secure HTTPS channel.",
  WORKFLOW_SERVER_SIDE_VALID: "Server-Side Validation",
  WORKFLOW_SERVER_SIDE_VALID_DESC: "When enabled, validation rules for registration fields are enforced in the APIs.",

  // SSO Integration
  SSO_INTEGRATION: "SSO Integration",
  MANAGE_SSO_INTEGRATION_DESC: "Maintain your Single Sign-On (SSO) integrations. Here you can connect, update, or remove identity providers to enable secure authentication for your applications.",

  // Access Configuration > Federated SSO
  OAUTH2_TAB_DESCRIPTION:
    "LoginRadius allows you to integrate your OAuth 2.0 client with LoginRadius. OAuth 2.0 (RFC 6749) is a set of standardized flows that enable you to use LoginRadius as a custom Identity Provider (IDP) for your services, allowing seamless customer login to your application using a standard procedure.",
  API_KEY_HEADER: "1. API Key: ",
  CALLBACK_URL_DESCRIPTION: "2. Callback URL: The URL of your site where users will be redirected after authentication.",
  SCOPE_URL_DESCRIPTION: "3. Scope: Permissions you want to request from users. Click here to configure a custom scope.",
  RESPONSE_TYPE_DESCRIPTION: "3. Response Type: Possible values are 'code', 'token', or both 'code' and 'token'.",
  CLICK_HERE_TO_GO_TO_SOCIAL_LOGIN: "Click here to go to Social Login to configure a custom scope.",
  ADD_NEW_OAUTH_CUSTOM_IDP: "Add a New Custom OAuth Provider",
  CUSTOM_IDP_DESCRIPTION:
    "Configure external custom Identity Providers (IDPs) compatible with SAML, OAuth 2.0, or OIDC. LoginRadius can forward user authentication requests to this provider and receive the authentication status.",
  CUSTOM_IDP_TOOLTIP: "LoginRadius will act as a service provider here",
  INVALID_APP_NAME: "The app name is not valid.",
  INVALID_TIME_LIMIT: "The maximum accepted value is 70.",
  INVALID_TIME: "The value must be an integer.",
  INVALID_PROVIDER_NAME: "The provider name is not valid.",
  INVALID_STORE_NAME: "The store name is not valid.",
  DATA_MAPPING_TEXT: "Fields or properties you want to include in the data response. The JSON Sample box shows sample data mapped to the selected keys.",
  NOTE_AUTOLOOKUP:
    "When AutoLookup is enabled, users are automatically redirected to the specified custom Identity Provider (IDP) after entering an email with this domain name. Otherwise, they follow the regular login workflow. When AutoLookup is enabled, the specific IDP does not appear in the Social Schema.",
  INVALID_DOMAIN_AUTOLOOKUP: "Invalid domain",
  AUDIENCES_TOOLTIP: "The intended recipients of the issued assertions.",
  LESS_THAN_MESSAGE: "must be less than or equal to %s.",
  POSITIVE_NUMBER: "must be greater than 0.",
  OTP_HEADER: "Fully customize the settings for your OTP here.",
  OTP_ERROR_MSG: "The OTP length must be between 4 and 8 characters.",
  OTP_LENGTH: "OTP Length",
  OTP_TYPE: "OTP Type",
  ADD_CUSTOM_FIELD: "Add Custom Field",
  YOU_DO_NOT_CURRENTLY_HAVE_ANY_CUSTOM_REGISTRATION_DATA: "You currently have no custom registration data.",
  SOCIAL_DATA_HEADER:
    "This section allows you to select the data points to collect from customers when they sign up with a social ID. Accessing data points beyond Basic Data may require additional steps with your chosen social provider(s).",
  BASIC_DATA: "Basic Data",
  EXTENDED_DATA: "Extended Data",
  SSO_DOMAIN_GROUPING_TAB_DESCRIPTION: "This page provides a view-only list of all production websites subscribed to LoginRadius Single Sign-On.",
  WEBSITE_URLS: "Website URL(s)",
  SSO_DOMAIN_GROUPING_ADD_DOMAIN: "Add New SSO Domain",
  ADD_NEW_SSO_DOMAINS: "Add New SSO Domains",
  SMS_TEMPLATES: "SMS Templates",
  EMAIL_TEMPLATES: "Email Templates",
  TEAM_MANAGEMENT_HEADER: "Manage team members for your LoginRadius account.",
  SOCIAL_PROVIDER_HEADER: "Configure and manage Social Identity Providers with pre-built connectors.",
  PLEASE_CONNECT_THIS_DATA_SOURCE_WITH_A_CUSTOME_FIELD_BEFORE_INSERTING_ANY_DATA: "Please connect this data source with a custom field before inserting any data.",
  VERIFICATION_SUBJECT: "Email Verification Settings",
  FORGOT_PASSWORD_SUBJECT: "Forgot Password Email Settings",
  WELCOME_EMAIL_SUBJECT: "Welcome Email Settings",
  DELETE_ACCOUNT_EMAIL_SUBJECT: "Delete Account Email Settings",
  PHONE_LOGIN_PHONENO_VERIFICATION_SUBJECT: "Phone Number Verification Settings",
  DELETE_ACCOUNT: "Delete Account",
  ADD_A_SAML_APP: "Add a SAML App",
  PHONE_LOGIN_PHONE_CHANGE_SUBJECT: "Phone Number Change Settings",
  PHONE_LOGIN_PASSWORD_RESET_SUBJECT: "Password Reset Settings",
  PHONE_LOGIN_WELCOME_SUBJECT: "Welcome SMS Settings",
  PHONE_LOGIN_ONETOUCHLOGIN_SUBJECT: "One-Touch Login SMS Settings",
  ADD_EMAIL_SUBJECT: "Add Email Settings",
  ADD_EMAIL_: "Add Email",
  PASSWORD_RESET_EMAIL_SUBJECT: "Reset Password Confirmation Email Settings",
  ONE_TOUCH_LOGIN_SUBJECT: "One-Touch Login Email Settings",
  SMART_LOGIN_SUBJECT: "Smart Login Email Settings",
  NO_CONFIGURATION_REQUIRED: "No configuration required.",
  SELECT_AND_CONFIGURE_PROVIDER: "Select and configure social ID providers",
  PHONE_LOGIN_PHONENO_VERIFICATION_DEFAULT: "Your Verification OTP is: #OTP#",
  PHONE_LOGIN_PHONE_CHANGE_DEFAULT: "Your Change Phone Number OTP is: #OTP#",
  PHONE_LOGIN_PASSWORD_RESET_DEFAULT: "Your Password Reset OTP is: #OTP#",
  PHONE_LOGIN_ONETOUCHLOGIN_DEFAULT: "Use #OTP# as your login code",
  PHONE_LOGIN_WELCOME_DEFAULT: "Hi #Name#, <br> Thanks for signing up.",
  FIELDS_SAVED: "Fields saved.",
  CUSTOM_FIELD_ADDED: "Custom field added successfully.",
  CUSTOM_FIELD_REMOVED: "Custom field removed successfully.",
  GENERAL: "General",
  ADVANCED: "Advanced",
  ACTIVE_FIELDS: "Active Fields",
  DISABLED_FIELD: "Disabled Field",
  STANDARD_FIELDS_BASIC: "Standard Fields (Basic)",
  STANDARD_FIELDS_ADVANCED: "Standard Fields (Advanced)",
  CUSETOME_FIELDS: "Custom Fields",
  ADD_NEW_FIELDS: "Add New Field",
  SETTING: "Settings",
  VALIDATION_STRING: "Validation String",
  DATA_SOURCE: "Data Source",
  FIELD_SETTINGS: "Field Settings",
  FORGOT_PIN_EMAIL_SUBJECT_INFO: "Forgot PIN with Email Settings",
  PASSWORDLESS_LOGIN_EMAIL_SUBJECT: "Passwordless Login with Email Settings",
  FORGOT_PIN: "Forgot PIN",
  FORGOT_PIN_EMAIL_SUBJECT: "Please Reset Your PIN",
  FORGOT_PIN_EMAIL_TEXT_TEMPLATE: `Hello #Name#,

Please reset your PIN by clicking the link below.
To reset your PIN, click the following link. If your browser does not open it, copy and paste it into your browser’s address bar:

#Url#?vtype=resetpin&vtoken=#GUID#

Regards
  `,
  FORGOT_PIN_SMS_DEFAULT: "Your Forgot PIN OTP is: #OTP#",
  FORGOT_PIN_EMAIL_BODY:
    "Hello #Name#,<br/><br/>Please reset your PIN by clicking the link below. <br/>To reset your PIN, click the following link. If your browser does not open it, copy and paste it into your browser’s address bar:<br/><br/>#Url#?vtype=resetpin&vtoken=#GUID#<br/><br/>Regards<br/>",
  ONE_CLICK_SIGNIN: "Passwordless Login",
  ONE_CLICK_SIGNIN_EMAIL_SUBJECT: "One-Click Sign-In",
  ONE_CLICK_SIGNIN_EMAIL_TEXT_TEMPLATE: `Hello #Name#,

You can login to your account by clicking the link below. Click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:

#Url#?vtype=oneclicksignin&vtoken=#GUID#

Regards
  `,
  ONE_CLICK_SIGNIN_EMAIL_BODY:
    "Hello #Name#,<br/><br/>You can login to your account by clicking the link below. Click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:<br/><br/>#Url#?vtype=oneclicksignin&vtoken=#GUID#<br/><br/>Regards<br/>",
  PASSWORDLESS_LOGIN_EMAIL_NOTIFICATION_INFO: "The amount of time that the #emailname# feature remains disabled for the customer after they reach their request limit.",
  PASSWORDLESS_LOGIN_EMAIL_REQUEST_LIMIT:
    "The Request Limit is the number of times a customer can request #emailname# during the request period before this feature is temporarily disabled. For example, a customer can request this email only 5 times (Request Limit) over 120 minutes (Request Period) before the feature is disabled.",
  PASSWORDLESS_LOGIN_EMAIL_HEADER:
    "By using 'Passwordless Login with Email,' also known as 'Passwordless Login,' an email with a login link is sent to the customer’s email address. Clicking the link logs the customer into their account. Configure your Passwordless Login with Email settings here.",
  STANDARD_LOGIN_VERIFICATION_EMAIL_HEADER:
    "You can fully customize the Verification Email sent to customers when they first register on your site. This email contains a link the customer must follow to verify their email address. Click the 'Add Template' button to start customizing your email templates. These templates support HTML and CSS.",
  STANDARD_LOGIN_FORGOT_PASSWORD_EMAIL_HEADER:
    "You can fully customize the Forgot Password Email sent to customers who request a password reset. This email contains a link the customer must follow to reset their password. Click the 'Add Template' button to start customizing your email templates. These templates support HTML and CSS.",
  STANDARD_LOGIN_WELCOME_EMAIL_HEADER:
    "You can fully customize the Welcome Email sent to newly registered customers here. This section allows you to define the email subject and body. We also support HTML code to incorporate your design and external URLs. These templates support HTML and CSS.",
  STANDARD_LOGIN_DELETE_ACCOUNT_EMAIL_HEADER:
    "You can fully customize the Delete Account Confirmation Email sent to confirm a customer’s request to delete their account within your web or mobile property. These templates support HTML and CSS.",
  STANDARD_LOGIN_ADD_EMAIL_HEADER: "You can fully customize the 'Add Email' email sent to customers who add a new email. These templates support HTML and CSS.",
  STANDARD_LOGIN_PASSWORD_RESET_EMAIL_HEADER:
    "You can fully customize the Password Reset Email sent to customers who request to retrieve or reset their passwords. This email contains a link the customer must follow to reset or retrieve their password. Click the 'Add Template' button to start customizing your email templates. These templates support HTML and CSS.",
  STANDARD_LOGIN_SMARTLOGIN_EMAIL_HEADER: "You can fully customize the Smart Login message sent to the customer’s email when the Smart Login feature is enabled. These templates support HTML and CSS.",
  STANDARD_LOGIN_ONETOUCHLOGIN_EMAIL_HEADER: "An email is sent when a customer executes a One-Touch Login. These templates support HTML and CSS.",
  PHONELOGIN_VERIFICATION_SMS_HEADER:
    "You can fully customize the Verification SMS template sent to customers when they first register with your site. This SMS contains an authentication code the customer needs to verify their phone number.",
  PHONELOGIN_PHONE_NO_CHANGE_SMS_HEADER:
    "You can fully customize the Phone Change SMS template sent to customers when they attempt to change their account phone number. This SMS contains an authentication code the customer needs to verify their new phone number.",
  PHONELOGIN_WELCOME_SMS_HEADER: "You can fully customize the Welcome SMS template sent to customers when they first register with your site.",
  PHONELOGIN_PASSWORDRESET_SMS_HEADER:
    "You can fully customize the Password Reset SMS template sent to customers when they use the Password Reset interface. This SMS contains an authentication code the customer needs to reset their password.",
  PHONELOGIN_ONETOUCHLOGIN_SMS_HEADER: "An SMS is sent when a customer executes a One-Touch Login. This SMS contains an authentication code the customer needs to verify their phone number.",
  PASSWORDLESS_LOGIN_SMS_DEFAULT: "Your One-Time Passcode (OTP) SMS verification code is #OTP#",
  PASSWORDLESS_LOGIN_SMS_HEADER:
    "With Passwordless Login with OTP, the user provides a phone number at registration. For each subsequent login, the user enters their phone number, and an OTP is sent to it. Configure your Passwordless Login with OTP settings here.",
  PASSWORDLESS_LOGIN_ONETIMEPASSCODE_SUBJECT: "Passwordless Login with OTP Settings",
  FORGOT_PIN_SUBJECT: "Forgot PIN with SMS Settings",
  ONETOUCHLOGIN_EMAIL_BODY:
    "Hello Guest,<br/><br/>Click this link to confirm your email address. Click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:<br/><br/>#Url#?vtype=noregistration&vtoken=#GUID#&welcomeemailtemplate=#welcomeemailtemplate#<br/><br/>Regards<br/>",
  ONETOUCHLOGIN_SMS_EMAIL_SUBJECT: "Log in Without Registration",
  SMART_LOGIN: "Smart Login",
  SMART_LOGIN_EMAIL_BODY:
    "Hello #Name#,<br/><br/>You can login to your account by clicking the link below.<br/>To log in, click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:<br/><br/>#Url#?vtype=smartlogin&vtoken=#GUID#<br/><br/>Regards<br/>",
  SMART_LOGIN_TEXT_TEMPLATE: `Hello #Name#,

You can login to your account by clicking the link below.
To log in, click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:

#Url#?vtype=smartlogin&vtoken=#GUID#

Regards
  `,
  ONETOUCHLOGIN_SMS_EMAIL_TEXT_TEMPLATE: `Hello Guest,

Click this link to confirm your email address. Click the following link, and if your browser does not open it, copy and paste it into your browser’s address bar:

#Url#?vtype=noregistration&vtoken=#GUID#&welcomeemailtemplate=#welcomeemailtemplate#

Regards
    `,
  PREVIEW_FOR: "Preview for",
  COMMON_PASSWORD_PREVENTION_DESC: "Blocks passwords that appear in widely used common password lists.",
  PASSWORD_POLICY: "Configure password expiration, history, and complexity rules to enhance account security and enforce strong authentication standards.",
  DICTIONARY_PASSWORD_PREVENTION_DESC: "Blocks common dictionary words from being used as passwords.",
  PROFILE_PASSWORD_PREVENTION_DESC: "Blocks passwords that match a user's profile fields, such as their email address.",
  PROFILE_DATA_EXACT_MATCH_DESC: "Blocks passwords that exactly match a user's profile data, such as their birthdate.",
  COMMON_PASSWORD_PREVENTION: "Common Password Protection",
  DICTIONARY_PASSWORD_PREVENTION: "Dictionary Password Protection",
  PROFILE_PASSWORD_PREVENTION: "Profile Fields Password Protection",
  PROFILE_DATA_EXACT_MATCH: "Profile Data Password Exact Match",
  COMMON_PASSWORD_SETTING_UPDATED_SUCCESSFULLY: "Common password prevention settings updated successfully.",
  DATA_SCHEMA_HEADER:
    "The LoginRadius customer registration form can be designed, configured, and managed here. Below, you can customize your desired fields, add or remove fields, set validation strings, and configure field types.",
  NO_SCHEMA_SET: "No schema is set for the selected custom object. Please contact LoginRadius support.",
  FIELD_NAME_IS_INVALID: "Field name is invalid.",
  PLEASE_SELECT_ANOTHER_DATA_SOURCE: "Please select another data source. This one might be connected to other custom fields.",
  THIS_CUSTOM_FIELD_IS_ALREADY_CREATED: "Custom field name already exists.",
  OUTBOUND_SSO: "Outbound SSO",
  INTEGRATION_HEADER:
    "Configure and manage your Outbound SSO integrations, also known as Federated SSO, where you act as the Custom IDP (IdP) authenticating customers to allow access to an external Service Provider (SP). Supported protocols include SAML, JWT, OAuth 2.0, and OpenID Connect.",
  SSO_INTEGRATION_HEADER: "Configure and manage Single Sign-On (SSO) integrations.",
  THIRD_PARTY_SOFTWARE_HEADER: "View and manage integrations in your account to feed and sync customer data directly to these third-party applications.",
  ZENDESK_NAME_ERROR: "Note: We don’t need the full URL, it is just the account name with alphanumeric characters.",
  MANAGE_SSO_INTEGRATION: "Manage Your SSO Integrations",
  MANAGE_SSO_INTEGRATION_DESCRIPTION: "Manage your Federated SSO integrations with pre-built configuration templates.",
  MANAGE_SSO_TEMPLATE: "Select an SSO Integration",
  MANAGE_SSO_TEMPLATE_DESCRIPTION: "Pre-built templates help you quickly deploy integrations.",
  NO_CONFIGURATION_SSO_INTEGRATION: "You haven’t configured any SSO integrations.",
  INBOUND_SSO: "Inbound SSO",
  SP_INTEGRATION_HEADER:
    "Manage your custom Custom IDP (IDP) integrations here. You can quickly connect a Custom IDP with LoginRadius, enabling users to authenticate with the IDP and access multiple service provider (SP) apps through LoginRadius. This configuration is also accessible under the respective protocol tab for advanced settings.",
  MANAGE_SSO_SP_INTEGRATION: "Manage Your Custom IDP Integrations",
  MANAGE_SSO_SP_INTEGRATION_DESCRIPTION: "Integrate a third-party IDP into LoginRadius with pre-built templates.",
  MANAGE_SSO_SP_TEMPLATE: "Select a Custom IDP (IDP)",
  ADD_CUSTOM_IDP: "Create Custom IDP",
  MANAGE_SSO_SP_TEMPLATE_DESCRIPTION: "Pre-built templates help you quickly deploy integrations.",
  NO_CONFIGURATION_SSO_SP_INTEGRATION: "You haven’t configured any Custom IDP (IDP).",
  CUSTOM_IDP_DESC: "Integrate your identity providers with LoginRadius using prebuilt integrations or standard protocols like OAuth, SAML or JWT.",
  CREATE_NEW: "Create a New",
  INTEGRATION: "Integration",
  NO_CONFIGURATION_SSO_INTEGRATION_DESCRIPTION: "Integrate SSO on LoginRadius admin console to allow your users to login via your identity providers.",
  DELETE_CUSTOM_DOMAIN_CONF: "You are removing the custom domain, Do you want to proceed ?",
  NO_CONFIGURATION_SSO_SP_INTEGRATION_DESCRIPTION: "Integrate a third-party IDP into LoginRadius with pre-built templates.",
  ADD_SSO_INTEGRATION: "Add SSO Integration",
  SAML_HEADER:
    "From this page, you can add, edit, or delete any SAML apps you connect with LoginRadius’ Single Sign-On. Configuring these apps allows customers to seamlessly authenticate between them and LoginRadius via Security Assertion Markup Language (SAML).",
  MANAGE_ROLE_PERMISSION_HEADER: "Define and manage user roles and permissions to grant different levels of user access",
  OPENIDCONNECT_HEADER:
    "OpenID Connect 1.0 is a simple identity layer on top of the OAuth 2.0 protocol. It allows clients to verify the identity of the end user based on authentication performed by an authorization server. It also obtains basic profile information about the end user in an interoperable, REST-like manner. Configure OpenID requests below.",
  DEFAULT_ROLE_HAS_BEEN_REMOVED_SUCCESSFULLY: "Default role removed successfully.",
  ROLE_HAS_BEEN_REMOVED_SUCCESSFULLY: "Role removed successfully.",
  ROLE_AND_PERMISSION_ADDED: "Role and its specified permissions have been added successfully.",
  PERMISSION_HAVE_BEEN_UPDATED_SUCCESSFULLY: "Permissions have been updated successfully.",
  YOU_CAN_FILL_OUT_THE_FORM_BELOW_TO_ADD_A_NEW_ROLE_WITH_RELATIVE_PERMISSION: "Fill out the form below to add a new role with related permissions.",
  YOU_CAN_FILL_OUT_THE_FORM_BELOW_TO_ADD_A_NEW_SECURITY_QUESTION: "Create security questions that users can select and set their secret answers for.",
  YOU_CAN_FILL_OUT_THE_FORM_BELOW_TO_ADD_A_NEW_SECURITY_QUESTION_SETTINGS: "Configure the Security Question Settings.",
  YOU_CAN_FILL_OUT_THE_FORM_BELOW_TO_ADD_A_NEW_WHITELIST_DOMAINS: "Fill out the form below to configure Website/App Domains.",
  CONFIGURED_ROLE_AND_PERMISSION: "Configured Roles and Permissions",
  MANAGE_ROLE_AND_PERMISSION: "Roles and Permissions",
  ROLE_IS_REQUIRED: "Role required.",
  PERMISSION_IS_REQUIRED: "Permission required.",
  ADD_PERMISSIONS: "Add Permissions",
  CUSTOMER_GROWTH: "User Growth",
  NEW_CUSTOMERS: "New Users",
  DAILY_ACTIVE_USERS: "Daily Active Users",
  MONTHLY_ACTIVE_USERS: "Monthly Active Users",
  ID_PROVIDER: "ID Provider",
  TOTAL_CUSTOMERS: "Total Users",
  TOTAL_NUMBER_OF_LOGINS: "Total Number of Logins",
  NUMBER_OF_NEW_LOGINS: "Number of New Logins",
  ALL_TIME_TOP_PROVIDER: "All-Time Top Provider",
  FILTERED_TOP_PROVIDER: "Filtered Top Provider",
  SITE_LOGIN_DISTRIBUTION: "Login Distribution",
  DEVICE: "Device",
  AGE_GROUP: "Age Group",
  NUMBER_OF_DELETED_CUSTOMER_PROFILES: "Number of Deleted User Profiles",
  NUMBER_OF_BLOCKED_CUSTOMER_PROFILES: "Number of Blocked User Profiles",
  NUMBER_OF_NEW_CUSTOMER_PROFILES: "Number of New User Profiles",
  NUMBER_OF_NEW_CUSTOMER_ACCOUNTS: "Number of New User Accounts",
  TOTAL_NUMBER_OF_DELETED_CUSTOMER_PROFILES: "Total Deleted User Profiles",
  TOTAL_NUMBER_OF_BLOCKED_CUSTOMER_PROFILES: "Total Blocked User Profiles",
  TOTAL_NUMBER_OF_CUSTOMER_PROFILES: "Total User Profiles",
  TOTAL_NUMBER_OF_CUSTOMER_ACCOUNTS: "Total User Accounts",
  IDENTITY_ANALYTICS: "Identity Analytics",
  LOGIN_ANALYTICS: "Login Analytics",
  NO_DOMAIN_SELECTED: "No Domain Selected",
  SEE_ALL_INSIGHTS: "See All Insights",
  IMPLEMENTATION_GUIDES: "Implementation Guides",
  SEE_ALL_GUIDES: "See All Guides",
  PRODUCT_UPDATES: "Product Updates",
  SEE_ALL_UPDATES: "See All Updates",
  JWT_HEADER:
    "Manage JWT (JSON Web Token) apps connecting with LoginRadius’ Single Sign-On. This allows your customers to authenticate seamlessly between your site and LoginRadius via JWT. Configure JWT requests below.",
  ENTER_NEW_PHONE_NUMBER: "Enter a new phone number",
  PHONE_TYPE: "Phone Type",
  PHONE_NUMBER: "Phone Number",
  ENTER_NEW_ADDRESS: "Enter new address",
  ADDRESS_TYPE: "Address Type",
  ADDRESS_1: "Address 1",
  ADDRESS_2: "Address 2",
  POSTAL_CODE: "Postal Code",
  REGION: "Region",
  ARE_YOU_SURE_REMOVE_PHONE_NUMBER: "Are you sure you want to remove this phone number?",
  ARE_YOU_SURE_REMOVE_ADDRESS: "Are you sure you want to remove this address?",
  PHONE_NUMBERS: "Phone Numbers",
  ADDRESSES: "Addresses",
  ADD_ADDRESS: "Add Address",
  TIME_ZONE: "Timezone",
  AGE: "Age",
  SELECTED_CUSTOMER_PROFILE_HAS_BEEN_UPDATED: "The selected user profile has been updated.",
  INVALID_PHONE_NUMBER_FORMAT: "Invalid phone number format",
  PHONE_TYPE_IS_REQUIRED: "Phone type required.",
  PHONE_NUMBER_IS_REQUIRED: "Phone number required.",
  ADDRESS_TYPE_IS_REQUIRED: "Address type required.",
  DUPLICATE_PERMISSION_ARE_NOT_ALLOWED: "Duplicate permissions are not allowed.",
  DUPLICATE_ROLE_ARE_NOT_ALLOWED: "Duplicate roles are not allowed.",
  ADD_NEW_ROLE: "Add New Role",
  ENTER_ROLE_NAME: "Enter Role Name",
  PROGRESSIVE_PROFILING_STEPS: "Progressive Profiling Steps",
  PROGRESSIVE_PROFILING: "Progressive Profiling",
  ADD_NEW_STEP: "Add New Step",
  STEP_NAME_REQUIRED: "Step name required.",
  STEP_NAME: "Step Name",
  SPECIAL_CHARACTERS_ARE_NOT_ALLOWED_IN_STEP_NAME: "Special characters are not allowed in the step name.",
  SPECIAL_CHARACTERS_ARE_NOT_ALLOWED_IN_ROLE_NAME: "Special characters are not allowed in the role name.",
  PROGRESSIVE_PROFILING_STEP_SAVED_SUCCESSFULLY: "Progressive Profiling step saved successfully.",
  THIS_STEP_NAME_IS_ALREADY_CREATED: "Step name already exists.",
  PROGRESSIVE_PROFILING_STEP_REMOVED_SUCCESSFULLY: "Progressive Profiling step removed successfully.",
  PROGRESSIVE_PROFILING_NOTE: "This step allows you to select a name you can use when implementing the progressive profiling interface with the",
  DOCUMENT: "Click here for more details about Progressive Profiling",
  PLEASE_CHOOSE_FIELD_FROM_RIGHT_SIDE: "Please choose a field from the right side.",
  PROGRESSIVE_PROFILING_HEADER:
    "Progressive profiling automates the gradual gathering of customer data by requesting permissions at various stages of the customer’s lifecycle, rather than all at once. Below, you can customize your desired progressive profiling steps and fields, add or remove fields, set validation strings, and configure field types. For example, you can create a step called 'Third Login' where additional permissions are requested on a customer’s third login.",
  THIS_USER_HAS_NO_DATA_IN: "This user has no data in",
  CUSTOM_OBJECT_NOT_CONFIGURED: "The custom object is not configured for this site. Please contact LoginRadius support for more information.",
  CUSTOMER_LOGGED_OUT: "The user has been logged out.",
  CUSTOMER_LOGOUT_ERROR: "Unable to log out the user at this moment. Please try again.",
  EMAIL_ADD_SUCCESS: "The email has been added successfully.",
  EXID_ADD_SUCCESS: "The External ID has been added.",
  EXID_REMOVE_SUCCESS: "The External ID has been removed.",
  CUSTOM_OBJECT_REMOVE_SUCCESS: "The custom object has been removed.",
  EMAIL_REMOVE_SUCCESS: "The selected email address has been removed.",
  CUSTOMER_ACCOUNT_ENABLED: "The selected user account has been unblocked.",
  CUSTOMER_ACCOUNT_DISABLED: "The selected user account has been blocked.",
  CUSTOMER_ACCOUNT_DELETED: "The selected user account has been deleted. It may take a few seconds to update. Please refresh this page to see the change.",
  CUSTOMER_ACCOUNT_ADD_DELAY: "It may take a few seconds to update. Please refresh this page to see the change.",
  CUSTOMER_ACCOUNT_UNLOCKED: "The selected user account has been unlocked.",
  CUSTOMER_PHONE_EMAIL_VERIFIED: "The user's phone and email are now marked as verified.",
  CUSTOMER_PHONE_EMAIL_UNVERIFIED: "The user's phone and email are now marked as unverified.",
  CUSTOMER_PHONE_VERIFIED_EMAIL_UNVERIFIED: "The user's phone is now marked as verified and email as unverified.",
  CUSTOMER_PHONE_UNVERIFIED_EMAIL_VERIFIED: "The user's phone is now marked as unverified and email as verified.",
  CUSTOMER_PHONE_VERIFIED: "The user's phone is now marked as verified.",
  CUSTOMER_PHONE_UNVERIFIED: "The user's phone is now marked as unverified.",
  CUSTOMER_EMAIL_VERIFIED: "The user's email is now marked as verified.",
  CUSTOMER_EMAIL_UNVERIFIED: "The user's email is now marked as unverified.",
  MFA: "MFA",
  CUSTOMER_MFA_RESET: "The MFA setting has been reset for the user.",
  PASSWORD_CHANGED_SUCCESS: "The password has been changed successfully.",
  PIN_CHANGED_SUCCESS: "The PIN has been changed successfully.",
  EMAIL_SEND_SUCCESS: "An email with the reset password link has been sent to",
  EMAIL_RESEND_SUCCESS: "A verification email has been sent to the email address:",
  UPDATE_VERIFY_STATUS: "Update verification status",
  VIEW_DETAILS: "View details",
  ADD_SECONDARY_EMAIL: "Add secondary email",
  ADD_EXTERNAL_ID: "Add external ID",
  EXTERNAL_IDS: "External IDs",
  SEND_RESET_PASSWORD: "Send reset password email",
  RESEND_VERIFICATION_MAIL: "Resend verification email",
  CUSTOMER_LOGOUT_CONFIRM: "Are you sure you want to log out this customer?",
  CUSTOMER_BLOCK_CONFIRM: "Are you sure you want to block this customer?",
  CUSTOMER_UNBLOCK_CONFIRM: "Are you sure you want to unblock this customer?",
  CUSTOMER_UNLOCK_CONFIRM: "Are you sure you want to unlock this customer?",
  CUSTOMER_REMOVE_EMAIL_CONFIRM: "Are you sure you want to remove the email of this customer?",
  REMOVE_EMAIL: "Remove Email",
  REMOVE_EXID: "Remove External ID",
  CUSTOMER_REMOVE_EXID_CONFIRM: "Are you sure you want to remove this user's External ID?",
  CUSTOMER_REMOVE_CUSTOM_OBJECT_CONFIRM: "Are you sure you want to remove this user's custom object?",
  BLOCK_CUSTOMER: "Block User",
  LOGOUT_CUSTOMER: "Log Out User",
  EMAIL_TYPE_PLACEHOLDER: "Enter email type",
  EMAIL_VALUE_PLACEHOLDER: "Enter email address",
  SELECT_EMAIL_ID: "Select email address",
  SELECT_RESET_PASSWORD: "Select Reset Password URL",
  SELECT_RESEND_EMAIL: "Select Resend Email URL",
  SELECT_EMAIL_TEMPLATE: "Select Email Template",
  CONFIRM_PASSWORD_PLACEHOLDER: "Confirm New Password",
  NEW_PASSWORD_PLACEHOLDER: "Enter New Password",
  UNBLOCK_CUSTOMER: "Unblock User",
  RESET_MFA: "Reset MFA Settings",
  MFA_TAB: "MFA",
  MFA_FACTOR_LABEL_EMAIL_OTP: "Email OTP",
  MFA_FACTOR_LABEL_SMS_OTP: "SMS OTP",
  MFA_FACTOR_LABEL_TOTP: "Time-based OTP(TOTP)",
  MFA_FACTOR_LABEL_PUSH_NOTIFICATIONS: "Push Notification",
  MFA_FACTOR_LABEL_PASSKEYS: "Passkeys",
  MFA_FACTOR_LABEL_DUO_AUTHENTICATION: "Duo Authentication",
  MFA_FACTOR_DELETE_EMAIL_CONFIRM: "Are you sure you want to remove the Email OTP factor for this user? The user will need to set it up again.",
  MFA_FACTOR_DELETE_SMS_CONFIRM: "Are you sure you want to remove the SMS OTP factor for this user? The user will need to set it up again.",
  MFA_FACTOR_DELETE_AUTHENTICATOR_CONFIRM: "Are you sure you want to remove the Authenticator App factor for this user? The user will need to set it up again.",
  MFA_FACTOR_DELETE_PUSH_CONFIRM: "Are you sure you want to remove the Push Notification factor for this user? The user will need to set it up again.",
  MFA_FACTOR_DELETE_PASSKEY_CONFIRM: "Are you sure you want to remove the Passkey factor for this user? The user will need to set it up again.",
  MFA_FACTOR_DELETE_DUO_CONFIRM: "Are you sure you want to remove the Duo Authentication factor for this user? The user will need to set it up again.",
  CUSTOMER_MFA_FACTOR_DELETED: "MFA factor removed successfully.",
  CUSTOMER_DELETE_CONFIRM: "Are you sure you want to delete this user? All data related to this user will be erased.",
  DELETE_CUSTOMER: "Delete User",
  UNLOCK_CUSTOMER: "Unlock User",
  CUSTOMER_ACCOUNT_LOADING_ERROR: "Unable to load the user account. Please try again.",
  CREATE_NEW_USER_DES: "Please fill out the form below to create a new user.",
  THIS_FIELD_IS_ALREADY_EXIST: "This field already exists.",
  THIS_FIELD_SCHEMA_IS_ALREADY_EXIST: "This field schema already exists.",
  TO_ADD_A_CUSTOME_FIELD_PLEASE:
    "To add a custom field, please click <a id='lnk_CustomField' rel='noopener noreferrer' href='/platform-configuration/authentication-configuration/standard-login/data-schema' className='mt-2 d-block'>here<span className='lricon_new_window ml-2 d-inline' /></a>.",
  DEFAULT_ROLE_PERMISSION_HEADER: "Select and Manage Default Roles & Permissions",
  DEFAULT_ROLES_AND_MEMBERSHIP: "Default Roles & Permissions",
  ROLES_AND_PERMISSIONS: "Roles & Permissions",

  // Data ETL Service
  ACTION_IMPORT: "Import",
  ACTION_UPDATE: "Update",
  ACTION_DELETE: "Delete",
  DATA_MIGRATION_REQUEST_QUEUED: "The data migration request has been queued successfully.",
  FILE_SIZE_EXCEEDED_LIMIT: "The file size exceeds the limit supported by LoginRadius. Please consider using a smaller input file or contact LoginRadius support.",
  NUMBER_OF_LINES_EXCEEDED_LIMIT_PART_1: "The number of lines in the input file exceeds",
  NUMBER_OF_LINES_EXCEEDED_LIMIT_PART_2: ", which is the maximum supported by LoginRadius. Please consider using a smaller input file or contact LoginRadius support.",
  DELIMITER_IS_REQUIRED: "A delimiter is required.",
  LOG_FILE_PASSWORD_IS_REQUIRED: "A log file password is required.",
  LOG_FILE_PASSWORD_6_CHARACTER_OR_MORE: "The log file password must be 6 characters or longer.",
  CSV_FILE_IS_REQUIRED: "A CSV file upload is required.",
  LOOKUP_TYPE_IS_REQUIRED: "A lookup type is required.",
  LOOKUP_INDEX_IS_REQUIRED: "A lookup index is required.",
  FIELD_CAN_ONLY_BE_MAPPED_ONCE: "A field can only be mapped once. Please review your mapping and try again.",
  PHONE_TYPE_AND_NUMBER_ARE_REQUIRED: "Both Phone Type and Phone Number are required for the PhoneNumbers object. Please review your mapping and try again.",
  EMAIL_TYPE_AND_VALUE_ARE_REQUIRED: "Both Type and Value are required for the Email object. Please review your mapping and try again.",
  TYPE_IS_REQUIRED_FOR_ADDRESS: "Type is a required field for an Addresses object. Please review your mapping and try again.",
  AT_LEAST_ONE_FIELD_REQUIRED_ADDRESS: "At least one field in Addresses (other than Type) must be populated. Please review your mapping and try again.",
  AT_LEAST_ONE_MAPPING_REQUIRED: "At least one mapping is required. Please review your mapping and try again.",
  LOOKUP_FIELD_MAPPING_REQUIRED: "The selected Lookup Type value must have a corresponding mapping in the mapping table. Please review your mapping and try again.",
  EMAIL_MAPPING_REQUIRED: "Email is a required mapping field. Please update your mapping and try again.",
  PASSWORD_MAPPING_REQUIRED: "Password is a required mapping field. Please update your mapping and try again.",
  CSV_INVALID_EXTENSION: "The CSV file must have the correct file extension (*.csv). Please review your mapping and try again.",
  SELECT_THE_COLUMN_NUMBER: "Select the column number",
  SELECT_DELIMITER_AND_CSV: "Please select a delimiter and CSV file first.",
  REQUEST_A_NEW_DATA_MIGRATION: "Request a New Data Migration",
  REQUEST_A_NEW_DATA_IMPORT: "Request a New Data Import",
  REQUEST_A_NEW_DATA_UPDATE: "Request a New Data Update",
  REQUEST_A_NEW_DATA_DELETION: "Request a New Data Deletion",
  PLEASE_FILL_OUT_FORM: "Please fill out the form below to request a data operation.",
  SELECT_CSV_DELIMITER: "Select CSV Delimiter",
  CSV_DELIMITER: "CSV Delimiter",
  SKIP_FIRST_ROW: "Skip First Row",
  SET_LOG_FILE_PASSWORD: "Set Log File Password",
  SET_PASSWORD_TO_OPEN_LOG_FILE: "Set Password to Open Log File",
  UPLOAD_CSV: "Upload CSV",
  SELECT_LOOKUP_TYPE: "Select Lookup Type",
  LOOKUP_TYPE: "Lookup Type",
  LOOKUP_INDEX: "Lookup Index",
  FIELD_MAPPING: "Field Mapping",
  DATA_MIGRATION_FIELD_MAPPING_DESCRIPTION:
    "Fields you want to map the CSV columns to. Mappings for Email, along with mandatory fields in the Data Schema, are required, as well as a mapping that corresponds with the Lookup Type.",
  LR_FIELD: "LR Field",
  CSV_COLUMN: "CSV Column",
  SELECT_LR_FIELD_TO_MAP_TO: "Select LR Field to Map To",
  DATA_MIGRATION_TAB_DESCRIPTION:
    "The Data Migration page allows you to perform user profile migration operations into the LoginRadius database using CSV files. Once a report is requested, LoginRadius will send you an email notification with a secure link to access the log file. Depending on the request pipeline, it may take up to an hour to receive the report.",
  NO_ETL_LOG_RECORDS_FOUND: "No ETL log records found.",
  DATA_ETL_LOGS: "Data ETL Logs",
  DATA_ETL_LOGS_TAB_DESCRIPTION: "This page contains all the logs for ETL requests and their corresponding download links.",
  ONE_COLUMN_INDEX_REQUIRED: "At least one column index is required.",
  ONE_MAPPING_REQUIRED: "At least one mapping is required.",

  ERROR_OCCURRED: "Uh Oh!",
  MSG_ERROR_GETTING_CHART_DATA: "Unable to retrieve the selected chart data. Please try again.",
  REQUEST_COUNT: "Request Count",
  RESPONSE_CODE: "Response Code",
  PERFORMANCE_PERCENTAGE: "Performance %",
  PREPARING_CHART: "Preparing chart...",
  NO_DATA_AVAILABLE_FOR_INTERVAL: "No data is available to display for the selected interval.",
  TAB_DESCRIPTION_THIRDPARTY_CONFIGURATION:
    "Here is a list of enabled integrations in your account to feed and sync customer data directly with these third-party applications. For example, an integration can be triggered when a new customer registers on your website, automatically feeding that customer’s information into Salesforce.",
  TAB_DESCRIPTION_THIRDPARTY_CONFIGURATION_LIST:
    "List of all back-end integrations currently supported by the LoginRadius Platform. <a class='global-link' href='https://www.loginradius.com/integrations/' target='_blank' rel='noopener noreferrer'>Click here</a> to see the full list of available integrations.",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  CONFIGURE: "Configure",
  ACTIVATE_INTEGRATION_MESSAGE: "Are you sure you want to activate",
  DEACTIVATE_INTEGRATION_MESSAGE: "Are you sure you want to deactivate",
  AVAILABLE_INTEGRATIONS: "Available Integrations for Your Site",
  ACTIVE_INTEGRATIONS: "Active Integrations",
  INACTIVE_INTEGRATIONS: "Inactive Integrations",
  EDIT_CONFIGURATION: "Edit Configuration",
  ADD_CONFIGURATION: "Add Configuration",
  INTEGRATION_INACTIVE: "The integration is now inactive.",
  NO_INTEGRATION_AVAILABLE: "No integrations are available for your site.",
  UNABLE_TO_GET_AVAILABLE_INTEGRATIONS: "Unable to retrieve the list of available integrations. Please try again.",
  UNABLE_TO_GET_INTEGRATION_DATA: "Unable to fetch the integration data.",
  INTEGRATION_UPDATED: "The integration has been updated.",
  INTEGRATION_CREATED: "The integration has been created.",
  INTEGRATION_ACTIVATED: "The integration has been activated successfully.",
  INTEGRATION_DEACTIVATED: "The integration has been deactivated successfully.",
  REQUEST_INTEGRATION_BUTTON: "Request Integration",
  ALL_INTEGRATIONS_LABEL: "All Integrations",
  AVAILABLE_INTEGRATIONS_LABEL: "Available Integrations",
  LIST_OF_INTEGRATIONS_AVAILABLE: "List of integrations available to configure for your site",
  LIST_OF_ALL_INTEGRATIONS: "List of all integrations",
  SEARCH_FOR_INTEGRATION: "Search for an Integration",
  INSTALLED_INTEGRATIONS: "Installed Integrations",
  LIST_OF_INTEGRATIONS_ACTIVE: "List of integrations active for your site",
  VIEW_BY: "View By",
  ADD_INTEGRATION: "Add integration",
  EDIT_INTEGRATION: "Edit integration",
  GET_STARTED_ADDING_INTEGRATON: "Get started by adding integrations",
  DEACTIVATE_INTEGRATION: "Deactivate Integration",
  ACTIVATE_ANYTIME_LATER: "You can activate this integration anytime later.",
  SELECT_AN_INTEGRATION: "Select an Integration",
  EVENT_TYPE: "Event Type",
  DEACTIVATE_INTEGRATION_CONFIRMATION: "Are you sure you want to deactivate ",
  ACTIVATE_INTEGRATION_CONFIRMATION: "Are you sure you want to activate ",
  DELETE_THIRD_PARTY_INTEGRATION_CONFIRMATION: "Are you sure you want to delete ",
  NO_FILTERS_SELECTED: "No filters selected.",
  RESET_FILTERS_INTEGRATIONS: "Reset the filters to view all integrations.",
  INTEGRATION_NAME_MAX_CHAR: "The webhook name must not exceed 24 characters.",
  INTEGRATION_NAME_EXISTS: "The webhook name already exists. Please use a different name.",
  INTEGRATION_NAME_SPECIAL_CHAR: "The webhook name can only contain letters, numbers, underscores, hyphens, and spaces.",
  XML_FILE_UPLOADED_SUCCESSFULLY: "The XML file has been uploaded successfully.",
  NAME_IS_REQUIRED: "A webhook name is required.",
  EVENT: "Event",
  SUBSCRIBED_URL: "Subscribed URL",
  SECRET_NAME: "Secret Name",
  INVALID_JSON_INPUT: "Invalid JSON input.",
  LABEL_EVENTS: "Events",
  LABEL_CREDENTIALS: "Credentials (Max 245 characters)",
  LABEL_METADATA: "Metadata",
  LABEL_DOWNLOAD_METADATA: "Download Metadata",
  LABEL_UPLOAD_METADATA: "Upload Metadata",
  LABEL_CONFIGURE_METADATA: "Configure from Metadata",
  LABEL_MAPPING: "Mapping",
  LABEL_PLUGIN_FILTERS: "Plugin Filters (Optional)",
  LABEL_FILTERS: "Filters (Optional)",
  LABEL_SCRIPT: "Script (Optional)",
  APPNAME: "App Name",
  RESPONSE_PERAMETER: "Response Parameter",
  RESPONSE_MODE: "Response Mode",
  JWT_EXPIRY_TIME: "Expiry Time",
  JWT_EXPIRE_BEFORE: "Do not Expire Before Time",
  LOGINURL: "Login URL",
  ALGORITHM: "Algorithm",
  SECRET_KEY: "Secret Key",
  AUDIENCE: "Audience",
  DATAMAPPING: "Data Mapping",
  PROFILE_KEY: "Profile Key",
  METADATA: "Metadata",
  JWT_APP_NAME_TOOLTIP: "LoginRadius will use this name to identify your apps during API calls",
  JWT_RESPONSE_PARAMETER_TOOLTIP:
    "LoginRadius will send a JSON Web Token after authentication in this response parameter (jwt is the default response parameter, which you can modify). It will be included in the selected response mode with the redirect URL (in the JWT redirection flow).",
  JWT_RESPONSE_MODE_TOOLTIP: "The JWT token will be returned using the selected method (in the JWT redirection flow).",
  JWT_EXPIRY_TIME_TOOLTIP: "The time after which the JWT token will expire.",
  JWT_LOGINURL_TOOLTIP: "Workflow URL",
  JWT_ALGORITHM_TOOLTIP: "The algorithm is used to sign the JWT token.",
  JWT_SECRET_KEY_TOOLTIP: "The secret key (symmetric or asymmetric) is used to sign the JWT.",
  JWT_AUDIENCE_TOOLTIP: "Enter the resource server that will accept the JWT.",
  JWT_DATA_MAPPING_TOOLTIP: "Specify the key-value pairs of LoginRadius profile data points you want to receive in the JWT payload.",
  JWT_METADATA_TOOLTIP: "Specify the key-value pairs of static non-profile data you want to receive in the JWT payload.",
  MAPPING_AUDIENCE_SETTINGS_TITLE: "Audience Settings",
  MAPPING_AUDIENCE_SETTINGS_DESCRIPTION: "Specify the intended recipients of the JWT token",
  MAPPING_TEMPLATE_TITLE: "Data Mapping Template",
  MAPPING_TEMPLATE_DESCRIPTION: "Specify the JSON of LoginRadius profile data points you want to receive in the JWT payload.",
  MAPPING_AUDIENCE_DESCRIPTION: "Intended recipients of the token (JWT) issued",
  MAPPING_DATA_MAPPING_KEY_LABEL: "Key",
  MAPPING_DATA_MAPPING_KEY_PLACEHOLDER: "Key",
  MAPPING_STANDARD_FIELDS_LABEL: "Standard Fields",
  MAPPING_CUSTOM_FIELDS_LABEL: "Custom Fields",
  MAPPING_PROFILE_KEYS_LABEL: "Profile Keys",
  MAPPING_STANDARD_CLAIMS_INFO: "Now you can use JWT template to define the JSON payload returned within the JWT token. Standard claims like iss, sub, aud, exp, and iat are automatically included.",
  MAPPING_JSON_EDITOR_TITLE: "JSON Editor",
  MAPPING_FORMAT_JSON_TOOLTIP: "Format JSON",
  MAPPING_COPY_JSON_TOOLTIP: "Copy JSON",
  MAPPING_NO_OPTIONS_AVAILABLE: "No options available.",
  MAPPING_ID_TOKEN_TEMPLATE_TITLE: "ID Token Mapping Template",
  MAPPING_ID_TOKEN_TEMPLATE_DESCRIPTION: "Specify the LoginRadius profile data to include within the ID Token payload.",
  MAPPING_INFO_TITLE: "New: JWT template for custom claims!",
  MAPPING_ID_TOKEN_INFO: "Now you can use JWT template to define the JSON payload returned within the ID Token. Standard claims like iss, sub, aud, exp, and iat are automatically included.",
  MAPPING_ACCESS_TOKEN_TEMPLATE_TITLE: "Access Token Mapping Template",
  MAPPING_ACCESS_TOKEN_TEMPLATE_DESCRIPTION: "Define the JSON payload returned within the Access Token.",
  MAPPING_ACCESS_TOKEN_INFO: "Now you can use JWT template to define the JSON payload returned within the Access Token. Standard claims like iss, sub, aud, exp, and iat are automatically included.",
  SAML_METADATA_DESCRIPTION: "The SAML metadata document contains details about your SAML application's deployment, including the issuer URL, configured certificate, and NameID format.",
  SAML_CONFIGURATION_ADDED_SUCCESSFULLY: "The SAML configuration has been added successfully.",
  SAML_CONFIGURATION_UPDATED_SUCCESSFULLY: "The SAML configuration has been updated successfully.",
  SAML_CONFIGURATION_DELETED_SUCCESSFULLY: "The SAML configuration has been deleted successfully.",
  UPDATE_SAML_CONFIGURATION_FAILED: "Failed to update the SAML configuration.",
  JWT_CONFIGURATION_ADDED_SUCCESSFULLY: "The JWT configuration has been added successfully.",
  JWT_CONFIGURATION_UPDATED_SUCCESSFULLY: "The JWT configuration has been updated successfully.",
  JWT_CONFIGURATION_DELETED_SUCCESSFULLY: "The JWT configuration has been deleted successfully.",
  UPDATE_JWT_CONFIGURATION_FAILED: "Failed to update the JWT configuration.",
  SHOPIFY_CONFIGURATION_ADDED_SUCCESSFULLY: "The Shopify configuration has been added successfully.",
  SHOPIFY_CONFIGURATION_UPDATED_SUCCESSFULLY: "The Shopify configuration has been updated successfully.",
  SHOPIFY_CONFIGURATION_DELETED_SUCCESSFULLY: "The Shopify configuration has been deleted successfully.",
  UPDATE_SHOPIFY_CONFIGURATION_FAILED: "Failed to update the Shopify configuration.",
  BIGCOMMERCE_CONFIGURATION_ADDED_SUCCESSFULLY: "The BigCommerce configuration has been added successfully.",
  BIGCOMMERCE_CONFIGURATION_UPDATED_SUCCESSFULLY: "The BigCommerce configuration has been updated successfully.",
  BIGCOMMERCE_CONFIGURATION_DELETED_SUCCESSFULLY: "The BigCommerce configuration has been deleted successfully.",
  UPDATE_BIGCOMMERCE_CONFIGURATION_FAILED: "Failed to update the BigCommerce configuration.",
  PERFECTMIND_CONFIGURATION_ADDED_SUCCESSFULLY: "The PerfectMind configuration has been added successfully.",
  PERFECTMIND_CONFIGURATION_UPDATED_SUCCESSFULLY: "The PerfectMind configuration has been updated successfully.",
  PERFECTMIND_CONFIGURATION_DELETED_SUCCESSFULLY: "The PerfectMind configuration has been deleted successfully.",
  UPDATE_PERFECTMIND_CONFIGURATION_FAILED: "Failed to update the PerfectMind configuration.",
  THEME_CUSTOMIZATION_HEADER: "The LoginRadius dashboard theme can be personalized here. Below, you can tweak the color scheme, font style, and logo, and see a preview of those changes in real time.",
  SETTINGS_SAVED_AS_DRAFT: "Settings have been saved as a draft. Click 'Publish' to apply the customized dashboard.",
  LABEL_DOWNWARD_MAPPING: "Downward Mapping (Optional)",
  FILTER_MUST_BE_ARRAY: "Filters must be an array.",
  PLUGIN_FILTERS_MUST_BE_ARRAY: "Plugin Filters must be an array.",
  DOWNWARD_MAPPING_MUST_BE_AN_OBJECT: "Downward Mapping must be a plain JSON object.",

  // Consent Management Form
  GROUP_ADDED_SUCCESS: "The consent group has been added successfully.",
  GROUP_UPDATED_SUCCESS: "This consent flow has been modified successfully.",
  START_FROM_DATE_FUTURE_ERROR: "The 'Start From' date must be a future date. Please select a different date and try again.",
  GROUP_DELETED_SUCCESS: "The consent flow has been turned off successfully.",
  OPTION_ADDED_SUCCESS: "The consent option has been added successfully.",
  FORM_SUCCESS: "The consent form has been published successfully.",
  CREATE_FORM: "Create Consent Form",
  EDIT_FORM: "Edit Consent Form",
  EMPTY_CONSENT_OPTION: "No options available.",
  CHOOSE_EVENT_DATE: "Please fill out the form below to select events and a start date.",
  CUSTOM_EVENTS: "Custom Events",
  ADD_EVENT: "Add Custom Event",
  PUBLISH_FORM: "Publish Form",
  CONSENT_OPTION: "Consent Options",
  START_FORM_DATE: "Start From Date",
  ERROR_MESSAGE_FOR_SAME_EVENT: "Please choose a different event, as this event is already in another active form.",
  ARE_YOU_WANT_TO_DISABLE_CONSENT: "Are you sure you want to disable consent?",
  ARE_YOU_WANT_TO_EDIT_CONSENT: "A new version of the live consent will be created, and the current live version will be disabled.",
  ADD_OPTION: "Add Consent Option",
  EMPTY_MASTER_LIST: "Please add at least one consent option to proceed.",
  OPTION_FORM_DESCRIPTION: "Please fill out the form below to create new options.",
  CONSENT_OPTION_DESCRIPTION:
    "The consent form can be configured to request end-user consent at predefined events (Registration, First Login, and Login) and custom events. Multiple consent forms can be configured, but each must be unique to its event.",
  CONSENT_VIEW_DESCRIPTION: "You can view the consent form details below. Click the' Clone' button to create a duplicate copy of this consent form.",
  ALREADY_EXSIST: "already exists.",
  CHOOSE_FROM_RIGHT: "Please choose at least one option from the right side.",
  CHOOSE_EVENT_DATE_HEADER: "Choose Events and Start Date",
  LIVE_TEXT: "Live ",
  FORM_STATUS: "The form is live.",
  NO_CONSENT_INFO_AVAILABLE: "No consent information is available for this user.",

  CSS_MINIFICATION_ERROR: "CSS minification error. Please contact LoginRadius support.",
  ARE_YOU_WANT_TO_PUBLISH_SETTING: "Are you sure you want to publish the settings?",
  ARE_YOU_WANT_TO_RESET_SETTING: "Are you sure you want to reset the settings?",
  // Configuration Deployment
  CONFIGURATION_DEPLOYMENT_DESCRIPTION:
    "Clone or transfer configurations between LoginRadius sites. Settings depend on Support-enabled features. Please refer to the support documents for a complete list of features not included in your configuration.",
  SOURCE_SITE: "Source Site",
  DESTINATION_SITE: "Destination Site",
  VIEW_CONFIGURATIONS: "View Configurations",
  DEPLOY_CONFIGURATIONS: "Deploy Configurations",
  ERR_GETTING_SITES: "Error retrieving sites.",
  ERR_GETTING_SITES_DESC: "Unable to retrieve your list of associated sites. Please try again later.",
  NO_SITES_AVAILABLE: "No sites are available.",
  NO_SITES_AVAILABLE_DESC: "You don't have any sites associated with this account yet.",
  ERR_SELECT_DIFF_SOURCE_DEST: "Please select different source and destination sites.",
  COMPARE_AND_DEPLOY: "Compare and Deploy",
  INVALID_SOURCE_DEST: "Invalid source or destination site name.",
  SELECT_A_DEST_SITE: "Please select a destination site to compare.",
  ERR_SELECT_CONFIGURATION_TO_TRANSFER: "Please select at least one configuration to transfer.",
  PLEASE_SELECT_CONFIGURATIONS: "Please select configurations to transfer.",
  FEATURE: "Feature",
  DESCRIPTION: "Description",
  CONFIGURATIONS: "Configurations",
  BASIC: "Basic",
  CONFIGURE_EVENTS_DESCRIPTION: "Configure events to set a PIN.",
  VALIDATE_EVENTS: "Select at least one event from the list above.",
  VALIDATE_SESSION_TOKEN_TIME: "Session Token Expiry Time is required, and its value must be greater than 0.",
  CONFIRM: "Confirm",
  FLOW_REQUIRED: "A flow is required.",
  SESSION_TOKEN_TIME_LABEL: "Session Token Expiry Time (Minutes)",
  PIN_AUTH_ENABLE_DESCRIPTION: "When enabled, this allows end users to set a PIN for their account.",
  EMAIL_TEMPLATE_NO_DATA: "Configure PIN Authentication to access this email template.",
  TEMPLATE_NO_DATA: "Please configure #feature# to access this template.",
  SMS_TEMPLATE_NO_DATA: "Configure PIN Authentication to access this SMS template.",
  GLOBAL_THEME: "Global Theme",
  HEADER_THEME: "Header Theme",
  FOOTER_THEME: "Footer Theme",
  SIDEBAR_THEME: "Sidebar Theme",
  LOGIN_PAGE_THEME: "Login Page Theme",
  SAVE_AS_DRAFT: "Save as Draft",
  PUBLISH: "Publish",
  MULTI_FACTOR_SETTINGS: "Multi-Factor Settings",
  LOGO_SIZE_SHOULD_BE_400X97_OR_ASPECT_RATIO: "The logo size should be 400x97 or maintain its aspect ratio.",
  MONTH_COMPARISON_TAB_DESCRIPTION: `The Historical Analysis section provides comparative charts of the number of registrations in the selected months. You can select different months, domains, and customer accounts or profiles.`,
  SELECT_ATLEAST_ONE_HOST: "Please select at least one host to fetch customer data.",
  NODATA_SELECTED_INP_PARAMS: "The selected input parameters contain no data.",
  SELECT_ATLEAST_ONE_MONTH: "Select at least one month to view data. You can select multiple months to compare.",
  UNABLE_TO_GET_MONTHLY_HISTORY: "Unable to retrieve monthly history.",
  SELECT_MONTHS: "Select Months",
  MONTH_TO_MONTH_COMPARISON: "Month-to-Month Comparison Chart",
  NO_OF_PROFILES_REGISTERED: "Number of Profiles Registered",
  NO_OF_ACCOUNTS_REGISTERED: "Number of Accounts Registered",
  CHECKING_FOR_PERMISSIONS: "Checking for access...",
  REGISTRATION_STREAKS_TAB_DESCRIPTION: `Compare the number of customer registrations between selected months.`,
  HIGHEST_ACCOUNT_REGISTERED: "Highest Number of Customer Accounts Registered",
  HIGHEST_PROFILES_REGISTERED: "Highest Number of Customer Profiles Registered",
  BEST_ACCOUNT_REGISTERED: "Best Customer Account Registration Streaks",
  BEST_PROFILES_REGISTERED: "Best Customer Profile Registration Streaks",
  HIGHEST_NO_OF_CONSECUTIVE: "The highest number of consecutive",
  WITH_ATLEAST_ONE_USER_REG: "days with at least one user registered.",
  WORST_ACCOUNT_REGISTERED: "Worst Customer Account Registration Streaks",
  WORST_PROFILES_REGISTERED: "Worst Customer Profile Registration Streaks",
  WITH_NO_USER_REG: "days with no user registrations at all.",
  PER_DAY: "Per Day",
  PER_WEEK: "Per Week",
  PER_MONTH: "Per Month",
  PER_QUARTER: "Per Quarter",
  PER_YEAR: "Per Year",
  CUSTOMER_GROWTH_OVER_TIME: "Customer Growth Over Time",
  ID_PROVIDER_DISTRIBUTION: "ID Provider Distribution",
  COUNTRY_DISTRIBUTION: "Country Distribution",
  AGE_DISTRIBUTION: "Age Distribution",
  GENDER_DISTRIBUTION: "Gender Distribution",
  BROWSER_DISTRIBUTION: "Browser Distribution",
  DEVICE_DISTRIBUTION: "Device Distribution",
  BY: "By",
  PROVIDER: "Provider",
  AGE_RANGE: "Age Range",
  BROWSER_USED_TO_CREATE: "Browser Used to Create",
  DEVICE_USED_TO_CREATE: "Device Used to Create",
  MOBILE_AND_TABLET: "Mobile & Tablet",
  DESKTOP: "Desktop",
  OTHERS: "Others",
  NUMBER_OF_NEW: "Number of New",
  TOTAL_CUSTOMER_PROFILES: "Total Customer Profiles",
  NEW_CUSTOMER_PROFILES: "New Customer Profiles",
  PLEASE_TRY_CHANGING_HEADER: "No data is available to display for the selected input. Please try changing the date, host, or customer type.",
  SELECT_A_MOBILE_LIBRARY: "Select a Mobile Library",

  // Identity Experience Framework
  IDENTITY_EXPERIENCE_FRAMEWORK: "Identity Experience Framework",
  PREVIEW: "Preview",
  IMPLEMENT: "Implement",
  REGISTER: "Register",
  PROFILE: "Profile",
  DEPLOYMENT: "Deployment",
  THEME: "Theme",
  TEMPLATES: "Templates",
  EDITOR: "Editor",
  UPLOAD_JSON: "Upload JSON",
  CUSTOMIZATION: "Customization",
  GLOBAL_THEME_SETTINGS: "Global Theme Settings",
  TEMPLATE_HEADINGS: "Choose one of our pre-built templates as a starting point and add your own customizations.",
  GLOBAL_THEME_SETTINGS_HEADINGS: "Configure your global theme settings, such as content, fonts, and forms.",
  CONTENT: "Content",
  FONTS: "Fonts",
  FORMS: "Forms",
  EDIT_CODE: "Edit Code",
  VISUAL_EDITOR: "Visual Editor",
  ADVANCED_EDITOR: "Advanced Editor",
  LAUNCH_PREVIEW: "Launch Preview",
  AUTHENTICATION_PAGES: "Authentication Pages",
  PROFILE_PAGES: "Profile Pages",
  WORKFLOW_PAGES: "Workflow Pages",
  ARE_YOU_SURE_RESET_THIS_HOSTED_ONE: "All your customized Auth Studio configurations for your ",
  ARE_YOU_SURE_RESET_THIS_HOSTED_TWO: " page will be cleared. Are you sure you want to reset?",
  CAUTION_FILE_MIGHT_BE_OVERWRITTEN: "Caution: Uploading a file will overwrite your existing configuration. Please use the Replace option instead.",
  UPLOADED_FILE_IS_EMPTY: "The uploaded file is empty.",
  PLEASE_UPLOAD_VALID_FILE: "Please upload a valid file.",
  ENTER_FILE_URL: "Enter a File URL",
  IMPLEMENT_SELF_HOSTED_TAB: "Self-Hosted Widget",
  IMPLEMENT_SELF_HOSTED_INTRO:
    "You can find details on how to access your IDX Auth Studio here. See <a id='blah-1' class='global-link' href='https://www.loginradius.com/docs/' rel='noopener noreferrer' target='_blank'>documentation here</a> for more details.",
  IMPLEMENT_SELF_HOSTED_CDN_LABEL: "Add this code to the <head> of your page.",
  IMPLEMENT_SELF_HOSTED_LROBJECT_LABEL: "Add this code to the <head> of your page, before the </head>. If you have already added this code, you may skip this step.",
  IMPLEMENT_SELF_HOSTED_LOGINSCREEN_LABEL: "Copy the code below and paste it before the </head> tag.",
  IMPLEMENT_SELF_HOSTED_BODY_LABEL: "Copy the code below and paste it before the </body> tag. Place it where you want the widget to display on your web page.",
  IMPLEMENT_HOSTED_TAB: "Hosted by LoginRadius",
  IMPLEMENT_HOSTED_INTRO: "Hello Hosted World. See <a id='' class='global-link' href='https://www.loginradius.com/docs/' target='new'>documentation here</a> for more details.",
  IMPLEMENT_HOSTED_URL_HEADER: "URLs for Pages Hosted by LoginRadius",
  IMPLEMENT_HOSTED_URL_DESCRIPTION: "Use the following URLs to link to Login, Register, Forgot Password, and (optional) Profile pages.",
  IMPLEMENT_HOSTED_URL_AUTH_LABEL: "URL for authentication pages (Login, Register, and Forgot Password).",
  IMPLEMENT_HOSTED_URL_PROFILE_LABEL: "URL for Profile pages (View and Edit), if applicable.",
  IMPLEMENT_HOSTED_TOKEN_LABEL: "Access Token",
  IMPLEMENT_HOSTED_LANDING_HEADER: "Landing Page URL for Authenticated Users",
  IMPLEMENT_HOSTED_LANDING_DESCRIPTION: "Enter the URL on your site where users will be redirected after successfully logging in, registering, or resetting their password.",
  IMPLEMENT_HOSTED_FAVICON_HEADER: "Favicon",
  IMPLEMENT_HOSTED_FAVICON_DESCRIPTION: "Enter the URL for the custom favicon hosted on your website that will be used on pages hosted by LoginRadius.",
  IMPLEMENT_HOSTED_FAVICON_LABEL: "Favicon URL",
  OVERWRITE: "Overwrite",
  OVERWRITE_HOSTED_PAGE_CONFIGS_CONFIRM: "Your theme will be switched, and all configurations and code changes will be reset. Continue?",
  FAVICON_URL_REQUIRED: "A favicon URL is required.",
  FAVICON_URL_INVALID: "The favicon URL is invalid.",
  IDX_IS_REQUIRED: " is required.",
  IDX_IS_INVALID: " is invalid.",
  FAVICON_SAVED: "The favicon has been updated successfully.",
  FAVICON_RESET: "The favicon has been reset successfully.",
  TEMPLATE_SAVE_SUCCESS: "The template has been saved successfully.",
  TEMPLATE_SAVE_ERROR: "The template failed to save.",
  LOADING_SUBSCRIPTION_ERROR: "Error loading subscription details.",
  LOADING_INVOICES_ERROR: "Error loading invoices.",
  CUSTOMIZE: "Customize",
  GENERAL_CONFIGURATION: "General Configuration",
  LOGIN_LABEL: "Login Label",
  SIGN_UP_LABEL: "Sign Up Label",
  FORGOT_PASSWORD_LABEL: "Forgot Password Label",
  FORGOT_PASSWORD_MESSAGE: "Forgot Password Message",
  SOCIAL_LOGIN_DIVIDER: "Social Login Divider",
  SIGN_UP_AND_FORGOT_PASSWORD_REQUEST: "Sign Up and Forgot Password Request Message",
  SIGN_UP_AND_FORGOT_PASSWORD_REQUEST_PHONE: "Sign Up and Forgot Password Phone Request Message",
  EMAIL_VERIFIED_MESSAGE: "Email Verified Message",
  SIGN_UP_LINK: "Sign Up Link",
  ADVANCED_CODE_EDITOR: "Advanced Theme Editor",
  BASIC_CODE_EDITOR: "Basic Theme Editor",
  ENABLE_ADVANCED_CODE_EDITOR: "Switch to Advanced Editor",
  ENABLE_BASIC_CODE_EDITOR: "Reset Theme Configurations",
  SINGLE_PAGE_STYLE: "Single Page Style",
  SINGLE_PANEL: "Single Panel",
  SOCIAL_SQUARE_STYLE: "Social Square Style",
  SHOW_LOGIN: "Enable Login Workflow",
  SHOW_SIGN_UP: "Enable Sign Up Workflow",
  SHOW_FORGOT_PASSWORD: "Enable Forgot Password Workflow",
  SHOW_RESET_PASSWORD: "Enable Reset Password Workflow",
  AFTER_LOGIN_URL: "After Login URL",
  AFTER_RESET_URL: "After Reset URL",
  LOGO_COLOR: "Logo Color",
  BACKGROUND_IMAGE: "Background Image",
  BACKGROUND_COLOR: "Background Color",
  TEXT_COLOR: "Text Color",
  FONT_FAMILY: "Font Family",
  INPUT_BACKGROUND: "Input Background",
  BODY: "Body",
  LOGO: "Logo",
  INPUT: "Input",
  SUBMIT_BUTTON: "Submit Button",
  CONFIRM_ADVANCED_EDITOR_MESSAGE: "Switching to the advanced code editor will discard any unsaved changes. Do you want to continue?",
  CONFIRM_BASIC_EDITOR_MESSAGE: "This will reset all changes made to your current theme. Do you want to continue?",
  CONFIRM_BASIC_EDITOR_CHECKBOX_MESSAGE: "I Understand this will reset all changes made to my current theme.",
  HOSTED_ON_LOGINRADIUS_SERVERS: "Are you sure you want to host this file on LoginRadius servers?",
  RANDOM_FILE_NAME: "Your file will be labeled with a random file name after being added.",
  SECURITY_COMPLIANCES_DESC:
    "LoginRadius has worked with third-party auditors to achieve industry-standard security compliance and align with best practices for security controls. Below is the list of security compliances and controls that LoginRadius adheres to.",
  BASIC_OR_ADVANCED_EDITOR: "Basic or Advanced Editor",
  ADVANCED_EDITOR_ONLY: "Advanced Editor Only",
  MFA_METHOD_NOT_AVAILABLE: "This Multi-Factor Authentication method is not available with your current plan. Please contact LoginRadius support for more information.",
  MESSAGES_SENT_TO_TWILIO: "Messages Sent to Twilio",
  SMS_MESSAGES_COUNT: "SMS Messages Count",
  MESSAGES_STATUS_BY_TWILIO: "Message Status Reported by Twilio",
  ERROR_OCCURRED_WHILE_SAVING: "An error occurred while saving the configuration.",
  IDENTITY_PROVIDERS: "Identity Providers",
  IDENTITY_PROVIDER_DESC: "Configure identity providers with supported protocols to handle authentication requests and verify users.",
  ENABLED_TO_LOAD_THE_SOCIAL_PROVIDER_CONFIGURATION: "Enable this setting to load the social provider configuration.",
  SOCIAL_PROVIDER_NOT_CONFIGURATION: "The social provider is not configured.",
  MULTIPLE_SOCIAL_CONFIG_NOT_FOUND: "Multiple social configurations were not found, or the resource does not exist.",
  SSO_ONLY_TEXT: "Please use SSO as per the configuration set by your organization admin.",
  EMAIL_PASSCODE_NOTIFICATION_INFO: "The amount of time that the #emailname# feature remains disabled for the customer after they reach their request limit.",
  EMAIL_PASSCODE_SUBJECT: "Email Passcode Settings",
  EMAIL_PASSCODE_REQUEST_LIMIT:
    "The request limit is the number of times a customer can request #emailname# during the request period before this feature is temporarily disabled. For example, a customer can request this email only 5 times (request limit) over the course of 120 minutes (request period) before the feature is disabled.",
  EMAIL_PASSCODE: "Email OTP",
  EMAIL_PASSCODE_SUBJECT_VALUE: "Verification Code",
  EMAIL_PASSCODE_EMAIL_BODY: "Hi #Name#, <br/><br/>Your MFA verification code is <b>#OTP#</b><br/><br/>Regards<br/>",
  EMAIL_PASSCODE_EMAIL_TEXT_TEMPLATE: `Hello #Name#,

Your MFA verification code is #OTP#

Regards
    `,
  EMAIL_PASSCODE_HEADER: "Deliver MFA OTPs to users’ email addresses. You can customize the standard email template used to send email OTPs.",
  EMAIL_OTP_SUCCESS_MESSAGE: "The Multi-Factor Authentication Email Passcode setting has been saved successfully.",
  EMAIL_OTP_ERROR_MESSAGE: "The Multi-Factor Authentication Email Passcode setting could not be saved successfully.",
  EMAIL_PASSCODE_SETTINGS_HEADER: "Configure these settings for the email that will be triggered for the Multi-Factor Passcode through LoginRadius.",
  TO_SETUP_EMAIL_CONFIGURATION: "To set up email configuration, click",
  MULTI_FACTOR_EMAIL_OTP_VALIDITY_LIMIT: "Multi-Factor OTP Validity Limit (Minutes)",
  ONE_TIME_PASSCODE: "One-Time Passcode",
  MULTI_FACTOR_EMAIL_OTP_VALIDITY_LIMIT_TOOLTIP: "The amount of time for which the code included in the one-time passcode email is valid.",
  MFA_SECURITY_QUESTION_HEADER: "Perform MFA with knowledge-based secrets that users can set during registration or afterward.",
  ADD_SECURITY_QUESTION_MFA: "Add Security Question for MFA",
  ADD_SECURITY_QUESTION_DES_MFA: "You can configure the security question for MFA.",
  MFA_SQ_ENABLE: "Enable Security Question for MFA",
  MFA_SQ_SUCCESS_MESSAGE: "The Security Questions setting has been saved successfully.",
  MFA_SQ_NOTE: "You can configure the security questions and their attempt limit.",
  MFA_SQ_NOTE_0_QUESTIONS: "Please add at least one security question to enable the Security Question for MFA.",
  MFA_SQ_ERROR_MESSAGE: "Security Questions settings could not be saved successfully.",
  SELECT_QUESTION_COUNT: "Select Question Count",
  SECURITY_QUESTION_ATTEMPT_SAVED_SUCCESSFULLY: "Security Question attempt limit saved successfully.",
  ADD_A_NEW_CONFIGURATION: "Add API",
  AUTHORIZATION_HEADER:
    "In this section, you can create APIs according to your requirements by defining the name, identifier, and scope. You can only add the scope name here; the actual scope must be handled in your implementation. For more information about the use case, refer to the <a id='lnk_app_section' class='global-link' href='/platform-configuration/authentication-configuration/machine-to-machine-authorization/machine-to-machine-app' rel='noopener noreferrer'>Manage M2M App</a> section. You can also view the details and scope of the LoginRadius Management API.",
  AUTHORIZATION_SCOPE: "Add scope name and description here. For each scope name, you must define the actual scope in your application.",
  AUTHORIZATION_SERVER_API: "Authorization Server APIs",
  MACHINE_AUTH_HEADER:
    "In this section, you can create M2M apps and grant them API access as needed. For each app, you can select the applicable scope, specify the name, token lifetime, and more. The scope can be one you added while creating APIs or one included in the LoginRadius Management API. For each app, a unique API Key and Secret is generated, which can be utilized in Machine-to-Machine communication use cases, such as IoT Device Authentication and Service-to-Service Authentication.",
  MACHINE_APP_LIST: "Machine-to-Machine App List",
  AUTHORIZATION_SERVER_API_DESCRIPTION: "Please fill out the form below to submit a request to add new authorization server APIs.",
  ADD_NEW_API: "Add a New API",
  M2M_APP_CONFIG: "Machine-to-Machine App List",
  AUDIENCE_DESCRIPTION: "Define the access for this app. You must select the audience (identifier) and the scope from the respective dropdown list.",
  M2M_DESCRIPTION: "Please fill out the form below to submit a request to add a new M2M App.",
  CLIENT_SECRET_SUCCESSFULLY_RESET: "The Client Secret has been successfully reset.",
  CLIENT_SECRET_NOTE: "Make sure to copy your Client Secret now. You won’t be able to see it again! You can always generate a new client secret if needed.",
  SECRET_KEY_NOTE: "Generate the OpenID Connect Secret using RS256 and add it here.",
  LABEL_RESET_SECRET_CONFIRMATION: "Are you sure you want to reset this?",
  RESET_SECRET_MODAL_CONTENT:
    "Resetting the client secret will permanently invalidate the existing secret. All integrations and applications relying on the current secret will cease to function until reconfigured with the newly generated value. Proceed only if you are prepared to update the affected systems immediately.",
  RESET_SECRET_TOOLTIP: "Reset client secret to regenerate the code, do not miss to copy it as it will only be visible once.",
  RESET_CLIENT_SECRET_TITLE: "Reset client secret?",
  RESET_CLIENT_SECRET_MESSAGE:
    "Resetting the client secret will invalidate the current secret. Any application or integration using the existing secret will stop working until updated. The new secret will be displayed only once — copy it immediately.",
  RESET_CLIENT_SECRET_ALERT: "This action cannot be undone.",
  RESET_CLIENT_SECRET_CONFIRMATION: "I understand that resetting the client secret may break existing integrations.",
  RESET_CLIENT_SECRET_BUTTON: "Reset secret",
  PROTOCOL: "Protocol",
  CLIENT_ID: "Client Id",
  CLIENT_SECRET: "Client Secret",
  PrivacyPolicyHistory: "Privacy Policy Logs",
  REFER_DOCUMENT: "Refer to document",
  RESTRICT_CUSTOM_PROVIDER_REGISTRATION: "Custom Provider Registration",
  RESTRICT_CUSTOM_PROVIDER_REGISTRATION_DESC: "When enabled, users can register using a custom provider.",
  JWT_HEADER_TEXT: "To use JIT Provisioning, ensure the following :",
  ACCOUNT_MERGING: "Account Merging",
  ACCOUNT_MERGING_DESC: "When enabled, the user’s traditional profile is automatically merged into their social profile if both profiles share the same email address.",
  TENANT_SETTINGS_DESC: "Manage all preferences and settings related to this tenant.",
  ACCOUNT_MERGING_DESC2: "A traditional profile is created when users log in via email-based login, and a social profile is created when they log in using a social provider.",
  NO_CALLBACK_LOGIN: "Social Login via Ping API",
  TENANT_SETTINGS: "Tenant Settings",
  TEAM_SSO: "Team SSO",
  NO_CALLBACK_LOGIN_DESC: "When enabled, in the social login workflow, the access token is captured via the Ping API on the parent window after successful authentication.",
  OTP_EMAIL_VERIFICATION: "OTP Email Verification",
  OTP_EMAIL_VERIFICATION_DESC: "When enabled, an OTP is sent to the user’s email for the email verification process.",
  // Mailazy
  RESET_MAILAZY_DOMAIN: "If you edit the domain name, the key and secret will be regenerated. You will need to update the SMTP configuration with the newly generated details.",
  MAILAZY_REG: "An OTP will be sent to the owner's email address for verification.",
  MAILAZY_COPY_KEY_SECRET: "Make sure to copy the Key and Secret now. You won’t be able to see them again.<br>This key and secret will be used for the Mailazy provider.",
  MAILAZY_SETTINGS: "Settings",
  MAILAZY_REGEN: "Please regenerate the Key and Secret.",
  MAILAZY_DOMAIN_SUCCESS: "Domain name saved successfully. Please verify to proceed further.",
  MAILAZY_REGEN_SUCCESS: "Key/Secret regenerated successfully.",
  MAILAZY_RESEND_OTP: "OTP has been resent successfully to your email address. Please verify it.",
  MAILAZY_EMAIL_ID: "Email Address (Owner)",
  MAILAZY_DNS_MESSAGE: "It may take up to 24 hours for DNS changes to take effect. You may skip it for now and verify later.",
  MAILAZY_ERROR: "Request could not be processed.",
  MAILAZY_DOMAIN_VERIFIED: "Domain name verified successfully.",
  MAILAZY_EMAIL_VERIFIED: "OTP verified successfully.",
  MAILAZY_OTP: "OTP will be valid for 7 days.",
  MAILAZY_OTP_MESSAGE: "The provided OTP is invalid. Please provide a valid OTP to proceed.",
  MAILAZY_REGISTER_MESSAGE: "This will be your email address registered with Mailazy.",
  MAILAZY_DOMAIN_FAIL: "Domain name verification has failed.",
  MAILAZY_DOMAIN_FORMAT: "Domain name invalid.",
  MAILAZY_RESET_POPUP: "If you change or reset the API key and secret, any API calls you have developed will stop working until you update them with your new key and secret.",
  SET_DNS_PROVIDER_RECORD: "Set the following record on your DNS provider to complete the verification.",
  VERIFIED: "Verified",
  PENDING_VERIFICATION: "Pending Verification",
  RESEND_OTP: "Resend OTP",
  MANAGE_CONFIGURATIONS: "Manage Configuration",
  SKIP_BUTTON: "Skip",
  BUTTON_REFRESH: "Refresh",
  REGENERATE: "Regenerate",
  MAILAZY_CONFIGURATION: "Mailazy Configuration",
  MAILAZY_CONFIGURATION_DESC: "You can configure a Mailazy connection to send transactional emails to your application users.",
  BACK: "Back",
  VERIFIED_MAILAZY_CONFIG_TOOLTIP: "Please use the same domain as verified for Mailazy Configuration.",
  CUSTOM_DOMAIN_DELETE_POPUP: "Verify the removal of this custom domain.",
  CUSTOM_DOMAIN_MAPPING__REMOVAL_POPUP: "Are you sure you want to remove this custom domain mapping?",
  CUSTOM_DOMAIN_ENTRY: "Domain Name",
  CUSTOM_DOMAIN_SAVED_SUCCESSFULLY: "Custom domain saved successfully.",
  CUSTOM_DOMAIN_DELETED_SUCCESSFULLY: "Custom domain deleted successfully.",
  EXTENDED_DATA_POINTS_ENABLED: "Extended data points have been enabled.",
  EXTENDED_DATA_POINTS_DISABLED: "Extended data points have been disabled.",
  MANDATORY_EMAIL_FLOW_SUB_HEADING: "Users receive a verification email and must verify their email address to log in.",
  OPTIONAL_EMAIL_FLOW_SUB_HEADING: "Users receive a verification email but are not required to verify their email address to log in.",
  DISABLED_EMAIL_FLOW_SUB_HEADING: "A verification email is not sent to users after registration.",
  IP_ACCESS_ENABLED_SUCCESS_MESSAGE: "Access restriction has been enabled.",
  ASK_REQUIRE_FIELD_ON_TRADITIONAL_LOGIN_MESSAGE: "Ask for added required fields on traditional login",
  IS_LOGOUT_ON_EMAIL_VERIFICATION_MESSAGE: "Logout on email verification.",
  GOOGLE_RECAPTCHA_INFO: "When enabled, the selected reCAPTCHA will apply to the registration form.",
  GOOGLE_RECAPTCHA_INFO_FOR_ONLY_INVISIBLE_RECAPTCHA: "When enabled, the Invisible reCAPTCHA will apply to the registration form.",
  ASK_PASSWORD_ON_SOCIAL_LOGIN_INFO: "When enabled, users must set a password when signing up with a social account.",
  ASK_PASSWORD_ON_SOCIAL_LOGIN_MESSAGE: "Set a password on social sign up",
  ASK_EMAILID_FOR_UNVERIFIED_USER_LOGIN_MESSAGE: "Ask for email for unverified user login",
  ENABLE_AUTOMATIC_LOGIN_AFTER_EMAIL_VERIFICATION_INFO: "When enabled, users will automatically log in to their account upon email verification.",
  ENABLE_AUTOMATIC_LOGIN_AFTER_EMAIL_VERIFICATION_MESSAGE: "Auto-login upon email verification",
  ENABLE_AUTOMATIC_LOGIN_AFTER_PASSWORD_RESET: "Enable Auto Login Upon Password Reset",
  ENABLE_AUTOMATIC_LOGIN_AFTER_PASSWORD_RESET_INFO: "When enabled, users will automatically log in to their account upon resetting their password.",
  ENABLE_AUTOMATIC_LOGIN_AFTER_PASSWORD_RESET_MESSAGE: "Auto-login upon password reset",
  ASK_OPTIONAL_FIELDS_ON_SOCIAL_SIGNUP_MESSAGE: "Ask for optional field(s) on social sign up",
  ENFORCE_PASSWORD_RULE_ON_LOGIN: "Enable Server-Side Password Rule on Login",
  ENFORCE_PASSWORD_RULE_ON_LOGIN_INFO: "When enabled, the password rule will also be validated on the server side during login.",
  ENFORCE_PASSWORD_RULE_ON_LOGIN_MESSAGE: "Password rule validation on the server side.",
  MFA_SETTING_HEADER: "Configure and manage multi-factor authentication (MFA) and step-up authentication.",
  STEP_UP_AUTH_HEADER: "Step-Up Authentication",
  STEP_UP_AUTH_DESCRIPTION:
    "You can configure Step-Up Authentication so that users must authenticate themselves again when the application triggers a specific event. For example, when changing the account password from the profile, the user would need to enter the existing password.",
  SETTINGS_UPDATED: "Settings have been updated.",
  CREATE_MAILAZY_ACCOUNT: "Create Mailazy Account",
  CUSTOMER_RESET_MFA_CONFIRM: "Are you sure you want to reset MFA settings for this customer? The customer will need to set up MFA again after the reset.",
  BTN_UPGRADE_MFA_SUCCESS: "OK, Let's Do It",
  REMIND_ME_10: "Remind Me in 10 Minutes",
  LETS_START_UPGRADE_MFA: "Start using enhanced MFA for your LoginRadius Admin Console account ",
  LESS_THAN_MIN: "in less than a minute.",
  RECONFIGURE_MFA: "Why do I need to reconfigure my MFA?",
  RECONFIGURE_MFA_DESCIPTION: "We have enhanced the MFA experience, requiring you to rescan the QR code in your Google Authenticator App and complete verification.",
  UPGRADE_MFA_TITLE: "Upgrade Your Account MFA",
  SETUP_GOOGLE_AUTH: "Set Up Google Authenticator",
  MFA_VERIFICATION_CODE: "Authenticator Code",
  MFA_RESET_WARNING: "Your account MFA has been reset. Do not exit this pop-up without completing the MFA upgrade process.",
  SSO_CONFIRM_POPUP:
    "Are you sure you want to disable Email/Password login and allow only SSO Login to access the LoginRadius Admin Console?<br/><br/>Ensure the configurations are correct. Otherwise, you will lose access to the Admin Console, and neither SSO nor Email/Password login will work.",
  SSO_CONFIRM_POPUP_WARNING:
    "<div class='alert alert-warning w-100' role='alert'><strong>Important: Completing this action will immediately require you to log in using SSO login if you are currently logged in with Email/Password login.</strong></div><br/>",
  SSO_LOGIN_DESCRIPTION: "Disable Email/Password login and allow only SSO Login to access the LoginRadius Admin Console.",
  NAME_INVALID: "Name is invalid.",
  EMAIL_WORKFLOW_UI_SUPPORT_TICKET_SUBJECT: "Email Verification Update",
  CURR_EMAIL_WORKFLOW_IS: "Current Email Verification is ",
  BUTTON_EDIT_WEB_HOOK: "Edit",
  BUTTON_UNSUBSCRIBE: "Unsubscribe",
  CUSTOM_OBJECTS: "Custom Objects",
  DUPLICATE_CUSTOM_OBJECTS: "Duplicate custom objects are not allowed.",
  CUSTOM_OBJECTS_ERROR: "Custom Object is required.",
  CANNOT_UPDATE_WEBHOOK: "Cannot update the custom object. Ensure you are editing a webhook with an SQS URL and try again.",
  UPDATE_WEBHOOK_HEADER: "Update Webhook",
  UPDATE_WEBHOOK_DESCRIPTION: "Edit the secret name for this webhook",
  ADD_WEBHOOK_HEADER: "Add New Webhook",
  NEW_WEBHOOK_HEADER: "New Webhook",
  ADD_WEBHOOK_DESCRIPTION: "Add a new webhook",
  NO_WEBHOOK_HEADER: "No Webhooks",
  NO_WEBHOOK_DESCRIPTION: "No webhooks have been configured yet.",
  PLEASE_FILL_OUT_UPDATE_FORM_BELOW: "Please fill out the form below to update the subscribed URL.",
  CONFIRM_DELETE_WEBHOOK_HEADER: "Are you sure you want to unsubscribe from this webhook?",
  WEBHOOK_UPDATED_SUCCESSFULLY: "Subscribed URL updated successfully.",
  /* FEDERATED_SSO_OAUTH2 */
  USER_MASK_ERROR: "User Code Mask format must be valid and not exceed 15 characters.",
  FEDERATED_SSO_OIDC_DESCRIPTION: "Create and manage identity apps that facilitate customer registration and authentication for your mobile, desktop, web, and IoT interfaces and applications.",
  FEDERATED_SSO_OAUTH2_DESCRIPTION: "OAuth 2.0 (RFC 6749) is a set of standardized flows that allow authenticating your customers at LoginRadius for your Service Provider (SP) applications.",
  FEDERATED_SSO_OAUTH2_FORM_TITLE: "Add OAuth2 App",
  ADD_AN_NEW_APP: "Add a New App",
  OAUTH_EDIT_DESCRIPTION: "Edit the following details to update the OAuth 2.0 App.",
  APP_EDIT_DESCRIPTION: "Edit the following details to update the app.",
  OAUTH_ADD_NEW_APP_DESCRIPTION: "Fill in the following details to create a new OAuth 2.0 App.",
  ADD_NEW_APP_DESCRIPTION: "Fill in the following details to create an app.",
  OAUTH2: "OAuth2",
  APP: "App",
  FEDERATED_SSO_OAUTH2_FORM_APPNAME: "App Name",
  FEDERATED_SSO_OAUTH2_FORM_APPNAME_TOOLTIP: "Enter the app name for LoginRadius to recognize your app during the API call.",
  FEDERATED_SSO_OAUTH2_FORM_ALGORITHMS: "Algorithm",
  FEDERATED_SSO_OAUTH2_FORM_GRANTTYPE: "Grant Type",
  FEDERATED_SSO_OAUTH2_FORM_GRANTTYPE_TOOLTIP: "Select how your app will obtain the access token.",
  FEDERATED_SSO_OAUTH2_FORM_DEVICE_CODE_CONFIGURATION: "Device Code Configuration",
  FEDERATED_SSO_OAUTH2_FORM_VERIFICATION_URL: "Verification URL",
  FEDERATED_SSO_OAUTH2_FORM_VERIFICATION_URL_TOOLTIP: "Enter the verification URL so users can manually enter their code into user agent.",
  FEDERATED_SSO_OAUTH2_FORM_VERIFICATION_COMPLETE_URL: "Verification Complete URL",
  FEDERATED_SSO_OAUTH2_FORM_VERIFICATION_COMPLETE_URL_TOOLTIP: "Enter the redirection URL for users after successful authentication.",
  FEDERATED_SSO_OAUTH2_FORM_DEVICE_CODE_EXPIRATION: "Device Code Expiration (Seconds)",
  FEDERATED_SSO_OAUTH2_FORM_DEVICE_CODE_EXPIRATION_TOOLTIP: "Enter the lifetime of the device code in seconds.",
  FEDERATED_SSO_OAUTH2_FORM_POLLING_INTERVAL: "Polling Interval (Seconds)",
  FEDERATED_SSO_OAUTH2_FORM_POLLING_INTERVAL_TOOLTIP: "Enter the time in seconds. This is the minimum time the client should wait between polling requests to the token endpoint.",
  FEDERATED_SSO_OAUTH2_FORM_USER_CODE_CHARACTER_SET: "User Code Character Set",
  FEDERATED_SSO_OAUTH2_FORM_USER_CODE_CHARACTER_SET_TOOLTIP: "Select the user code character set.",
  FEDERATED_SSO_OAUTH2_FORM_USER_CODE_MASK: "User Code Mask",
  FEDERATED_SSO_OAUTH2_FORM_USER_CODE_MASK_TOOLTIP: "Enter the user code pattern. For example, ***-*** generates ASD-QWE user code.",
  FEDERATED_SSO_OAUTH2_FORM_TOKEN_EXPIRATION: "Token Expiration (Seconds)",
  FEDERATED_SSO_OAUTH2_FORM_TOKEN_EXPIRATION_TOOLTIP: "Enter the lifetime of the Access Token in seconds.",
  FEDERATED_SSO_OAUTH2_FORM_TOKEN_METHOD: "Token Endpoint Auth Method",
  FEDERATED_SSO_OAUTH2_FORM_TOKEN_METHOD_TOOLTIP: "Select the client authentication method to authenticate the Authorization Server when using the token endpoint.",
  FEDERATED_SSO_OAUTH2_FORM_FORCE_REAUTH: "Force Reauthentication",
  FEDERATED_SSO_OAUTH2_FORM_FORCE_REAUTH_TOOLTIP: "If checked, reauthentication is required for the authorization request. Otherwise, reauthentication is not applicable.",

  APP_NAME_EXTRA: "A unique internal name for this provider",
  CLIENT_ID_EXTRA: "This is the unique identifier assigned to your app. Use this when integrating with the Authorization Server or other client-side flows.",
  CLIENT_SECRET_EXTRA: "This secret key authenticates your app with the Authorization Server. Keep it secure and never expose it in client-side code or public repositories",
  ALGO_EXTRA: "The algorithm used for token signing and verification.",
  GRANT_TYPE_EXTRA: "Select how your app will obtain the access token",
  TOKEN_EP_AUTH_METH_EXTRA: "Token Endpoint Authentication Method defines how your client application proves its identity when calling the token endpoint of the authorization server",
  FORCE_REAUTH_EXTRA: "If checked, reauthentication is required for the authorization request. Otherwise, reauthentication is not applicable.",
  SIGNEDUSER_INFO_EXTRA: "If checked, user info is returned as a signed JWT Token; otherwise, it is returned in JSON format.",
  TOKEN_EXP_TIME_EXTRA: "Enter the lifetime of the Access Token in seconds.",
  REFRESH_TOKEN_TTL_EXTRA: "Enter the lifetime of the Refresh Token in seconds.",
  ENABLE_CORS_EXTRA: "Allow specified domains to access your app’s APIs from the browser; enable if your app runs on a different domain than your APIs.",
  SCOPES_EXTRA: "Select the access privileges requested for Access Tokens.",

  API_GENERAL_TITLE: "General Settings",
  API_GENERAL_DESCRIPTION: "Basic API information",
  API_SCOPES_TITLE: "Scopes",
  API_SCOPES_DESCRIPTION: "Add scope name and description here. For each scope name, you must define the actual scope in your application.",

  USER_ACCESS: "User Access",
  USER_ACCESS_DESCRIPTION: "Configure how users can access API",
  TOKEN_SETTINGS: "Token Settings",
  TOKEN_SETTINGS_DESCRIPTION: "Manage API access and token settings",

  API_VIEW_TITLE: "View API",
  API_EDIT_TITLE: "Edit API",
  API_CREATE_TITLE: "Create API",
  API_VIEW_DESCRIPTION: "View your Authorization Server API here",
  API_EDIT_DESCRIPTION: "Edit your Authorization Server API here",
  API_CREATE_DESCRIPTION: "Add your Authorization Server API here",
  API_BACK_TO_LIST: "Back to APIs List",
  API_NO_APIS_FOUND: "No APIs Found",
  API_SCOPE_NAME_PLACEHOLDER: "read:orders",
  API_SCOPE_DESCRIPTION_PLACEHOLDER: "Enter description",
  API_NO_SCOPES: "No scopes defined",
  API_SCOPE: "Scope",
  API_DELETE_SCOPE_CONFIRMATION: "This scope might be assigned to roles and applications. Deleting it will revoke access to it.",
  API_NAME_LABEL: "API Name",
  API_NAME_PLACEHOLDER: "Enter API name",
  API_IDENTIFIER_LABEL: "Identifier",
  API_IDENTIFIER_PLACEHOLDER: "https://api-endpoint/",
  API_ACCESS_RBAC_LABEL: "Access based on RBAC Roles",
  API_ACCESS_RBAC_TOOLTIP: "When enabled, access is enforced based on RBAC roles.",
  API_ACCESS_RBAC_DESCRIPTION: "When disabled, users may request access if the API scope supports it.",
  API_TOKEN_TTL_LABEL: "Token TTL (In Secs)",
  API_ALLOW_TOKEN_EXCHANGE: "Allow Token Exchange",
  API_TOKEN_EXCHANGE_DESCRIPTION: "Securely issue, map, and exchange tokens to enable trusted authentication and authorization across systems and applications",
  API_TRUSTED_CLIENT_SUBJECTS: "Trusted Client Subjects",

  OIDC_DISABLE_TOOLTIP: "Open ID Connect 1.0 Protocol does not support M2M App type",
  FEDERATED_SSO_OPENID_FORM_APPNAME: "Enter name of your application",
  APP_NAME_DESCRIPTION: "For LoginRadius to recognize your app during the API call",
  NAME_OF_APP: "Name of your application",
  CHOOSE_PROTOCOL: "Choose a Protocol",
  CHOOSE_APP_TYPE: "Choose an App Type",
  EXPLORE_PREBUILT_CONNECTIONS: "Explore SAML, JWT and other Prebuilt integrations",
  EXPLORE_PREBUILT_CONNECTIONS_DESCRIPTION: "Use SSO Integrations to integrate SAML, JWT and other platforms like Salesforce, Shopify, Zendesk etc without configuring protocols.",
  GO_TO_SSO_CONNECTORS: "Go to SSO Integrations",
  GO_TO_APPS: "Go to Apps",
  CREATE_SSO_INTEGRATION: "Create SSO Integration",
  STORE_DETAILS_TITLE_BIGCOMM: "Store Details",
  STORE_DETAILS_DESCRIPTION_BIGCOMM: "Configure basic information about your BigCommerce storefront.",
  API_CREDS_TITLE_BIGCOMM: "API Credentials",
  API_CREDS_DESCRIPTION_BIGCOMM: "Use your BigCommerce API keys to authorize secure access to store data.",
  PERMS_SCOPES_TITLE_BIGCOMM: "Permissions & Scopes",
  PERMS_SCOPES_DESCRIPTION_BIGCOMM: "Define what your app can access within BigCommerce.",
  DATA_MAPPING_TITLE_BIGCOMM: "Data Mapping",
  DATA_MAPPING_DESCRIPTION_BIGCOMM: "Map BigCommerce profile data to your CIAM user model.",
  STORE_DETAILS_TITLE_SHOPIFY: "Store Details",
  STORE_DETAILS_DESCRIPTION_SHOPIFY: "Configure basic information about your Shopify storefront.",
  AUTH_SETTINGS_TITLE_SHOPIFY: "Authentication Settings",
  AUTH_SETTINGS_DESCRIPTION_SHOPIFY: "Configure secure credentials for JWT authentication with Shopify.",
  DATA_MAPPING_TITLE_SHOPIFY: "Data Mapping",
  DATA_MAPPING_DESCRIPTION_SHOPIFY: "Map Shopify profile data to your CIAM user model.",
  STORE_DETAILS_TITLE_XPLOR: "Store Details",
  STORE_DETAILS_DESCRIPTION_XPLOR: "Configure basic information about your Xplor storefront.",
  AUTH_SETTINGS_TITLE_XPLOR: "Authentication Settings",
  AUTH_SETTINGS_DESCRIPTION_XPLOR: "Configure secure credentials for JWT authentication with Xplor.",
  DATA_MAPPING_TITLE_XPLOR: "Data Mapping",
  DATA_MAPPING_DESCRIPTION_XPLOR: "Map Xplor profile data to your CIAM user model.",
  GENERAL_SETTINGS_TITLE_INTEGRATION: "General Settings",
  GENERAL_SETTINGS_DESCRIPTION_INTEGRATION: "Set up the basic details to identify and integrate your %appType% application.",
  GENERAL_SETTINGS_TITLE_JWT: "General Settings",
  GENERAL_SETTINGS_DESCRIPTION_JWT: "Set up the basic details to identify and integrate your JWT application.",
  TOKEN_SESSION_SETTINGS_TITLE_JWT: "Token & Session Settings",
  TOKEN_SESSION_SETTINGS_DESCRIPTION_JWT: "Configure the token and session settings for your JWT application.",
  DATAMAPPING_METADATA_TITLE_JWT: "Data Mapping & Metadata",
  DATAMAPPING_METADATA_DESCRIPTION_JWT: "Attach custom fields or static values to the data response.",
  GENERAL_SETTINGS_TITLE_SAML: "General Settings",
  GENERAL_SETTINGS_DESCRIPTION_SAML: "Set up the basic details to identify and integrate your SAML application.",
  URLS_TITLE_SAML: "URLs",
  URLS_DESCRIPTION_SAML: "The URL of the page to where users will be redirected for authentication.",
  SERVICE_PROVIDER_DETAILS_TITLE_SAML: "Service Provider Details",
  SERVICE_PROVIDER_DETAILS_DESCRIPTION_SAML: "The Service Provider endpoints and settings that LoginRadius will use to establish a SAML session.",
  AUDIENCES_TITLE_SAML: "Audiences",
  AUDIENCES_DESCRIPTION_SAML: "Configure the audiences for your SAML application.",
  FEDERATED_SSO_OPENID_FORM_APPNAME_TOOLTIP: "Enter the app name for LoginRadius to recognize your app during the API call.",
  FEDERATED_SSO_OPENID_FORM_ALGORITHMS: "Algorithm",
  FEDERATED_SSO_OPENID_FORM_GRANTTYPE: "Grant Type",
  FEDERATED_SSO_OPENID_FORM_GRANTTYPE_TOOLTIP: "Select how your app will obtain the access token.",
  FEDERATED_SSO_OPENID_FORM_DEVICE_CODE_CONFIGURATION: "Device Code Configuration",
  FEDERATED_SSO_OPENID_FORM_VERIFICATION_URL: "Verification URL",
  FEDERATED_SSO_OPENID_FORM_VERIFICATION_URL_TOOLTIP: "Enter the verification URL for users to manually enter their user code into their user agent.",
  FEDERATED_SSO_OPENID_FORM_VERIFICATION_COMPLETE_URL: "Verification Complete URL",
  FEDERATED_SSO_OPENID_FORM_VERIFICATION_COMPLETE_URL_TOOLTIP: "Enter the redirection URL for users after successful authentication.",
  FEDERATED_SSO_OPENID_FORM_DEVICE_CODE_EXPIRATION: "Device Code Expiration (Seconds)",
  FEDERATED_SSO_OPENID_FORM_DEVICE_CODE_EXPIRATION_TOOLTIP: "Enter the lifetime of the device code in seconds.",
  FEDERATED_SSO_OPENID_FORM_POLLING_INTERVAL: "Polling Interval (Seconds)",
  FEDERATED_SSO_OPENID_FORM_POLLING_INTERVAL_TOOLTIP: "Enter the time in seconds. This is the minimum time the client should wait between polling requests to the token endpoint.",
  FEDERATED_SSO_OPENID_FORM_USER_CODE_CHARACTER_SET: "User Code Character Set",
  FEDERATED_SSO_OPENID_FORM_USER_CODE_CHARACTER_SET_TOOLTIP: "Select the user code character set.",
  FEDERATED_SSO_OPENID_FORM_USER_CODE_MASK: "User Code Mask",
  FEDERATED_SSO_OPENID_FORM_USER_CODE_MASK_TOOLTIP: "Enter the user code pattern. For example, ***-*** generates ASD-QWE user code.",
  FEDERATED_SSO_OPENID_FORM_TOKEN_EXPIRATION: "Token Expiration Time (In Secs)",
  FEDERATED_SSO_OPENID_FORM_TOKEN_EXPIRATION_TOOLTIP: "Enter the lifetime of the Access Token in seconds.",
  FEDERATED_SSO_OPENID_FORM_IDTOKEN_EXPIRATION: "ID Token Expiration (Seconds)",
  FEDERATED_SSO_OPENID_FORM_IDTOKEN_EXPIRATION_TOOLTIP: "Enter the lifetime of the ID Token in seconds.",
  FEDERATED_SSO_OPENID_FORM_TOKEN_METHOD: "Token Endpoint Auth Method",
  FEDERATED_SSO_OPENID_FORM_TOKEN_METHOD_TOOLTIP: "Select the client authentication method to authenticate the Authorization Server when using the token endpoint.",
  FEDERATED_SSO_OPENID_FORM_SCOPES: "Scopes",
  FEDERATED_SSO_OPENID_FORM_SCOPES_TOOLTIP: "Select the access privileges requested for Access Tokens.",
  FEDERATED_SSO_OPENID_FORM_FORCE_REAUTH: "Force Reauthentication",
  FEDERATED_SSO_OPENID_FORM_FORCE_REAUTH_TOOLTIP: "If checked, reauthentication is required for the authorization request. Otherwise, reauthentication is not applicable.",
  FEDERATED_SSO_OPENID_FORM_ISSIGNED: "Signed User Info",
  FEDERATED_SSO_OPENID_FORM_ISSIGNED_TOOLTIP: "If checked, user info is returned as a signed JWT Token; otherwise, it is returned in JSON format.",
  FEDERATED_SSO_OPENID_FORM_AUDIENCES: "Intended recipients of the issued token.",
  FEDERATED_SSO_OPENID_FORM_AUDIENCES_TOOLTIP: "Enter the resource server that will accept the OIDC.",
  FEDERATED_SSO_OPENID_FORM_AUDIENCES_KEY: "App Audiences",
  FEDERATED_SSO_OPENID_FORM_AUDIENCES_BUTTON: "Add",
  FEDERATED_SSO_OPENID_FORM_DATA_MAPPING: "Fields or properties you want to add to the data response.",
  FEDERATED_SSO_OPENID_FORM_DATA_MAPPING_TOOLTIP: "Specify the key-value pair of LoginRadius profile data points you want to receive in the ID Token payload.",
  FEDERATED_SSO_OPENID_FORM_DATA_MAPPING_KEY: "Enter Key",
  FEDERATED_SSO_OPENID_FORM_DATA_MAPPING_VALUE: "Enter Profile Key",
  FEDERATED_SSO_OPENID_FORM_DATA_MAPPING_BUTTON: "Add",
  FEDERATED_SSO_OPENID_FORM_META_DATA: "Static non-profile values you want to add to the data response.",
  FEDERATED_SSO_OPENID_FORM_META_DATA_TOOLTIP: "Specify the key-value pairs of static non-profile data you want to receive in the ID Token payload.",
  FEDERATED_SSO_OPENID_FORM_META_DATA_KEY: "Enter Key",
  FEDERATED_SSO_OPENID_FORM_META_DATA_VALUE: "Enter Value",
  FEDERATED_SSO_OPENID_FORM_META_DATA_BUTTON: "Add",
  APP_PROTOCOAL_DESCRIPTION: "Know more about each protocol type",
  READ_SSO_DOCUMENTATION: "Read the Federated SSO Docs",
  SAML_APP_DESCRIPTION: "XML‑based Single Sign‑On for corporate Identity Providers.",
  APP_GROUP_GENERAL_TITLE: "General settings",
  APP_GROUP_GENERAL_DESCRIPTION: "Basic application information",
  APP_GROUP_CREDENTIALS_TITLE: "Credentials & security",
  APP_GROUP_CREDENTIALS_DESCRIPTION: "Configure the core credentials and security options that govern how the app communicates with the CIAM platform.",
  APP_GROUP_GRANT_TYPE_TITLE: "Grant settings",
  APP_GROUP_GRANT_TYPE_DESCRIPTION: "Configure how the app obtains tokens and how it authenticates at the token endpoint.",
  APP_GROUP_REDIRECT_URL_TITLE: "Redirect & logout URLs",
  APP_GROUP_REDIRECT_URL_DESCRIPTION: "Define the endpoints for post-authentication and post-logout redirections.",
  APP_GROUP_TOKEN_TITLE: "Token & session settings",
  APP_GROUP_TOKEN_DESCRIPTION: "Control token lifetimes and session-related security.",
  APP_GROUP_AUTHORIZATION_REQUESTS_TITLE: "Authorization requests",
  APP_GROUP_AUTHORIZATION_REQUESTS_DESCRIPTION: "Configure how this app uses pushed and rich authorization requests.",
  APP_GROUP_CROSS_ORIGIN_TITLE: "Cross-origin authentication",
  APP_GROUP_CROSS_ORIGIN_DESCRIPTION: "Restrict which domains can interact with the app’s authentication endpoints and define network access rules.",
  APP_GROUP_AUDIENCE_TITLE: "Audiences & scopes",
  APP_GROUP_AUDIENCE_DESCRIPTION: "Specify the intended recipients of tokens and define access levels.",
  APP_GROUP_APIS_TITLE: "APIs",
  APP_GROUP_DATA_MAPPING_TITLE: "Data mapping & metadata",
  APP_GROUP_DATA_MAPPING_DESCRIPTION: "Attach custom fields or static values to the data response.",
  APP_GROUP_BACK_CHANNEL_LOGOUT_TITLE: "Back-channel logout",
  APP_GROUP_BACK_CHANNEL_LOGOUT_DESCRIPTION: "Configure back-channel logout settings to ensure users are logged out from all sessions across different applications.",
  APP_GROUP_DEVICE_TITLE: "Device code configuration",
  APP_GROUP_DEVICE_DESCRIPTION: "Configure device authorization flow settings when Device Code grant is enabled.",
  APP_GROUP_MCP_TITLE: "MCP registration",
  APP_GROUP_MCP_DESCRIPTION: "Manage CIMD or DCR settings for MCP registrations.",
  APP_GROUP_OIDC_AUDIENCES_TITLE: "OIDC audiences",
  APP_GROUP_OIDC_AUDIENCES_DESCRIPTION: "Enter the resource server that will accept the OIDC.",
  APP_GROUP_OIDC_ENDPOINTS_TITLE: "OIDC endpoint URLs",
  APP_GROUP_OIDC_ENDPOINTS_DESCRIPTION: "Copy these OpenID Connect endpoints for this app.",
  APP_GROUP_OIDC_PAR_ENDPOINT_LABEL: "Pushed Authorization Request URL",
  APP_GROUP_OAUTH_ENDPOINTS_TITLE: "OAuth endpoint URLs",
  APP_GROUP_OAUTH_ENDPOINTS_DESCRIPTION: "Copy these OAuth endpoints for this app.",
  JWT_APP_DESCRIPTION: "Lightweight, JSON‑Web‑Token SSO for custom or service‑to‑service integrations.",
  SMS_OTP_SUCCESS_MESSAGE: "Multi-Factor Authentication SMS Passcode settings saved successfully.",
  MULTI_FACTOR_HEADER: "Configure and Manage MFA Settings",
  GOOGLE_AUTHENTICATOR: "Time-based OTP (TOTP)",
  PUSH_NOTIFICATION_HEADER: "Push Notification",
  PUSH_NOTIFICATION_CARD_DESCRIPTION:
    "Trigger push notifications for Multi-Factor Authentication that your customers can approve or deny by tapping. Deliver push notifications to customers via the LoginRadius Authenticator or your native mobile apps.",
  PUSH_NOTIFICATION_DESCRIPTION:
    "Send push notifications for Multi-Factor Authentication that your customers can respond to. Push notifications can be delivered via the LoginRadius Authenticator or your own native mobile apps.",
  PUSH_NOTIFICATION_FORM_HEADER: "Push Notification Delivery Configuration",
  PUSH_NOTIFICATION_FORM_DESCRIPTION:
    "Enable this option to configure push notification delivery. You can set up push notification delivery through the LoginRadius Authenticator for Android and iOS or your own native mobile apps.",
  PUSH_SAVED_SUCCESS: "Your push notification settings have been updated successfully.",
  DUO_AUTH_FORM_HEADER: "Duo Authentication Configuration",
  DUO_AUTH_FORM_DESCRIPTION:
    "Enable this option to configure Duo authentication delivery. You can set up Duo authentication delivery through Duo Mobile for Android and iOS or your own native mobile apps.",
  GENERAL_DUOAUTHENTICATION_DESCRIPTION: "Configure general settings for Duo authentication.",
  DUO_SAVED_SUCCESS: "Your Duo authentication settings have been updated successfully.",
  DUO_SAVE_ERROR: "An error occurred while updating your Duo authentication settings. Please try again.",

  DUO_HEADER: "Duo Authentication",
  DUO_CARD_DESCRIPTION: "Duo Authentication enhances security by requiring users to provide two or more verification factors to gain access to applications and systems.",
  DUO_DESCRIPTION:
    "Duo Authentication combines something the user knows (like a password) with something the user has (like a smartphone or security token), adding an extra layer of protection against unauthorized access.",

  PASSKEY_HEADER: "Passkeys",
  PASSKEY_DESCRIPTION: "Perform MFA with passkeys, allowing users to verify MFA challenges with biometrics or PINs.",
  PASSKEY_SAVED_SUCCESS: "Your passkey settings have been updated successfully.",
  PASSKEY_SAVE_ERROR: "An error occurred while updating your passkey authentication settings. Please try again.",
  ENABLE_PASSKEY_TOOLTIP: "Passkey as a MFA  factor can be used only if passkey feature is enabled as first factor, please go inside the section and enable passkey.",
  PASSKEY_ATTESTATION_HELPTEXT:
    "Please select the preferred device attestation method: None (no or limited device information), Indirect (basic device information with privacy considerations), or Direct (full device details requested, some devices may fall back due to platform privacy restrictions).",

  PASSKEY_NOTICE_MESSAGE: "Do you want to set up passkey configuration?",
  EMAIL_PASSCODE_NOTICE_MESSAGE: "DO you want to modify the email template?",
  SMS_PASSCODE_NOTICE_MESSAGE: "Do you want to modify the SMS template?",

  OPTION_SMS: "SMS",
  OPTION_VOICE: "Voice",
  OPTION_VOICE_SMS: "SMS & Voice",
  DELIVERY_METHORD_REQUIRED: "OTP Delivery Method is required.",
  DELIVERY_METHORD: "OTP Delivery Method",
  SELECT_VOICE_TYPE: "Voice Type",
  OPTION_MALE: "Male",
  OPTION_FEMALE: "Female",
  OPTION_ALICE: "Alice",
  SELECT_LANGUAGE: "Language",
  SELECT_REPEAT_OTP: "Repeat OTP on Call",
  SECRET_NAME_LESS_THAN_20: "Secret Name should not exceed 20 characters.",
  SECRET_NAME_SHOULD_NOT_CONTAIN_SPECIAL: "Special characters are not allowed in the Secret Name.",
  OPTION_SMS_HELP: "OTP will be sent via SMS for both initial and resend requests.",
  OPTION_SMS_VOICE_HELP: "OTP will be sent via SMS initially, but users can choose SMS or Voice Call for OTP resend requests.",
  AUDIT_LOG_INTEGRATION_HEADER:
    "To ensure efficient centralized logging, configure an audit log integration of your choice from the provided options. This integration synchronizes audit logs with your chosen central logging system. You can only configure or modify one integration.",
  CREDENTIALS_AUDIT_LOG: "Credentials",
  CREDENTIALS_AUDIT_LOG_TEXT: "Provide the authentication credentials required for integration.",
  AUDIT_LOG_INTEGRATION: "Audit Log Integration",
  PERMISSION_MESSAGE_AUDIT_LOG_INTEGRATION:
    "These settings cannot be changed because Audit Log Integration has not yet been enabled for your site. Please contact LoginRadius support for more information.",
  AUDIT_LOG_RESET_SUCCESS: "Audit Log Configuration has been reset.",
  INVALID_DOMAIN_AUDIT_LOG: "Invalid Domain",
  CREATE_NEW_ROLE: "New Role",
  CREATE_NEW_ROLE_PARA: "Create roles to represent the types of users who access your applications.",

  SUSPICIOUS_CITY_EMAIL_TO_USER: "SUSPICIOUS_CITY_EMAIL_TO_USER",
  SUSPICIOUS_CITY_EMAIL_TO_ADMIN: "SUSPICIOUS_CITY_EMAIL_TO_ADMIN",
  SUSPICIOUS_DEVICE_EMAIL_TO_USER: "SUSPICIOUS_DEVICE_EMAIL_TO_USER",
  SUSPICIOUS_DEVICE_EMAIL_TO_ADMIN: "SUSPICIOUS_DEVICE_EMAIL_TO_ADMIN",
  SUSPICIOUS_IP_EMAIL_TO_USER: "SUSPICIOUS_IP_EMAIL_TO_USER",
  SUSPICIOUS_IP_EMAIL_TO_ADMIN: "SUSPICIOUS_IP_EMAIL_TO_ADMIN",
  SUSPICIOUS_COUNTRY_EMAIL_TO_USER: "SUSPICIOUS_COUNTRY_EMAIL_TO_USER",
  SUSPICIOUS_COUNTRY_EMAIL_TO_ADMIN: "SUSPICIOUS_COUNTRY_EMAIL_TO_ADMIN",
  SUSPICIOUS_BROWSER_EMAIL_TO_USER: "SUSPICIOUS_BROWSER_EMAIL_TO_USER",
  SUSPICIOUS_BROWSER_EMAIL_TO_ADMIN: "SUSPICIOUS_BROWSER_EMAIL_TO_ADMIN",
  SUSPICIOUS_CITY_SMS_TO_USER: "SUSPICIOUS_CITY_SMS_TO_USER",
  SUSPICIOUS_DEVICE_SMS_TO_USER: "SUSPICIOUS_DEVICE_SMS_TO_USER",
  SUSPICIOUS_IP_SMS_TO_USER: "SUSPICIOUS_IP_SMS_TO_USER",
  SUSPICIOUS_COUNTRY_SMS_TO_USER: "SUSPICIOUS_COUNTRY_SMS_TO_USER",
  SUSPICIOUS_BROWSER_SMS_TO_USER: "SUSPICIOUS_BROWSER_SMS_TO_USER",

  CHOOSE_CUSTOMIDP: "Choose your Identity Provider",
  CHOOSE_CUSTOMIDP_DESC: "Build your own identity connection using standard protocols  like SAML, JWT, OAuth, or ADFS.",
  PREBUILT_IDPS: "Pre-Built Identity providers",
  PREBUILT_IDPS_DESC: "Easily connect to trusted identity providers with pre-built integrations.",
  USECASES_PROVIDERS: "Usecases for choosing Providers",
  USECASES_PROVIDERS_DESC: "Create your own SSO setup using protocols like SAML, JWT, OAuth",
  CUSTOM_PROVIDERS: "Custom Providers",
  CUSTOM_PROVIDERS_DESC_1: "Need to integrate with in-house apps or partner systems",
  CUSTOM_PROVIDERS_DESC_2: "Have a corporate IdP that supports industry protocols",
  CUSTOM_PROVIDERS_DESC_3: "Want control over the SSO handshake, claims, and user flow",
  ENTERPRISE_PROVIDERS_PREBUILT: "Enterprise Providers ( Pre-built connectors)",
  ENTERPRISE_PROVIDERS_PREBUILT_DESC: "Use pre-built SSO connectors for platforms like Salesforce, Google Workspace, Okta, and more",
  ENTERPRISE_PROVIDERS_PREBUILT_DESC_1: "Want a plug-and-play integration for popular enterprise tools",
  ENTERPRISE_PROVIDERS_PREBUILT_DESC_2: "Prefer a low-code setup managed by your IT team",
  READ_IDP_DOCS: "Read the Identity Provider Docs",

  SAML_LOGINFLOW_TITLE: "Login Flow",
  SAML_LOGINFLOW_DESCRIPTION: "Define your application’s SAML identity and audience parameters.",
  SAML_GENERAL_TITLE: "General Settings",
  SAML_GENERAL_DESCRIPTION: "Define your application’s SAML identity and audience parameters.",
  SAML_CERTIFICATE_TITLE: "Certificates",
  SAML_CERTIFICATE_DESCRIPTION: "Configure how trust is established between your app and the IdP.",
  SAML_SSOENDPOINTS_TITLE: "SSO Endpoints",
  SAML_SSOENDPOINTS_DESCRIPTION: "Configure authentication and logout URLs required for your SAML handshake",
  SAML_ATTRIBUTES_TITLE: "Attribute Mappings",
  SAML_ATTRIBUTES_DESCRIPTION: "Map CIAM user fields into SAML attributes for your Service Provider.",
  SAML_ADDITIONAL_SETTINGS_TITLE: "Additional Settings",
  SAML_ADDITIONAL_SETTINGS_DESCRIPTION: "Configure Auto look up and Social Scheme settings",

  JWT_GENERAL_SETTINGS_TITLE: "General Settings",
  JWT_GENERAL_SETTINGS_DESCRIPTION: "Configure your custom JWT provider",
  JWT_TOKEN_VERIFICATION_SETTINGS_TITLE: "Token Verification Settings",
  JWT_TOKEN_VERIFICATION_SETTINGS_DESCRIPTION: "Configure your JWT Provider’s token verification",
  JWT_TOKEN_TIMING_CONFIG_TITLE: "Token Timing Configuration",
  JWT_TOKEN_TIMING_CONFIG_DESCRIPTION: "Controls for validating token timing",
  JWT_TOKEN_SRC_TITLE: "JWT Token Source",
  JWT_TOKEN_SRC_DESCRIPTION: "Configure where and how to extract the JWT from the request.",
  JWT_TOKEN_CLAIM_REQ_TITLE: "Token Claims Requirements",
  JWT_TOKEN_CLAIM_REQ_DESCRIPTION: "Specify mandatory claims expected in the token.",
  JWT_AUD_ISS_MATCH_TITLE: "Audience and Issuer Matching",
  JWT_AUD_ISS_MATCH_DESCRIPTION: "Used to redirect based on email domain and validate token issuer.",
  JWT_ATTRIBUTE_MAPPING_TITLE: "Attribute Mappings",
  JWT_ATTRIBUTE_MAPPING_DESCRIPTION: "Validate who the token is intended for.",
  JWT_ADDITIONAL_SETTINGS_TITLE: "Additional Settings",
  JWT_ADDITIONAL_SETTINGS_DESCRIPTION: "Configure Auto look up and Social Scheme settings",

  ADFS_GEN_SETTINGS_TITLE: "General Settings",
  ADFS_GEN_SETTINGS_DESCRIPTION: "Define your application’s SAML identity and audience parameters.",
  ADFS_CERTIFICATE_TITLE: "Certificates",
  ADFS_CERTIFICATE_DESCRIPTION: "Configure how trust is established between your app and the IdP.",
  ADFS_SSO_CONFIG_TITLE: "SSO Configuration",
  ADFS_SSO_CONFIG_DESCRIPTION: "Configure authentication and logout URLs required for your SAML handshake",
  ADFS_ATTRIBUTES_TITLE: "Attribute Mappings",
  ADFS_ATTRIBUTES_DESCRIPTION: "Map CIAM user fields into SAML attributes for your Service Provider.",
  ADFS_ADDITIONAL_SETTINGS_TITLE: "Additional Settings",
  ADFS_ADDITIONAL_SETTINGS_DESCRIPTION: "Configure Auto look up and Social Scheme settings",

  OAUTH_GENERAL_SETTINGS_TITLE: "General Settings",
  OAUTH_GENERAL_SETTINGS_DESCRIPTION: "Configure your custom OAuth provider",
  OAUTH_ENDPOINTS_TITLE: "OAuth Endpoints",
  OAUTH_ENDPOINTS_DESCRIPTION: "Enter the core endpoints required to perform the OAuth handshake.",
  OAUTH_APP_CREDENTIALS_TITLE: "App Credentials",
  OAUTH_APP_CREDENTIALS_DESCRIPTION: "Provide the OAuth application credentials from your IDP.",
  OAUTH_AUTH_SETTINGS_TITLE: "Authorization Settings",
  OAUTH_AUTH_SETTINGS_DESCRIPTION: "Configure how the OAuth handshake behaves and how tokens are handled.",
  OAUTH_TOKEN_METHODS_TITLE: "Token Methods & Parameters",
  OAUTH_TOKEN_METHODS_DESCRIPTION: "Configure how the OAuth handshake behaves and how tokens are handled.",
  OAUTH_HEADERS_TITLE: "Headers",
  OAUTH_HEADERS_DESCRIPTION: "Add custom headers to be sent in token or profile requests.",
  OAUTH_QUERY_PARAMS_TITLE: "Query Parameters",
  OAUTH_QUERY_PARAMS_DESCRIPTION: "Define additional query parameters for OAuth requests.",
  OAUTH_DATA_MAPPING_TITLE: "Data Mapping",
  OAUTH_DATA_MAPPING_DESCRIPTION: "Map response fields from the IDP to your CIAM schema.",
  OAUTH_ADDITIONAL_SETTINGS_TITLE: "Additional Settings",
  OAUTH_ADDITIONAL_SETTINGS_DESCRIPTION: "Configure Auto look up and Social Scheme settings",

  ADFS_PROVIDERNAME_EXTRA: "A unique internal name for this provider",
  ADFS_DISPLAY_EXTRA: "What users see on the login screen (e.g., “Login with Google”).",
  ADFS_IDP_LOC_EXTRA: "The URL where your app will send the SAML AuthnRequest. Provided by your IdP.",
  ADFS_SOCIALSCHEMA_EXTRA: "When AutoLookup is enabled, users are redirected to this IDP automatically after entering a matching email domain. This IDP will not appear in the Social Schema.",
  ADFS_SP_CERT_EXTRA: "Paste the X.509 certificate used by the IdP to sign responses. PEM format required.",
  ADFS_IDP_LOGOUT_URL_EXTRA: "The endpoint on the IdP that handles logout requests. Often ends in /logout.",
  ADFS_STATE_RELAY_EXTRA: "A custom URL or value to maintain app state across the SAML flow.",
  ADFS_IDP_CERT_EXTRA: "Paste the X.509 certificate used by the IdP to sign responses. PEM format required.",
  ADFS_AUTOLOOKUP_EXTRA: "When AutoLookup is enabled, users are redirected to this IDP automatically after entering a matching email domain. This IDP will not appear in the Social Schema.",

  JWT_PROVIDERNAME_EXTRA: "A unique internal name for this provider",
  JWT_ALGO_EXTRA: "The algorithm is used to sign the JWT token (e.g. RS256, HS256).",
  JWT_KEY_EXTRA: "A secret used to sign the JWT. Required for HS256 and similar symmetric algorithms.",
  JWT_CLOCK_SKEW_EXTRA:
    "The allowed time difference between the issuer’s and receiver’s system clocks. Use A positive value if the receiver is behind, negative if receiver is ahead and a zero or blank value indicates no time difference.",
  JWT_EXPIRATION_TIME_EXTRA: "Extra timeto allow before token expiration.",
  JWT_TOKEN_QUERY_PARAM_EXTRA: "The name of the query parameter carrying the JWT (if not using headers).",
  JWT_LOGIN_URL_EXTRA: "login URL that can redirect users if the token is missing.",
  JWT_USE_AUTH_HEAD_EXTRA: "Enable if the JWT is expected in the Authorization header.",
  JWT_ENABLE_AUTOLOOKUP_EXTRA: "When AutoLookup is enabled, users are redirected to this IDP automatically after entering a matching email domain. This IDP will not appear in the Social Schema.",
  JWT_INCLUDE_SOCIAL_SCHEMA_EXTRA:
    "This option controls whether your Custom Identity Provider appears as a login button on the LoginRadius Auth Studio page and in social login forms rendered by the LoginRadius libraries.",

  OAUTH_PROVIDERNAME_EXTRA: "A unique internal name for this provider",
  OAUTH_EXT_PARAM_REDIRECT_EXTRA: "Key-value parameters to append to the OAuth redirect URL if needed.",
  OAUTH_CUST_LOGIN_ENDPOINT_EXTRA: "URL where users are redirected to authorize the app.",
  OAUTH_ACCESSTOKEN_ENDPOINT_EXTRA: "Endpoint used to exchange the code for a token.",
  OAUTH_APP_KEY_EXTRA: "The client ID issued by your IDP.",
  OAUTH_SCOPE_EXTRA: "API's Scopes:  https://api.loginradius.com/identity/v2/manage",
  OAUTH_RESP_TYPE_EXTRA: "Typically code for standard OAuth flows.",
  OAUTH_REQ_TOKEN_EXTRA: "Usually POST, depends on provider spec.",
  OAUTH_ENABLE_AUTOLOOKUP_EXTRA: "When AutoLookup is enabled, users are redirected to this IDP automatically after entering a matching email domain. This IDP will not appear in the Social Schema.",
  OAUTH_INCLUDE_SOCIAL_SCHEMA_EXTRA:
    "This option controls whether your Custom Identity Provider appears as a login button on the LoginRadius Auth Studio page and in social login forms rendered by the LoginRadius libraries.",
  OAUTH_EXTRACT_USER_PROFILE_ID_TOKEN: "Extract User Profile from ID Token",
  OAUTH_JWKS_ENDPOINT_URL: "JWKS Endpoint URL",
  OAUTH_EXTRACT_USER_PROFILE_ID_TOKEN_EXTRA: "Enable if the profile should be extracted from the OIDC ID token claims.",
  OAUTH_JWKS_ENDPOINT_URL_EXTRA: "The endpoint used to fetch the public keys (JWKS) to verify the ID token or signed userinfo signature.",

  SAML_PROVIDERNAME_EXTRA: "A unique internal name for this provider",
  SAML_DISPLAY_EXTRA: "What users see on the login screen (e.g., “Login with Google”).",
  SAML_IDP_BINDING_EXTRA: "Choose how your system sends the SAML request (e.g., HTTP-POST or Redirect).",
  SAML_IDP_LOC_EXTRA: "The URL where your app will send the SAML AuthnRequest. Provided by your IdP.",
  SAML_IDP_LOGOUT_EXTRA: "The endpoint on the IdP that handles logout requests. Often ends in /logout.",
  SAML_RELAY_EXTRA: "A custom URL or value to maintain app state across the SAML flow.",
  SAML_SP_CERT_EXTRA: "Paste the X.509 certificate used by the IdP to sign responses. PEM format required.",
  SAML_IDP_CERT_EXTRA: "Paste the X.509 certificate used by the IdP to sign responses. PEM format required.",
  SAML_AUTOLOOKUP_EXTRA: "When AutoLookup is enabled, users are redirected to this IDP automatically after entering a matching email domain. This IDP will not appear in the Social Schema.",
  SAML_INCLUDE_SOCIAL_SCHEMA_EXTRA:
    "This option controls whether your Custom Identity Provider appears as a login button on the LoginRadius Auth Studio page and in social login forms rendered by the LoginRadius libraries.",

  NEW_BRAND_HEADER: "Build an AI-Powered Branded Identity Experience Page",
  NEW_BRAND_DESCRIPTION: "With just a few clicks, create and personalize the UI of the authentication page for your brand's application and app.",
  BRAND_NAME: "Brand Name",
  PREVIOUS: "Previous",
  CONTINUE: "Continue",
  LOADING_ELIPSIS: "Loading...",
  COMPLETE: "Complete",
  PRIVACY_CONSENT_TITLE: "Privacy and Consent",
  PRIVACY_CONSENT_HEADER: "Manage Customer Data Privacy and Consent Workflows",
  PRIVACY_VERSIONING_TITLE: "Privacy Versioning",
  CONSENT_MANAGEMENT_TITLE: "Consent Management",
  PRIVACY_VERSIONING_HEADER: "Manage privacy policy versions, obtain consent as required, and prompt customer action for new versions, among other features.",
  PRIVACY_VERSIONING_CARD_HEADER: "Manage your privacy policy versions, track which version is currently accepted by each customer, and request customer actions based on workflow requirements.",
  AGE_VERIFICATION_CARD_HEADER: "Manage the minimum age required for customer registration per the Children's Online Privacy Protection Act (COPPA).",
  INBOUND_SSO_CARD_HEADER:
    "Configure and manage your Inbound SSO integrations, also known as Web SSO, where you act as the Service Provider (SP) receiving customer authentication from an external Custom IDP (IdP).",
  OUTBOUND_SSO_CARD_HEADER:
    "Configure and manage your Outbound SSO integrations, also known as Federated SSO, where you act as the Custom IDP (IdP) authenticating customers to allow access to an external Service Provider (SP). Supported protocols include SAML, JWT, OAuth 2.0, and OpenID Connect.",
  SSO_CONNECTORS_CARD_DESC: "Configure and manage SSO connector plugins for popular platforms like Shopify, BigCommerce, and PerfectMind.",
  CONSENT_MANAGEMENT_CARD_DESC: "Obtain and manage customer consent for your privacy policies and other terms and conditions.",

  BOT_PROTECTION_CARD_DESC: "Enable bot protection for specific APIs so that various actions beyond customer registration will dynamically trigger a CAPTCHA when necessary.",
  IP_DOMAIN_ACCESS_MANAGEMENT_CARD_HEADER: "IP Address",
  IP_DOMAIN_ACCESS_MANAGEMENT_CARD_DESC: "Configure and manage which IP addresses and IP ranges can make LoginRadius API requests.",
  IP_DOMAIN_ACCESS_MANAGEMENT_CARD_DESC2: "Enable this option to allow or deny access to LoginRadius APIs from specific IP addresses or ranges.",

  BRUTE_FORCE_PROTECTION: "Brute Force Protection",
  BRUTE_FORCE_PROTECTION_CARD_DESC:
    "Enforce a lockout or an additional authentication step when configured rate limits are triggered for customer registration and authentication. This only works if security answers are set up.",
  ATTACK_PROTECTION_HEADER: "Protect Your Users from Automated Attacks",
  PLATFORM_SECURITY_HEADER:
    "Platform Security details the multiple solutions LoginRadius offers to secure your platform, prevent fraud by blocking fraudulent domains, and configure CAPTCHA settings.",
  WORKFLOWS_HEADER: "Workflows",
  WORKFLOWS_DESCRIPTION: "Build identity workflows for user registration, login, MFA, and other authentication processes and use them across different brands.",
  NEW_WORKFLOW_HEADER: "New Workflow",
  NEW_WORKFLOW_DESCRIPTION: "Create, test, and deploy a new workflow to optimize customer experience and security.",
  NEW_BRAND: "New Template",
  NEW_BRAND_DESC: "Create a new template to manage your customer identity experience across different applications and platforms.",
  NEW_BRAND_TEMPLATES_HEADER: "Pre Built Templates",
  NEW_BRAND_TEMPLATES_DESCRIPTION: "Use our pre-configured templates and modify them to meet your needs.",
  CREATE_WITH_AI: "Create with AI",
  START_WITH_AI_HEADER: "Start with AI",
  START_WITH_AI_DESCRIPTION: "Leverage AI to generate a customized template based on your specific requirements and use cases.",
  UNLOCK_AI_TEMPLATES_TITLE: "Unlock AI-powered templates",
  UNLOCK_AI_TEMPLATES_DESCRIPTION: "Generate fully branded login experiences instantly with AI. Available as an add-on feature.",
  UNLOCK_AI_BULLET_1: "Create tailored login flows in seconds",
  UNLOCK_AI_BULLET_2: "Align with your brand colors and identity",
  UNLOCK_AI_BULLET_3: "Generate branded templates from screenshots, URLs, or prompts",
  UNLOCK_AI_EMAIL_TEMPLATES_TITLE: "Unlock AI-powered email templates",
  UNLOCK_AI_EMAIL_TEMPLATES_DESCRIPTION: "Generate fully branded email experiences instantly with AI. Available as an add-on feature.",
  UNLOCK_AI_EMAIL_BULLET_1: "Create tailored email templates in seconds",
  UNLOCK_AI_EMAIL_BULLET_2: "Match your brand colors, fonts, and tone automatically",
  UNLOCK_AI_EMAIL_BULLET_3: "Create responsive email layouts for all devices",
  LEARN_MORE: "Learn more",
  NEW_WORKFLOW_TEMPLATES: "Workflow Templates",
  START_WITH_BRAND_TEMPLATE_HEADER: "Start with pre-built Template",
  START_WITH_BRAND_TEMPLATE_DESCRIPTION: "Use our pre-configured templates and modify them to meet your needs.",
  START_IN_BRAND_EDITOR_HEADER: "Start with default Template",
  START_IN_BRAND_EDITOR_DESCRIPTION: "Use our interactive template builder to create a template from scratch.",
  USE_TEMPLATES: "Use Templates",
  CREATE_FROM_SCRATCH: "Create From Scratch",

  NEW_WORKFLOW_TEMPLATES_HEADER: "Workflow Templates",
  NEW_WORKFLOW_TEMPLATES_DESCRIPTION: "Use our pre-configured identity workflow templates and modify them to meet your needs.",
  THEME_CUSTOMIZATION_DESCRIPTION: "Configure and manage customized themes for your brands that require visual and workflow differentiation to offer brand-specific experiences for your customers.",
  UPDATE_WORKFLOW_NAME: "Update Workflow",
  DUPLICATE_WORKFLOW_NAME: "Duplicate Workflow",
  START_IN_EDITOR_HEADER: "Start in the Editor",
  START_IN_EDITOR_DESCRIPTION: "Use our interactive workflow builder to create a workflow from scratch.",
  START_WITH_TEMPLATE_HEADER: "Start with a Template",
  START_WITH_TEMPLATE_DESCRIPTION: "Use our pre-configured identity workflow templates and modify them to meet your needs.",
  START_WITH_JSON_HEADER: "Start with a JSON File",
  START_WITH_JSON_DESCRIPTION: "Upload a workflow JSON file to reuse or modify the workflow for your use case.",

  PASSWORD_EXPIRATION: "Password Expiration",
  PASSWORD_HISTORY: "Password History",
  MANAGE_SMS_PROVIDER: "Manage SMS Providers",
  MANAGE_SMS_PROVIDER_DESC: "Edit or delete Text/SMS service provider configurations.",
  MANAGE_PROVIDER: "Manage Providers",
  MANAGE_PROVIDER_DESC: "Edit and delete communication service provider configurations.",
  DELETE_PROVIDER_CONTENT: "Are you sure to delete SMTP sender name and email configured for individual email template(s) will not work.",

  PASSWORD_POLICY_HEADER: "",
  MANAGE_CUSTOMERS_DESC: "List of all users registered to your app.",
  WORKFLOW_SCRIPTS_HEADER: "Scripts",
  WORKFLOW_SCRIPTS_DESCRIPTION: "Add your custom executable scripts in this section and use them in workflows under the script's node.",
  WORKFLOW_SCRIPTS_EDITOR_HEADER: "Script Editor",
  WORKFLOW_SCRIPTS_EDITOR_DESCRIPTION: "Add and edit your scripts in this section.",
  WORKFLOW_REDIRECT_URL_TEXT: "If the Redirect URL is not empty, the user will be redirected. Otherwise, a success message and a Home Page button will be displayed.",
  WORKFLOW_SUCCESS_FINAL_MESSAGE: "If the success message is provided, it will be shown to the user. Otherwise, a default success message will be displayed. ",
  WORKFLOW_FAILURE_FINAL_MESSAGE: "If the failure message is provided, it will be shown to the user. Otherwise, a default failure message will be displayed.",
  WORKFLOW_HOME_PAGE_BUTTON_TEXT: "If the Home Page Button Text is not empty, the user will see a button with that text. Otherwise, the button will display the default text.",
  // User Action Popup
  EMAIL_TYPE: "Email Type",
  EMAIL_VALUE: "Email Value",
  UPDATE_VERFICATION_STATUS_DESC: "Select or deselect the checkbox to mark the field as Verified or Unverified.",
  NO_EMAIL_OR_PHONE: "This account does not have an email or phone number.",
  PASSKEYS_HEADER: "Passkeys",
  PASSKEYS_DESCRIPTION: "Configure and manage the Passkeys authentication method (based on FIDO2).",
  PASSKEY_ADDED_SUCCESSFULLY: "Passkey configuration added successfully.",
  PASSKEY_UPDATED_SUCCESSFULLY: "Passkey configuration updated successfully.",
  BREACHED_PASSWORD_ADDED_SUCCESSFULLY: "Breached Password configuration added successfully.",
  BREACHED_PASSWORD_UPDATED_SUCCESSFULLY: "Breached Password configuration updated successfully.",

  BREACHED_PASSWORD_HEADER: "Breached Password Protection",
  BREACHED_PASSWORD_DESCRIPTION: "Check if users are using passwords exposed in known external data breaches.",
  BREACHED_PASSWORD_LOGIN_TOOLTIP: "Enable this option to check for password breaches during login and alert the customer.",
  BREACHED_PASSWORD_REGISTRATION_TOOLTIP: "Enable this option to check for password breaches during registration and alert the customer.",
  BREACHED_PASSWORD_PASSWORD_CHANGE_TOOLTIP: "Enable this option to check for password breaches during password changes and alert the customer.",
  BREACHED_PASSWORD_ADMIN_NOTIFICATION_EVENT_TOOLTIP: "Send email alerts to the admin team for each breached password detection during these events.",
  BREACHED_PASSWORD_LOGIN_ACTION_TOOLTIP: "Select the action to take when a breached password is detected during login.",

  ACCOUNT_ENUMERATION_PROTECTION: "Account Enumeration Protection",
  ACCOUNT_ENUMERATION_PROTECTION_DESCRIPTION:
    "When enabled, the public Email, Phone Number, and Username Availability APIs are blocked. This stops attackers from checking whether an email, phone number, or username belongs to an existing account and using that information to target users.",
  ACCOUNT_ENUMERATION_PROTECTION_DISABLE_TITLE: "Disable Account Enumeration Protection",
  ACCOUNT_ENUMERATION_PROTECTION_DISABLE_WARNING:
    "Disabling this protection allows access to the public Email, Phone Number, and Username Availability APIs. Attackers may then be able to check whether an email, phone number, or username belongs to an existing account and use that information to target users. Are you sure you want to disable this protection?",

  NO_SOTT_FOUND: "You do not currently have any SOTT.",
  DATE_RANGE_TOKEN_VALIDITY: "Date Range for Token Validity",
  END_DATE_TOKEN_VALIDITY: "End date for Token Validity",
  COMMENTS_OPTIONAL: "Comments",
  OPTIONAL: " (Optional)",
  GENERATE_NEW_SOTT_DESCRIPTION: "Use the form below to generate a new SOTT. Technology and Date Range for token validity are required to create a token.",
  NO_CONFIGURED_BRANDS: "There are no configured brands.",
  ADD_NEW_BRAND: "Add a New Brand",
  REVERT_BRAND_POPUP: "Are you sure you want to revert to the default brand?",
  CERTIFICATE_RENEWED_SUCCESSFULLY: "Certificate renewed successfully.",
  CUSTOM_ID_PROVIDERS: "Custom Identity Providers",

  MY_ACCOUNT_DESC: "Manage your LoginRadius account.",
  BILLING_DESC: "View your LoginRadius subscription details and invoice information.",
  SUBSCRIPTION_DETAILS: "Subscription Details",
  INVOICES: "Invoices",

  EMAIL_AUTHENTICATION_UPDATED_SUCCESSFULLY: "Email authentication updated successfully.",
  EMAIL_AUTHENTICATION_UPDATED_FAILED: "Email authentication update failed.",
  PHONE_AUTHENTICATION_UPDATED_SUCCESSFULLY: "Phone authentication updated successfully.",
  PHONE_AUTHENTICATION_UPDATED_FAILED: "Phone authentication update failed.",
  USERNAME_AUTHENTICATION_UPDATED_SUCCESSFULLY: "Username authentication updated successfully.",
  USERNAME_AUTHENTICATION_UPDATED_FAILED: "Username authentication update failed.",

  VERIFICATION_FLOW_TOOLTIP: "Select the verification flow for the email verification process.",
  EMAIL_VERIFICATION_FLOW_CAPTION:
    "Control whether email verification is required, optional, or skipped. Mandatory reduces fake accounts, Optional lets users in while nudging verification, and Disabled suits internal or invite-only apps.",
  VERIFICATION_METHOD_TOOLTIP: "Select the verification method for the email verification process.",
  CASE_SENSITIVE_USERNAME_TOOLTIP: "Enable this setting to make usernames case-sensitive.",
  DUPLICATE_EMAIL_WITH_UNIQUE_USERNAME_TOOLTIP: "Enable this setting to allow users to have multiple accounts with the same email address. However, the username for each account must be unique.",

  EMAIL_AUTHENTICATION_CONFIG_TITLE: "Email",
  EMAIL_AUTHENTICATION_CONFIG_DESC: "Allow users to register and log in with email address.",
  EMAIL_CONFIGURATION_CARD_TITLE: "Email Configuration",
  EMAIL_CONFIGURATION_CARD_DESC: "Configure the email settings.",
  PHONE_AUTHENTICATION_CONFIG_TITLE: "Phone",
  PHONE_AUTHENTICATION_CONFIG_DESC: "Allow users to register and log in with phone numbers.",
  PHONE_CONFIGURATION_CARD_TITLE: "Phone Configuration",
  PHONE_CONFIGURATION_CARD_DESC: "Configure the phone settings.",
  USERNAME_AUTHENTICATION_CONFIG_TITLE: "Username",
  USERNAME_AUTHENTICATION_CONFIG_DESC: "Allow users to set unique usernames to register and log in.",
  CASE_SENSITIVITY_HEADER: "Case sensitivity",
  CASE_SENSITIVITY_DESCRIPTION: "Usernames must match exactly as registered, including letter casing.",
  DUPLICATE_EMAIL_UNIQUE_USERNAME_HEADER: "Duplicate Email with Unique Username",
  DUPLICATE_EMAIL_UNIQUE_USERNAME_DESCRIPTION: "Allow users to make multiple accounts with same email address, but unique username.",
  USERNAME_CONFIGURATION_CARD_TITLE: "Username Configuration",
  USERNAME_AUTHENTICATION_CONFIG_CASE_SENSITIVE_DESC: "When enabled, usernames become case-sensitive.",
  USERNAME_AUTHENTICATION_CONFIG_DUPLICATE_EMAIL_DESC: "When enabled, users can have multiple accounts with the same email address, but unique usernames.",
  USERNAME_CONFIGURATION_CARD_DESC: "Configure the username settings.",
  PASSWORDLESS_AUTHENTICATION_CONFIG_TITLE: "Passwordless",
  PASSWORDLESS_AUTHENTICATION_CONFIG_DESC: "Manage passwordless authentication settings.",
  PASSWORDS_CONFIG_TITLE: "Passwords",
  PASSWORDS_CONFIG_DESC: "Manage password policy settings, including password complexity, history, and expiry.",
  PASSWORDLESS_CONFIG_TITLE: "Passwordless",
  PASSWORDLESS_CONFIG_DESC: "Manage passwordless settings.",
  PASSKEY_CONFIG_TITLE: "Passkey",
  PASSKEY_CONFIG_DESC: "Manage Passkey settings.",
  EMAIL_PROVIDER_TITLE_CTA: "Default Email Provider",
  EMAIL_PROVIDER_DESC_CTA: "LoginRadius will be your default email provider. You can configure your own SMTP provider here.",
  EMAIL_TEMPLATE_TITLE_CTA: "Default Email Template -",
  EMAIL_TEMPLATE_DESC_CTA: "This will be your default email template. You can configure your own email template here.",
  SMS_VERIFICATION_SETTINGS_TITLE: "Verification Settings",
  SMS_VERIFICATION_SETTINGS_DESC: "Set request limits, request disabled period and OTP validity limits for phone verification",
  SMS_VERIFICATION_METHOD_TITLE: "Phone Verification OTP",
  SMS_VERIFICATION_METHOD_INFO: "Phone numbers are verified using a one-time password (OTP) sent via SMS.",
  SMS_VERIFICATION_OTP_PREVIEW_TITLE: "Please verify the OTP",
  SMS_VERIFICATION_OTP_PREVIEW_SUBTITLE: "Verify your account by entering the 6 digit verification OTP sent to",
  SMS_VERIFICATION_OTP_PREVIEW_PHONE: "+91-982323232",
  SMS_VERIFICATION_OTP_ENTER_LABEL: "Enter 6-digit OTP",
  SMS_VERIFICATION_OTP_VERIFY_BTN: "Verify OTP",
  SMS_VERIFICATION_OTP_RESEND: "Didn't receive the OTP?",
  SMS_VERIFICATION_OTP_RESEND_LINK: "Resend OTP",
  SMS_VERIFICATION_MAX_REQUESTS_LABEL: "Request Limit",
  SMS_VERIFICATION_MAX_REQUESTS_DESC: "Number of verification attempts an user can request",
  SMS_VERIFICATION_COOLDOWN_LABEL: "Request Disabled Period",
  SMS_VERIFICATION_COOLDOWN_DESC: "Time window during which users cannot request another SMS.",
  SMS_VERIFICATION_TOKEN_VALIDITY_LABEL: "OTP Validity Limit",
  SMS_VERIFICATION_TOKEN_VALIDITY_DESC: "Duration before the OTP expires.",
  SMS_VERIFICATION_PREVIEW_TOOLTIP: "Preview Only",
  EMAIL_VERIFICATION_SETTINGS_TITLE: "Verification Settings",
  EMAIL_VERIFICATION_SETTINGS_DESC: "Set request limits, request disabled period and email token validity limits for email verification",
  EMAIL_VERIFICATION_OTP_PREVIEW_TITLE: "Please verify the OTP",
  EMAIL_VERIFICATION_LINK_PREVIEW_TITLE: "Please verify your email",
  EMAIL_VERIFICATION_SENT_SUBTITLE: "We've sent a verification email. Verify your account by clicking on the link sent to",
  EMAIL_VERIFICATION_OTP_ENTER_LABEL: "Enter 6-digit OTP",
  EMAIL_VERIFICATION_OTP_VERIFY_BTN: "Verify OTP",
  EMAIL_VERIFICATION_SPAM_NOTE: "Not able to find the email sent? Make sure to",
  EMAIL_VERIFICATION_SPAM_LINK: "check spam folder",
  EMAIL_VERIFICATION_RESEND_BTN: "Resend Verification Email",
  EMAIL_VERIFICATION_CODE_CARD_TITLE: "Email Verification OTP",
  EMAIL_VERIFICATION_CODE_CARD_DESC: "A one-time numeric OTP entered manually.",
  EMAIL_VERIFICATION_LINK_CARD_TITLE: "Email Verification Link",
  EMAIL_VERIFICATION_LINK_CARD_DESC: "A secure, time-limited link sent to the user's inbox.",
  EMAIL_VERIFICATION_MAX_REQUESTS_LABEL: "Request Limit",
  EMAIL_VERIFICATION_MAX_REQUESTS_DESC: "Number of verification attempts an user can request",
  EMAIL_VERIFICATION_TOKEN_VALIDITY_LABEL: "Email Token Validity Limit",
  EMAIL_VERIFICATION_TOKEN_VALIDITY_DESC: "Duration before the link/OTP expires.",
  EMAIL_VERIFICATION_COOLDOWN_LABEL: "Request Disabled Period",
  EMAIL_VERIFICATION_COOLDOWN_DESC: "Time window during which users cannot request another email.",
  PASSKEY_TYPE_CARD_TITLE: "Passkey Type",
  PASSKEY_TYPE_CARD_DESCRIPTION: "Choose the type of passkey your users can register.",
  PASSKEY_PREVIEW_TOOLTIP: "Preview Only",
  PASSKEY_PREVIEW_ARIA_LABEL: "Passkey type preview",
  PASSKEY_AUTOFILL_LABEL: "Auto-Fill",
  PASSKEY_AUTOFILL_RECOMMENDED: "RECOMMENDED",
  PASSKEY_AUTOFILL_DESCRIPTION: "Browser or device offers passkey automatically. Best UX for end users.",
  PASSKEY_BUTTON_LABEL: "Button",
  PASSKEY_BUTTON_DESCRIPTION: 'Users click "Login with Passkeys" button to start.',
  PASSKEY_BOTH_LABEL: "Both",
  PASSKEY_BOTH_DESCRIPTION: "Auto-fill when available, fallback to button if not.",
  PASSKEY_ENROLLMENT_CARD_TITLE: "Enrollment Settings",
  PASSKEY_ENROLLMENT_CARD_DESCRIPTION: "Configure how and when users are enrolled in passkeys.",
  PASSKEY_PROGRESSIVE_ENROLLMENT_LABEL: "Progressive Enrollment",
  PASSKEY_PROGRESSIVE_ENROLLMENT_DELAY_LABEL: "Progressive Enrollment Delay",
  PASSKEY_LOCAL_ENROLLMENT_LABEL: "Local Enrollment",
  PASSKEY_ADDITIONAL_CARD_TITLE: "Additional Settings",
  PASSKEY_ADDITIONAL_CARD_DESCRIPTION: "Customize Passkey configuration for your domain, browser prompt, and cross-origin behavior.",
  PASSKEY_RP_DISPLAY_NAME_LABEL: "Relying Party Display name",
  PASSKEY_RP_ID_LABEL: "Relying Party ID",
  PASSKEY_RP_ORIGINS_LABEL: "Relying Party Origins",
  PASSKEY_ADD_RP_ORIGINS_BUTTON: "Add Relying Party Origins",
  PASSKEY_ATTESTATION_LABEL: "Attestation (Optional)",
  PASSKEY_ATTESTATION_NONE: "None",
  PASSKEY_ATTESTATION_INDIRECT: "Indirect",
  PASSKEY_ATTESTATION_DIRECT: "Direct",
  PASSKEY_DISABLE_HEADING: "Disable Passkey",
  PASSKEY_DISABLE_CONFIRM_BUTTON: "Disable",
  PASSKEY_MFA_DISABLE_TOOLTIP: "Passkey MFA is enabled for this tenant. To disable Passkey, please disable Passkey MFA first.",
  PASSKEY_PREVIEW_SIGN_IN: "Sign In",
  PASSKEY_PREVIEW_WELCOME: "Welcome Back! Fill in the details to continue",
  PASSKEY_PREVIEW_EMAIL_LABEL: "Email ID",
  PASSKEY_PREVIEW_EMAIL_PLACEHOLDER: "Enter your Email ID",
  PASSKEY_PREVIEW_AUTOFILL_BADGE: "AutoFill",
  PASSKEY_PREVIEW_CONTINUE: "Continue",
  PASSKEY_PREVIEW_LOGIN_WITH_PASSKEYS: "Login with Passkeys",
  PASSKEY_PREVIEW_NO_ACCOUNT: "Don't have an Account?",
  PASSKEY_PREVIEW_SIGN_UP: "Sign Up",
  SMS_PROVIDER_TITLE_CTA: "Default SMS Provider",
  SMS_PROVIDER_DESC_CTA: "LoginRadius will be your default SMS provider. You can configure your own SMS provider here.",
  SMS_TEMPLATE_TITLE_CTA: "Default SMS Template -",
  SMS_TEMPLATE_DESC_CTA: "This will be your default SMS template. You can configure your own SMS template here.",
  USERNAME_DISABLED_TOGGLE_TOOLTIP: "Disable the 'Duplicate Email with Unique Username' setting to disable username authentication configuration.",
  PASSWORDLESS_DISABLED_TOGGLE_TOOLTIP: "This feature is not yet available in your current plan. Please contact LoginRadius support to enable it.",
  PASSWORDLESS_ENABLED_TOGGLE_TOOLTIP: "You have purchased the passwordless feature, and it is enabled for your account.",
  PASSWORD_DISABLED_TOGGLE_TOOLTIP: "The Password Policy feature is enabled by default.",
  PASSKEY_DISABLED_TOGGLE_TOOLTIP: "The #title# feature is not yet available in your current plan. Please contact LoginRadius support to enable it.",
  // Dashboard
  CONFIGURE_AUTHENTICATION: "Configure Authentication",
  ENABLE_AUTHENTICATION_METHODS_CONFIGURE_OAUTH_PROVIDERS: "Set up at least one authentication type and method to allow users to register and log in.",
  ADD_SECURITY_FEATURES: "Add Security Features",
  STRENGTHEN_YOUR_SECURITY_POSTURE_WITH_GRANULAR_CONTROL: "Set up attack protection rules, password policies, session management, and more.",
  BRANDING: "Branding",
  CONFIGURE_AND_MANAGE_CUSTOMIZED_THEMES_FOR_YOUR_BRANDS: "Configure and manage customized themes for your brands.",
  GO_TO_CONFIGURATION: "Go to Configuration",
  SECURITY: "Security",
  MANAGE_TEAM: "Manage Team",
  TEAM_TITLE: "Team Management",
  TEAM_DESC: "Configure RBAC to manage team members' access with granular permissions.",
  COLON: "Should not start or end with a colon.",
  ORCHESTRATION_DESC:
    "Customize workflows for customer registration, authentication, forgot passwords, and more to optimize the experience. For example, design different workflows for various brands you manage or deploy separate workflows for different customer segments.",
  SAML_PROVIDER_TEAM_TOOLTIP: "Use this app name to log in to your account.",
  TEAMSSO_ADFS_TOOLTIP: "Active Directory Federation Services (ADFS) is supported only with service provider-initiated login flow.",
  CHOOSE_SSO_INTEGRATION: "Choose your SSO Integration",
  CHOOSE_CUSTOM_PROTOCOLS: "Choose your Custom Protocols",
  PREBUILT_INTEGRATIONS: "Prebuilt Integrations",
  AUTHENTICATION_TYPE_SUBTITLE: "Choose the identifier your users will use to register and sign in.",
  ADDITIONAL_SSO_PROTOCOLS: "Additional SSO Protocols",
  ADDITIONAL_SSO_PROTOCOLS_DESC: "Expand your federated SSO with modern, token‑based protocols for web, mobile, and service‑to‑service apps.",
  OAUTH2_DESC: "A standard for delegated authorization—issue access tokens to client apps without sharing user passwords.",
  OIDC1_DESC: "An identity layer on top of OAuth 2.0—issue ID tokens to authenticate users across your apps.",
  AUTHENTICATION_TYPE_LABEL_TOOLTIP: "Users cannot disable both email and phone authentication; at least one authentication type must remain active.",
  AUTHENTICATION_CONFIGURATION_DESC: "Configure how users can register and authenticate.",
  AUTHENTICATION_CONFIG_TITLE: "#type# Authentication",
  AUTHENTICATION_CONFIG_CONFIRM_TITLE: "#action# #type# Authentication",
  AUTHENTICATION_CONFIG_CONFIRM_MESSAGE: "Are you sure you want to #action# #type# Authentication?",
  TEAM_SSO_DESC: "Configure a Single Sign-On option for your team members to use when accessing the Admin Console.",
  EMPTY_SEARCH_RESULT: "Your search did not match any results. Try another keyword or browse through the navigation menu.",
  PHONE_NOT_INCLUDED_IN_FORMS: "Phone ID is not included in the default form. Please add Phone ID to form to change this field.",
  PHONE_ID_IS_THE_ONLY_FIELD: "Phone ID can't be marked optional as it is the only primary identifier in the form.",
  EMAIL_ID_IS_THE_ONLY_FIELD: "Email ID can't be marked optional as it is the only primary identifier in the form.",
  EMAIL_DISABLED_TOGGLE_TOOLTIP: "Email is the only enabled authentication type. Enable another type before disabling it.",
  PHONE_DISABLED_TOGGLE_TOOLTIP: "Phone is the only enabled authentication type. Enable another type before disabling it.",
  CONTACT_SUPPORT_USERS: "For further information, please contact LoginRadius support.",
  API_CONFIG_ADDED_SUCCESSFULLY: "API configuration added successfully.",
  API_CONFIG_UPDATED_SUCCESSFULLY: "API configuration updated successfully.",
  API_CONFIG_DELETED_SUCCESSFULLY: "API configuration deleted successfully.",
  API_CONFIG_ADDED_FAILED: "API configuration addition failed.",
  NATIVE_APP: "Native App",
  MACHINE_2_MACHINE_APP: "Machine 2 Machine App",
  SINGLE_PAGE_APP: "Single Page App",
  WEB_APP: "Web App",
  NATIVE_APP_DESC: "Apps installed on a user’s device",
  MACHINE_2_MACHINE_APP_DESC: "Backend services or automated jobs that need to call APIs directly, without user login.",
  WEB_APP_DESC: "Server-side apps that run on a backend and can safely store secrets.",
  NATIVE_APP_EXAMPLES: "e.g.: iOS or Android apps, Desktop or TV apps etc",
  MACHINE_2_MACHINE_APP_EXAMPLES: "e.g.:  Microservices, Server to server communication or API gateways etc",
  SPA_EXAMPLES: "e.g.: React, Angular, Vue frontends etc",
  WEB_APP_EXAMPLES: "e.g.:  Node.js, Express, ASP.NET, Java, PHP etc",
  SPA_DESC: "Browser-based apps that run entirely in JavaScript.",
  OAUTH_2: "OAuth 2.0",
  OAUTH_2_DESC: "Create an OAuth 2.0 Application when your app needs APIs or resource access on behalf of a user or another system without sharing passwords.",
  OIDC_1: "OpenID Connect 1.0",
  OIDC_1_DESC: "OIDC is an identity layer built on top of OAuth 2.0. Create an OIDC Application when your app needs user authentication and profile data in addition to API access.",
  M2M_DISABLED_TOOLTIP: "e.g.: API Gateway, Microservices",
  API_CONFIG_DESC: "Manage access to LoginRadius APIs. Create multiple API key and secret sets as needed.",
  API_CONFIG_HEADER: "API Configuration",
  API_ACCOUNTKEY: "API Account Key",
  APPS_DESCRIPTION: "Set up registration and authentication for your user-facing apps across web, mobile, and desktop. Also, configure machine-to-machine authorization.",
  APPS_DELETE_DESCRIPTION: "This action cannot be reversed; all configurations related to this app will be deleted.",
  APPLICATIONS_SEARCH_PLACEHOLDER: "Search by application name",
  APPLICATIONS_EMPTY_TITLE: "No applications available",
  APPLICATIONS_EMPTY_SUBTITLE: "Create an application to get started",
  APPLICATIONS_ADD_APPLICATION: "Add application",
  APPLICATIONS_DELETE_APPLICATION: "Delete application",
  APPLICATIONS_BASIC_INFO_DESC: "Configure the core credentials and security options that govern how the app communicates with the CIAM platform.",
  APPLICATIONS_CLIENT_ID_HELP: "This is the unique identifier assigned to your app. Use this when integrating with the Authorization Server or other client-side flows.",
  APPLICATIONS_CLIENT_SECRET_HELP: "This secret key authenticates your app with the Authorization Server. Keep it secure and never expose it in client-side code or public repositories.",
  APPLICATIONS_TOKEN_AUTH_METHOD_HELP: "Token Endpoint Authentication Method defines how your client application proves its identity when calling the token endpoint of the authorization server.",
  APPLICATIONS_GRANT_SETTINGS_DESC: "Configure how the app obtains tokens and how it authenticates at the token endpoint.",
  APPLICATIONS_GRANT_TYPES_HELP:
    "Grant Type determines how your application requests and receives access tokens - choose based on whether your app acts on behalf of a user or independently as a service.",
  APPLICATIONS_SCOPES_HELP:
    "Scopes define what user information your application can access - for example, selecting Email includes the user's email address in the token, while Profile includes their name and picture.",
  APPLICATIONS_MCP_REG_DESC: "Manage CIMD or DCR settings for MCP registrations.",
  APPLICATIONS_CIMD_HELP:
    "Client ID Metadata Document (CIMD) allows a client to use a URL as its identity, letting your server fetch and verify client details automatically instead of relying on static credentials.",
  APPLICATIONS_DCR_HELP:
    "Dynamic Client Registration (DCR) allows external applications to automatically register and obtain their own credentials at runtime, without requiring manual setup in the dashboard.",
  APPLICATIONS_ENDPOINTS_REDIRECT_DESC: "Define the endpoints for post-authentication and post-logout redirections.",
  APPLICATIONS_CORS_SECTION_DESC: "Restrict which domains can interact with the app's authentication endpoints and define network access rules.",
  APPLICATIONS_CORS_TOGGLE_DESC: "Allow specified domains to access your app's APIs from the browser; enable if your app runs on a different domain than your APIs.",
  APPLICATIONS_BACKCHANNEL_DESC: "Configure back-channel logout settings to ensure users are logged out from all sessions across different applications.",
  APPLICATIONS_BACKCHANNEL_TOGGLE_DESC: "Configure back-channel logout settings to ensure users are logged out from all sessions across different applications.",
  APPLICATIONS_APIS_DESC: "Configure audiences and scopes.",
  APPLICATIONS_TOKENS_DESC: "Control token lifetimes and session-related security.",
  APPLICATIONS_FORCE_REAUTH_HELP: "When enabled, users must re-authenticate at the authorization server instead of silently continuing with an existing session.",
  APPLICATIONS_PAR_TITLE: "Pushed Authorization Request (PAR)",
  APPLICATIONS_PAR_HELP: "Configure whether this app can use PAR and whether authorization requests must be sent through the PAR endpoint.",
  APPLICATIONS_PAR_ENABLED_HELP: "When enabled, this app may send authorization requests through the PAR endpoint.",
  APPLICATIONS_PAR_REQUIRED_LABEL: "Require PAR",
  APPLICATIONS_PAR_REQUIRED_HELP: "Require this app to send authorization requests through the PAR endpoint.",
  APPLICATIONS_RAR_TITLE: "Rich Authorization Request (RAR)",
  APPLICATIONS_RAR_HELP: "Configure whether this app can send rich authorization request data and restrict which top-level `authorization_details.type` values are accepted.",
  APPLICATIONS_RAR_ENABLED_HELP: "When enabled, this app may include rich authorization request data in PAR flows.",
  APPLICATIONS_RAR_ALLOWED_TYPES_LABEL: "Allowed RAR Types",
  APPLICATIONS_RAR_ALLOWED_TYPES_HELP: "Add the allowed top-level `authorization_details.type` values for this app. Values are matched case-insensitively.",
  APPLICATIONS_RAR_EMPTY_TYPES_WARNING: "No RAR types configured. Requests with `authorization_details.type` will be rejected.",
  APPLICATIONS_SIGNED_USERINFO_HELP: "When allowed, user info is returned as a signed JWT Token; otherwise, it is returned in JSON format.",
  APPLICATIONS_MANAGE_API_UNAVAILABLE_NOTICE: "Manage APIs cannot be added because this app does not use the client_credentials grant. Existing entries remain until you remove them.",
  AUTHENTICATION_TYPE_DESC: "Enable at least one type.",
  AUTHENTICATION_TYPE_B2B_DESC: "Email is enabled by default for B2B authentication.",
  AUTHENTICATION_METHOD_DESC: "Enable at least one method.",
  ADD_CUSTOM_DOMAIN: "Add custom domain",
  TEMPLATE_SETTINGS_NOTE: "You can customize the sender's email and name instead of using the global values from the configured SMTP. This customization will apply only to this email template.",

  // Logout All Customers
  LOGOUT_ALL_CUSTOMERS: "Logout All Customers",
  LOGOUT_ALL_CUSTOMERS_DESC: "This feature allows you to log out all customers currently logged into the system, providing an extra layer of security and ensuring the integrity of customer accounts.",
  ALL_CUSTOMERS_LOGGED_OUT_SUCCESSFULLY: "All customers have been logged out successfully.",
  LOGOUT_ALL_CUSTOMERS_PROCEED_MESSAGE: "Are you sure you want to log out all customers? This action will terminate all active customer sessions.",
  LOGOUT_ALL_CUSTOMERS_REAUTHENTICATE_MESSAGE: "Re-authentication is required to complete this action. Click 'Proceed' to log out.",
  ADD_NEW_TEMPLATE: "Add New Template",
  NEW_TEMPLATE: "New Template",
  TEMPLATE_SETTINGS: "Template Settings",
  PLACEHOLDER_LIST: "Placeholder List",
  EDIT_MAIL_SUBJECT: "Edit Email Subject",

  DATE_RANGE: "Date Range",
  PRIVACY_VERSIONING_STRICT_MODE_DESC: "Strict mode will enforce the latest privacy policy version for all users.",
  PRIVACY_VERSIONING_MODERATED_MODE_DESC: "Moderated mode will allow users to log in regardless of whether they accept or decline the policy.",
  VERSION_HISTORY_DESC: "Your privacy version history is shown here. Enable the feature to add a new version.",
  CONFIGURATION_DESC: "Add a new website or app domain(s).",
  COPY_SOTT: "Copy SOTT",
  HEADERS: "Headers",
  QUERY_PARAMS: "Query Parameters",
  LIMIT_BANNER_TEXT: "added in the free trial. Upgrade to unlock adding unlimited apps and features!",
  TRIAL_BANNER_SUBTEXT: "Upgrade your plan to unlock all features and enhance your experience.",
  GETTING_STARTED_TITLE: "Get Started with LoginRadius",
  GETTING_STARTED_DESCRIPTION: "Explore the features and resources needed to secure your apps and users.",
  GETTING_STARTED_CTA_TITLE: "Use Our Branded Auth Studio Experience",
  GETTING_STARTED_CTA_DESCRIPTION: "Design login UI elements with the flexibility of CSS and HTML.",
  GETTING_STARTED_CTA_B2B_TITLE: "Manage Your Partners",
  GETTING_STARTED_CTA_B2B_DESCRIPTION: "Effortlessly manage your partners' organizations, users, roles /permissions, and SSO integration—all in one place.",
  GETTING_STARTED_WELCOME_TITLE: "Welcome to the New LoginRadius Dashboard",
  GETTING_STARTED_WELCOME_BODY_TITLE: "Your New Admin Console is Live!",
  GETTING_STARTED_WELCOME_BODY_TEXT: "We've upgraded to a modern, more robust dashboard to provide a seamless experience.",
  GETTING_STARTED_WELCOME_BODY_DESCRIPTION: "Enjoy enhanced features, faster performance, and improved usability designed to make managing your CIAM solutions easier than ever.",
  GETTING_STARTED_WELCOME_BUTTON: "Let's Get Started",
  SETUP_MFA: "Set Up MFA",
  ADD_TEAM_MEMBERS: "Add Team Members",
  WORKFLOWS: "Workflows",
  CUSTOM_IDP: "Set Up Custom Identity Provider",
  SETUP_GUIDE: "Setup Guide",
  GETTING_STARTED_CTA_BUTTON: "Go to Branding",
  GETTING_STARTED_CTA_B2B_BUTTON: "Go to Organizations",
  SDKS: "SDKs",
  API_REFERENCES: "API References",
  COMMUNITY: "Community",
  SOCIAL_ACCOUNTS: "Social Accounts",
  FULLNAME: "Full Name",
  AUTHENTICATION_TYPE: "Authentication Type",
  AUTHENTICATION_METHODS: "Authentication Methods",
  GETTING_STARTED_AUTHENTICATION_CONFIGURATION_DESCRIPTION: "Set up authentication types and methods to allow users to register and log in.",
  GETTING_STARTED_MFA_DESCRIPTION: "Secure your application with MFA to protect your users from unauthorized access.",
  GETTING_STARTED_TEAM_MEMBERS_DESCRIPTION: "Invite a new member to the team.",
  GETTING_STARTED_WORKFLOWS_DESCRIPTION: "Rapidly design, test, deploy, and manage identity experiences with no-code capabilities.",
  GETTING_STARTED_CUSTOM_IDP_DESCRIPTION: "Set up a third-party identity provider using prebuilt integrations or standard protocols like SAML.",
  GETTING_STARTED_SETUP_GUIDE_DESCRIPTION: "Explore our end-to-end tutorial guide for application stacks using LoginRadius.",
  GETTING_STARTED_SDKS_DESCRIPTION: "Explore detailed SDKs to get started with the LoginRadius platform.",
  GETTING_STARTED_API_REFERENCES_DESCRIPTION: "Explore LoginRadius's extensive APIs to integrate with your application.",
  GETTING_STARTED_USER_LIMIT_TOOLTIP_TEXT: "The user limit applies to the total number of unique users you can manage in the trial plan. Get a paid plan to manage unlimited users.",
  GETTING_STARTED_EMAIL_LIMIT_TOOLTIP_TEXT:
    "The email limit applies only to emails sent via the LoginRadius default email provider. Configure your own email SMTP provider to send unlimited emails. (To configure an email provider, check the branding section.)",
  GETTING_STARTED_SMS_LIMIT_TOOLTIP_TEXT:
    "The SMS limit applies only to SMS sent via the LoginRadius default SMS provider. Set up your own SMS provider to send unlimited SMS. (To configure an SMS provider, check the branding section.)",
  EXPIRED_PLAN_TITLE: "Your Free Trial Has Expired",
  EXPIRED_PLAN_DESCRIPTION: `Your free trial for tenant "#appName#" has ended. We hope you’ve explored how LoginRadius can enhance security over the last 21 days.`,
  EXPIRED_PLAN_CTA: "Contact Us",
  EXPIRED_PLAN_CARD_TITLE: "Benefits",
  EXPIRED_PLAN_CARD_SUBTITLE_1: "Seamless User Authentication",
  EXPIRED_PLAN_CARD_SUBTEXT_1: "Simplify user access with advanced options like passwordless login, social login, and multi-protocol support.",
  EXPIRED_PLAN_CARD_SUBTITLE_2: "Adaptive Multi-Factor Authentication (MFA)",
  EXPIRED_PLAN_CARD_SUBTEXT_2: "Protect accounts with intelligent, context-aware MFA that adapts to real-time risks for optimal security.",
  EXPIRED_PLAN_CARD_SUBTITLE_3: "No-Code Orchestration",
  EXPIRED_PLAN_CARD_SUBTEXT_3: "Effortlessly manage complex workflows and integrations with a no-code platform, saving developer time and reducing deployment effort.",
  EXPIRED_PLAN_CARD_SUBTITLE_4: "Unified Customer Profiles",
  EXPIRED_PLAN_CARD_SUBTEXT_4: "Gain a 360° view of your customers with centralized, actionable identity data to personalize user experiences and drive engagement.",
  EXPIRED_PLAN_CARD_SUBTITLE_5: "Brand Builder",
  EXPIRED_PLAN_CARD_SUBTEXT_5: "Create fully branded, customizable login, registration, and profile management pages with easily, ensuring seamless alignment with your brand.",
  NO_ORGANIZATIONS_CONNECTIONS_SUBTITLE: "Get started by configuring Custom IDPs to handle authentication in your organization.",
  CREATE_SAML_CONNECTION: "Create a custom SAML provider for the organization.",
  CREATE_OIDC_CONNECTION: "Create a custom OIDC provider for the organization.",
  CREATE_OKTA_CONNECTION: "Create a custom Okta provider for the organization.",
  CREATE_ENTRAID_CONNECTION: "Create a custom EntraID provider for the organization.",
  CREATE_GOOGLE_WORKSPACE_CONNECTION: "Create a custom Google Workspace provider for the organization.",
  CREATE_SALESFORCE_CONNECTION: "Create a custom Salesforce provider for the organization.",
  ORGANIZATIONS: "Organizations",
  ORGANIZATION: "Organization",
  ORGANIZATIONS_DESCRIPTION: "Manage your organizations and their associated roles and users.",
  CREATE_ORGANIZATION: "Create organization",
  UPDATE_ORGANIZATION: "Update organization",
  DELETE_ORGANIZATION: "Delete Organization",
  EDIT_ORGANIZATION: "Edit Organization",
  DEACTIVATE_ORGANIZATION: "Deactivate Organization",
  ACTIVATE_ORGANIZATION: "Activate Organization",
  ORGANIZATION_CONFIRMATION_STATUS: "Are you sure you want to %s this organization?",
  NO_ORGANIZATIONS_TITLE: "You Don’t Have Any Organizations Yet",
  NO_ORGANIZATIONS_DESCRIPTION: "Get started by adding organizations to your LoginRadius site.",
  DELETE_ORGANIZATION_CONFIRMATION: "Are you sure you want to delete this organization? All connections and users related to this organization will be deleted.",
  INVITE_USERS: "Invite Users",
  INVITE_USER: "Invite User",
  INVITE_USERS_DESCRIPTION: "Invite users to join the #OrgName# organization.",
  ADD_USER: "Add User",
  ALL_USERS: "All Users",
  INVITED_USERS: "Invited Users",
  NO_INVITED_USERS_TITLE: "You Don't Have Any Invited Users",
  NO_INVITED_USERS_DESCRIPTION: "You have not invited any users to join your organization.",
  INVITE_USER_INFO: "Invitations sent to users will expire after 7 days.",
  ADD_USER_TITLE: "Add users to organization",
  NO_CUSTOMER_FOUND: "No user found.",
  NO_USER_FOUND: "No users found.",
  INVITE_TO_ORG: "Invite users to join your organization.",
  UPDATE_USER: "Update user",
  DELETE_USER_CONFIRMATION: "Are you sure you want to remove this user?",
  USER: "User",
  CUSTOMER: "Customer",
  ADD_TO_ORG: "Add to Organization",
  NOT_PART_OF_ORG: "This user is not a member of any organization.",
  NOT_PART_OF_ORG_DESCRIPTION: "Get started by adding the user to an organization.",
  INVITATION: "Invitation",
  RESEND_INVITATION: "Resend Invitation",
  REVOKE_INVITATION: "Revoke Invitation",
  REVOKE: "Revoke",
  RESEND_EMAIL_URL: "Resend Email URL",
  RESEND_INVITATION_CONFIRMATION: "Do you want to resend the invite to ",
  RESENT_INVITATION_ERROR_MSG: "The user has already been invited. Please use the 'Resend Invitation' action to send the invite again.",
  BTN_RESEND_INVITATION: "Resend Invite",
  REVOKE_INVITATION_CONFIRMATION: "Are you sure you want to revoke this invitation?",
  NO_ROLES_TITLE: "You Don't Have Any Roles Yet",
  NO_ROLES_DESCRIPTION: "Get started by adding roles to your tenant.",
  CREATE_ROLE: "Create role",
  UPDATE_ROLE: "Update Role",
  DELETE_ROLE: "Delete Role",
  EDIT_ROLE: "Edit role",
  REMOVE_FROM_ORG: "Delete from Organization",
  DELETE_ROLE_CONFIRMATION: "Are you sure you want to delete this role? All users mapped to this role will be unassigned from it.",
  REASSIGN_ROLE_NOTIFICATION: "This role is already assigned to users. To proceed, you must reassign those users to another role.",
  SHOW_TENANT_ROLES: "Show Tenant Roles",
  PERMISSION: "Permission",
  NO_PERMISSIONS_TITLE: "You Don't Have Any Permissions Yet",
  NO_PERMISSIONS_DESCRIPTION: "Get started by adding permissions to your tenant.",
  CREATE_PERMISSION: "Create Permission",
  UPDATE_PERMISSION: "Update Permission",
  DELETE_PERMISSION: "Delete Permission",
  EDIT_PERMISSION: "Edit Permission",
  LR_ROLE_RESTRICTED_TOOLTIP: "This role is required by default and can't be edited or deleted",
  LR_PERMISSION_RESTRICTED_TOOLTIP: "This permission is required by default and can't be edited or deleted",
  DELETE_PERMISSION_CONFIRMATION: "This permission might be assigned to roles and users. Deleting it will revoke their access to it.",
  ORGANIZATION_CUSTOM_IDP_DESCRIPTION: "Configure identity providers with supported protocols for your organizations.",
  GROUPID_REQUIRED: "Please input the Group ID!",
  GROUP_NAME_REQUIRED: "Please input the Name!",
  GROUP_ROLEID_REQUIRED: "Please select the Role ID!",
  SELECT_ROLE_ID: "Select Role ID",
  ATTRIBUTES_DESCRIPTION_GROUPS: "Attributes to be sent to the IDP.",
  IDP_CONFIGURATION: "Identity Provider Configuration",
  IPD_CONFIGURATION_DESCRIPTION: "Manage the identity provider metadata manually or using a URL.",
  SWITCH_MANUAL: "Switch to Manual Configuration",
  SWITCH_DYNAMIC: "Switch to Dynamic Configuration",
  IDP_METADATA_URL_DESCRIPTION: "URL Metadata Configuration",
  NO_CUSTOMERS: "You Don't Have Any Users",
  NO_CUSTOMERS_FOUND_FILTERS: "No users found with the following filters.",
  RESET_FILTERS_CUSTOMERS: "Reset the filters to view all users.",
  RESET_FILTERS: "Reset Filters",
  SOURCE_PLACEHOLDER: "Enter Source",
  SOURCEID_PLACEHOLDER: "Enter Source ID",
  NO_PRIVACY_POLICY_FOUND: "No privacy policy logs available.",
  NO_PRIVACY_POLICY_FOUND_DESCRIPTION: "No privacy logs were found on your tenant.",
  NO_CONSENT_LOGS_FOUND: "No consent logs available.",
  NO_CONSENT_LOGS_FOUND_DESCRIPTION: "No consent logs were found on your tenant.",
  NO_CUSTOMERS_DESCRIPTION: "Get started by adding users to your tenant.",

  CREATE_CUSTOMER: "Create User",
  SERVICE_PROVIDER_DETAILS: "Service Provider Details",
  GROUPS_AND_ROLES_ASSIGNMENTS: "Groups and Role Assignments",
  USER_DELETED_SUCCESSFULLY: "User deleted successfully.",
  USER_UPDATED_SUCCESSFULLY: "User updated successfully.",
  NO_GROUPS_ASSIGNED: "No groups assigned.",
  NO_GROUPS_ASSIGNED_SUBTITLE: "Get started by assigning groups to your connection.",
  EDIT_GROUP_ROLE: "Edit group role",
  DELETE_GROUP_ROLE: "Delete Group Role",
  DELETE_GROUP_ROLE_CONFIRMATION: "Are you sure you want to delete this group role?",
  GROUP_ROLE: "Group Role",
  ADD_GROUP_ROLE: "Add group role",
  CANT_TRANSFER_TO_YOURSELF: "You can't transfer ownership to yourself.",

  JIT_TITLE: "Just-In-Time Provisioning",
  JIT_DESCRIPTION: "Enable Just-In-Time provisioning to automatically create user accounts when users log in for the first time.",
  JIT_CARD_TITLE: "Provision SSO Users",
  JIT_CARD_DESCRIPTION: "Enable Just-In-Time provisioning to automatically create user accounts when users log in for the first time.",
  JIT_CONNECTION_NOT_ADDED: "Please configure SSO to enable Just-In-Time Provisioning.",
  JIT_CONNECTION_NOT_ENABLED: "Please enable SSO to enable Just-In-Time Provisioning.",
  JIT_DISABLE_MESSAGE: "Are you sure you want to disable Just-In-Time Provisioning? This will prevent new users from being created automatically.",
  INIVITATION_URL: "Invitation URL",
  JIT_DOMAIN_NOT_ADDED: "Please add a domain and configure SSO to enable Just-In-Time Provisioning.",
  JIT_ENABLED_MESSAGE: "Just-In-Time Provisioning is active. Users will be automatically provisioned during SSO login.",
  JIT_DISABLED_MESSAGE: "Just-In-Time Provisioning is disabled. Users will not be automatically provisioned during SSO login.",
  JIT_STEP_TITLE_1: "Add at least one domain to the organization.",
  IDENTITIES: "Identities",
  JIT_STEP_TITLE_2: "Configure SSO for this organization.",
  DIRECTORY_SYNC_TITLE: "Directory Sync",
  DIRECTORY_SYNC_DESCRIPTION: "Connect your directory provider to provision users via SCIM and monitor token usage.",
  DIRECTORY_SYNC_EMPTY_TITLE: "Directory Sync is not configured",
  DIRECTORY_SYNC_EMPTY_DESCRIPTION: "Set up Directory Sync to generate SCIM credentials and automate provisioning.",
  DIRECTORY_SYNC_VIEW_DOCS: "View documentation",
  DIRECTORY_SYNC_DOC_LABEL: "Documentation",
  DIRECTORY_SYNC_PROVIDER_LABEL: "%s directory",
  DIRECTORY_SYNC_PROVIDER_PLACEHOLDER: "Directory provider",
  DIRECTORY_SYNC_PROVIDER_OKTA: "Okta",
  DIRECTORY_SYNC_PROVIDER_AZURE: "Azure",
  DIRECTORY_SYNC_PROVIDER_CUSTOM: "Custom",
  DIRECTORY_SYNC_STATUS_LABEL: "Status",
  DIRECTORY_SYNC_STATUS_PLACEHOLDER: "Not syncing",
  DIRECTORY_SYNC_CREATED_ON: "Created",
  DIRECTORY_SYNC_LAST_UPDATED: "Last updated",
  DIRECTORY_SYNC_ENDPOINT_LABEL: "SCIM endpoint",
  DIRECTORY_SYNC_ENDPOINT_PLACEHOLDER: "Endpoint unavailable",
  DIRECTORY_SYNC_ENDPOINT_HELP: "Use this endpoint when configuring SCIM provisioning in your directory.",
  DIRECTORY_SYNC_INFO_TEXT: "To know how to synchronize your application's %s directories using SCIM refer",
  DIRECTORY_SYNC_TOKENS_TITLE: "Directory tokens",
  DIRECTORY_SYNC_TOKENS_SUBTITLE: "List of tokens used for the SCIM integration.",
  DIRECTORY_SYNC_NEW_TOKEN: "New Token",
  DIRECTORY_SYNC_TOKEN_NAME: "Token name",
  DIRECTORY_SYNC_TOKEN_STATUS: "Status",
  DIRECTORY_SYNC_TOKEN_CREATED: "Created",
  DIRECTORY_SYNC_TOKEN_LAST_USED: "Last used",
  DIRECTORY_SYNC_TOKEN_ACTIONS: "Actions",
  DIRECTORY_SYNC_TOKEN_NOT_USED_PLACEHOLDER: "Not used yet",
  DIRECTORY_SYNC_ACTIONS_PLACEHOLDER: "Coming soon",
  DIRECTORY_SYNC_TOKEN_DELETE_ACTION: "Delete",
  DIRECTORY_SYNC_TOKEN_DELETE_HEADING: "Delete Token?",
  DIRECTORY_SYNC_TOKEN_DELETE_TITLE: "Token",
  DIRECTORY_SYNC_TOKEN_DELETE_MESSAGE: 'All access using token "%s" will be revoked immediately.',
  DIRECTORY_SYNC_TOKEN_DELETE_CONFIRM_TEXT: "DELETE TOKEN",
  DIRECTORY_SYNC_TOKEN_DELETE_CONFIRM_PLACEHOLDER: "Enter DELETE TOKEN",
  DIRECTORY_SYNC_TOKEN_DELETE_INSTRUCTION: 'Please type "%s" to confirm your action.',
  DIRECTORY_SYNC_TOKEN_DELETE_BUTTON: "Delete Token",
  DIRECTORY_SYNC_TOKEN_DELETE_DISABLED: "At least one token is required",
  DIRECTORY_SYNC_ADD_TOKEN_BUTTON: "Add Token",
  DIRECTORY_SYNC_ADD_TOKEN_MODAL_TITLE: "Add token",
  DIRECTORY_SYNC_ADD_TOKEN_NAME_LABEL: "Token Name",
  DIRECTORY_SYNC_ADD_TOKEN_NAME_PLACEHOLDER: "Enter token name",
  DIRECTORY_SYNC_ADD_TOKEN_NAME_REQUIRED: "Please enter a token name",
  DIRECTORY_SYNC_ADD_TOKEN_NAME_HELPER: "Use a friendly name so you can identify this token later.",
  DIRECTORY_SYNC_ADD_TOKEN_CANCEL: "Cancel",
  DIRECTORY_SYNC_ADD_TOKEN_SUBMIT: "Create Token",
  DIRECTORY_SYNC_CREATE_CTA: "Create Directory",
  DIRECTORY_SYNC_CREATE_MODAL_TITLE: "Create directory",
  DIRECTORY_SYNC_CREATE_NAME_LABEL: "Directory Name",
  DIRECTORY_SYNC_CREATE_NAME_PLACEHOLDER: "Enter directory name",
  DIRECTORY_SYNC_CREATE_NAME_REQUIRED: "Please enter a directory name",
  DIRECTORY_SYNC_CREATE_PROVIDER_LABEL: "Directory Provider",
  DIRECTORY_SYNC_CREATE_PROVIDER_PLACEHOLDER: "Select",
  DIRECTORY_SYNC_CREATE_PROVIDER_REQUIRED: "Please select a directory provider",
  DIRECTORY_SYNC_CREATE_CANCEL: "Cancel",
  DIRECTORY_SYNC_CREATE_SUBMIT: "Create Directory",
  DIRECTORY_SYNC_DELETE_ACTION: "Delete Directory",
  DIRECTORY_SYNC_DELETE_TITLE: "Directory",
  DIRECTORY_SYNC_DELETE_HEADING: "Delete Directory?",
  DIRECTORY_SYNC_DELETE_MESSAGE: "All %s data associated with this directory will be deleted. This action is immediate and cannot be undone.",
  DIRECTORY_SYNC_DELETE_CONFIRM_TEXT: "DELETE DIRECTORY",
  DIRECTORY_SYNC_DELETE_CONFIRM_PLACEHOLDER: "Enter DELETE DIRECTORY",
  DIRECTORY_SYNC_DELETE_INSTRUCTION: 'Please type "%s" to confirm your action.',
  DIRECTORY_SYNC_DELETE_BUTTON: "Delete Directory",
  DIRECTORY_SYNC_TOKEN_MODAL_TITLE: "Directory created",
  DIRECTORY_SYNC_TOKEN_MODAL_NAME_LABEL: "Token Name",
  DIRECTORY_SYNC_TOKEN_MODAL_TOKEN_LABEL: "Token",
  DIRECTORY_SYNC_TOKEN_MODAL_ACKNOWLEDGE: "I've copied the Token",
  DIRECTORY_SYNC_TOKEN_MODAL_WARNING_TITLE: "Save Token Before Continuing",
  DIRECTORY_SYNC_TOKEN_MODAL_WARNING_DESCRIPTION: "This token will not be shown again. Make sure you copy it now and store it in a safe place.",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_TITLE: "Token created",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_NAME_LABEL: "Token Name",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_TOKEN_LABEL: "Token",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_WARNING_TITLE: "Save token before continuing",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_WARNING_DESCRIPTION: "This token will not be shown again. Make sure you copy it now and store it in a safe place.",
  DIRECTORY_SYNC_NEW_TOKEN_MODAL_ACKNOWLEDGE: "I've copied the Token",
  WEBINAR_TITLE: "What Will CIAM Look Like in 2025: LoginRadius Product Roadmap",
  WEBINAR_DESCRIPTION:
    "Join us for an exclusive preview of what’s next in the LoginRadius product ecosystem and see firsthand how the platform enables businesses to create secure, scalable, and tailored customer identity experiences in 2025.",
  WEBINAR_SUBTEXT_1: "Wednesday, March 12th, 2025",
  WEBINAR_SUBTEXT_2: "01:00 PM - 02:30 PM PDT",
  WEBINAR_BUTTON_TEXT: "Register Now",
  MFA_DISABLED: "MFA is Disabled",
  CONFIGURE_MFA: "Configure MFA",
  MFA_FACTORS: "MFA Factors",
  MFA_FACTORS_INFO_TEXT: "Atleast one MFA factor should be enabled",
  MFA_DISABLED_SUBTITLE: "Multi-Factor Authentication is not enabled at the tenant level. To configure MFA for organizations, go to MFA settings to enable it.",
  SELECT_CONFIGURATION: "Select a Flow",
  CUSTOM_CONFIGURATION: "Custom Configuration",
  MFA_CONFIGURATION: "MFA Configuration",
  FACTORS: "Factors",
  FACTORS_TOOLTIP: "MFA factors are set by the tenant and apply to all organization users, It cannot be modified at the organization level.",
  TENANT_LEVEL: "Tenant Level",
  TENANT_MFA_OPTIONAL: "The tenant has set MFA as optional for this organization.",
  TENANT_MFA_MANDATORY: "The tenant has set MFA as mandatory for this organization.",
  MFA_MANDATORY: "MFA is set to mandatory for this organization.",
  MFA_TYPE_SELECT: "Select whether MFA should be mandatory or optional for this organization.",
  TENANT_MFA_SETTINGS_CONFIRMATION_TITLE: "MFA configuration will be applied to all organizations under this tenant",
  TENANT_MFA_SETTINGS_CONFIRMATION_DESCRIPTION: "Organizations under this tenant will have the same MFA configuration as the one you are about to set.",
  MFA_FACTORS_EMAIL_OTP: "Deliver OTP via email message to the user's email.",
  MFA_FACTORS_SMS_OTP: "Deliver OTP via text message to the user's phone.",
  MFA_FACTORS_AUTHENTICATOR: "Generate secure codes with LoginRadius Authenticator, Google Authenticator, etc.",
  MFA_FACTORS_DUO: "Use Duo Security for authentication.",
  MFA_FACTORS_PASSKEY: "Use passkeys to authenticate.",
  MFA_FACTORS_PUSH_NOTIFICATION: "Trigger a push notification via LoginRadius Authenticator or a native mobile app.",
  MFA_FACTORS_SECURITY_QUESTIONS: "Answer security questions to authenticate.",
  NO_MFA_FACTORS_AVAILABLE_TITLE: "No MFA Factors Available",
  NO_MFA_FACTORS_AVAILABLE_DESCRIPTION: "Please enable MFA factors to see them listed here.",
  FAILED_TO_ADD_USER_TO_ORG: "User cannot be added to the organization. Please add an email to the user to proceed.",
  SETUP_YOUR_TENANT_TITLE: "Setup your tenant",
  SETUP_YOUR_TENANT_DESCRIPTION: "A few quick choices and you'll be up and running in no time",
  // SETUP_YOUR_TENANT_TYPE: "Tenant Type",
  SETUP_YOUR_TENANT_B2C_TAG: "B2C",
  SETUP_YOUR_TENANT_B2C_TAG_CONSUMER: "Consumers",
  SETUP_YOUR_TENANT_B2C_TAG_PUBLIC: "Public",
  SETUP_YOUR_TENANT_B2C_TAG_NETFLIX: "Netflix",
  SETUP_YOUR_TENANT_B2C_TAG_SPOTIFY: "Spotify",
  SETUP_YOUR_TENANT_B2C_TAG_WALMART: "Walmart",
  SETUP_YOUR_TENANT_B2B_TAG: "B2B",
  SETUP_YOUR_TENANT_B2B_TAG_HUBSPOT: "HubSpot",
  SETUP_YOUR_TENANT_B2B_TAG_SLACK: "Slack",
  SETUP_YOUR_TENANT_B2B_TAG_FIGMA: "Figma",
  SETUP_YOUR_TENANT_B2C_TAG_ORGANIZATIONS: "Organizations",
  SETUP_YOUR_TENANT_INFO: "Please note that this selection cannot be changed later.",
  SETUP_YOUR_TENANT_NAME_LABEL: "Tenant name",
  SETUP_YOUR_TENANT_BUTTON: "Create Tenant",
  PARTNER_PROGRAM_DESCRIPTION: "For B2B apps serving businesses, teams, organizations, or partners.",
  CUSTOMER_PROGRAM_DESCRIPTION: "For B2C apps serving individual users like shoppers, readers, or subscribers.",
  TRIAL_LIMIT_ORGANIZATION_INFO: "The number of organizations that can be created and managed",
  TRIAL_LIMIT_ORGANIZATION_SSO_INFO: "The number of Custom IDP configurations that can be created and managed",
  TRIAL_LIMIT_EMAIL_INFO: "The number of emails that can be sent via the LoginRadius default email provider",
  TRIAL_LIMIT_SMS_INFO: "The number of SMS messages that can be sent via the LoginRadius default SMS provider",
  TRIAL_LIMIT_USERS_INFO: "The number of unique users that can be managed in the trial plan",

  // PIN Auth
  PIN_AUTH_HEADER: "Allow users to set a PIN for their account and use it during authentication or re-authentication instead of a password.",
  PIN_UPDATE_SUCCESS: "PIN authentication updated successfully.",
  PIN_UPDATE_FAIL: "Failed to update PIN authentication.",
  PIN_FLOW: "PIN Flow",
  PIN_FLOW_DESCRIPTION: "Select how the PIN must be configured.",
  MANDATORY_FLOW: "Mandatory",
  MANDATORY_FLOW_DESC: "Users will be required to authenticate with a PIN.",
  OPTIONAL_FLOW: "Optional",
  OPTIONAL_FLOW_DESC: "Users will have the option to authenticate without a PIN.",
  PIN_EVENT: "Events to Set PIN",
  PIN_EVENT_DESC: "Select when the PIN should be triggered.",
  ON_REGISTRATION: "On Registration",
  ON_REGISTRATION_DESC: "Activate the PIN upon user registration.",
  ON_FIRST_LOGIN: "On First Login",
  ON_FIRST_LOGIN_DESC: "Activate the PIN on the first login after registration.",
  ON_LOGIN: "On Login",
  ON_LOGIN_DESC: "Activate the PIN every time a user logs in.",
  SESSION_TOKEN: "Session Token",
  SESSION_TOKEN_DESC: "Configure when the PIN session token should expire.",
  SESSION_TOKEN_EXPIRY_LABEL: "Session Token Expiry Time (in Minutes)",
  SESSION_TOKEN_EXPIRY_TIME: "Session Token Expiry Time",
  SESSION_TOKEN_EXPIRY_DESC_1: "The session token expiry time should be greater than the access token time.",
  SESSION_TOKEN_EXPIRY_DESC_2: "To manage access token time,",
  SESSION_TOKEN_EXPIRY_DESC_3: "go to Session Management.",
  PIN_VALIDATION_RULES: "PIN Validation Rules",
  PIN_VALIDATION_RULES_DESC: "Set up validation rules for the PIN.",
  PIN_VALIDATION_RULES_TOOLTIP_1: "To configure validation rules for the PIN,",
  PIN_VALIDATION_RULES_TOOLTIP_2: "go to Forms.",
  EMAIL_TEMPLATES_DESC: "Available email templates for sending forgot PIN emails.",
  EMAIL_TEMPLATES_TOOLTIP_1: "To configure an email template for PIN reset/recovery,",
  EMAIL_TEMPLATES_TOOLTIP_2: "go to Email Template.",
  SMS_TEMPLATES_DESC: "Available SMS templates for sending forgot PIN text messages.",
  SMS_TEMPLATES_TOOLTIP_1: "To configure an SMS template for PIN reset/recovery,",
  SMS_TEMPLATES_TOOLTIP_2: "go to SMS Template.",
  DISABLE_PIN_AUTH: "Disable PIN Authentication",
  DISABLE_PIN_AUTH_DESC: "Are you sure you want to disable PIN authentication?",
  B2B_STEPS_1: "Create an Organization",
  B2B_STEPS_2: "Add Domain to Organization",
  B2B_STEPS_3: "Add/Invite Users to Organization",
  B2B_STEPS_4: "Setup IDPs for Organization",
  DOMAIN_VERIFIED: "Domain(s) added here will be automatically considered as verified.",

  SUNSET_TITLE: "Sunsetting the Old Admin Console Soon",
  SUNSET_TEXT: "We launched the New Admin Console to provide a smoother, intuitive, and enhanced user experience.",
  SUNSET_ALERT:
    "We are extending the Old Admin Console sunset timeline to May 21st, 2025. While you’ll still have access to the Old Admin Console, we encourage you to continue using the New Admin console.",
  SUNSET_CONFIRM_TEXT: "Do you still want to switch?",
  SUNSET_CANCEL_BUTTON: "No, I like it here",
  SUNSET_CONFIRM_BUTTON: "Switch anyway",

  // Audit Log Integration
  AUDIT_LOG_INTEGRATION_DESC: "Sync your audit logs by choosing one integration to centralize all your logs.",
  NAME_OF_INTEGRATION: "Name of Integration",
  ACTIVE: "Active",
  DELETE_CONNECTION: "Delete Connection",
  ENDPOINT_CONFIGURATION: "Endpoint Configuration",
  ENDPOINT_CONFIGURATION_DESC: "Endpoint URL and other necessary config information",
  ONLY_ONE_AUDIT_LOG_INTEGRATION: "Only one of the above Integration(s) can be configured.",
  DELETE_INTEGRATION_CONFIRMATION: "Are you sure you want to delete this Audit Log integration?",
  INTEGRATION_DELETED_SUCCESSFULLY: "Integration deleted successfully.",
  INSTALLED: "Installed",
  OK: "OK",
  PROGRESSIVE_PROFILING_DESCRIPTION: "Seamlessly evolve customer profiles with multi-stage, permission-based data collection—tailor each step to engage users at key moments in their journey.",
  ADD_STEP: "Add Step",
  ADD_STEP_NO_DATA: "No Steps added yet",
  ADD_STEP_NO_DATA_DESCRIPTION: "Start building your customer journey by creating your first profiling step.",
  DELETE_STEP_DESCRIPTION: "Are you sure you want to delete this Step? All Fields added and used in LoginRadius V2 JS will no longer be functional.",
  THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  EDIT_STEP: "Edit Step",
  MOBILE_VIEW_TITLE: " LoginRadius works best on desktop",
  MOBILE_VIEW_DESCRIPTION: "To configure authentication, set up branding, and explore other features, please log in on your desktop browser.",
  MOBILE_VIEW_TEXT: "Explore our docs meanwhile",
  MOBILE_VIEW_BUTTON: "Go to docs",
  CONFIRM_PASSWORD_VALIDATION_TOOLTIP: "Validation rules are the same as the password field, you cannot edit it.",
  CONFIRM_PASSWORD_ISMANDATORY_TOOLTIP: "Is Mandatory field is same as the password field, you cannot edit it.",
  VALIDATION_RP_ORIGIN_MUST_END_WITH_RPID: "Relying Party Origin must end with the Relying Party ID.",
  MOBILE_VIEW_SKIP_BUTTON: "Skip and use anyway",
  MOBILE_VIEW_DOCS_TEXT: "Meanwhile, you can explore our documentation",
  MOBILE_VIEW_DOCS_BUTTON: "Go to docs",
  DISCARD_UNSAVED_CHANGES: "You have unsaved changes. Are you sure you want to discard them?",
  DISCARD_CHANGES: "Discard Changes",
  UNSAVED_CHANGES: "Unsaved Changes",
  DELETE_STYLE_CONFIRMATION: "Are you sure you want to delete this style?",
  STYLE_IN_USE_TITLE: "Style in use",
  STYLE_IN_USE_MESSAGE_PREFIX: "This style is currently being used by ",
  STYLE_IN_USE_MESSAGE_SUFFIX: ". If you delete it, the domain will automatically fall back to the default style (%p) of the %q template.",
  GO_TO_CUSTOM_DOMAINS: "Go to Custom Domains",
  NO_CHANGES_TO_DEPLOY: "No changes to deploy",
  ADD_TRANSLATION: "Add Translation",
  REMOVE_TRANSLATION: "Remove Translation",
  TRANSLATION_REMOVE_CONFIRMATION: "This will remove the translation for the selected language. Please ensure that you have a backup of the content if needed.",
  ADD_TRANSLATION_MESSAGE: `This will add %s language translation with default text to your template. You can then customize the text for this language.`,
  REMOVE_TRANSLATION_MESSAGE: `Are you sure you want to remove the %s translation?`,
  ADD_TRANSLATION_TITLE: `Add %s to your template`,
  REMOVE_TRANSLATION_TITLE: `Remove %s from your template`,
  DEPLOY_CODE_TITLE: "Deploy Code Changes",
  DEPLOY_BUTTON_TEXT: "Deploy",
  SAVE_DEPLOY_BUTTON: "Save and Deploy",
  NEW_HOSTED_PAGES_EDITOR_EXPERIENCE: "A New Auth Studio Editor Experience! Create multiple styles, preview instantly, and customize faster — now with a modern editor built for scale.",
  HOSTED_PAGES_DESCRIPTION: "Design and deploy authentication journeys like login, sign up, and MFA in Auth Studio — fully branded and ready to use.",
  INTERNATIONALIZATION: "Internationalization",
  DEPLOY_WORKFLOW_BRAND_CHECKBOX_MESSAGE: "I understand that these changes will be applied to the workflow.",
  DEPLOY_WORKFLOW_BRAND_MESSAGE: "You are about to deploy this brand for the Workflow. This will make this brand the default brand for all workflow pages.",
  DEPLOY_WORKFLOW_BRAND_ALERT_MESSAGE: "This action will set the selected brand as the default for all workflow pages.",
  DEPLOY_WORKFLOW_BRAND_TITLE: "Deploy for Workflow",
  DEPLOY_WORKFLOW_BRAND_BUTTON: "Deploy for Workflow",
  LOGINRADIUS_DEFAULT_V3: "LoginRadius Default V3",
  LOGINRADIUS_DEFAULT_V2: "LoginRadius Default V2",
  LOGINRADIUS_DEFAULT: "LoginRadius Default",
  DEPLOYED_BRAND_TOOLTIP: "This template is currently deployed on your Auth Studio URL",
  DEPLOYED_LABEL: "DEPLOYED",
  DEFAULT_LABEL: "DEFAULT",
  ORCHESTRATION_LABEL: "Orchestration",
  TEMPLATE_LIQUID_GLASS_LABEL: "Liquid Glass",
  TEMPLATE_LIQUID_GLASS_DESCRIPTION: "A liquid glass template inspired by the latest trends in design.",
  TEMPLATE_VIBRANT_LABEL: "Vibrant Login Page",
  TEMPLATE_VIBRANT_DESCRIPTION: "A vibrant login page template with central login box",
  TEMPLATE_VALUE_PROP_LABEL: "Login Page with Value Proposition",
  TEMPLATE_VALUE_PROP_DESCRIPTION: "A login page template with a value proposition on the left half",
  TEMPLATE_CAROUSEL_LABEL: "Carousel",
  TEMPLATE_CAROUSEL_DESCRIPTION: "A login page template with a carousel on the right half",
  TEMPLATE_TESTIMONIAL_LABEL: "Testimonials",
  TEMPLATE_TESTIMONIAL_DESCRIPTION: "A login page template with a testimonial section",
  TEMPLATE_GRADIENT_ILLUSTRATION_LABEL: "Illustration",
  TEMPLATE_GRADIENT_ILLUSTRATION_DESCRIPTION: "A modern login page with a navbar and gradient illustration",
  CONFIGURE_YOUR_CUSTOM_PROVIDER: "Configure your custom provider",
  PUSH_INVALID_SERVICE_JSON_ERROR: "Invalid file extension. Please select a json file.",
  PUSH_INVALID_P12_ERROR: "Invalid file extension. Please select a .p12 file.",
  PUSH_SERVICE_JSON_ALREAY_PRESENT: "Note: Service JSON is present in the Database.",
  PUSH_P12_ALREAY_PRESENT: "Note: Apns certificate is present in the Database.",
  BRAND_FROM_SCREENSHOT_TITLE: "Screenshot",
  BRAND_FROM_SCREENSHOT_DESCRIPTION: "Create a template from a screenshot image",
  BRAND_FROM_URL_TITLE: "URL",
  BRAND_FROM_URL_DESCRIPTION: "Create a template from a URL reference",
  BRAND_FROM_PROMPT_TITLE: "Prompt",
  BRAND_FROM_PROMPT_DESCRIPTION: "Create a template from a prompt",
  FILE_UPLOAD_TEXT: "Click or drag file to this area to upload",
  IMAGE_UPLOAD_HINT: "Support for a single image upload. Make sure the image is of the login page.",
  PROMPT_PLACEHOLDER: "A modern and sleek template for a tech startup, featuring a minimalist logo and a vibrant color palette.",
  BRAND_GENERATION_METHOD: "Select Template Generation Method",
  BRAND_NAME_PLACEHOLDER: "Enter Template Name",
  ONLY_PNG_JPG_ALLOWED: "Only PNG and JPG/Jpeg files are allowed.",
  MAX_IMAGE_SIZE_ALLOWED: "Image must smaller than 2MB!",
  SPLIT_LAYOUT: "Split Layout",
  NAVBAR: "Navbar",
  FOOTER: "Footer",
  SAVE_DEFAULT_CHECKBOX_MESSAGE: "I understand that these changes will be immediately reflected in Auth Studio.",
  SAVE_V2_CODE_CHECKBOX_MESSAGE: "I understand that these changes will overwrite the existing code files.",
  SAVE_DEFAULT_MESSAGE: "Saving these changes will immediately update Auth Studio for all users.",
  SAVE_V2_CODE_MESSAGE: "Saving these changes will overwrite the existing code files for Auth Studio.",
  EDIT_TEMPLATE_NAME: "Edit Template Name",
  UPDATE_TEMPLATE_NAME: "Update Template Name",
  SAVE_CHANGES_MESSAGE: "Saving these changes will update your template configuration.",
  SET_AS_DEFAULT: "Set as Default",
  EMAIL_PROVIDER: "Email Provider",
  NAME_TOOLTIP_EMAIL_PROVIDER: "Name of the saved mail provider configuration to send the email template.",
  SAVE_DEFAULT_ALERT_MESSAGE: "You are modifying the deployed template. Changes will be immediately reflected in Auth Studio.",
  DEPLOY_TEMPLATE: "Deploy Template",
  DEPLOY_STYLE: "Deploy Style",
  DEPLOY_V2_TEMPLATE: "Deploy V2 Template",
  // File upload validation
  MAX_SIZE: "maximum file size allowed is %s",
  MIN_SIZE: "minimum file size allowed is %s",
  FILE_TYPE: "file type is invalid. Allowed file types are %s",
  DEPLOY_TEMPLATE_MESSAGE: "Are you sure you want to deploy this template? This will change the default template for Auth Studio.",
  DEPLOY_TEMPLATE_V2_MESSAGE: "Are you sure you want to deploy this V2 template? This will replace the existing deployed template for Auth Studio.",
  DEPLOY_TEMPLATE_V2_ALERT: "Your current deployed template will be replaced by old V2 template.",
  DEPLOY_TEMPLATE_CONFIRMATION: "I understand that this will change the deployed template for Auth Studio.",
  DEPLOY_TEMPLATE_ALERT: "Your current deployed template will be replaced.",
  WARNING_DELETE_TEMPLATE: "This action cannot be undone.",
  RPS_TITLE: "Requests Per Second (RPS)",
  RPS_TOOLTIP: "Peak RPS for your APIs over the selected date range.",
  SELECT_STYLE: "Select Style",
  UPGRADE_ANALYTICS: "Upgrade For More Analytics",
  HOSTED_PAGES_ORCHESTRATION_TOOLTIP:
    "Please note that Orchestration Workflows are only compatible with V3 JavaScript templates. You can use this default V3 JS template to deploy and integrate your orchestration workflows seamlessly.",
  HOSTED_PAGES_DEFAULT_TOOLTIP: "This is the default V3 JavaScript template provided by LoginRadius for use with Auth Studio and Orchestration Workflows.",
  VALID_DOMAIN_OR_LOCALHOST: "must be either 'localhost' or a valid domain name",

  // RP Origin Validations
  INVALID_RP_ANDROID_MISSING_HASH: "Invalid RP Origin: Android origin must contain APK key hash",
  INVALID_RP_ANDROID_INVALID_HASH: "Invalid RP Origin: Android APK key hash must be a valid Base64 encoded string",
  INVALID_RP_IOS_MISSING_BUNDLE: "Invalid RP Origin: iOS origin must contain bundle ID",
  INVALID_RP_IOS_INVALID_BUNDLE: "Invalid RP Origin: iOS bundle ID must follow reverse domain notation (e.g., com.example.app)",
  INVALID_RP_INVALID_FORMAT: "Invalid RP Origin: Must start with 'https://', 'http://localhost' (dev only), 'android:apk-key-hash:', or 'ios:bundle-id:'",
  INVALID_RP_HTTP_NOT_LOCALHOST: "Invalid RP Origin: HTTP is only allowed for localhost (use 'localhost', not IP address)",
  INVALID_RP_IP_ADDRESS_NOT_ALLOWED: "Invalid RP Origin: Use 'localhost' instead of IP address for local development",
  INVALID_RP_LOCALHOST: "Invalid RP Origin: When using localhost origin, RPID must be 'localhost'",
  HOSTED_PAGES_TAG_DEFAULT: "AUTH STUDIO",
  ORCHESTRATION_TAG_DEFAULT: "ORCHESTRATION",
  DEFAULT_TAG_DEFAULT: "DEFAULT",

  // Custom Domain Mapping
  ADD_DOMAIN: "Add Domain",
  COPY_DNS_RECORDS: "Copy and paste this in your DNS records",
  REMOVE_TEMPLATE_MAPPING: "Remove Template Mapping",
  MAP_TEMPLATE: "Map Template",
  TEMPLATE: "Template Name",
  SELECT_TEMPLATE: "Select Template",
  MAP_TO_TEMPLATE: "Map to Template",
  REFRESH_VERIFICATION_STATUS: "Refresh Verification Status",
  REMOVE_MAPPING_WARINING: "Note: Removing custom domain mapping will fallback to your default template",
  CUSTOM_DOMAIN: "Custom Domain",
  DOMAIN_REMOVE_CONFIRMATION: "Are you sure you want to remove %s?",
  DOMAUN_REMOVE_MESSAGE: "Doing this will automatically deploy %s to default template.",
  SAVE_TO_DEPLOY: "Save changes to Deploy Template",
  DEPLOY_TO_TRY: "Deploy template to Try",
  SAVE_TO_TRY: "Save changes to Try",
  LOGINRADIUS_HOSTED_DOMAIN: "LoginRadius Hosted Domain",
  DOMAIN_BY_LR: "Domain provided by LoginRadius",
  MAPPED_DOMAINS: "Mapped Custom Domains",
  MAPPED_DOMAINS_TOOLTIP: "Template is currently deployed on these domains",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_OTP_1: "I need an email template for when a user wants to add a new email address. It should just ask them to verify with an OTP.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_OTP_2:
    "Create a sleek, modern email for our 'FinTechPro' brand. The user is adding a new email to their profile. The subject should be 'Confirm Your New Email Address'. Make the #OTP# code placeholder very large and easy to read.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_MAGICLINK_1: "Generate an email for adding a new email address, but this one needs to use a magic link instead of a code.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ADD_EMAIL_MAGICLINK_2:
    "Design a friendly email for our 'SocialSphere' app. 'Just one more step! Click the button below to confirm your new email.' The button should be our brand's primary blue color and say 'Verify Email Address'. It must use the #Url# magic link. Use a clean sans-serif font (e.g., Inter or system UI), a light gray background (#f5f7fa), body text in dark gray, a navy header accent, and a subtle teal accent for links; make the primary blue button (e.g., #007BFF) slightly darker on hover.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_OTP_1: "Create an email to invite a new user to join an organization on our platform. They need to verify with an OTP.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_OTP_2:
    "Write a professional and welcoming email for our B2B platform, 'TeamSync'. The subject should be \"You're invited to join [Organization Name]\". The body should say 'To accept your invitation, please use this code: #OTP#'. Use a clean, corporate-style layout.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_MAGICLINK_1: "I need an organization invitation email that uses a magic link to let the user accept.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_INVITE_USER_TO_ORGANIZATION_MAGICLINK_2:
    "Let's create a splashy invitation email for 'ProjectFlow'. Subject: \"You've Been Invited!\" It should have a big, prominent button that says 'Accept Invitation & Join Team'. This button must link to the #Url# magic link. Use our company logo at the top. Use brand styling: primary color deep blue #0057B8 with accent orange #FF8A00, light gray background #F7F9FC, and a clean sans-serif font like Inter or Helvetica for headings and body.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_OTP_1: "I need an email for when a user requests to delete their account. It should send them an OTP to confirm.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_OTP_2:
    "Generate a security-focused email for delete account using OTP. Subject: 'Action Required: Account Deletion Request'. Clearly state that a request was made and to use the #OTP# to confirm. Must include a \"If this wasn't you, please contact support immediately\" line.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_MAGICLINK_1: "Email template for deleting an account, but using a magic link to confirm.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_DELETEACCOUNT_MAGICLINK_2:
    "Create an email for account deletion confirmation. Subject: 'Final Confirmation to Delete Your Account'. Make a very clear, red button that says 'Yes, Permanently Delete My Account'. This button should use the magic link. Add 'If you did not request this, please ignore this email.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_OTP_1:
    "Create a helpful 'Reset Password' email for our 'GameVerse' app. 'Lost your password? No worries!' It needs to show the OTP code clearly in the #FPass section. Below that, in the #FProv section, gently remind them 'You usually log in with: #Providers#'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_OTP_2:
    "Generate the template for reset password using OTP. Must include the #FPass...FPass# wrapper around the OTP instructions, and the #FProv...FProv# wrapper around the #Providers# variable. The first section should say 'Here is your password reset code:', and the second 'Login Provider:'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_MAGICLINK_1: "Forgot password email, but with a magic link instead of a code. Still need to show the provider.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPASSWORD_MAGICLINK_2:
    "Need the HTML for reset password using Magic Link. It must respect the #FPass and #FProv wrappers. The #FPass section must contain an <a> tag styled as a button using the #Url#?vtype=forgotpassword&vtoken=#GUID# link. The #FProv section should be a simple paragraph: 'Provider: #Providers#'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_OTP_1: "I need the standard registration email. The user signs up and gets an OTP to verify their email.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_OTP_2:
    "Generate an email verification template for new signups (REGISTRATION - OTP). Subject: 'Your Verification Code'. Body text: 'Welcome! Please use the following code to verify your email address: #OTP#'. Include a standard footer with our company info.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_MAGICLINK_1: "Registration email, but with a magic link to verify.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_REGISTRATION_MAGICLINK_2:
    "Create a 'Confirm Your Account' email for our new app 'Mindful'. Make it calm and clean with our green brand color. A single button that says 'Verify My Email' using the magic link. Subject: 'Welcome to Mindful! Please confirm your email.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_OTP_1:
    "Make a super simple 'Login to QuickDocs' email. Subject: 'Your Login Code'. Body: \"Here's your code to sign in: #OTP#\". Make it very mobile-friendly and fast to load. No images, just text and the code.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_OTP_2:
    "Generate an HTML template for ONECLICKSIGNIN (OTP). The email's entire purpose is to deliver the #OTP#. Center the code, make the font size 24px, bold, and use a monospace font for clarity. Add a note: 'This code will expire in 5 minutes.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_MAGICLINK_1: "One-click sign-in email, but with a magic link.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_ONECLICKSIGNIN_MAGICLINK_2:
    "Need a template for one click sign in using magic link. The link is #Url#?vtype=oneclicksignin&vtoken=#GUID#. Create a prominent, full-width button with this link. Add a security footer: 'This login link was requested from your device.'",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_OTP_1:
    "Create an email for our 'GlobalBank' app. 'Reset Your PIN'. 'Use the following code to set a new PIN: #OTP#'. Must be very secure and professional. Use our official bank header and footer.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_OTP_2:
    "Template for FORGOTPIN (OTP). Subject: 'Your PIN Reset Code'. Body: 'A request was made to reset your PIN. Use this code: #OTP#'. Include a 5-minute expiry warning.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_MAGICLINK_1: "Forgot PIN email, but with a magic link.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_FORGOTPIN_MAGICLINK_2:
    "Generate HTML for FORGOTPIN using magic link. The CTA button is the most important part. 'Click here to reset your PIN'. Link must use the correct vtype=resetpin parameter.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_OTP_1:
    "Make an email for 'ShopCentral'. 'Confirm your email to continue'. 'To sign in or create your account, please use this code: #OTP#'. This is for new users, so make it welcoming and explain what's happening.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_OTP_2:
    "Generate the template for One touch login using OTP. The description says 'confirm their email'. So, Subject: 'Confirm Your Email Address'. Body: 'Please use this code to continue: #OTP#'.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_MAGICLINK_1: "Passwordless login for a new user, but with a magic link.",
  EMAIL_TEMPLATES_PROMPT_EXAMPLE_NOREGISTRATIONPASSWORDLESSLOGIN_MAGICLINK_2:
    "Create a 'Welcome to ShopCentral!' email. 'Click the button to sign in or create your account.' Button text: 'Continue to ShopCentral'. Link it to the magic link. This is their first interaction, so make it look good!",
  AI_BRAND_URL_ERROR_TITLE: "Are you sure you gave url of an Auth page?",
  AI_BRAND_URL_ERROR_DESC:
    "Please make sure you open the auth page and paste the exact url. If you did so then please try manually taking the screenshot and use Create with Screenshot to create your page",
  AI_BRAND_SCREENSHOT_ERROR_TITLE: "Could not click the screenshot from the provided URL",
  AI_BRAND_SCREENSHOT_ERROR_DESC: "We could not take the screenshot of the page properly, try to manually take screenshot and use Create With Screenshot to create your page",
  TRIAL_APP_LIMIT: "TRIAL APP LIMIT",
  FREE_TRIAL_LIMITS: "Free Trial Limits",
  PERMISSION_NAME: "Permission Name",
  PERMISSION_ID: "Permission ID",
  DEFAULT_WORKFLOW_TITLE: "Default Workflow",
  DEFAULT_WORKFLOW_TITLE_TOOLTIP: "Select a workflow to be executed by default for this application.",

  // Login distribution
  LOGIN_DISTRIBUTION_TITLE: "Login Distribution",
  BROWSER_DISTRIBUTION_TITLE: "Browser Distribution",
  OS_DISTRIBUTION_TITLE: "OS Distribution",
  PROVIDER_DISTRIBUTION_TITLE: "Provider Distribution",
  DEVICE_DISTRIBUTION_TITLE: "Device Distribution",
  BROWSER_DISTRIBUTION_NO_DATA: "No data available for Browser Distribution.",
  OS_DISTRIBUTION_NO_DATA: "No data available for OS Distribution.",
  PROVIDER_DISTRIBUTION_NO_DATA: "No data available for Provider Distribution.",
  DEVICE_DISTRIBUTION_NO_DATA: "No data available for Device Distribution.",

  MCP_SERVERS_NAV: "MCP Servers",
  MCP_SERVERS_PAGE_TITLE: "MCP Servers",
  MCP_SERVERS_PAGE_DESCRIPTION: "Manage MCP Servers, clients, and consented users.",
  MCP_SERVERS_CREATE_SERVER: "Create MCP Server",
  MCP_SERVERS_UPDATE_SERVER: "Update MCP Server",
  MCP_SERVERS_DELETE_SERVER: "Delete MCP Server",
  MCP_SERVERS_TABLE_NAME: "Name",
  MCP_SERVERS_TABLE_TYPE: "Type",
  MCP_SERVERS_TABLE_CREATED_DATE: "Created Date",
  MCP_SERVERS_TABLE_STATUS: "Status",
  MCP_SERVERS_TABLE_ACTIONS: "Actions",
  MCP_SERVERS_FILTER_DCR_STATUS: "DCR Status",
  MCP_SERVERS_FILTER_CIMD_STATUS: "CIMD Status",
  MCP_SERVERS_FILTER_ALL: "All",
  MCP_SERVERS_FILTER_ENABLED: "Enabled",
  MCP_SERVERS_FILTER_DISABLED: "Disabled",
  MCP_SERVERS_TAB_CONFIGURATION: "Configuration",
  MCP_SERVERS_TAB_CLIENTS: "Clients",
  MCP_SERVERS_TAB_CONSENTED_USERS: "Consented Users",
  MCP_SERVERS_CONFIG_APP_NAME_LABEL: "Enter name of your application",
  MCP_SERVERS_CONFIG_APP_NAME_PLACEHOLDER: "Application name",
  MCP_SERVERS_CONFIG_CLIENT_ID: "Client Id",
  MCP_SERVERS_CONFIG_CLIENT_SECRET: "Client Secret",
  MCP_SERVERS_CONFIG_TOKEN_AUTH_METHOD: "Token Endpoint Auth Method",
  MCP_SERVERS_CONFIG_GRANT_TYPES: "Grant Types",
  MCP_SERVERS_CONFIG_SCOPES: "Scopes",
  MCP_SERVERS_CONFIG_TOKEN_TTL: "Token TTL",
  MCP_SERVERS_CONFIG_ID_TOKEN_TTL: "ID Token TTL",
  MCP_SERVERS_CONFIG_REFRESH_TOKEN_TTL: "Refresh Token TTL",
  MCP_SERVERS_CONFIG_ENABLE_CORS: "Enable CORS",
  MCP_SERVERS_CONFIG_ALLOWED_CORS_ORIGIN: "Allowed CORS Origins",
  MCP_SERVERS_CONFIG_ALLOWED_CORS_ORIGIN_PLACEHOLDER: "Enter one URL per line",
  MCP_SERVERS_CONFIG_LOGIN_REDIRECT_URI: "Login Redirect URIs",
  MCP_SERVERS_CONFIG_LOGIN_REDIRECT_URI_PLACEHOLDER: "Enter one URL per line",
  MCP_SERVERS_CONFIG_LOGOUT_REDIRECT_URI: "Logout Redirect URIs",
  MCP_SERVERS_CONFIG_LOGOUT_REDIRECT_URI_PLACEHOLDER: "Enter one URL per line",
  MCP_SERVERS_CONFIG_DCR_LABEL: "DCR (Dynamic Client Registration)",
  MCP_SERVERS_CONFIG_DCR_DESCRIPTION: "When enabled, client data is stored and managed in a shared identity store instead of per application",

  MCP_SERVERS_CONFIG_CIMD_LABEL: "CIMD (Client ID Metadata Document)",
  MCP_SERVERS_CONFIG_CIMD_DESCRIPTION: "When enabled, new clients can be created programmatically without manual configuration",
  MCP_SERVERS_RESET_SECRET: "Reset Secret",
  MCP_SERVERS_CLIENTS_SEARCH_PLACEHOLDER: "Search by name or client ID",
  MCP_SERVERS_CLIENTS_CLIENT_NAME: "Client Name",
  MCP_SERVERS_CLIENTS_CLIENT_ID: "Client ID",
  MCP_SERVERS_CLIENTS_TYPE: "Type",
  MCP_SERVERS_CLIENTS_ACTIONS: "Actions",
  MCP_SERVERS_CLIENTS_DELETE_CLIENT: "Delete Client",
  MCP_SERVERS_CLIENTS_METADATA_URL: "Metadata URL",
  MCP_SERVERS_USERS_USER_ID: "User ID",
  MCP_SERVERS_USERS_CLIENT_NAME: "Client Name",
  MCP_SERVERS_USERS_SCOPES_GRANTED: "Scopes Granted",
  MCP_SERVERS_USERS_ACTIONS: "Actions",
  MCP_SERVERS_USERS_REVOKE_ACCESS: "Revoke Access",
  MCP_SERVERS_DELETE_SERVER_CONFIRM: "Deleting this server will also delete all its clients and revoke access for all consented users. This action cannot be undone.",
  MCP_SERVERS_DELETE_SERVER_CONFIRM_CHECKBOX: "I understand this action cannot be undone.",
  MCP_SERVERS_DELETE_CLIENT_CONFIRM: "Deleting this client will revoke access for all consented users. Are you sure?",
  MCP_SERVERS_REVOKE_USER_TITLE: "Revoke User Consent",
  MCP_SERVERS_REVOKE_USER_CONFIRM: "This will remove this user's consent for the client. Existing access tokens remain valid until they expire. Continue?",
  MAX_USERS_ALERT: "Only up to 10,000 users can be displayed in the user list. If you have more than 10,000 users, please use the User Export feature to download the complete list of users.",

  // Security Analytics
  SECURITY_ANALYTICS_TITLE: "Security Analytics",
  SECURITY_ANALYTICS_DESCRIPTION: "In-depth security analytics: login trends, MFA health, bot activity, password threats, and domain restrictions.",
  SECURITY_ANALYTICS_NO_DATA: "No data available",
  SECURITY_ANALYTICS_FEATURE_DISABLED: "This feature is not enabled. Enable it to view analytics.",
  SECURITY_ANALYTICS_GO_TO_SETTINGS: "Go to Settings",
  SECURITY_ANALYTICS_INSIGHTS_CRUMB: "Insights",
  SECURITY_ANALYTICS_PAGE_DESCRIPTION: "Login trends, MFA health, bot activity, password threats, and domain restrictions across your tenant.",
  SECURITY_ANALYTICS_EXPORT_LABEL: "Export",

  // Security Analytics — Login Activity
  SA_LOGIN_ACTIVITY_TITLE: "Login Activity",
  SA_LOGIN_ACTIVITY_ERROR: "Error fetching login activity.",
  SA_LOGIN_ACTIVITY_FAILED_REASONS_TITLE: "Failed Login Reasons",
  SA_LOGIN_ACTIVITY_FILTER_PLACEHOLDER: "Login factor",
  SA_LOGIN_ACTIVITY_FILTER_REASON_PLACEHOLDER: "Error reason",
  SA_LOGIN_ACTIVITY_NO_DATA_TITLE: "No login activity in this range",
  SA_LOGIN_ACTIVITY_NO_DATA_DESCRIPTION: "No login attempts were recorded in the selected window. Try a wider date range to confirm.",

  // Security Analytics — MFA Overview
  SA_MFA_TITLE: "MFA Overview",
  SA_MFA_ERROR: "Error fetching MFA overview.",
  SA_MFA_UNAVAILABLE_TITLE: "Strengthen Security with Multi-Factor Authentication",
  SA_MFA_UNAVAILABLE_MESSAGE: "Add an extra layer of verification to every login. Significantly reduce account takeover risk with MFA.",
  SA_MFA_DISABLED_MESSAGE: "MFA is not enabled. Enable Multi-Factor Authentication to view analytics.",
  SA_MFA_ENABLE_LABEL: "Enable MFA",
  SA_MFA_FAILED_REASONS_TITLE: "Failed MFA Reasons",
  SA_MFA_FILTER_PLACEHOLDER: "MFA factor",
  SA_MFA_FILTER_REASON_PLACEHOLDER: "Error reason",

  // Security Analytics — Password Reset
  SA_PASSWORD_RESET_TITLE: "Password Reset",
  SA_PASSWORD_RESET_ERROR: "Error fetching password reset data.",
  SA_PASSWORD_RESET_FAILED_REASONS_TITLE: "Failed Reset Reasons",
  SA_PASSWORD_RESET_FILTER_PLACEHOLDER: "Reset type",
  SA_PASSWORD_RESET_FILTER_REASON_PLACEHOLDER: "Error reason",
  SA_PASSWORD_RESET_TOTAL_LABEL: "Total Resets",
  SA_PASSWORD_RESET_NO_DATA_TITLE: "No password reset activity in this range",
  SA_PASSWORD_RESET_NO_DATA_DESCRIPTION: "No password reset attempts were recorded in the selected window. Try a wider date range to confirm.",

  // Security Analytics — Brute Force Protection
  SA_BRUTE_FORCE_TITLE: "Brute Force Protection",
  SA_BRUTE_FORCE_ERROR: "Error fetching brute force data.",
  SA_BRUTE_FORCE_UNAVAILABLE_TITLE: "Defend Against Brute Force Attacks",
  SA_BRUTE_FORCE_UNAVAILABLE_MESSAGE: "Automatically lock out repeat offenders and block credential stuffing before damage is done.",
  SA_BRUTE_FORCE_DISABLED_MESSAGE: "Brute Force Protection is not configured. Enable it to view analytics.",
  SA_BRUTE_FORCE_SETTINGS_LABEL: "Configure Protection",
  SA_BRUTE_FORCE_NO_DATA_TITLE: "No brute-force lockouts in this range",
  SA_BRUTE_FORCE_NO_DATA_DESCRIPTION: "No user accounts were locked due to repeated failed attempts in the selected window. Try a wider date range to confirm.",

  // Security Analytics — Breached Password Detection
  SA_BREACHED_PASSWORD_TITLE: "Breached Password Protection",
  SA_BREACHED_PASSWORD_ERROR: "Error fetching breached password data.",
  SA_BREACHED_PASSWORD_UNAVAILABLE_TITLE: "Protect Against Breached Passwords",
  SA_BREACHED_PASSWORD_UNAVAILABLE_MESSAGE: "81% of breaches start with stolen passwords. Detect compromised credentials before they reach users.",
  SA_BREACHED_PASSWORD_DISABLED_MESSAGE: "Breached Password Protection is not enabled. Enable it to view analytics.",
  SA_BREACHED_PASSWORD_SETTINGS_LABEL: "Enable Protection",
  SA_BREACHED_PASSWORD_FILTER_PLACEHOLDER: "Breach type",
  SA_BREACHED_PASSWORD_NO_DATA_TITLE: "No breached-password events in this range",
  SA_BREACHED_PASSWORD_NO_DATA_DESCRIPTION: "None of the passwords used or set in the selected window appeared in known breach lists. Try a wider date range to confirm.",

  // Security Analytics — Bot Protection
  SA_BOT_PROTECTION_TITLE: "Bot Protection (CAPTCHA Analytics)",
  SA_BOT_PROTECTION_ERROR: "Error fetching bot protection data.",
  SA_BOT_PROTECTION_UNAVAILABLE_TITLE: "Stop Automated Bot Attacks",
  SA_BOT_PROTECTION_UNAVAILABLE_MESSAGE: "Block bots before they abuse your registration and login flows with intelligent CAPTCHA protection.",
  SA_BOT_PROTECTION_DISABLED_MESSAGE: "Bot Protection (CAPTCHA) is not configured. Enable it to view analytics.",
  SA_BOT_PROTECTION_SETTINGS_LABEL: "Configure CAPTCHA",
  SA_BOT_PROTECTION_NO_DATA_TITLE: "No bot-protection events in this range",
  SA_BOT_PROTECTION_NO_DATA_DESCRIPTION: "No CAPTCHA challenges or bot attempts were recorded in the selected window. Try a wider date range to confirm.",

  // Security Analytics — Restricted Domains
  SA_RESTRICTED_DOMAINS_TITLE: "Failed Auth from Restricted Domains",
  SA_RESTRICTED_DOMAINS_ERROR: "Error fetching restricted domain data.",
  SA_RESTRICTED_DOMAINS_UNAVAILABLE_TITLE: "Control Access with Domain Restrictions",
  SA_RESTRICTED_DOMAINS_UNAVAILABLE_MESSAGE: "Prevent signups from unauthorized, disposable, or competitor email domains.",
  SA_RESTRICTED_DOMAINS_DISABLED_MESSAGE: "Domain restrictions are not configured. Enable them to view analytics.",
  SA_RESTRICTED_DOMAINS_SETTINGS_LABEL: "Configure Domains",
  SA_RESTRICTED_DOMAINS_NO_DATA_TITLE: "No restricted-domain events in this range",
  SA_RESTRICTED_DOMAINS_NO_DATA_DESCRIPTION: "No auth attempts from restricted domains were recorded in the selected window. Try a wider date range to confirm.",

  // Security Analytics — Common Labels
  SA_TOTAL: "Total",
  SA_SUCCESSFUL: "Successful",
  SA_FAILED: "Failed",
  SA_TRIGGERED: "Triggered",
  SA_ABANDONED: "Abandoned",
  SA_BRUTE_FORCE_SECURITY_ANSWER_INVALID: "Security Answer Invalid",
  SA_BRUTE_FORCE_RECAPTCHA_LOCK: "reCAPTCHA Lock",
  SA_BRUTE_FORCE_SECURITY_QUESTION_LOCK: "Security Question Lock",
  SA_BRUTE_FORCE_USER_ID_LOCKED: "User ID Locked",
  SA_BRUTE_FORCE_MFA_LOCK: "MFA Lock",
  SA_BREACHED_PASSWORD_ON_REGISTER: "Breached Password on Register/Update",
  SA_BREACHED_PASSWORD_ON_LOGIN: "Breached Password on Login",
  SA_BREACHED_PASSWORD_ON_FORCED_RESET: "Breached Password on Forced Reset",
  SA_RESTRICTED_DOMAIN_LABEL: "Restricted Domain",
  SA_SPAM_DOMAIN_LABEL: "Spam Domain",

  SWITCH_TENANT_TITLE: "Tenant Changed",
  SWITCH_TENANT_MESSAGE: "You have switched to <b>%s</b> in another tab. Refresh this tab to continue with the same tenant.",
  SWITCH_TENANT_NOTE: "The most recently opened LoginRadius tenant applies to all tabs in this browser.",

  //started-page
  GETTING_STARTED_DAILY_ACTIVE_SUBTITLE: "Unique users who authenticated · last 7 days",
  GETTING_STARTED_ANALYTICS_LINK: "Analytics",
  GETTING_STARTED_MONTHLY_ACTIVE_SUBTITLE: "Unique authenticated users per month for last 3 months",
  GETTING_STARTED_USER_GROWTH_SUBTITLE: "Account and profile changes · last 7 days",
  GETTING_STARTED_USER_ACCOUNTS: "New User Accounts",
  GETTING_STARTED_USER_PROFILES: "New User Profiles",
  GETTING_STARTED_BLOCKED: "Blocked",
  GETTING_STARTED_DELETED: "Deleted",
  GETTING_STARTED_NEW_ACCOUNTS_LABEL: "New accounts",
  GETTING_STARTED_API_HEALTH_TITLE: "API Health & Usage",
  GETTING_STARTED_API_HEALTH_SUBTITLE: "Today's Api health and usage",
  GETTING_STARTED_PLATFORM_ANALYTICS: "Platform Analytics",
  GETTING_STARTED_API_CALLS_TODAY: "API calls today",
  GETTING_STARTED_ERROR_RATE: "Error rate",
  GETTING_STARTED_P95_LATENCY: "p95 latency",
  GETTING_STARTED_API_UPGRADE_HEADING: "Want 30-day trends, endpoint breakdown & alerting?",
  GETTING_STARTED_API_UPGRADE_DESC: "Platform Analytics shows you where errors spike, which endpoints are slow, and alerts you before users notice.",
  GETTING_STARTED_TEAM_TITLE: "Team Overview",
  GETTING_STARTED_TEAM_SUBTITLE: "Admin console members · access and activity status",
  GETTING_STARTED_MANAGE_TEAM_LINK: "Manage Team",
  GETTING_STARTED_TOTAL_MEMBERS: "Total members",
  GETTING_STARTED_ACROSS_ALL_ROLES: "across all roles",
  GETTING_STARTED_INACTIVE_MEMBERS: "Inactive 6+ months",
  GETTING_STARTED_OF_TOTAL_MEMBERS: "of %s members",
  GETTING_STARTED_WITHOUT_MFA: "Without MFA",
  GETTING_STARTED_MEMBERS_BY_ROLE: "MEMBERS BY ROLE · TOP 5",
  GETTING_STARTED_AUTH_METHODS_TITLE: "Authentication Methods",
  GETTING_STARTED_AUTH_METHODS_SUBTITLE: "Features enabled on your tenant",
  GETTING_STARTED_PASSWORDS: "Passwords",
  GETTING_STARTED_PASSWORDLESS: "Passwordless",
  GETTING_STARTED_SOCIAL_LOGINS: "Social logins",
  GETTING_STARTED_SECURITY_TITLE: "Security Overview",
  GETTING_STARTED_SECURITY_SUBTITLE: "Feature enablement status across your application",
  GETTING_STARTED_BOT_PROTECTION: "Bot Protection",
  GETTING_STARTED_BOT_PROTECTION_DESC: "Detects and blocks automated login and registration attempts.",
  GETTING_STARTED_BREACHED_PASSWORD: "Breached Password Detection",
  GETTING_STARTED_BREACHED_PASSWORD_DESC: "Blocks passwords found in known data breach databases.",
  GETTING_STARTED_BRUTE_FORCE_DESC: "Locks accounts after repeated failed login attempts.",
  GETTING_STARTED_MFA_DESC: "Requires a second verification step at login.",
  GETTING_STARTED_RBA_NAME: "Risk-Based authentication",
  GETTING_STARTED_RBA_DESC: "Triggers step-up auth when anomalous signals are detected.",
  GETTING_STARTED_DOMAIN_RESTRICTION: "Domain Restriction",
  GETTING_STARTED_DOMAIN_RESTRICTION_DESC: "Limits registration and login to approved email domains.",
  GETTING_STARTED_AUTH_STUDIO_TITLE: "Auth Studio",
  GETTING_STARTED_AUTH_STUDIO_SUBTITLE: "Your tenant's live login page URL",
  GETTING_STARTED_CUSTOMISE_LINK: "Customise",
  GETTING_STARTED_COPIED: "Copied",
  GETTING_STARTED_OPEN: "Open",
  GETTING_STARTED_CHART_USERS: "Users",
  GETTING_STARTED_STATUS_OPTIONAL: "Enabled (Optional)",

  MANAGE_API_REMOVED_CLIENT_CREDS_OFF: "The /manage API was removed because client_credentials is no longer enabled for this application.",
  // Hosted Pages — file tree actions
  DELETE_PAGE: "Delete Page",
  DELETE_HEAD: "Delete Head"
};
